<template>
    <div v-if="pageData.data">
        <div class="zone-title zone-title--bg banded landing__zone-title--short">
            <div class="zone-title zone-title--bg banded">
                <div class="zone-title__foreground foreground">
                    <div class="container-title">
                        <h2>Timeline of Cyber Incidents Involving Financial Institutions</h2>
                    </div>
                </div>
            </div>
        </div>
        <div id="aboutTab">
            <div id="aboutTabContent">
                <div class="top-section">
                    <div class="close-button">
                        <button class="close-panel" id="close-about">
                            <span class="ceip-icon icon-cancel-circle">X</span>
                        </button>
                    </div>
                </div>
                <div class="section about-overlay">
                    <div class="foreground">
                        <div class="tab-content">
                            <div class="tab-pane fade in active" role="tabpanel" id="aboutTracker">
                                <div class="component">
                                    <h4>About the Timeline</h4>
                                    <p>
                                        The timeline tracks cyber incidents involving financial institutions dating back
                                        to 2007. The timeline is based on Carnegie research and data BAE Systems’s
                                        threat intelligence team shares with Carnegie on a monthly basis and are
                                        subsequently added to the timeline. The incidents are coded using several
                                        indicators and can be filtered accordingly:
                                    </p>
                                    <ol>
                                        <li>incident type;</li>
                                        <li>
                                            target country and target region, which include information about the
                                            physical location of the victim(s);
                                        </li>
                                        <li>
                                            actor type, which includes information about the attacker to the extent
                                            known;
                                        </li>
                                        <li>
                                            attribution, which includes an assessment of the level of confidence in the
                                            information about the attacker; and
                                        </li>
                                        <li>other details about the incident summarized in a short narrative text.</li>
                                    </ol>
                                    <p>
                                        With respect to associating a specific date with a cyber incident, which may be
                                        part of a longer cyber operation, the dates for each event are chosen
                                        intuitively either using the starting date/month of the incident, if known, or
                                        when the incident was first reported. For further questions about the
                                        methodology, please
                                        <a href="mailto:cyberpolicy@ceip.org">contact the team here</a>.
                                    </p>
                                    <p>When citing this resource, please use the following format:</p>
                                    <p>
                                        Carnegie Endowment for International Peace and BAE Systems. Timeline of Cyber
                                        Incidents Involving Financial Institutions. FinCyber Initiative, Carnegie
                                        Endowment for International Peace.
                                        https://carnegieendowment.org/features/fincyber-timeline (access date).”
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h3 class="active" id="aboutTabClick">About <span class="hide-mobile">the Fincyber Timeline</span></h3>
        </div>
        <div class="section gray-background">
            <div class="foreground">
                <div class="cols intro">
                    <div class="col col-70">
                        <div class="gutters">
                            <p class="gutter-top roman-normal-book">
                                This timeline chronicles ~200 cyber incidents targeting financial institutions since
                                2007, and can be filtered by country, region, year, attribution, incident type, and
                                actor type. Cybersecurity risks to the financial system have grown in recent years, in
                                part because the cyber threat landscape is worsening; in particular, state-sponsored
                                cyberattacks targeting financial institutions are becoming more frequent, sophisticated,
                                and destructive. In 2017, the G20 warned that cyberattacks could “<a
                                    href="https://carnegieendowment.org/files/g20-communique.pdf"
                                    >undermine the security and confidence and endanger financial stability</a
                                >.”
                            </p>
                            <p class="roman-normal-book">
                                To keep track of the evolution of the threat landscape, Carnegie’s Technology and
                                International Affairs Program updates this timeline with data from provided by the Cyber
                                Threat Intelligence unit of BAE Systems. The timeline has not been designed to cover
                                every single incident but rather to provide insight into key trends and how the threat
                                landscape is evolving over time.
                            </p>
                        </div>
                    </div>
                    <div class="col col-30">
                        <div class="gutters">
                            <a href="/specialprojects/fincyber/">
                                <div class="gutter-top banded">
                                    <div class="inside">
                                        <div class="text">The FinCyber Project</div>
                                    </div>
                                </div>
                            </a>
                            <a href="/specialprojects/fincyber/about/">
                                <div class="banded">
                                    <div class="inside">
                                        <div class="text">The FinCyber Strategy Project</div>
                                    </div>
                                </div>
                            </a>
                            <a href="/specialprojects/fincyber/guides">
                                <div class="banded">
                                    <div class="inside">
                                        <div class="text">Capacity-building Toolbox</div>
                                    </div>
                                </div>
                            </a>
                            <a href="/specialprojects/fincyber/workingpapers/">
                                <div class="banded">
                                    <div class="inside">
                                        <div class="text">Research Working Paper Series</div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section foreground top">
            <div id="timeline-top"></div>
            <div class="nav-wrapper" id="sticky-filter">
                <strong>Filter by:</strong>
                <ul class="clean-list list-across-spaced sticky">
                    <li class="js-element">
                        <a class="menu-trigger"
                            >Highly Targeted Country <span class="ceip-icon icon-arrow-down"></span
                        ></a>
                        <div class="mega-menu menu">
                            <ul class="clean-list list-across-divided">
                                <li>
                                    <a class="countryFilter active" id="Bangladesh" @click="countryFilterInput"
                                        >Bangladesh</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Brazil" @click="countryFilterInput">Brazil</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Canada" @click="countryFilterInput">Canada</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Chile" @click="countryFilterInput">Chile</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="China" @click="countryFilterInput">China</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Estonia" @click="countryFilterInput">Estonia</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="France" @click="countryFilterInput">France</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Georgia" @click="countryFilterInput">Georgia</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Germany" @click="countryFilterInput">Germany</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="India" @click="countryFilterInput">India </a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Iran" @click="countryFilterInput">Iran</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Japan" @click="countryFilterInput">Japan</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Kenya" @click="countryFilterInput">Kenya</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Mexico" @click="countryFilterInput">Mexico</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Nigeria" @click="countryFilterInput">Nigeria</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Poland" @click="countryFilterInput">Poland</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Russia" @click="countryFilterInput">Russia </a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="SouthAfrica" @click="countryFilterInput"
                                        >South Africa
                                    </a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="SouthKorea" @click="countryFilterInput"
                                        >South Korea
                                    </a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Thailand" @click="countryFilterInput"
                                        >Thailand</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Uganda" @click="countryFilterInput">Uganda</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="Ukraine" @click="countryFilterInput">Ukraine</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="UnitedArabEmirates" @click="countryFilterInput"
                                        >United Arab Emirates</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="UK" @click="countryFilterInput"
                                        >United Kingdom</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="UnitedStates" @click="countryFilterInput"
                                        >United States</a
                                    >
                                </li>
                            </ul>
                            <ul class="clean-list list-across-divided">
                                <li>
                                    <a class="countryFilter active" id="Africa" @click="countryFilterInput">Africa</a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="CentralAmerica" @click="countryFilterInput"
                                        >Central America</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="EastAsia" @click="countryFilterInput"
                                        >East Asia</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="EasternEurope" @click="countryFilterInput"
                                        >Eastern Europe</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="MiddleEast" @click="countryFilterInput"
                                        >Middle East</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="NorthAmerica" @click="countryFilterInput"
                                        >North America</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="SouthAmerica" @click="countryFilterInput"
                                        >South America
                                    </a>
                                </li>
                                <li>
                                    <a class="countryFilter active" id="SoutheastAsia" @click="countryFilterInput"
                                        >Southeast Asia</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="SouthAsia" @click="countryFilterInput"
                                        >South Asia</a
                                    >
                                </li>
                                <li>
                                    <a class="countryFilter active" id="WesternEurope" @click="countryFilterInput"
                                        >Western Europe
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="js-element">
                        <a class="menu-trigger">Incident type <span class="ceip-icon icon-arrow-down"></span></a>
                        <div class="mega-menu menu">
                            <ul class="clean-list list-across-divided">
                                <li>
                                    <a class="incidentTypeFilter active" id="dataBreach" @click="incidentFilterInput"
                                        >Data breach</a
                                    >
                                </li>
                                <li>
                                    <a class="incidentTypeFilter active" id="theft" @click="incidentFilterInput"
                                        >Theft</a
                                    >
                                </li>
                                <li>
                                    <a class="incidentTypeFilter active" id="espionage" @click="incidentFilterInput"
                                        >Espionage</a
                                    >
                                </li>
                                <li>
                                    <a class="incidentTypeFilter active" id="disruption" @click="incidentFilterInput"
                                        >Disruption</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="js-element">
                        <a class="menu-trigger">Actor type <span class="ceip-icon icon-arrow-down"></span></a>
                        <div class="mega-menu menu">
                            <ul class="clean-list list-across-divided">
                                <li>
                                    <a class="actorFilter active" id="nonstate" @click="actorFilterInput"
                                        >Nonstate actor</a
                                    >
                                </li>
                                <li>
                                    <a class="actorFilter active" id="stateSponsored" @click="actorFilterInput"
                                        >State-sponsored actor</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="js-element">
                        <a class="menu-trigger">Attribution <span class="ceip-icon icon-arrow-down"></span></a>
                        <div class="mega-menu menu">
                            <ul class="clean-list list-across-divided">
                                <li>
                                    <a class="attributionFilter active" id="confirmed" @click="attributionFilterInput"
                                        >High Confidence</a
                                    >
                                </li>
                                <li>
                                    <a class="attributionFilter active" id="speculated" @click="attributionFilterInput"
                                        >Speculated</a
                                    >
                                </li>
                                <li>
                                    <a class="attributionFilter active" id="unknown" @click="attributionFilterInput"
                                        >Unknown</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="js-element">
                        <a class="menu-trigger">Year <span class="ceip-icon icon-arrow-down"></span></a>
                        <div class="mega-menu menu">
                            <ul class="clean-list list-across-divided">
                                <li>
                                    <a class="yearFilter active" id="y2022" @click="yearFilterInput">2022</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2021" @click="yearFilterInput">2021</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2020" @click="yearFilterInput">2020</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2019" @click="yearFilterInput">2019</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2018" @click="yearFilterInput">2018</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2017" @click="yearFilterInput">2017</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2016" @click="yearFilterInput">2016</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2015" @click="yearFilterInput">2015</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2014" @click="yearFilterInput">2014</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2013" @click="yearFilterInput">2013</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2012" @click="yearFilterInput">2012</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2011" @click="yearFilterInput">2011</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2010" @click="yearFilterInput">2010</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2009" @click="yearFilterInput">2009</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2008" @click="yearFilterInput">2008</a>
                                </li>
                                <li>
                                    <a class="yearFilter active" id="y2007" @click="yearFilterInput">2007</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <div class="active-filters align-left gutters-bottom hidden" id="activeFilters">
                    <a class="button-alt" id="Reset" @click="resetTimeline">Reset</a>
                    <strong>Active Filters: </strong>
                    <ul class="clean-list list-across-divided" id="filters-display"></ul>
                </div>
            </div>
            <div id="chartdiv"></div>
            <div id="info"></div>
            <div class="frst-container" data-animation-name="slideInUp" id="timeline-start">
                <!--frst-left-align/frst-right-align/frst-alternate/frst-date-opposite/frst-responsive-right-->
                <div class="frst-timeline frst-timeline-style-8">
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2022</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BeanstalkFarms2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Beanstalk Farms cryptocurrency theft</h2>
                                <span class="frst-date">April 17</span>
                                <p>
                                    On April 17, 2022, the decentralised finance platform Beanstalk Farms lost $180
                                    million in a cryptocurrency heist.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 4/18/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 17, 2022, the decentralised finance platform Beanstalk Farms lost
                                            $180 million in a cryptocurrency heist. The attackers took out a large
                                            enough loan to acquire enough voting rights to make the necessary governance
                                            changes to move all of Beanstalk’s reserves. The price of each Bean has
                                            since plumeted to near zero before coming back up to around one dollar.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FakecallsTrojan2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Fakecalls banking trojan</h2>
                                <span class="frst-date">April 11</span>
                                <p>
                                    On April 11, 2022, researchers reported on the banking trojan Fakecalls, which has
                                    the ability to ‘talk’ to victims and pretend to be a employee of the bank.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong> 4/11/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 11, 2022, researchers reported on the banking trojan Fakecalls,
                                            which has the ability to ‘talk’ to victims and pretend to be a employee of
                                            the bank. Fakecalls mimics the mobile apps of popular Korean-based banks.
                                            The trojan seeks to gain access to the victims contacts, microphone, camera,
                                            location and call handling, and attackers attempt to gain payment data or
                                            confidential information from the victim. Fakecalls also has a spyware
                                            toolkit.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CashMama2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>CashMama data breach</h2>
                                <span class="frst-date">April 6</span>
                                <p>
                                    On April 6, 2022, India-based loans app CashMama reported a data breach, in which
                                    customer data that was invasively collected and stored was exposed.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India
                                            <strong>Date Breach First Reported:</strong> 4/6/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 6, 2022, India-based loans app CashMama reported a data breach, in
                                            which customer data that was invasively collected and stored was exposed.
                                            CashMama’s Amazon S3 bucket was left in open form, which exposed customers’
                                            personal data and other sensitive information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="LazarusTrojan2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Lazarus ‘Trojanised’ decentralised finance app</h2>
                                <span class="frst-date">April 1</span>
                                <p>
                                    On April 1, 2022, North Korean state-sponsored threat group Lazarus was found to be
                                    using ‘Trojanised’ decentralised finance apps to deliver malware in their latest
                                    spearphishing campaign.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 4/1/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 1, 2022, North Korean state-sponsored threat group Lazarus was
                                            found to be using ‘Trojanised’ decentralised finance apps to deliver malware
                                            in their latest spearphishing campaign. The malware is a full-featured
                                            backdoor containing sufficient capabilities to control the compromised
                                            victim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RoninCrypto2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ronin cryptocurrency theft</h2>
                                <span class="frst-date">March 23</span>
                                <p>
                                    On March 23 2022, blockchain project Ronin lost $615 million in ether and USD Coin
                                    tokens in the second largest cryptocurrency heist to date.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Canada<br />
                                            <strong>Date Breach First Reported:</strong> 3/29/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 23 2022, blockchain project Ronin lost $615 million in ether and
                                            USD Coin tokens in the second largest cryptocurrency heist to date. Hackers
                                            exploited a feature allowing users to transfer their digital assets from
                                            crypto network to another. Ronin is used to power the popular online
                                            blockchain game Axie Infinity. The US subsequently attributed the incident
                                            to North Korean state-backed hacking collective Lazarus Group and announced
                                            new sanctions against an ethereum wallet belonging to the group.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TransUnionSA2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>TransUnion SA data breach</h2>
                                <span class="frst-date">March 17</span>
                                <p>
                                    Credit bureau TransUnion SA suffered a cyber attack which saw around three million
                                    customer's data stolen by a criminal third party.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong> 3/17/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Credit bureau TransUnion SA suffered a cyber attack which saw around three
                                            million customer's data stolen by a criminal third party. The attackers
                                            demanded a ransom but TransUnion refused to pay.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="MoscowStockExchange2022"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Moscow Stock Exchange and Sberbank cyber attack</h2>
                                <span class="frst-date">February 28</span>
                                <p>
                                    On February 28, 2022, the Moscow Stock Exchange and Sberbank, Russia’s largest
                                    lender, were hit by DDoS attacks that took their websites offline.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Russia<br />
                                            <strong>Date Breach First Reported:</strong> 2/28/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 28, 2022, the Moscow Stock Exchange and Sberbank, Russia’s
                                            largest lender, were hit by DDoS attacks that took their websites offline.
                                            The incidents were claimed by the Ukrainian IT Army, a crowdsourced
                                            community of hackers created by the Ukrainian government.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="AonRansomware022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Aon ransomware attack</h2>
                                <span class="frst-date">February 25</span>
                                <p>
                                    On February 25, 2022, global insurance and reinsurance broker, Aon was hit by a
                                    ransomware attack, causing limited disruption to a number of their services.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 2/28/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 25, 2022, global insurance and reinsurance broker, Aon was hit
                                            by a ransomware attack, causing limited disruption to a number of their
                                            services. The attack reportedly left no significant impact on the company,
                                            and Aon has not disclosed further details about the incident.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="UkraineGovFebDDOS2022"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ukrainian government and banking sector DDoS</h2>
                                <span class="frst-date">February 15</span>
                                <p>
                                    On February 15, 2022, the web portal of Ukraine’s defence ministry and the banking
                                    and terminal services at several large state-owned lenders were downed in the
                                    largest DDoS attacks to hit the country to date.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Ukraine<br />
                                            <strong>Date Breach First Reported:</strong> 2/16/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 15, 2022, the web portal of Ukraine’s defence ministry and the
                                            banking and terminal services at several large state-owned lenders were
                                            downed in the largest DDoS attacks to hit the country to date. The Ukrainian
                                            government publicly attributed the incident to Moscow. The Kremlin has
                                            denied involvement for the operation, which hit Ukraine at a time when the
                                            country is bracing itself for a possible invasion from Russian forces.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="IRAFinancialTrust2022"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>IRA Financial Trust cryptocurrency theft</h2>
                                <span class="frst-date">February 8</span>
                                <p>
                                    On February 8, 2022, IRA Financial Trust, which offers self-directed retirement
                                    accounts, lost $36 million in cryptocurrency when unknown threat actors drained $21
                                    million in Bitcoin and $15 million in Ethereum from the accounts of IRA customers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 2/14/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 8, 2022, IRA Financial Trust, which offers self-directed
                                            retirement accounts, lost $36 million in cryptocurrency when unknown threat
                                            actors drained $21 million in Bitcoin and $15 million in Ethereum from the
                                            accounts of IRA customers. IRA Financial allows its customers to purchase
                                            cryptocurrency through a partnership with the cryptocurrency exchange Gemini
                                            Trust Co.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MedusaPhishing2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Medusa malware phishing attacks</h2>
                                <span class="frst-date">February 7</span>
                                <p>
                                    On February 4, 2022, researchers reported that the Medusa Android banking Trojan has
                                    increased infection rates and the scope of geographic regions targeted.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 2/7/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 4, 2022, researchers reported that the Medusa Android banking
                                            Trojan has increased infection rates and the scope of geographic regions
                                            targeted. The malware aims to steal online credentials to go on and perform
                                            financial fraud. Medusa has begun targeting victims in North America and
                                            Europe, using the same distribution service as FluBot malware to carry out
                                            their smishing campaigns.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="WormholeCryptocurrency2022"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Wormhole cryptocurrency theft</h2>
                                <span class="frst-date">February 2</span>
                                <p>
                                    On February 2, 2022, cryptocurrency platform Wormhole lost an estimated $322 million
                                    worth of Ether currency when a threat actor exploited a vulnerability in the
                                    platform’s smart contracts, making it the second largest hack of a decentralized
                                    platform to date.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Switzerland<br />
                                            <strong>Date Breach First Reported:</strong> 2/2/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 2, 2022, cryptocurrency platform Wormhole lost an estimated $322
                                            million worth of Ether currency when a threat actor exploited a
                                            vulnerability in the platform’s smart contracts, making it the second
                                            largest hack of a decentralized platform to date. Wormhole is offering the
                                            hacker $10 million in exchange for return of the stolen funds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Qubit2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Qubit Finance cryptocurrency theft</h2>
                                <span class="frst-date">January 27</span>
                                <p>
                                    On January 27, 2022, decentralized finance platform Qubit Finance suffered a breach,
                                    in which threat actors were able to steal $80 million worth of cryptocurrency.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong> 1/28/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 27, 2022, decentralized finance platform Qubit Finance suffered a
                                            breach, in which threat actors were able to steal $80 million worth of
                                            cryptocurrency. The attackers exploited a vulnerability in one of its
                                            Ethereum blockchain contracts. Qubit has offered to pay the attacker a
                                            bounty to return the stolen funds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TeaBotFluBot2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>TeaBot and FluBot banking trojan resurgence</h2>
                                <span class="frst-date">January 26</span>
                                <p>
                                    On January 26, 2022, the TeaBot and FluBot banking trojans were detected to be
                                    targeting Android devices once again.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 1/26/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 26, 2022, the TeaBot and FluBot banking trojans were detected to
                                            be targeting Android devices once again. The banking trojans steal banking,
                                            contact, and SMS data from infected machines, and are being dispatched in
                                            phishing campaigns.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Multichain2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Multichain cryptocurrency theft</h2>
                                <span class="frst-date">January 17</span>
                                <p>
                                    On January 17, 2022, Multichain, a platform that allows users to swap tokens between
                                    blockchains, lost approximately $1.4 million when hackers exploited a vulnerability
                                    in the blockchain service.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 1/19/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 17, 2022, Multichain, a platform that allows users to swap tokens
                                            between blockchains, lost approximately $1.4 million when hackers exploited
                                            a vulnerability in the blockchain service. One of the attackers is now
                                            negotiating with the victims to return 80% of the stolen funds and keep the
                                            remaining 20% as a ‘tip’.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CryptoCom2022">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Crypto.com 2FA bypass hack</h2>
                                <span class="frst-date">January 17</span>
                                <p>
                                    On January 17, 2022, major cryptocurrency exchange Crypto.com suffered a cyber
                                    attack that led to unauthorized withdrawals of bitcoin and Ether worth $35 million
                                    and affected at least 483 user accounts.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 1/17/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 17, 2022, major cryptocurrency exchange Crypto.com suffered a
                                            cyber attack that led to unauthorized withdrawals of bitcoin and Ether worth
                                            $35 million and affected at least 483 user accounts. The exchange has
                                            subsequently instituted strict 2FA measures a fund restoration program for
                                            qualifying users.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="OPFinancialGroup2022"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>OP Financial Group cyberattack</h2>
                                <span class="frst-date">January 9</span>
                                <p>
                                    On January 9, 2022, the biggest bank in Finland, OP Financial Group suffered a
                                    cyberattack which disrupted its services.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Finland
                                            <strong>Date Breach First Reported:</strong> 1/11/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 9, 2022, the biggest bank in Finland, OP Financial Group suffered
                                            a cyberattack which disrupted its services. The attack also affected logins
                                            to the site but online services were restored shortly after and no
                                            customer’s information or funds were compromised.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2021</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="OCBCPhishing2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>OCBC phishing scam</h2>
                                <span class="frst-date">December 23</span>
                                <p>
                                    On December 23, 2021, around 790 banking customers of Singporean bank OCBC were
                                    targeted in a phishing scam resulting in a loss of at least $13.7 million.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 1/11/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 23, 2021, around 790 banking customers of Singporean bank OCBC
                                            were targeted in a phishing scam resulting in a loss of at least $13.7
                                            million. Once victims clicked on the link provided and typed in their
                                            credentials, attackers were able to gain access to victim’s bank accounts
                                            and drain it of its entire funds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="AscendEX2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>AscendEX hot wallet breach</h2>
                                <span class="frst-date">December 11</span>
                                <p>
                                    On December 12, 2021, crypto exchange AscendEX lost $77.7 million in a breach of its
                                    hot wallet.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 12/11/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 12, 2021, crypto exchange AscendEX lost $77.7 million in a
                                            breach of its hot wallet. Assets were taken across three
                                            blockchains—Ethereum, Binance Smart Chain, and Polygon—with stolen tokens
                                            including significant amounts of stablecoins. The firm subsequently froze
                                            deposits and withdrawals.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Bitmart2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bitmart security breach</h2>
                                <span class="frst-date">December 4</span>
                                <p>
                                    On December 4, 2021, Bitmart, a crypto trading platform, experienced a major
                                    security breach, resulting in hackers withdrawing almost $200 million in assets.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 12/5/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 4, 2021, Bitmart, a crypto trading platform, experienced a major
                                            security breach, resulting in hackers withdrawing almost $200 million in
                                            assets. The security breach was mainly caused by a stolen private key, which
                                            affected two of its ethereum and binance smart chain hot wallets. Bitmart
                                            says it will reimburse victims for all losses.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BadgerDAO2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BadgerDAO DeFi protocol hack</h2>
                                <span class="frst-date">December 2</span>
                                <p>
                                    On December 2, 2021, decentralied finance ("DeFi") protocol BadgerDAO was hit by a
                                    cyber attack in which hackers stole $120.3 million in crypto.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple
                                            <strong>Date Breach First Reported:</strong> 12/2/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 2, 2021, decentralied finance ("DeFi") protocol BadgerDAO was
                                            hit by a cyber attack in which hackers stole $120.3 million in crypto. The
                                            DAO paused all smart contracts in order to prevent further withdrawals.
                                            Crypto lender Celsius Network subsequently confirmed the company had lost
                                            money from the hack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Monox2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Monox cryptocurrency theft</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    On December 1, 2021, blockchain startup MonoX Finance lost $31M when a threat actor
                                    exploited a vulnerability in the software the company uses to draft smart contracts.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Singapore<br />
                                            <strong>Date Breach First Reported:</strong> 12/07/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 1, 2021, blockchain startup MonoX Finance lost $31M when a
                                            threat actor exploited a vulnerability in the software the company uses to
                                            draft smart contracts. The threat actor was able to inflate the price of the
                                            MONO token and use it to cash out all the other deposited tokens.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="TaiwaneseFinancialNov2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Taiwanese financial institutions cyber espionage</h2>
                                <span class="frst-date">November 30</span>
                                <p>
                                    From the end of November 2021, Taiwan’s financial sector was hit by a months-long
                                    cyber espionage campaign attributed to Chinese state-sponsored group APT 10.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Taiwan <br />
                                            <strong>Date Breach First Reported:</strong> 2/21/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Espionage
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            From the end of November 2021, Taiwan’s financial sector was hit by a
                                            months-long cyber espionage campaign attributed to Chinese state-sponsored
                                            group APT 10. Attackers ran malicious code on local systems and installed a
                                            RAT that allowed them to maintain persistent remote access to the infected
                                            system.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="USRegs2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Incident notification requirements for U.S. banks</h2>
                                <span class="frst-date">November 18</span>
                                <p>
                                    On November 18, 2021, the Federal Deposit Insurance Corporation, the Board of
                                    Governors of the Federal Reserve System, and the Office of the Comptroller of the
                                    Currency issued a joint final rule to establish computer security incident
                                    notification requirements for banking organisations and their service providers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 11/18/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> N/A
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 18, 2021, the Federal Deposit Insurance Corporation, the Board
                                            of Governors of the Federal Reserve System, and the Office of the
                                            Comptroller of the Currency issued a joint final rule to establish computer
                                            security incident notification requirements for banking organisations and
                                            their service providers. The rule seeks to provide agencies with early
                                            warnings of suspected threats.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Robinhood2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Robinhood data breach</h2>
                                <span class="frst-date">November 8</span>
                                <p>
                                    On November 8, 2021, Robinhood, the American stock trading platform, disclosed a
                                    data breach after their systems were hacked.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 11/8/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 8, 2021, Robinhood, the American stock trading platform,
                                            disclosed a data breach after their systems were hacked. A threat actor
                                            gained access to the personal information of around 7 million customers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="bZx2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>bZx cryptocurrency theft</h2>
                                <span class="frst-date">November 6</span>
                                <p>
                                    On November 6, 2021, threat actors stole an estimated $55 million from bZx, a
                                    decentralised finance platform that allows users to borrow, loan, and speculate on
                                    cryptocurrency price varations.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 11/6/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 6, 2021, threat actors stole an estimated $55 million from bZx,
                                            a decentralised finance platform that allows users to borrow, loan, and
                                            speculate on cryptocurrency price varations. A bZx developer was sent a
                                            phishing email with a malicious Word document attached. Threat actors
                                            compromised the developer's mnemonic wallet phrase and emptied their
                                            personal wallet before stealing two private keys for bZx's Polygon and
                                            Binance Smart Chain (BSC) blockchains.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FBIATM2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FBI warns of ATM crypto scams</h2>
                                <span class="frst-date">November 4</span>
                                <p>
                                    On November 4, 2021, the FBI warned that scams involving cryptocurrency ATMs and QR
                                    codes are on the rise.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 11/4/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 4, 2021, the FBI warned that scams involving cryptocurrency ATMs
                                            and QR codes are on the rise. Cybercriminals have started to abuse QR codes
                                            to receive fraudulent cryptocurrency payments from their victims.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Zloader2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Zloader banking malware</h2>
                                <span class="frst-date">November 1</span>
                                <p>
                                    Since November 2021, the banking trojan Zloader has been exploiting Microsoft’s
                                    digital signature verification method to inject malicious code into a signed system
                                    dynamic link library (DLL).
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple
                                            <strong>Date Breach First Reported:</strong> 01/07/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Since November 2021, the banking trojan Zloader has been exploiting
                                            Microsoft’s digital signature verification method to inject malicious code
                                            into a signed system dynamic link library (DLL). The banking trojan
                                            leverages Atera, an enterprise remote monitoring and management application,
                                            for intial access to targeted machines, and as of January 2022, the
                                            malicious DLL had been downloaded to 2000+ unique victim IPs.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SharkBot2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>UK and Italian banks targeted by SharkBot banking trojan</h2>
                                <span class="frst-date">November 1</span>
                                <p>
                                    In late October 2021, researchers from Cleafy and ThreatFabric discovered a new
                                    Android banking Trojan called SharkBot.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Italy, United Kingdom
                                            <strong>Date Breach First Reported:</strong> 11/1/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In late October 2021, researchers from Cleafy and ThreatFabric discovered a
                                            new Android banking Trojan called SharkBot. The trojan tricks targets into
                                            downloading malicious apps from Google Play Store and grants itself admin
                                            rights, collects keystrokes, intercepts/hides F2A SMS messages, and accesses
                                            mobile banking and crypocurrency apps to transfer funds. SharkBot has been
                                            detected targeting international banks from the United Kingdom and Italy and
                                            five different cryptocurrency services.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FBIRansomware2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FBI warns of novel ransomware extortion methods</h2>
                                <span class="frst-date">November 1</span>
                                <p>
                                    On November 1, 2021, the FBI warned that ransomware actors have been using
                                    significant financial events and stock information, specifically, publicly available
                                    information such as upcoming mergers to inform their targeting and extortion of
                                    victims.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States
                                            <strong>Date Breach First Reported:</strong> 11/1/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware<br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 1, 2021, the FBI warned that ransomware actors have been using
                                            significant financial events and stock information, specifically, publicly
                                            available information such as upcoming mergers to inform their targeting and
                                            extortion of victims.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PakistanBank2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>National Bank of Pakistan attack</h2>
                                <span class="frst-date">October 29</span>
                                <p>
                                    On October 29, 2021, the National Bank of Pakistan suffered a destructive cyber
                                    attack, which is said to have impacted some of its services including the bank's
                                    ATMs, internal network, and mobile apps.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Pakistan
                                            <strong>Date Breach First Reported:</strong> 11/2/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 29, 2021, the National Bank of Pakistan suffered a destructive
                                            cyber attack, which is said to have impacted some of its services including
                                            the bank's ATMs, internal network, and mobile apps. Steps were taken
                                            immediately to isolate the incident, and the bank stated that no data was
                                            breached and no funds were stolen.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CreamFinance2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>DeFi platform Cream Finance $130 million theft</h2>
                                <span class="frst-date">October 27</span>
                                <p>
                                    On October 27, 2021, in their third attack this year, attackers stole around $130
                                    million from Cream Finance, a decentralized finance ("DeFi") platform.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Poland
                                            <strong>Date Breach First Reported:</strong> 10/27/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 27, 2021, in their third attack this year, attackers stole around
                                            $130 million from Cream Finance, a decentralized finance ("DeFi") platform.
                                            The attackers exploited a vulnerability in the platform's lending system
                                            (flash loaning) to steal all of their assets and tokens running on the
                                            Ethereum blockchain.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Nixdorf2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Diebold Nixdorf ATM vulnerability</h2>
                                <span class="frst-date">October 25</span>
                                <p>
                                    On October 28, 2021, researchers from Positive Technologies discovered
                                    vulnerabilities in the Wincor Cineo ATMs, owned by Diebold Nixdorf, an American
                                    multinational financial and retail technology company.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States
                                            <strong>Date Breach First Reported:</strong> 10/25/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 28, 2021, researchers from Positive Technologies discovered
                                            vulnerabilities in the Wincor Cineo ATMs, owned by Diebold Nixdorf, an
                                            American multinational financial and retail technology company. With access
                                            to the dispenser controller's USB port, outdated or modified firmware could
                                            be installed to bypass the encryption and make cash ATM withdrawals.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Flubot2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Flubot targets Android devices with fake security updates and apps</h2>
                                <span class="frst-date">October 22</span>
                                <p>
                                    On October 26, 2021, the Nigerian Communications Commission announced the discovery
                                    of a new malware, dubbed Flubot, targeting Android devices with fake security
                                    updates and application installations.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Nigeria
                                            <strong>Date Breach First Reported:</strong> 10/1/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 26, 2021, the Nigerian Communications Commission announced the
                                            discovery of a new malware, dubbed Flubot, targeting Android devices with
                                            fake security updates and application installations. The malware draws fake
                                            web views on infected devices, with the goal of stealing personal data,
                                            particularly credit card details or online banking credentials.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TA5052021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Russian-linked TA505 targets financial institutions with phishing campaign</h2>
                                <span class="frst-date">October 15</span>
                                <p>
                                    On October 15, 2021, researchers discovered that Russian-linked TA505 was targeting
                                    financial institutions globally in a new malware campaign, tracked as MirrorBlast.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Russia
                                            <strong>Date Breach First Reported:</strong> 10/15/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 15, 2021, researchers discovered that Russian-linked TA505 was
                                            targeting financial institutions globally in a new malware campaign, tracked
                                            as MirrorBlast. The infection begins with an email attachment document.
                                            After clicking the URL, targets will be directed to a fake OneDrive site, a
                                            compromised SharePoint, displaying a sign-in requirement to evade sandboxes.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Pichincha2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ecuadorian Pichincha Bank disrupted by cyber attack</h2>
                                <span class="frst-date">October 10</span>
                                <p>
                                    On October 10, 2021, Pichincha Bank in Ecuador was hit by a cyber attack that
                                    disrupted customers' access to bank services, including their online and mobile app
                                    tools.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Ecuador
                                            <strong>Date Breach First Reported:</strong> 10/12/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 10, 2021, Pichincha Bank in Ecuador was hit by a cyber attack
                                            that disrupted customers' access to bank services, including their online
                                            and mobile app tools. The bank stated that they had identified a
                                            cybersecurity incident that had partially disabled their services.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="BrazilianInsurance2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Brazilian insurance giant cyber attack</h2>
                                <span class="frst-date">October 2</span>
                                <p>
                                    On October 2, 2021, Porto Seguro, Brazil's third-largest insurance company, suffered
                                    a cyberattack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil
                                            <strong>Date Breach First Reported:</strong> 10/15/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 2, 2021, Porto Seguro, Brazil's third-largest insurance company,
                                            suffered a cyberattack. The attack resulted in temporary instability to its
                                            service channels and some of its systems. No data leakage has been
                                            identified in relation to the company or its subsidiaries, customers, or
                                            partners, including any personal data.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="OnlineRetailersTrojan2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Online retailers hit by banking trojan</h2>
                                <span class="frst-date">October 1</span>
                                <p>
                                    In late 2021, a long list of brands and online retailers were infected with the
                                    banking Trojan, Ramnit.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple
                                            <strong>Date Breach First Reported:</strong> 1/31/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In late 2021, a long list of brands and online retailers were infected with
                                            the banking Trojan, Ramnit. Ramnit aims to take over targets online accounts
                                            to steal their card payment data and has been detected in use since 2010.
                                            Ramnit was the top active banking Trojan for 2021.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PixStealer2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>PixStealer targets Brazilian banking applications</h2>
                                <span class="frst-date">September 29</span>
                                <p>
                                    On September 29, 2021, researchers from Check Point Research discovered a new wave
                                    of malicious Android applications targeting Brazilian banking applications,
                                    including the Central Bank's Pix payment system.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil
                                            <strong>Date Breach First Reported:</strong> 9/29/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 29, 2021, researchers from Check Point Research discovered a
                                            new wave of malicious Android applications targeting Brazilian banking
                                            applications, including the Central Bank's Pix payment system. One of the
                                            malicious applications contains a never-seen-before functionality which
                                            steals victims' money using Pix transactions, dubbed PixStealer.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="BankingTrojanIndia2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Banking trojan targets Indian Android-based financial customers</h2>
                                <span class="frst-date">September 22</span>
                                <p>
                                    On September 22, 2021, researchers reported that Android phone banking customers in
                                    India were being targeted the Drinik banking trojan malware.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India
                                            <strong>Date Breach First Reported:</strong> 9/22/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 22, 2021, researchers reported that Android phone banking
                                            customers in India were being targeted the Drinik banking trojan malware.
                                            The malware stole users' personal data and funds using phishing techniques.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NZOutages2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>New Zealand banks hit by outages in suspected cyber attack</h2>
                                <span class="frst-date">September 8</span>
                                <p>
                                    On September 8, 2021, the websites of various New Zealand financial institutions and
                                    the national postal service were down due to a suspected cyber attack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> New Zealand, Australia
                                            <strong>Date Breach First Reported:</strong> 9/8/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 8, 2021, the websites of various New Zealand financial
                                            institutions and the national postal service were down due to a suspected
                                            cyber attack. The financial institutions included Australia and New Zealand
                                            Banking Grp Ltd and Kiwibank, with the latter facing challenges into the
                                            next week.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Kaspersky09021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Kaspersky detects fraudulent resources targeting cryptocurrency users</h2>
                                <span class="frst-date">September 1</span>
                                <p>
                                    On September 1, 2021, Kapersky reported that it had detected over 1,500 fraudulent
                                    global resources targeting potential crypto investors/users interested in mining,
                                    and prevented over 70,000 user attempts to visit such sites, since the beginning of
                                    2021.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple
                                            <strong>Date Breach First Reported:</strong> 9/1/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 1, 2021, Kapersky reported that it had detected over 1,500
                                            fraudulent global resources targeting potential crypto investors/users
                                            interested in mining, and prevented over 70,000 user attempts to visit such
                                            sites, since the beginning of 2021.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TaiwaneseDeFi2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Taiwanese DeFi Platform hit by cyber attack</h2>
                                <span class="frst-date">August 30</span>
                                <p>
                                    On August 30, 2021, Cream Finance, a Taiwanese decentralised finance platform, lost
                                    over $29 million in cryptocurrency assets to hackers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Taiwan
                                            <strong>Date Breach First Reported:</strong> 8/30/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 30, 2021, Cream Finance, a Taiwanese decentralised finance
                                            platform, lost over $29 million in cryptocurrency assets to hackers. The
                                            hackers exploited a bug and used a re-entrancy attack to steal AMP tokens
                                            and ETH coins.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FIN8US2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FIN8 targets U.S. financial organizations</h2>
                                <span class="frst-date">August 25</span>
                                <p>
                                    On August 25, 2021, FIN8, the financially motivated cybercriminal gang, backdoored
                                    and breached the network of two unidentified U.S. financial organizations.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>8/25/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 25, 2021, FIN8, the financially motivated cybercriminal gang,
                                            backdoored and breached the network of two unidentified U.S. financial
                                            organizations. The attack was conducted using the new Sardonic malware, an
                                            updated version of the BadHatch backdoor.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="JapanCrypto2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Japanese Crypto Exchange Liquid hit by cyber attack</h2>
                                <span class="frst-date">August 18</span>
                                <p>
                                    On August 18, 2021, Liquid, a Japanese cryptocurrency exchange, was the target in a
                                    cyber attack that resulted in a loss of $97 million worth of digital coins.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Japan<br />
                                            <strong>Date Breach First Reported:</strong> 8/18/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 18, 2021, Liquid, a Japanese cryptocurrency exchange, was the
                                            target in a cyber attack that resulted in a loss of $97 million worth of
                                            digital coins. According to researchers, $45 million were in ethereum
                                            tokens, which were converted to ether, to prevent the assets from being
                                            frozen.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="NigerianFraudster2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Nigerian fraudster reveals bank theft methods</h2>
                                <span class="frst-date">August 16</span>
                                <p>
                                    On August 16, 2021, Nigerian police arrested a suspected fraudster, who revealed
                                    that the country's Access Bank and First Bank were the easiest banks to hack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Nigeria<br />
                                            <strong>Date Breach First Reported:</strong>8/16/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 16, 2021, Nigerian police arrested a suspected fraudster, who
                                            revealed that the country's Access Bank and First Bank were the easiest
                                            banks to hack. The fraudster further disclosed how his gang emptied the bank
                                            accounts of Nigerians using missing or stolen SIM cards.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BrazilianNT2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Brazilian National Treasury ransomware</h2>
                                <span class="frst-date">August 13</span>
                                <p>On August 13, 2021, Brazil's National Treasury was hit by a ransomware attack.</p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil<br />
                                            <strong>Date Breach First Reported:</strong>8/15/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 13, 2021, Brazil's National Treasury was hit by a ransomware
                                            attack. Assessments found there was no damage to the structuring systems of
                                            the National Treasury or to programs that enable the purchase of Brazilian
                                            government bonds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PolyNetwork2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Poly Network temporary theft</h2>
                                <span class="frst-date">August 10</span>
                                <p>
                                    On August 10, 2021, Poly Network, a Chinese blockchain site, lost $600 million after
                                    hackers exploited a vulnerability in their system to steal thousands of digital
                                    tokens.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> China<br />
                                            <strong>Date Breach First Reported:</strong>8/11/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 10, 2021, Poly Network, a Chinese blockchain site, lost $600
                                            million after hackers exploited a vulnerability in their system to steal
                                            thousands of digital tokens. While dubbed one of the largest cryptocurrency
                                            heists ever, the hackers subsequently returned all of the funds stolen in
                                            the hack
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Oscorp2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Oscorp malware returns as an Android botnet</h2>
                                <span class="frst-date">July 27</span>
                                <p>
                                    On July 27, 2021, Cleafy researchers reported that users of banking applications in
                                    Spain, Poland, Germany, Turkey, the United States, Japan, Italy, Australia, France,
                                    and India were being targeted by a botnet campaign dubbed UBEL.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Spain, Poland, Germany, Turkey, United States,
                                            Japan, Italy, Australia, France, India<br />
                                            <strong>Date Breach First Reported:</strong>7/27/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 27, 2021, Cleafy researchers reported that users of banking
                                            applications in Spain, Poland, Germany, Turkey, the United States, Japan,
                                            Italy, Australia, France, and India were being targeted by a botnet campaign
                                            dubbed UBEL. UBEL can gain access to sensitive information and exfiltrate it
                                            back to a remote server, hiding its presence and achieving persistence. The
                                            campaign relied on a botnet created from the Android malware Oscorp. The
                                            malware was previously observed abusing accessibility services to hijack
                                            user credentials from European banking applications.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BackNine2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BackNine data breach</h2>
                                <span class="frst-date">July 16</span>
                                <p>
                                    On July 16, 2021, BackNine, an insurance tech start-up, exposed thousands of
                                    sensitive insurance applications in a data breach.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>7/16/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 16, 2021, BackNine, an insurance tech start-up, exposed thousands of
                                            sensitive insurance applications in a data breach. One of BackNine’s storage
                                            servers, hosted on Amazon’s cloud, was misconfigured to allow anyone access
                                            to the 711,000 files inside, including completed insurance applications that
                                            contain highly sensitive personal and medical information on the applicant
                                            and their family.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FBIWarning72021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FBI warns of ongoing attacks on virtual assets</h2>
                                <span class="frst-date">July 9</span>
                                <p>
                                    On July 9, 2021, the FBI warned cryptocurrency owners, exchanges, and third-party
                                    payment platforms of threat actors actively targeting virtual assets.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>7/9/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 9, 2021, the FBI warned cryptocurrency owners, exchanges, and
                                            third-party payment platforms of threat actors actively targeting virtual
                                            assets. According to the FBI, attackers are using several tactics to steal
                                            and launder cryptocurrency, including technical support fraud, SIM swapping
                                            (aka SIM hijacking), and taking control of their targets' cryptocurrency
                                            exchange accounts via identity theft or account takeovers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="MorganStanleyAccellion2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Morgan Stanley targeted in Accellion hack</h2>
                                <span class="frst-date">July 8</span>
                                <p>
                                    On July 10, 2021, Morgan Stanley, the American investment banking giant, reported a
                                    data breach tied to zero-day attacks on Accellion's legacy File Transfer Appliance.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>7/10/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 10, 2021, Morgan Stanley, the American investment banking giant,
                                            reported a data breach tied to zero-day attacks on Accellion's legacy File
                                            Transfer Appliance. Attackers stole personal information belonging to its
                                            customers by hacking into the Accellion FTA server of its third-party
                                            vendor, Guidehouse.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Bit2check2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bit2check identified in card skimming ecosystem</h2>
                                <span class="frst-date">June 16</span>
                                <p>
                                    On June 16, 2021, researchers at RiskIQ discovered that a Google IP address briefly
                                    hosted a malicious card skimmer domains.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>6/16/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 16, 2021, researchers at RiskIQ discovered that a Google IP address
                                            briefly hosted a malicious card skimmer domains. This IP then hosted a
                                            domain offering a helpful service for card skimmers (bit2check), allowing
                                            them to authenticate stolen payment data for a fee. Researchers found that
                                            the individual behind bit2check is a Kurdish actor calling themself Hama.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="IntuitTurbotax2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Intuit discloses TurboTax data breach</h2>
                                <span class="frst-date">June 12</span>
                                <p>
                                    On June 12, 2021, Intuit, an American financial software company, notified TurboTax
                                    customers that some of their personal and financial data has been compromised in
                                    account takeover attacks.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>6/12/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Credential Stuffing <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 12, 2021, Intuit, an American financial software company, notified
                                            TurboTax customers that some of their personal and financial data has been
                                            compromised in account takeover attacks. Criminals gained access to victims'
                                            account using credentials stolen from previously breached online services.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="GermanBanksDDOS2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>German banks hit by DDoS attack on IT provider</h2>
                                <span class="frst-date">June 4</span>
                                <p>
                                    On June 4, 2021, Fiducia &amp; GAD IT, a German company that operates technology on
                                    the nation's cooperative banks, was hit by a DDoS attack, disrupting more than 800
                                    financial institutions in the country.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Germany <br />
                                            <strong>Date Breach First Reported:</strong>6/4/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 4, 2021, Fiducia &amp; GAD IT, a German company that operates
                                            technology on the nation's cooperative banks, was hit by a DDoS attack,
                                            disrupting more than 800 financial institutions in the country.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="UKInsurer2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>UK Insurer Recovers from Ransomware Attack</h2>
                                <span class="frst-date">May 25</span>
                                <p>
                                    On May 25, 2021, UK-based insurance firm One Call stated that it had successfully
                                    restored its systems onto a new environment separate from the one that was impacted
                                    by a ransomware attack on May 13, adding that a ransomware note purportedly from
                                    DarkSide could not be verified as authentic.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom <br />
                                            <strong>Date Breach First Reported:</strong>5/25/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 25, 2021, UK-based insurance firm One Call stated that it had
                                            successfully restored its systems onto a new environment separate from the
                                            one that was impacted by a ransomware attack on May 13, adding that a
                                            ransomware note purportedly from DarkSide could not be verified as
                                            authentic.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="SmallBanksRansomware2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Small Banks Face Ransomware Attacks</h2>
                                <span class="frst-date">May 24</span>
                                <p>
                                    On May 24, 2021, two ransomware groups, DarkSide and Ragnar Locker, demanded ransom
                                    from three small banks after posting evidence of stolen customer data belonging to
                                    the banks.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>5/24/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 24, 2021, two ransomware groups, DarkSide and Ragnar Locker, demanded
                                            ransom from three small banks after posting evidence of stolen customer data
                                            belonging to the banks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ChasePhishing2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Chase Bank phishing attacks</h2>
                                <span class="frst-date">May 15</span>
                                <p>
                                    From May to August 2021, researchers from Cyren reported a 300% increase in phishing
                                    attacks targeting Chase Bank.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>10/5/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            From May to August 2021, researchers from Cyren reported a 300% increase in
                                            phishing attacks targeting Chase Bank. The XBALTI phishing kits were
                                            designed to mimic the Chase banking portal. Researchers stated that the
                                            phishing kits were highly sophisticated and designed to harvest more than
                                            just email addresses and passwords, including banking and credit card
                                            information, social security numbers, and home addresses.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="AXA2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>AXA hit by ransomware</h2>
                                <span class="frst-date">May 15</span>
                                <p>
                                    On May 16, 2021, French insurer Axa said that its branches in Thailand, Malaysia,
                                    Hong Kong and the Philippines had been struck by a ransomware attack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A <br />
                                            <strong>Date Breach First Reported:</strong>5/16/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Known
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 16, 2021, French insurer Axa said that its branches in Thailand,
                                            Malaysia, Hong Kong and the Philippines had been struck by a ransomware
                                            attack. A day before, the Avaddon ransomware group claimed to have stolen 3
                                            TB of sensitive data from AXA's Asian operations and initiated DDoS attacks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CounterfeitApps2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Finance Related Counterfeit Android and iOS Apps Identified</h2>
                                <span class="frst-date">May 12</span>
                                <p>
                                    On May 12, 2021, Sophos, a cybersecurity firm, identified 167 fake Android and iOS
                                    financial trading, banking, and cryptocurrency apps being used by hackers to steal
                                    money.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A <br />
                                            <strong>Date Breach First Reported:</strong>5/12/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 12, 2021, Sophos, a cybersecurity firm, identified 167 fake Android
                                            and iOS financial trading, banking, and cryptocurrency apps being used by
                                            hackers to steal money. The attackers used social engineering techniques,
                                            counterfeit websites including a fake iOS App Store download page, and an
                                            iOS app-testing website to distribute the fake apps to unsuspecting users.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="LazarusGroup2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Lazarus Group Behind CryptoCore Heists</h2>
                                <span class="frst-date">May 1</span>
                                <p>
                                    On May 24, 2021, researchers from ClearSky determined that the North Korean
                                    state-sponsored group Lazarus was behind multiple attacks on cryptocurrency
                                    exchanges, previously attributed to a threat actor they named CryptoCore.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States, Israel, Japan <br />
                                            <strong>Date Breach First Reported:</strong>5/24/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 24, 2021, researchers from ClearSky determined that the North Korean
                                            state-sponsored group Lazarus was behind multiple attacks on cryptocurrency
                                            exchanges, previously attributed to a threat actor they named CryptoCore.
                                            The group is believed to have stolen hundreds of millions of U.S. dollars by
                                            breaching cryptocurrency exchanges in the U.S., Israel, Europe, and Japan
                                            over the past three years.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BizarroEU2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bizarro Expands To Europe</h2>
                                <span class="frst-date">May 1</span>
                                <p>
                                    On May 17, 2021, a cybersecurity firm uncovered a new banking trojan family dubbed
                                    "Bizarro" that rampantly scaled up its operations from Brazil to Europe.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A <br />
                                            <strong>Date Breach First Reported:</strong>5/17/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 17, 2021, a cybersecurity firm uncovered a new banking trojan family
                                            dubbed "Bizarro" that rampantly scaled up its operations from Brazil to
                                            Europe. These trojans have been used to try and steal credentials from
                                            customers of 70 banks from different European and South American countries.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Upstox2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Upstox Suffers Ransomware Attack</h2>
                                <span class="frst-date">April 11</span>
                                <p>
                                    On April 11, 2021, stockmarket broker Upstox announced a data breach that
                                    compromised contact data and KYC details of its users from third-party
                                    data-warehouse systems.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India <br />
                                            <strong>Date Breach First Reported:</strong>4/11/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 11, 2021, stockmarket broker Upstox announced a data breach that
                                            compromised contact data and KYC details of its users from third-party
                                            data-warehouse systems. Hackers apparently demanded a ransom of $1.2 million
                                            in order to not go public with the data.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SADebt2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South African debt collector ransomware attack</h2>
                                <span class="frst-date">April 1</span>
                                <p>
                                    On September 22, 2021, Debt-IN Consultants, a South African debt collector, was hit
                                    by a major ransomware attack, resulting in a significant data breach of consumer and
                                    employee personal information.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa <br />
                                            <strong>Date Breach First Reported:</strong>9/22/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 22, 2021, Debt-IN Consultants, a South African debt collector,
                                            was hit by a major ransomware attack, resulting in a significant data breach
                                            of consumer and employee personal information. The data of more than 1.4
                                            million South Africans was illegally accessed from the company’s servers,
                                            with confidential consumer data and voice recordings of calls between
                                            Debt-IN debt recovery agents and financial services customers posted on the
                                            dark web.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="USCNA021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>US Insurance Firm CNA Hit by Cyberattack</h2>
                                <span class="frst-date">March 21</span>
                                <p>
                                    On March 21, 2021, CNA Financial suffered a ransomware attack which disrupted the
                                    company’s employee and customer services for three days.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>3/23/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 21, 2021, CNA Financial suffered a ransomware attack which
                                            disrupted the company’s employee and customer services for three days. The
                                            insurance company engaged third-party forensic experts and also alerted law
                                            enforcement to begin further investigations. CNA later revealed that over
                                            75,000 people's personal data was exposed during the attack. Subsequent
                                            reporting revealed the firm paid $40 million in ransom.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Swarmshop2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Cybercrime Forum Swarmshop Database Leaked</h2>
                                <span class="frst-date">March 17</span>
                                <p>
                                    On March 17, 2021, the database of the card shop Swarmshop was leaked on a rival
                                    underground forum.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A <br />
                                            <strong>Date Breach First Reported:</strong>4/8/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 17, 2021, the database of the card shop Swarmshop was leaked on a
                                            rival underground forum. The compromised data contained 623,036 payment-card
                                            records, 498 sets of online banking account credentials, 69,592 sets of
                                            American Social Security Numbers and Canadian Social Insurance Numbers, and
                                            12,344 records of user data. The leak was discovered on April 8, 2021 by a
                                            computer intelligence firm.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FTCPhishingMar2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FTC Warns Of New Phishing Email Scam</h2>
                                <span class="frst-date">March 17</span>
                                <p>
                                    On March 17, 2021, the Federal Trade Commission (FTC) issued an alert warning
                                    individuals of an e-mail scam about COVID-19 stimulus payments.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>3/17/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 17, 2021, the Federal Trade Commission (FTC) issued an alert
                                            warning individuals of an e-mail scam about COVID-19 stimulus payments. The
                                            new scam emails appear to be from acting FTC Chairwoman Rebecca Slaughter.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="FBI4BilCybercrime2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FBI Attributes Loss of $4 billion to Cybercrime</h2>
                                <span class="frst-date">March 17</span>
                                <p>
                                    On March 17, 2021, the FBI released its Internet Crime Report 2020 which stated that
                                    American victims reported $4.2 billion in losses as a result of cybercrime and
                                    internet fraud to the FBI last year.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States, Canada, South Africa, Panama,
                                            Italy<br />
                                            <strong>Date Breach First Reported:</strong>3/17/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 17, 2021, the FBI released its Internet Crime Report 2020 which
                                            stated that American victims reported $4.2 billion in losses as a result of
                                            cybercrime and internet fraud to the FBI last year. The FBI’s Internet Crime
                                            Complaint Center claimed that it received an average of more than 2,000
                                            complaints per day through 2020. Losses of $1.8 billion, $29.1 million, and
                                            $146 million were suffered due to BEC scams, ransomware attacks, and
                                            technology support scams respectively in the United States.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="GooglePlayFraud2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>New Billing Fraud Apps Found On Google Play Store</h2>
                                <span class="frst-date">March 12</span>
                                <p>
                                    On April 19, 2021, a cybersecurity firm reported a new set of fraudulent Android
                                    apps in the Google Play store, primarily targeting users in Southwest Asia and the
                                    Arabian Peninsula.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>4/19/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 19, 2021, a cybersecurity firm reported a new set of fraudulent
                                            Android apps in the Google Play store, primarily targeting users in
                                            Southwest Asia and the Arabian Peninsula. The apps, suspected to belong to
                                            the "Joker" malware, work by hijacking SMS message notifications to carry
                                            out billing fraud. More than 700,000 downloads were recorded before the apps
                                            were removed from the platform.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FIN8BadHatch2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FIN8 Releases New Variant of BADHATCH kit</h2>
                                <span class="frst-date">March 10</span>
                                <p>
                                    On March 10, 2021, Bitdefender reported re-emergence of the threat actor FIN 8 in
                                    2020 and the subsequent updated versions of its point-of-sale malware, BadHatch.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States, Canada, South Africa, Panama,
                                            Italy<br />
                                            <strong>Date Breach First Reported:</strong>3/10/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 10, 2021, Bitdefender reported re-emergence of the threat actor FIN
                                            8 in 2020 and the subsequent updated versions of its point-of-sale malware,
                                            BadHatch. FIN8 has been using new versions of BadHatch backdoor to
                                            compromise companies in chemical insurance, retail, and technology in the
                                            United States, Canada, South Africa, Panama, and Italy.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FinraScam2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FINRA Sends Scam Alert To Brokerage Industry</h2>
                                <span class="frst-date">March 4</span>
                                <p>
                                    On March 04, 2021, the Financial Industry Regulatory Authority (FINRA) warned member
                                    firms of an ongoing phishing campaign involving emails sent by impersonators.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>3/4/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 04, 2021, the Financial Industry Regulatory Authority (FINRA)
                                            warned member firms of an ongoing phishing campaign involving emails sent by
                                            impersonators. The emails urged recipients to respond to a non-compliance
                                            issue by opening a corrupt link or document.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="WallStreetCapitalCall2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Wall Street Targeted In New Capital Call Fraud Scheme</h2>
                                <span class="frst-date">March 3</span>
                                <p>
                                    On March 3, 2021, a cybersecurity firm reported Capital Call Investment scams as the
                                    latest threat vector used to swindle exorbitant amount of money from Wall Street
                                    firms and their clients.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>3/3/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 3, 2021, a cybersecurity firm reported Capital Call Investment
                                            scams as the latest threat vector used to swindle exorbitant amount of money
                                            from Wall Street firms and their clients. Scammers have been impersonating
                                            investment firms to seek funds for investment commitments.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PloutusVariant2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ploutus Variant Targets ATMs in Latin America</h2>
                                <span class="frst-date">March 2</span>
                                <p>
                                    On March 02, 2021, a cybersecurity firm disclosed a new variant of the malware
                                    Ploutus which has been targeting ageing ATM devices produced by Itautec.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>3/2/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 02, 2021, a cybersecurity firm disclosed a new variant of the
                                            malware Ploutus which has been targeting ageing ATM devices produced by
                                            Itautec. Ploutus-I operates by communicating directly with XFS to command
                                            the ATMs to disgorge cash.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CNAFinancial2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>CNA reports data breach after ransomware attack</h2>
                                <span class="frst-date">March 1</span>
                                <p>
                                    On July 9, 2021, CNA Financial Corporation, a leading US-based insurance company,
                                    notified customers of a data breach following a March 2021 ransomware attack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong> 7/9/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 9, 2021, CNA Financial Corporation, a leading US-based insurance
                                            company, notified customers of a data breach following a March 2021
                                            ransomware attack. Over 75,000 individuals are estimated to be affected.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SequoiaCapital2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Sequoia Capital Discloses Data Breach</h2>
                                <span class="frst-date">February 19</span>
                                <p>
                                    On February 19, 2021, Sequoia Capital informed its investors of a data breach
                                    jeopardizing some of their personal and financial information.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>2/20/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 19, 2021, Sequoia Capital informed its investors of a data
                                            breach jeopardizing some of their personal and financial information. The
                                            company claimed to have been a victim of a phishing attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="IndictNKCybercriminals2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>US Indicts Three North Korean Cybercriminals</h2>
                                <span class="frst-date">February 17</span>
                                <p>
                                    On February 17, 2021, a federal indictment charged three North Korean computer
                                    programmers with participating in a wide-ranging criminal conspiracy including
                                    conducting a series of destructive cyberattacks, stealing and extorting more than
                                    $1.3 billion of money and cryptocurrency from financial institutions and companies,
                                    creating and deploying multiple malicious cryptocurrency applications, and
                                    developing and fraudulently marketing a blockchain platform.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> North Korea <br />
                                            <strong>Date Breach First Reported:</strong> 2/17/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 17, 2021, a federal indictment charged three North Korean
                                            computer programmers with participating in a wide-ranging criminal
                                            conspiracy including conducting a series of destructive cyberattacks,
                                            stealing and extorting more than $1.3 billion of money and cryptocurrency
                                            from financial institutions and companies, creating and deploying multiple
                                            malicious cryptocurrency applications, and developing and fraudulently
                                            marketing a blockchain platform. The suspects were believed to have been
                                            working for the North Korean military and were linked to the prolific North
                                            Korean threat group Lazarus. The trio are thought to be behind cyberattacks
                                            beginning as early as November 2014 targeting the media industry.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NYCovid2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>New York State Warns Against COVID-19 Relief Fund Targeting</h2>
                                <span class="frst-date">February 16</span>
                                <p>
                                    On February 16, 2021, the New York State Department of Financial Services (DFS)
                                    alerted all its regulated entities of a cybercampaign stealing customer’s personal
                                    information from public-facing websites.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>2/16/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 16, 2021, the New York State Department of Financial Services
                                            (DFS) alerted all its regulated entities of a cybercampaign stealing
                                            customer’s personal information from public-facing websites. The criminals
                                            are suspected of using the stolen data to illegally access pandemic and
                                            unemployment benefits.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="IRSPhishing2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>IRS Warns of Phishing Attacks</h2>
                                <span class="frst-date">February 10</span>
                                <p>
                                    On February 10, 2021, the Internal Revenue Service (IRS) warned US tax professionals
                                    of a phishing scam attempting to steal the tax preparer’s identity.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>2/10/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 10, 2021, the Internal Revenue Service (IRS) warned US tax
                                            professionals of a phishing scam attempting to steal the tax preparer’s
                                            identity. The scammers have been impersonating the IRS to trick tax
                                            preparers to disclose sensitive information that would allow them to file
                                            fraudulent tax returns.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CubaRansomware2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Cuba Ransomware Attacks Payment Processors</h2>
                                <span class="frst-date">February 3</span>
                                <p>
                                    On February 3, 2021, Automatic Funds Transfer Services, a payment processor,
                                    suffered a ransomware attack by a group called Cuba Ransomware.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>2/18/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 3, 2021, Automatic Funds Transfer Services, a payment processor,
                                            suffered a ransomware attack by a group called Cuba Ransomware. The group
                                            claimed to have stolen sensitive information including financial documents,
                                            correspondences with bank employees, account movements, balance sheets, and
                                            tax documents. The attack sparked data breach notifications from numerous US
                                            state agencies.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TruistBankSpear2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Spear-Phishing Campaign Impersonates Financial Insitutions</h2>
                                <span class="frst-date">February 1</span>
                                <p>
                                    On May 12, 2021 the FBI warned of a spear-phishing campaign impersonating Truist
                                    Bank, in an attempt to get recipients to download a fake Windows application.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States <br />
                                            <strong>Date Breach First Reported:</strong>5/12/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 12, 2021 the FBI warned of a spear-phishing campaign impersonating
                                            Truist Bank, in an attempt to get recipients to download a fake Windows
                                            application. Other U.S. and UK financial institutions have also been
                                            impersonated in the campaign, spoofing these institutions through registered
                                            domains, email subjects, and applications.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FIN72021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FIN7 Backdoor Masquerades as Ethical Hacking Tool</h2>
                                <span class="frst-date">February 1</span>
                                <p>
                                    On May 13, 2021, a cybersecurity firm discovered a new backdoor malware called Lizar
                                    being employed by the FIN7 cybercrime gang.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong> 5/13/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Known
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 13, 2021, a cybersecurity firm discovered a new backdoor malware
                                            called Lizar being employed by the FIN7 cybercrime gang. The group has been
                                            impersonating a legitimate cybersecurity company to distribute Lizar as a
                                            penetration testing tool for Windows networks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NZBankData2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Reserve Bank of New Zealand Data Breach</h2>
                                <span class="frst-date">January 10</span>
                                <p>
                                    The Reserve Bank of New Zealand suffered a data breach after actors illegally
                                    accessed its information through one of the bank's third-party file sharing
                                    services.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> New Zealand<br />
                                            <strong>Date Breach First Reported:</strong>1/10/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data Breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            The Reserve Bank of New Zealand suffered a data breach after actors
                                            illegally accessed its information through one of the bank's third-party
                                            file sharing services. The Bank is now actively seeking a new platform to
                                            replace the previously compromised file sharing service.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="MicrosoftExchangeServers2021"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Microsoft Exchange Servers Breach</h2>
                                <span class="frst-date">January 6</span>
                                <p>
                                    Claiming over 30,000 victims within the US, the large-scale cyberattack on Microsoft
                                    Exchange servers was first discovered by a security testing firm on January 6, 2021.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>1/6/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> Data Breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Claiming over 30,000 victims within the United States, the large-scale
                                            cyberattack on Microsoft Exchange servers was first discovered by a security
                                            testing firm on January 6, 2021. The hackers dubbed Hafnium exploited four
                                            zero-day vulnerabilities in the servers to claim hundreds of thousands of
                                            victims globally including the European Banking Authority and Chile's
                                            Comisión para el Mercado Financiero. On March 5 2021, Microsoft released
                                            security updates to patch the vulnerabilities which prompted the hackers to
                                            hasten their operation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="AmericanExpress2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>American Express Leak</h2>
                                <span class="frst-date">January 5</span>
                                <p>
                                    A hacker posted data of 10,000 Mexico-based American Express card users on a forum
                                    for free.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Mexico<br />
                                            <strong>Date Breach First Reported:</strong>1/5/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data Breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            A hacker posted data of 10,000 Mexico-based American Express card users on a
                                            forum for free. Information included full credit card numbers and personal
                                            information such as emails and addresses, but did not contain passwords or
                                            expiration dates. In the forum post, the hacker also claimed to have more
                                            data information from Mexican bank customers of Santander, American Express,
                                            and Banamex.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RockeGroup2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Rocke Group Targets Apache, Oracle, and Redis web servers</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    Chinese cybercrime group Rocke released an improved version of its cryptojacking
                                    malware Pro-Ocean targeting cloud applications with the goal of mining Monero, a
                                    decentralized cryptocurrency.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>1/27/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Chinese cybercrime group Rocke released an improved version of its
                                            cryptojacking malware Pro-Ocean targeting cloud applications with the goal
                                            of mining Monero, a decentralized cryptocurrency. The latest variant comes
                                            with better worm and rootkit capabilities and has been leveraging known
                                            vulnerabilities to target Apache ActiveMQ, Oracle WebLogic, and Redis.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PayPalSMS2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>PayPal SMS Phishing Scheme</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    A new SMS-based phishing scheme has been targeting PayPal in an attempt to gain
                                    access to accounts.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>1/4/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            A new SMS-based phishing scheme has been targeting PayPal in an attempt to
                                            gain access to accounts. The messages impersonate the payment processor,
                                            warning users that their accounts have been limited and that they need to
                                            verify their identities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TeaBot2021">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>New Android Malware TeaBot Targets European Banks</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    At the beginning of January 2021, a cybersecurity firm discovered a new Android
                                    banking trojan dubbed as TeaBot.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>05/10/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            At the beginning of January 2021, a cybersecurity firm discovered a new
                                            Android banking trojan dubbed as TeaBot. The malware aims to steal victim’s
                                            credentials and SMS messages to carry out fraudulent transactions against a
                                            predefined list of banks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2020</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="IndianChqbook2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Indian Fintech Chqbook Suffers Breach</h2>
                                <span class="frst-date">December 25</span>
                                <p>
                                    Two million credit score records from Chqbook, an Indian FinTech startup, were found
                                    on the dark web.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong>1/27/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data Breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Two million credit score records from Chqbook, an Indian FinTech startup,
                                            were found on the dark web. The leaked data contained users’ names, contact
                                            details, and loan detail information. The hacking group ShinyHunters was
                                            believed to have been responsible for the leak.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ScottishEPA2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Hackers Leak Data from Scottish Environmental Protection Agency</h2>
                                <span class="frst-date">December 24</span>
                                <p>
                                    On January 22, hackers published over 4,000 documents from the Scottish
                                    Environmental Protection Agency (SEPA) after the organization refused to pay a
                                    ransom.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>1/22/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 22, hackers published over 4,000 documents from the Scottish
                                            Environmental Protection Agency (SEPA) after the organization refused to pay
                                            a ransom. SEPA fell victim to a hack on December 24, where around 1.2GB of
                                            data was stolen from its servers. However, the agency has refused to
                                            entertain ransom demands.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Accellion2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Accellion Data Breach</h2>
                                <span class="frst-date">December 16</span>
                                <p>
                                    Starting in mid-December 2020, cybercriminal groups linked to FIN11 and the Clop
                                    group began exploiting multiple zero-day vulnerabilities in Accellion's legacy File
                                    Transfer Appliance.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Australia, New Zealand, United States<br />
                                            <strong>Date Breach First Reported:</strong>12/20/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Known
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Starting in mid-December 2020, cybercriminal groups linked to FIN11 and the
                                            Clop group began exploiting multiple zero-day vulnerabilities in Accellion's
                                            legacy File Transfer Appliance. Globally, around 100 Accellion customers
                                            using the software were targeted including the Australian Securities and
                                            Investment Commission (ASIC), Michigan FlagStar bank, and New Zealand’s
                                            central bank.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FBIThirdParty2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FBI Warns of Third-Party Service Attacks</h2>
                                <span class="frst-date">December 8</span>
                                <p>
                                    On December 8, FBI Director Christopher Wray warned banks to be wary of "cyber
                                    criminals targeting the vulnerabilities in third-party services” as a way in to
                                    financial institution data.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>12/8/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 8, FBI Director Christopher Wray warned banks to be wary of
                                            "cyber criminals targeting the vulnerabilities in third-party services” as a
                                            way in to financial institution data. Wray issued this warning at a
                                            conference on financial crimes enforcement.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MobileSpoofing2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Mobile Spoofing Enables Massive Bank Theft</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    Researchers from IBM Trusteer discovered that criminals had been using mobile device
                                    emulators to steal millions from European and American banks.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>12/16/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Researchers from IBM Trusteer discovered that criminals had been using
                                            mobile device emulators to steal millions from European and American banks.
                                            The hackers used around 20 emulators to spoof more than 16,000 phones belong
                                            to customers with compromised accounts. By entering usernames and passwords
                                            through these emulators, hackers were able to initiate fraudulent money
                                            orders and siphon money from mobile accounts.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Shirbit2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Shirbit Ransomware Attack</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    Shirbit, an Israeli-based insurance company, was hit by a ransomware attack that
                                    appears to be the work of the hacker group BlackShadow.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Israel<br />
                                            <strong>Date Breach First Reported:</strong>12/4/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Shirbit, an Israeli-based insurance company, was hit by a ransomware attack
                                            that appears to be the work of the hacker group BlackShadow. The group
                                            demanded 50 bitcoin at first, gradually increasing its demands to 200
                                            bitcoin. Although BlackShadow released several rounds of sensitive data,
                                            Shirbit refused to pay the ransom.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="SouthAfricanBankBreach2020"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South African Bank Breach</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    On December 3, Absa, a South African bank, confirmed that an employee working as a
                                    credit analyst sold the personal information of some 200,000 customers to third
                                    parties.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>12/3/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Insider Threat <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 3, Absa, a South African bank, confirmed that an employee
                                            working as a credit analyst sold the personal information of some 200,000
                                            customers to third parties.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Classiscam2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Scam-as-a-Service Operator Classiscam Steals Over $6.5M From Users</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    In 2020, a Russian-based cybercrime operation, known as "Classiscam," helped
                                    classified ad scammers steal more than $6.5M from users in Europe and the United
                                    States.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>1/14/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In 2020, a Russian-based cybercrime operation, known as "Classiscam," helped
                                            classified ad scammers steal more than $6.5M from users in Europe and the
                                            United States. Scammers expanded operations by employing native speakers to
                                            lure potential buyers into conversations on WhatsApp and other messaging
                                            platforms.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ElectroRAT2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>ElectroRAT Campaign Targets Cryptocurrency Users</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    A new remote access tool (RAT) has become prevalent in a new campaign against
                                    cryptocurrency users.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>12/1/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            A new remote access tool (RAT) has become prevalent in a new campaign
                                            against cryptocurrency users. Dubbed "ElectroRAT," the new tool is written
                                            in the Go programming language and appears to target a variety of operating
                                            systems, including Windows, MacOS, and Linux. Security researchers believe
                                            that the RAT has been in use for at least a year.//frst-timeline-block
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="DenmarkBank2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Denmark’s central bank exposed in SolarWinds hack</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    On June 29, 2021, Denmark’s central bank disclosed that it was compromised in the
                                    2020 global SolarWinds hacking operation.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Denmark<br />
                                            <strong>Date Breach First Reported:</strong>6/29/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 29, 2021, Denmark’s central bank disclosed that it was compromised
                                            in the 2020 global SolarWinds hacking operation. While a backdoor to its
                                            network was open for seven months, the bank said there's been no evidence of
                                            compromise beyond the first stage of attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SolarWindsUS2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>SolarWinds Puts U.S. Banks on High Alert</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    Earlier in 2020, hackers broke into SolarWinds' "Orion" system, an IT-management
                                    instrument used by multiple U.S. government agencies and many major companies.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>12/13/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Espionage
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Earlier in 2020, hackers broke into SolarWinds' "Orion" system, an
                                            IT-management instrument used by multiple U.S. government agencies and many
                                            major companies. The hack appears to be the work of state-sponsored actors
                                            operating out of Russia. Although no initial reports indicated that major
                                            U.S. banks were targets, FS-ISAC has been partnering with Wall Street to
                                            offer strategic risk mitigation strategies.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="SouthKoreaSupply2020"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South Korean Supply Chain Attack</h2>
                                <span class="frst-date"> November 16</span>
                                <p>
                                    On November 16, security researchers discovered that a widespread security
                                    application used by South Korean banks and government agencies had been compromised
                                    through a novel supply-chain attack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>11/16/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 16, security researchers discovered that a widespread security
                                            application used by South Korean banks and government agencies had been
                                            compromised through a novel supply-chain attack. The attack compromised the
                                            digital security certificates of two firms, corrupting browser software and
                                            enabling the spread of trojan malware. The Lazarus Group is thought to be
                                            behind the attacks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="AustralianStockExchange2020"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Australian Stock Exchange Software Glitch</h2>
                                <span class="frst-date"> November 16</span>
                                <p>
                                    On Monday, November 16, Australia's stock exchange halted trading 20 minutes after
                                    opening due to a software issue that caused inaccurate market data.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Australia<br />
                                            <strong>Date Breach First Reported:</strong>11/16/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On Monday, November 16, Australia's stock exchange halted trading 20 minutes
                                            after opening due to a software issue that caused inaccurate market data.
                                            The problem was remedied overnight and the exchange reopened on Tuesday.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="GoDaddyScam2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>GoDaddy Scam on Cryptocurrency Trading Platforms</h2>
                                <span class="frst-date"> November 15</span>
                                <p>
                                    Over the course of the week of November 15, fraudsters scammed employees at GoDaddy,
                                    the world's largest domain name registrar, into transferring ownership and/or
                                    control of targeted domains to unauthorized users.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>11/20/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Over the course of the week of November 15, fraudsters scammed employees at
                                            GoDaddy, the world's largest domain name registrar, into transferring
                                            ownership and/or control of targeted domains to unauthorized users. Then,
                                            these scammers were able to redirect email and web traffic destined for
                                            several crytocurrency trading platforms.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Ghimob2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ghimob Banking Malware Spreads</h2>
                                <span class="frst-date"> November 9</span>
                                <p>
                                    Ghimob, a banking malware originating from Brazil, has recently begun spreading
                                    globally.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil<br />
                                            <strong>Date Breach First Reported:</strong>11/9/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Ghimob, a banking malware originating from Brazil, has recently begun
                                            spreading globally. The malware is a fully featured trojan that allows
                                            hackers to access the infected device remotely and complete the fraudulent
                                            transaction with the victim's smartphone, thereby avoiding anti-fraud
                                            behavioral systems run by financail institutions.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="GermanGootkit2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>German Users Targeted by Gootkit Resurgence</h2>
                                <span class="frst-date"> November 1</span>
                                <p>
                                    On November 23, security researchers became aware of a resurgence in Gootkit
                                    infections in Germany.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Germany<br />
                                            <strong>Date Breach First Reported:</strong>11/23/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 23, security researchers became aware of a resurgence in Gootkit
                                            infections in Germany. Gootkit is a capable banking trojan designed to steal
                                            financially-related information. In this latest campaign, attackers used
                                            compromised websites to trick users into downloading malicious files.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="IndonesianFintech2020"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Indonesian Fintech Data Breach</h2>
                                <span class="frst-date">October 31</span>
                                <p>
                                    On October 31, Indonesian fintech company Cermati reported 2.9 million users'
                                    information was leaked and sold in a hacker forum.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Indonesia<br />
                                            <strong>Date Breach First Reported:</strong>10/31/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data Breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 31, Indonesian fintech company Cermati reported 2.9 million
                                            users' information was leaked and sold in a hacker forum. User information
                                            included full names, email addresses, physical addresses, phone numbers,
                                            bank accounts, and tax and national ID numbers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ECBGlitch2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>European Central Bank Technical Glitch</h2>
                                <span class="frst-date">October 23</span>
                                <p>
                                    On October 23, a software defect led to a disruption to the European Central Bank’s
                                    main payment system for almost 11 hours.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Germany<br />
                                            <strong>Date Breach First Reported:</strong>10/28/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 23, a software defect led to a disruption to the European Central
                                            Bank’s main payment system for almost 11 hours. The disruption affected
                                            ECB's Target2 critical function.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Vizom2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Vizom Banking Malware</h2>
                                <span class="frst-date">October 19</span>
                                <p>
                                    On October 19, 2020, researchers from IBM uncovered a new form of malware using
                                    remote overlay attacks to strike Brazilian bank account holders, which has been
                                    dubbed Vizom.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil<br />
                                            <strong>Date Breach First Reported:</strong>10/19/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 19, 2020, researchers from IBM uncovered a new form of malware
                                            using remote overlay attacks to strike Brazilian bank account holders, which
                                            has been dubbed Vizom. It is being utilized in an active campaign across
                                            Brazil designed to compromise bank accounts via online financial services.
                                            Vizom spreads through spam-based phishing campaigns and disguises itself as
                                            popular videoconferencing software, tools that have become crucial to
                                            business and social life due to the coronavirus pandemic.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FIN112020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FIN11 Ransomware Campaign</h2>
                                <span class="frst-date">October 14</span>
                                <p>
                                    On October 14, FireEye reported that FIN11, a financial cybercrime group active
                                    since 2016, has recently switched to ransomware as its primary mode of attack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>10/14/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 14, FireEye reported that FIN11, a financial cybercrime group
                                            active since 2016, has recently switched to ransomware as its primary mode
                                            of attack. FIN11 has been conducting attacks around the world since 2016.
                                            FIN11 campaigns initially focused on entering networks to steal data, with
                                            researchers noting that the hacking group commonly deployed BlueSteal, a
                                            tool used to steal banking information from Point-of-Sale (POS) terminals.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BetterSure2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BetterSure Attempted Phishing Attack</h2>
                                <span class="frst-date">October 11</span>
                                <p>
                                    On October 11, nearly 4000 clients of BetterSure, a South African home insurance
                                    company, experienced a phishing attack but no data was comprised.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>10/12/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 11, nearly 4000 clients of BetterSure, a South African home
                                            insurance company, experienced a phishing attack but no data was comprised.
                                            Using a phishing e-mail, the attackers gained access to an internal e-mail
                                            account of a BetterSure administration employee. However, the bank says its
                                            firewall and e-mail security system immediately picked up on the threat. The
                                            bank claims that no personal data was accessed.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="UgandaMObile2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ugandan Mobile Money Hack</h2>
                                <span class="frst-date">October 3</span>
                                <p>
                                    On October 3, 2020, hackers targeted Pegasus Technologies, a firm that processes
                                    mobile money transactions for two telecom firms, MTN Uganda and Airtel.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Uganda<br />
                                            <strong>Date Breach First Reported:</strong>10/5/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> SIM Card Fraud <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 3, 2020, hackers targeted Pegasus Technologies, a firm that
                                            processes mobile money transactions for two telecom firms, MTN Uganda and
                                            Airtel. The service was temporarily suspended, causing a halt to much of the
                                            mobile money transfer ecosystem in the country. At least $3.2 million is
                                            estimated to have been stolen in the hack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="JapaneseGlitch2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Japanese Exchanges Technical Glitch</h2>
                                <span class="frst-date">October 1</span>
                                <p>
                                    On October 1, 2020, a technical glitch halted trading on Japan’s stock exchanges,
                                    including the Nikkei 225.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Japan<br />
                                            <strong>Date Breach First Reported:</strong>10/1/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 1, 2020, a technical glitch halted trading on Japan’s stock
                                            exchanges, including the Nikkei 225. The disruption happened when a backup
                                            system failed to kick in after a hardware malfunction, according to the
                                            Japan Exchange Group. The halt wasn't connected to a cyber attack. Trading
                                            was suspended at the main Tokyo stock exchange along with connected bourses
                                            in Nagoya, Fukuoka and Sapporo.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="HungarianBanks2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Hungarian Banks DDoS Attack</h2>
                                <span class="frst-date">September 23</span>
                                <p>
                                    On September 23, 2020, several Hungarian banking and telecommunication services were
                                    disrupted by a powerful DDoS attack launched from computer servers in Russia, China,
                                    and Vietnam, telecoms firm Magyar Telekom reported.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Hungary<br />
                                            <strong>Date Breach First Reported:</strong>9/26/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 23, 2020, several Hungarian banking and telecommunication
                                            services were disrupted by a powerful DDoS attack launched from computer
                                            servers in Russia, China, and Vietnam, telecoms firm Magyar Telekom
                                            reported. The volume of data traffic in the attack was 10 times higher than
                                            the amount usually seen in DDoS events, the company said.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RussianBanks2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Russian Banks Ransomware Campaign</h2>
                                <span class="frst-date">September 23</span>
                                <p>
                                    On September 23, 2020, Group-IB reported that a cybercrime gang dubbed 'OldGremlin'
                                    had been targeting banks and other businesses in Russia with ransomware since early
                                    March, 2020.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Russia<br />
                                            <strong>Date Breach First Reported:</strong>9/23/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 23, 2020, Group-IB reported that a cybercrime gang dubbed
                                            'OldGremlin' had been targeting banks and other businesses in Russia with
                                            ransomware since early March, 2020. OldGremlin uses spear-phishing emails to
                                            enter networks and then encrypts data for a ransom of around $50,000. The
                                            Russian-speaking group is also notable for its apparent focus on
                                            Russian-based companies.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ChileanBanco2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Chilean Banco Estado Ransomware Attack</h2>
                                <span class="frst-date">September 6</span>
                                <p>
                                    On September 6, 2020, Banco Estado, the only public bank in Chile and one of the
                                    three largest in the country, had to shut down its nationwide operations on Monday
                                    due to a ransomware cyberattack launched by REvil.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Chile<br />
                                            <strong>Date Breach First Reported:</strong> 9/6/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 6, 2020, Banco Estado, the only public bank in Chile and one of
                                            the three largest in the country, had to shut down its nationwide operations
                                            on Monday due to a ransomware cyberattack launched by REvil.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CIH2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>CIH Bank Theft</h2>
                                <span class="frst-date">August 28</span>
                                <p>
                                    On August 28, 2020, Morocco’s CIH Bank experienced a breach customer accounts
                                    resulting in unauthorized transactions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Morocco<br />
                                            <strong>Date Breach First Reported:</strong>8/29/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Skimmer <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 28, 2020, Morocco’s CIH Bank experienced a breach customer
                                            accounts resulting in unauthorized transactions. According to the bank, the
                                            customers’ accounts were hacked after their owners used their credit cards
                                            to make online purchases from a scam website, indicating a card skimming
                                            scheme. CIH bank has assured customers it will reimburse them for any
                                            fraudulent transactions and advised its users to turn off international
                                            transactions between use to prevent further fraud.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BeagleBoyz2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>North Korean 'BeagleBoyz' Global Campaign</h2>
                                <span class="frst-date">August 26</span>
                                <p>
                                    On August 26, 2020, the U.S. government issued a joint alert to warn the public
                                    about an ongoing cyber campaign by North Korea-backed 'BeagleBoyz' group which is
                                    using remote access malware tools to steal millions from financial institutions in
                                    at least 38 countries around the world.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Argentina, Brazil, Bangladesh, Bosnia and
                                            Herzegovina, Bulgaria, Chile, Costa Rica, Ecuador, Ghana, India, Indonesia,
                                            Japan, Jordan, Kenya, Kuwait, Malaysia, Malta, Mexico, Mozambique, Nepal,
                                            Nicaragua, Nigeria, Pakistan, Panama, Peru, Philippines, Singapore, South
                                            Africa, South Korea, Spain, Taiwan, Tanzania, Togo, Turkey, Uganda, Uruguay,
                                            Vietnam, Zambia<br />
                                            <strong>Date Breach First Reported:</strong> 8/26/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 26, 2020, the U.S. government issued a joint alert to warn the
                                            public about an ongoing cyber campaign by North Korea-backed 'BeagleBoyz'
                                            group which is using remote access malware tools to steal millions from
                                            financial institutions in at least 38 countries around the world.
                                        </p>
                                        <p>
                                            The U.S. government considers BeagleBoyz to be a subset of HIDDEN COBRA
                                            activity. According to U.S. CISA, 'BeagleBoyz overlap to varying degrees
                                            with groups tracked by the cybersecurity industry as Lazarus, Advanced
                                            Persistent Threat 38 (APT38), Bluenoroff, and Stardust Chollima and are
                                            responsible for the FASTCash ATM cash outs reported in October 2018,
                                            fraudulent abuse of compromised bank-operated SWIFT system endpoints since
                                            at least 2015, and lucrative cryptocurrency thefts'.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="DeathStalker2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>DeathStalker Campaign</h2>
                                <span class="frst-date">August 26</span>
                                <p>
                                    On August 26, 2020, Kaspersky revealed a new hack-for-hire group, DeathStalker, had
                                    been targeting institutions worldwide since 2012, with a focus law firms and
                                    financial entities.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Argentina, China, Cyprus, India, Israel, Lebanon,
                                            Switzerland, Russia, Taiwan, Turkey, the United Kingdom, the United Arab
                                            Emirates<br />
                                            <strong>Date Breach First Reported:</strong>8/26/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 26, 2020, Kaspersky revealed a new hack-for-hire group,
                                            DeathStalker, had been targeting institutions worldwide since 2012, with a
                                            focus law firms and financial entities. Kaspersky researchers report that
                                            DeathStalker is not motivated by financial gain. Victim organizations are
                                            small and medium-sized businesses located in Argentina, China, Cyprus,
                                            India, Israel, Lebanon, Switzerland, Russia, Taiwan, Turkey, the United
                                            Kingdom and the United Arab Emirates.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NZStock2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>New Zealand Stock Exchange DDoS Attack</h2>
                                <span class="frst-date">August 26</span>
                                <p>
                                    On August 26, the New Zealand Stock Exchange's network provider experienced an
                                    extended DDoS attack that lasted several days and caused the Exchange to shut down
                                    operations.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> New Zealand<br />
                                            <strong>Date Breach First Reported:</strong>8/26/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 26, the New Zealand Stock Exchange's network provider experienced
                                            an extended DDoS attack that lasted several days and caused the Exchange to
                                            shut down operations. The NZX website and markets announcement platform were
                                            also impacted. The Australian government and other member states of the Five
                                            Eyes alliance reportedly helped with response and recovery efforts.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SAExperian2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South Africa Experian Data Breach</h2>
                                <span class="frst-date">August 19</span>
                                <p>
                                    On August 19, 2020, Experian South Africa, a major credit bureau, experienced a data
                                    breach that exposed personal information of up to 24 million South Africans
                                    according to the South Africa Banking Risk Information Centre; however, Experian
                                    South Africa disputed the reported numbers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong> 8/19/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data Breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 19, 2020, Experian South Africa, a major credit bureau,
                                            experienced a data breach that exposed personal information of up to 24
                                            million South Africans according to the South Africa Banking Risk
                                            Information Centre; however, Experian South Africa disputed the reported
                                            numbers. 793,749 business entities are thought to be affected.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="JuspayData2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Payments Processor Juspay Data Leak</h2>
                                <span class="frst-date">August 18</span>
                                <p>
                                    On August 18, 2020, payments processor Juspay's was hacked through a compromised
                                    server, resulting in the leak of over 100 million debit and credit card users.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong> 1/4/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 18, 2020, payments processor Juspay's was hacked through a
                                            compromised server, resulting in the leak of over 100 million debit and
                                            credit card users. Juspay processes payments from many major companies,
                                            including Amazon, Swiggy, and MakeMyTrip. On January 4, 2021, Juspay
                                            confirmed the hack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FinanceRDoS2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Finance Sector RDoS Campaign</h2>
                                <span class="frst-date">August 17</span>
                                <p>
                                    On August 17, Akamai, a global content delivery network, reported an ongoing
                                    campaign of RDoS (Ransom DDoS) attacks targeting the financial sector and other
                                    businesses.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>8/17/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 17, Akamai, a global content delivery network, reported an ongoing
                                            campaign of RDoS (Ransom DDoS) attacks targeting the financial sector and
                                            other businesses. The extortion demands are similar to those used by DDoS
                                            ransom groups in the past. The actors claimed to be Fancy Bear and targeted
                                            businesses in multiple countries including the UK, the United States, and
                                            the APAC region.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CACodvid2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Canadian COVID-19 Relief Fund Theft</h2>
                                <span class="frst-date">August 15</span>
                                <p>
                                    On August 15, 2020, the Government of Canada reported that it’s GCKey, a critical
                                    single sign-on (SSO) system, had been subject to credential stuffing attacks aimed
                                    at stealing COVID-19 relief funds.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Canada<br />
                                            <strong>Date Breach First Reported:</strong>8/15/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 15, 2020, the Government of Canada reported that it’s GCKey, a
                                            critical single sign-on (SSO) system, had been subject to credential
                                            stuffing attacks aimed at stealing COVID-19 relief funds. Attackers were
                                            able to get away with 11,200 GCKey accounts. GCKey provides access to
                                            crucial services for immigration, taxes, pension, and benefits across
                                            Canadian government institutions.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Pepperstone2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Pepperstone Data Breach</h2>
                                <span class="frst-date">August 6</span>
                                <p>
                                    On August 6, Pepperstone, a Melbourne-based global derivatives broker, was subject
                                    to a data breach, compromising the personal data of an unknown number of customers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Australia<br />
                                            <strong>Date Breach First Reported:</strong>8/6/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data Breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 6, Pepperstone, a Melbourne-based global derivatives broker, was
                                            subject to a data breach, compromising the personal data of an unknown
                                            number of customers. Pepperstone’s subsequent investigation showed that no
                                            trading accounts or funds had been corrupted.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NetWalker2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>NetWalker Ransomware Attacks</h2>
                                <span class="frst-date">August 4</span>
                                <p>
                                    On August 4, 2020, McAfee reported that ransomware-as-a-service (RaaS) provider
                                    NetWalker had made $25 million over the previous five months through ransomware
                                    attacks.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>8/4/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 4, 2020, McAfee reported that ransomware-as-a-service (RaaS)
                                            provider NetWalker had made $25 million over the previous five months
                                            through ransomware attacks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TaiwaneseData2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Taiwanese financial institutions data exfiltration</h2>
                                <span class="frst-date">August 1</span>
                                <p>
                                    From August 2020, Taiwanese financial institutions have been targeted by a
                                    state-sponsored, Chinese advanced peristent threat group, Antlion, in an espionage
                                    campaign.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Taiwan<br />
                                            <strong>Date Breach First Reported:</strong>2/3/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Espionage
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            From August 2020, Taiwanese financial institutions have been targeted by a
                                            state-sponsored, Chinese advanced peristent threat group, Antlion, in an
                                            espionage campaign. Using the customised backdoor xPack, Antlion gained
                                            access to target’s machines, from which they were able to exfiltrate vast
                                            amounts of data.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Dave2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Dave Third Party Banking App Breach</h2>
                                <span class="frst-date">July 25</span>
                                <p>
                                    On July 25, 2020, hackers published data and personal information of 7.5 million
                                    users of ‘Dave’ banking app.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>7/25/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 25, 2020, hackers published data and personal information of 7.5
                                            million users of ‘Dave’ banking app. The attackers accessed and exfiltrated
                                            data between June 10 and July 3, 2020 by entering through Waydev, a third
                                            party analytics platform used by the Dave engineering team. The company has
                                            since patched the security gap, but the data has been leaked onto the hacker
                                            forum RAID and was available for free download by forum members. The breach
                                            included full names, emails, birth dates, and home addresses, encrypted
                                            social security numbers, and hashed passwords.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RwandaBankHeist20">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Rwandan Bank Heist</h2>
                                <span class="frst-date">July 24</span>
                                <p>
                                    On July 30, 2020, Rwanda Investigation Bureau (RIW) revealed that they had arrested
                                    a hacker suspected of stealing Rwf 22.5 million from Nesen Industry Company's bank.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Rwanda<br />
                                            <strong>Date Breach First Reported:</strong>7/30/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 30, 2020, Rwanda Investigation Bureau (RIW) revealed that they had
                                            arrested a hacker suspected of stealing Rwf 22.5 million from Nesen Industry
                                            Company's bank. The theft had been executed through a local bank's automated
                                            payment system to transfer cash to different bank accounts. The bank had
                                            initially reported the incident on July 24, 2020.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="AttemptedSASSA020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Attempted SASSA Breach</h2>
                                <span class="frst-date">July 24</span>
                                <p>
                                    On July 26, three suspects were arrested by South African authorities for attempting
                                    to hack into the South African Social Security Agency (SASSA).
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>7/26/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 26, three suspects were arrested by South African authorities for
                                            attempting to hack into the South African Social Security Agency (SASSA). In
                                            a court hearing held two a few months after the incident, two of the hackers
                                            known to be first time offenders were granted bail.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Scotiabank2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Scotiabank Data Breach</h2>
                                <span class="frst-date">July 21</span>
                                <p>
                                    On July 21, Scotiabank warned “a limited number” of customers of a data breach after
                                    Scotiabank bank an employee accessed client accounts without a valid business
                                    reason.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Canada<br />
                                            <strong>Date Breach First Reported:</strong>7/21/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 21, Scotiabank warned “a limited number” of customers of a data
                                            breach after Scotiabank bank an employee accessed client accounts without a
                                            valid business reason.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Emotet2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Emotet Spreading QakBot Banking Malware</h2>
                                <span class="frst-date">July 21</span>
                                <p>
                                    On July 21, observed Emotet, a known botnet, spreading the QakBot banking trojan at
                                    an unusually high rate.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>7/21/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 21, observed Emotet, a known botnet, spreading the QakBot banking
                                            trojan at an unusually high rate. QakBot recently replaced the longtime
                                            TrickBot payload.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Kattana2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Kattana Crypto App Malware</h2>
                                <span class="frst-date">July 16</span>
                                <p>
                                    On July 16, researchers discovered GMERA malware embedded within Kattana, a
                                    cryptocurrency app, being used to steal wallet information.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>7/16/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 16, researchers discovered GMERA malware embedded within Kattana, a
                                            cryptocurrency app, being used to steal wallet information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Twitter2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Famous Twitter Accounts Hijacked for Bitcoin</h2>
                                <span class="frst-date">July 15</span>
                                <p>
                                    On July 15, several notable Twitter accounts including Joe Biden and Elon Musk were
                                    hacked to post a Bitcoin address purporting to double any contributions to the
                                    address.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 7/15/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 15, several notable Twitter accounts including Joe Biden and Elon
                                            Musk were hacked to post a Bitcoin address purporting to double any
                                            contributions to the address. The spear phishing operation targeted Twitter
                                            employees and was able to gain access to admin-level tools; in all, the
                                            hackers made more than $113,500.
                                        </p>
                                        <p>
                                            On July 31, a 17-year-old suspect related to the recent Twitter Bitcoin scam
                                            was arrested in Florida.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Argenta2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Argenta ATM Attack</h2>
                                <span class="frst-date">July 13</span>
                                <p>
                                    On July 13, Argenta, a Belgian savings bank shut down 143 cash machines after
                                    suffering a cyber-attack from unknown criminals.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Belgium<br />
                                            <strong>Date Breach First Reported:</strong>7/13/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 13, Argenta, a Belgian savings bank shut down 143 cash machines
                                            after suffering a cyber-attack from unknown criminals. The attack was
                                            self-reported by Argenta, who refused to say how much money was affected.
                                            The criminals tried to leverage the technique known as 'jackpotting' to take
                                            control of the cash machines.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SpanishCrypto2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Spanish Crypto App Malware</h2>
                                <span class="frst-date">July 12</span>
                                <p>
                                    In July 2020, Avast found Cerberus malware hidden in a cryptocurrency converter app
                                    used to infect victims of Android devices.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong> 7/12/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In July 2020, Avast found Cerberus malware hidden in a cryptocurrency
                                            converter app used to infect victims of Android devices.
                                        </p>
                                        <p>
                                            Primarily used by Spanish speaking users, the dropper embedded in the app
                                            later became active to download another malicious APK. Shortly after the
                                            malicious C&amp;C communication was seized and the malware became
                                            dormant/harmless once again. The app had amassed thousands of downloads
                                            before being taken down.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SECRansomeware2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>SEC Warning of Ransomware Attacks on US Banks</h2>
                                <span class="frst-date">July 10</span>
                                <p>
                                    On July 10, the SEC issued a warning about a rise in ransomware attacks on U.S.
                                    financial firms.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>7/10/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> N/A
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 10, the SEC issued a warning about a rise in ransomware attacks on
                                            U.S. financial firms. These attacks focus on gaining access to the company
                                            and then enacting ransomware and have targeted firms all across the
                                            financial services sector.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MrbMiner2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Crypto-mining Botnet MrbMiner linked to Iranian Software Developer</h2>
                                <span class="frst-date">July 1</span>
                                <p>
                                    Cybersecurity firm Sophos has found evidence tying the operations of MrbMiner, a
                                    crypto-mining botnet, to a boutique software development firm in Shiraz, Iran.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Iran<br />
                                            <strong>Date Breach First Reported:</strong>1/21/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Cybersecurity firm Sophos has found evidence tying the operations of
                                            MrbMiner, a crypto-mining botnet, to a boutique software development firm in
                                            Shiraz, Iran. MrbMiner has been operational since the summer of 2020,
                                            launching brute-force attacks against Microsoft SQL Servers databases to
                                            gain access to poorly secured accounts. Once inside, the botnet would create
                                            a backdoor and download a cryptocurrency miner.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="LedgerWallet2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ledger Wallet E-Commerce Data Leak</h2>
                                <span class="frst-date">June 25</span>
                                <p>
                                    On June 25, 2020, cryptocurrency hardware wallet manufacturer Ledger's e-commerce
                                    database was breached.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>12/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data Breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 25, 2020, cryptocurrency hardware wallet manufacturer Ledger's
                                            e-commerce database was breached. The company initially discovered the
                                            breach in July after it was tipped off by a researcher, and began an
                                            internal investigation. Months later, stolen data — including email
                                            addresses, phone numbers, and addresses of customers — were put up on the
                                            sharing martketplace Raidforums for free.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Goldenspy2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>GoldenSpy Malware in Chinese Tax Software</h2>
                                <span class="frst-date">June 25</span>
                                <p>
                                    On June 25, 2020, researchers identified a new backdoor trojan, dubbed 'GoldenSpy,'
                                    in Chinese tax software.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> China<br />
                                            <strong>Date Breach First Reported:</strong> 6/25/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Speculated<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 25, 2020, researchers identified a new backdoor trojan, dubbed
                                            'GoldenSpy,' in Chinese tax software. Shortly after the discovery, the
                                            actors behind it delivered a silent uninstaller to remove all traces of the
                                            said malware. While the attribution remains unknown, researchers speculated
                                            that it has the characteristics similar to a coordinated APT campaign that
                                            focuses on foreign companies operating in China.
                                        </p>
                                        <p>
                                            Researchers further uncovered an earlier campaign tied to GoldenSpy malware
                                            that came installed with Chinese tax software. New evidence suggests that
                                            GoldenSpy was preceded by another piece of malware that employed similar
                                            capabilities to infect taxpayers within China. This earlier version of
                                            GoldenSpy is called GoldenHelper."
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="IcedID2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>IcedID Banking Trojan Using COVID-19 lures</h2>
                                <span class="frst-date">June 22</span>
                                <p>
                                    On June 22, 2020, researchers identified a new variant of the IcedID banking trojan
                                    that uses COVID-19 related phishing lures.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>6/22/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 22, 2020, researchers identified a new variant of the IcedID banking
                                            trojan that uses COVID-19 related phishing lures. This new variant is using
                                            steganography to infect the victims and comes equipped with fresh
                                            anti-detection capabilities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="EuropeanDDOS2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>European Bank Targeted by Large DDoS Attack</h2>
                                <span class="frst-date">June 21</span>
                                <p>
                                    On June 21, 2020, a large unidentified European bank was the target of a massive
                                    DDoS attack that sent 809 million packets per second through its network.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>6/23/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 21, 2020, a large unidentified European bank was the target of a
                                            massive DDoS attack that sent 809 million packets per second through its
                                            network. Akami, a global content delivery network and IT services provider,
                                            called the attack the “largest ever recorded” on their platforms, but
                                            reported it was able to mitigate the attack against the undisclosed
                                            customer.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Coincheck2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Coincheck Data Breach</h2>
                                <span class="frst-date">June 4</span>
                                <p>
                                    On June 4, 2020 Coincheck, a Japanese digital currency exchange, paused remittances
                                    after unknown attackers gained access to Coincheck's domain registry service and
                                    fraudulently obtained user email addresses as well as personal data.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Japan<br />
                                            <strong>Date Breach First Reported:</strong>6/4/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 4, 2020 Coincheck, a Japanese digital currency exchange, paused
                                            remittances after unknown attackers gained access to Coincheck's domain
                                            registry service and fraudulently obtained user email addresses as well as
                                            personal data.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BancoBCR2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Banco BCR Data Breach</h2>
                                <span class="frst-date">May 21</span>
                                <p>
                                    On May 21, 2020, the operators of the Maze Ransomware released 2GB of data,
                                    including credit card credentials, from Banco BCR, the state-owned Bank of Costa
                                    Rica.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Costa Rica<br />
                                            <strong>Date Breach First Reported:</strong> 5/23/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 21, 2020, the operators of the Maze Ransomware released 2GB of data,
                                            including credit card credentials, from Banco BCR, the state-owned Bank of
                                            Costa Rica. Notably, the attackers claimed they decided not to encrypt Banco
                                            BCR data with ransomware because “the possible damage was too high.”
                                        </p>
                                        <p>
                                            Three weeks previously on May 1, 2020, the operators announced that they had
                                            breached Banco BCR, first in August 2019, and then in February 2020 at which
                                            point they stole 11 million credit card credentials and other data.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="NigerianHackingGroup2020"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Nigerian Hacking Group Targets US Unemployment Systems</h2>
                                <span class="frst-date">May 14</span>
                                <p>
                                    On May 14, the U.S. Secret Service Bulletin alerted citizens to multiple fraudulent
                                    claims targeting state unemployment benefit programs.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>5/14/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 14, the U.S. Secret Service Bulletin alerted citizens to multiple
                                            fraudulent claims targeting state unemployment benefit programs. A group of
                                            Nigerian cybercriminals known as "Scattered Canary" appear to be behind the
                                            attacks, which targeted unemployment systems in Washington State as well as
                                            Florida, Massachusetts, North Carolina, Oklahoma, Rhode Island, and Wyoming.
                                            The group was able to steal millions from Washington State through
                                            fraudulent claims, although at least $300 million was recovered.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="IndianMobileApp2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Indian Mobile Banking Apps Malware</h2>
                                <span class="frst-date">May 14</span>
                                <p>
                                    On May 14, CERT-In, India’s national CERT, released a warning that a mobile banking
                                    malware called 'EventBot' that steals personal financial information was affecting
                                    Android users in India.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong> 5/14/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 14, CERT-In, India’s national CERT, released a warning that a mobile
                                            banking malware called 'EventBot' that steals personal financial information
                                            was affecting Android users in India.
                                        </p>
                                        <p>
                                            EventBot is a mobile-banking Trojan Trojan that targets over 200 financial
                                            applications, money-transfer services and cryptocurrency wallets across the
                                            US, Europe, and now India. It steals user data from financial applications,
                                            reads user SMS messages, and intercepts SMS messages to bypass 2FA.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Norfund2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Norfund Business Email Compromise</h2>
                                <span class="frst-date">May 13</span>
                                <p>
                                    On May 13, Norfund, Norway's state investment fund, was subject to a $10 million
                                    heist that involved business email compromise.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Norway<br />
                                            <strong>Date Breach First Reported:</strong> 5/14/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 13, Norfund, Norway's state investment fund, was subject to a $10
                                            million heist that involved business email compromise. Scammers were able to
                                            gain access to the email system, which allowed them to actively monitor
                                            internal communications.
                                        </p>
                                        <p>
                                            The attackers spent months doing reconnaissance in Norfund’s email system to
                                            design their fraudulent scheme. According to Norfund, they “manipulated and
                                            falsified information exchange between Norfund and the borrowing
                                            institution,” resulting in the attackers intercepting a $10 million loan
                                            that was meant for a microfinance institution in Cambodia.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Diebold2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Diebold Nixdorf Ransomware Attack</h2>
                                <span class="frst-date">May 11</span>
                                <p>
                                    On May 11, 2020, American ATM manfacturer Diebold Nixdorf was hit by a ransomware
                                    attack that caused 'a limited IT systems outage'.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 5/11/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 11, 2020, American ATM manfacturer Diebold Nixdorf was hit by a
                                            ransomware attack that caused 'a limited IT systems outage'. ATMs were not
                                            affected.
                                        </p>
                                        <p>
                                            While the company did not give any details, additional reporting suggests
                                            that the ransomware in question might have been 'ProLock', the successor of
                                            'PwndLocker'. ProLock was found to be using QakBot and unprotected Remote
                                            Desktop Protocol (RDP) servers with weak credentials.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PerSwaysion2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>PerSwaysion Group Targets Executives with Spear-Phishing</h2>
                                <span class="frst-date">April 30</span>
                                <p>
                                    Group-IB has reported that PerSwaysion, a cybercrime group operating since mid-2019,
                                    has breached the email accounts of high-ranking executives at more than 150 firms.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>4/30/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Group-IB has reported that PerSwaysion, a cybercrime group operating since
                                            mid-2019, has breached the email accounts of high-ranking executives at more
                                            than 150 firms. The group appears to have primarily targeted the financial
                                            sector, although it has expanded into other verticals, and typically uses
                                            phishing campaigns to breach corporate email accounts. The group members
                                            appear to be based in Nigeria and South Africa.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="NKoreaWebSkimming2020"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>North Korean Web Skimming Attacks</h2>
                                <span class="frst-date">April 23</span>
                                <p>
                                    On April 23, it was reported that North Korean hackers had been using webskimming
                                    malware to steal payment card details from online stores since at least May 2019.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Serbia, Montenegro, Croatia, Slovenia, Bosnia and
                                            Herzegovina<br />
                                            <strong>Date Breach First Reported:</strong>4/23/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 23, it was reported that North Korean hackers had been using
                                            webskimming malware to steal payment card details from online stores since
                                            at least May 2019. The attacks seem to be focused on the Balkans. The impact
                                            is not clear, but the attack was simple enough to execute multiple times on
                                            one target.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="dForce2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>dForce Cryptocurrency Attack and Return</h2>
                                <span class="frst-date">April 21</span>
                                <p>
                                    On April 21, 2020 an attacker stole $25 million in Ethereum, a popular
                                    cryptocurrency, from the dForce platform, a cryptocurrency firm, only to return the
                                    funds two days later.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> China<br />
                                            <strong>Date Breach First Reported:</strong>4/21/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 21, 2020 an attacker stole $25 million in Ethereum, a popular
                                            cryptocurrency, from the dForce platform, a cryptocurrency firm, only to
                                            return the funds two days later. The attacker did not return all funds in
                                            the same distribution of currencies that were taken but instead returned
                                            some in different tokens. It is not known why the attacker is returning the
                                            stolen funds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SpanishBanks2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Spanish Banks Attacked with Brazilian Trojan</h2>
                                <span class="frst-date">April 13</span>
                                <p>
                                    On April 13, 2020, IBM researchers reported that Spanish banks had been the target
                                    of by a Brazilian banking Trojan, Grandoreiro, in a campaign lasting months.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Spain<br />
                                            <strong>Date Breach First Reported:</strong> 4/13/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 13, 2020, IBM researchers reported that Spanish banks had been the
                                            target of by a Brazilian banking Trojan, Grandoreiro, in a campaign lasting
                                            months. The campaign exploits the Coronavirus outbreak by using videos
                                            themed on the pandemic that convince users to run a hidden executable.
                                        </p>
                                        <p>
                                            Grandoreiro is a remote-overlay banking trojan that, upon a user accessing
                                            their online banking, can display images to impersonate said bank. This
                                            allows attacks to then then move money from the victims accounts. The
                                            malware executes upon access to a hardcoded list of entities, mostly local
                                            banks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="SouthKoreaUSCard2020"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South Korean and US Payment Card Leak</h2>
                                <span class="frst-date">April 9</span>
                                <p>
                                    On April 9, 2020, a cache of 400,000 payment card records from banks in South Korea
                                    and the U.S. were uploaded to a well-known underground marketplace.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea, United States<br />
                                            <strong>Date Breach First Reported:</strong> 4/24/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 9, 2020, a cache of 400,000 payment card records from banks in
                                            South Korea and the U.S. were uploaded to a well-known underground
                                            marketplace.
                                        </p>
                                        <p>
                                            According to Group-IB, a security firm, the data dump was identified as the
                                            biggest sale of South Korea related bank records in 2020. The database
                                            contained mostly Track 2 information, meaning the data stored on the
                                            magnetic stripe of a card such as the bank identification number (BIN), the
                                            account number, expiration date and CVV.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="TurkeyDogContinues2020"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Turkey Dog Continues To Claim Victims</h2>
                                <span class="frst-date">April 1</span>
                                <p>
                                    Operating since April 2020, Turkey Dog activity has been luring unaware Turkish
                                    speakers into downloading malicious Android trojans through fake click-baits.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Turkey<br />
                                            <strong>Date Breach First Reported:</strong>2/24/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Operating since April 2020, Turkey Dog activity has been luring unaware
                                            Turkish speakers into downloading malicious Android trojans through fake
                                            click-baits. The banking trojans, Cerberus and Anubis, have been used to
                                            steal user credentials to gain access to bank accounts.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BankTrojan2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>US, Canadian, Australian Banks Hit By Banking Trojan</h2>
                                <span class="frst-date">March 30</span>
                                <p>
                                    On March 30, researchers reported that U.S., Canadian, and Australian banks were
                                    being increasingly targeted by Zeus Sphinx, a banking trojan that had been dormant
                                    for three years.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States, Canada, Australia<br />
                                            <strong>Date Breach First Reported:</strong> 5/11/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 30, researchers reported that U.S., Canadian, and Australian banks
                                            were being increasingly targeted by Zeus Sphinx, a banking trojan that had
                                            been dormant for three years. The attackers target those waiting on
                                            government relief payments from Covid-19.
                                        </p>
                                        <p>
                                            The campaign used COVID-19 as a lure, such as sending booby-trapped document
                                            files named “COVID 19 relief.” Zeus Sphinx gained notoriety in 2015 for
                                            being used to target major financial institutions in the UK, and eventually
                                            in Brazil, Australia and North America. This version of the malware
                                            underwent core changes in its persistence mechanism, injections tactics, and
                                            bot configuration.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MontePaschi2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Monte de Paschi Bank Attack</h2>
                                <span class="frst-date">March 30</span>
                                <p>
                                    On March 30, 2020, attackers breached email accounts of employees at Monte dei
                                    Paschi bank, an Italian state-owned bank, and sent messages to clients with voice
                                    mail attachments.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Italy<br />
                                            <strong>Date Breach First Reported:</strong>4/11/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 30, 2020, attackers breached email accounts of employees at Monte
                                            dei Paschi bank, an Italian state-owned bank, and sent messages to clients
                                            with voice mail attachments. The bank notified customers on March 30 but did
                                            not disclose if there had been a data breach, the nature of the sent emails
                                            or if customers had been impacted.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ChubbRansomware2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Chubb Ransomware Attack</h2>
                                <span class="frst-date">March 26</span>
                                <p>
                                    On March 26, 2020, Insurer Chubb was targeted by Maze ransomware and the attackers
                                    claimed to have data stolen.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>3/26/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 26, 2020, Insurer Chubb was targeted by Maze ransomware and the
                                            attackers claimed to have data stolen. Chubb claimed its networks were
                                            unaffected but admitted investigating an incident relating to the access of
                                            third-party data. Chubb itself offers insurance to compensate those who
                                            suffer costs from data breaches.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SquareMilner2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Square Milner data breach</h2>
                                <span class="frst-date">March 25</span>
                                <p>
                                    On March 25, 2020, Square Milner, one of the largest accountancy firms in the US,
                                    experienced a possible data breach.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>4/22/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 25, 2020, Square Milner, one of the largest accountancy firms in
                                            the US, experienced a possible data breach. According to Squar Milner, the
                                            data breach may have included names, addresses, Social Security numbers or
                                            Tax ID numbers. It appears client data was accessed via credential stuffing
                                            but an actual data breach of their systems is yet to be ruled out.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Finastra2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Finastra Ransomware Attack</h2>
                                <span class="frst-date">March 20</span>
                                <p>
                                    On March 20, 2020, Finastra, a large London-based financial technology company,
                                    stated they were the victim of a ransomware attack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong> 3/20/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 20, 2020, Finastra, a large London-based financial technology
                                            company, stated they were the victim of a ransomware attack. The attack
                                            resulted in disruption of Finastra services as they shut down certain
                                            servers in response to the attack which had most impact on their North
                                            America operations.
                                        </p>
                                        <p>
                                            Finastra employs more than 10,000 people and provides services to nearly all
                                            of the top 50 banks globally. The company claimed there was no evidence of
                                            customer or employee data exfiltration.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SEAsiaBanks2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Southeast Asian Banks Credit Card Breach</h2>
                                <span class="frst-date">March 6</span>
                                <p>
                                    On March 6, 2020, it was reported that over 200,000 credit card details from top
                                    banks in Singapore, Malaysia, the Phillippines, Vietnam, Indonesia, and Thailand
                                    were stolen and published online.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Malaysia; Singapore; Philippines; Vietnam;
                                            Indonesia; Thailand<br />
                                            <strong>Date Breach First Reported:</strong>3/6/2020
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 6, 2020, it was reported that over 200,000 credit card details from
                                            top banks in Singapore, Malaysia, the Phillippines, Vietnam, Indonesia, and
                                            Thailand were stolen and published online. Security researchers determined
                                            that the Philippines had 172,828 cards breached, Malaysia and Singapore had
                                            37,145 and 25,290 cards breached respectively. One of the banks, CIMB Group
                                            Holdings, responded that they were confident there was no breach and the
                                            details would have been obtained elsewhere.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ItalianBanks2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Italian Banks Data Theft</h2>
                                <span class="frst-date">March 3</span>
                                <p>
                                    On March 3, 2021, researchers at Avast reported that at least 100 Italian banks were
                                    compromised in attacks using the Ursnif banking Trojan.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Italy<br />
                                            <strong>Date Breach First Reported:</strong>3/3/2020
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 3, 2021, researchers at Avast reported that at least 100 Italian
                                            banks were compromised in attacks using the Ursnif banking Trojan. Over
                                            1,700 credentials were also stolen from a single payment processor. In June
                                            2021, researchers discovered the trojan had incorporated the Cerberus
                                            malware into its tool set to increase its attack surface.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="AustraliaBanks2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Australian Banks DDoS Extortion</h2>
                                <span class="frst-date">February 25</span>
                                <p>
                                    On February 25, 2020, it was reported that Australian banks and other financial
                                    institutions were being extorted by the Silence group with DDoS attacks unless they
                                    paid a ransom.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Australia<br />
                                            <strong>Date Breach First Reported:</strong>2/25/2020
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 25, 2020, it was reported that Australian banks and other
                                            financial institutions were being extorted by the Silence group with DDoS
                                            attacks unless they paid a ransom. DDoS attacks have taken place but not
                                            against all targets, as they do not have the resources to attack all those
                                            threatened. The Silence group has also been linked to stealing from banks
                                            across Eastern Europe, South and Central Asia, and more recently,
                                            Sub-Saharan Africa. The group demanded payment in the cryptocurrency Monero
                                            to prevent the attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Paypal2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>PayPal Accounts Linked to Google Play Abused</h2>
                                <span class="frst-date">February 21</span>
                                <p>
                                    On February 21, 2020, hackers targeted PayPal accounts to carry out unauthorized
                                    purchases, estimated to be worth tens of thousands of euros, by exploiting PayPal’s
                                    Google Pay integration.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States, Germany<br />
                                            <strong>Date Breach First Reported:</strong>2/25/2020
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 21, 2020, hackers targeted PayPal accounts to carry out
                                            unauthorized purchases, estimated to be worth tens of thousands of euros, by
                                            exploiting PayPal’s Google Pay integration. The purchases were made at a
                                            variety of Target stores in the United States. Most of the victims appear to
                                            be German PayPal users.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Loqbox2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Loqbox Data Breach</h2>
                                <span class="frst-date">February 20</span>
                                <p>
                                    On February 20, Loqbox, a UK-based credit score builder startup, was the victim of a
                                    data breach in which customer details were compromised.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>3/2/2020
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 20, Loqbox, a UK-based credit score builder startup, was the
                                            victim of a data breach in which customer details were compromised. This
                                            included names, dates of birth, addresses, and phone numbers. Partial card
                                            and account details were exposed although not enough to make payments or
                                            access accounts. Loqbox claims all funds are secure and have not been
                                            accessed by attackers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Rakyat2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Indonesian Bank Rakyat hit by cyberattack</h2>
                                <span class="frst-date">February 1</span>
                                <p>
                                    In February 2020, Bank Rakyat Indonesia was reported to have been targeted by the
                                    North Korean hacking group, Lazarus.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Indonesia<br />
                                            <strong>Date Breach First Reported:</strong>10/26/21
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2020, Bank Rakyat Indonesia was reported to have been targeted
                                            by the North Korean hacking group, Lazarus. The attackers are believed to
                                            have gained access to the bank's computer networks using malware previously
                                            used in the Bangladesh bank heist, BEEFEATER. It remains unclear whether or
                                            not the attackers stole any funds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Nedbank2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Nedbank Third-Party Breach</h2>
                                <span class="frst-date">February 1</span>
                                <p>
                                    On February 13, 2020, Nedbank, a major bank in southern Africa, notified its
                                    customers of a breach of a third-party service provider hired by the bank for its
                                    marketing and promotional activites.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa, Angola, Kenya, Lesotho, Malawi,
                                            Mozambique, Namibia, Swaziland, Zimbabwe<br />
                                            <strong>Date Breach First Reported:</strong>2/13/20
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 13, 2020, Nedbank, a major bank in southern Africa, notified its
                                            customers of a breach of a third-party service provider hired by the bank
                                            for its marketing and promotional activites. The personal information of 1.7
                                            million customers of the bank was leaked through the breach.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="DeepVoice2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>“Deep voice” enabled bank theft</h2>
                                <span class="frst-date">January 15</span>
                                <p>
                                    On January 15, 2020, hackers transferred $35 million from a Hong Kong-based bank,
                                    using "deep voice" technology to clone a bank director’s speech.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Arab Emirates<br />
                                            <strong>Date Breach First Reported:</strong>10/13/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 15, 2020, hackers transferred $35 million from a Hong Kong-based
                                            bank, using "deep voice" technology to clone a bank director’s speech. The
                                            U.A.E. has sought American investigators’ help in tracing $400,000 of stolen
                                            funds that went into U.S.-based accounts held by Centennial Bank.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="AfricaBanks2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Sub-Saharan African Banks Targeted</h2>
                                <span class="frst-date">January 2</span>
                                <p>
                                    In the first week of January 2020, it was reported that major banks in sub-Saharan
                                    Africa were targeted by the Silence hacking group.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Africa<br />
                                            <strong>Date Breach First Reported:</strong>1/17/2020
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In the first week of January 2020, it was reported that major banks in
                                            sub-Saharan Africa were targeted by the Silence hacking group. According to
                                            Kaspersky, who attributed the attacks to the Silence group based on malware
                                            used, the general outline of such an attack involved phishing emails being
                                            sent with the malware, data gathering, and then withdrawing large amounts of
                                            cash in one go via ATMs. As of mid-January 2020, the attacks are ongoing and
                                            persist in targeting large banks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="WebShellUse2020">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Web Shell Use Increases in Web Skimming Attacks</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    On April 7, 2021, VISA warned that threat actors are increasingly deploying web
                                    shells on compromised servers to exfiltrate credit card information stolen from
                                    online store customers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong>4/7/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 7, 2021, VISA warned that threat actors are increasingly deploying
                                            web shells on compromised servers to exfiltrate credit card information
                                            stolen from online store customers. At least 45 eSkimming attacks occured in
                                            2020 using web shells.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2019</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Travelex2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Travelex Hit with Sodinokibi</h2>
                                <span class="frst-date">December 31</span>
                                <p>
                                    On December 31, 2019, Travelex, a major foreign exchange company, took all its
                                    computer systems offline after company systems were infected with Sodinokibi
                                    ransomware and the attackers demanded $6 million to remove it.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>12/31/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 31, 2019, Travelex, a major foreign exchange company, took all
                                            its computer systems offline after company systems were infected with
                                            Sodinokibi ransomware and the attackers demanded $6 million to remove it.
                                            This also impacted the exchange services of many major banks including
                                            Lloyds, Barclays, and RBS, who all use Travelex. The attackers also claimed
                                            to have exfiltrated 5GB of personal customer data that they threatened would
                                            be released if they did not receive payment. The attackers are believed to
                                            have used a VPN exploit that remained unpatched to access the firm’s
                                            systems. As of the end of January it has taken over a month for Travelex to
                                            restore its site and even then, only partially. It is unclear whether
                                            Travelex paid the ransom in this time.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Advantage2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Advantage and Argus Capital Funding Data Breach</h2>
                                <span class="frst-date">December 24</span>
                                <p>
                                    On December 24, 2019, researchers discovered a data breach from Advantage and Argus
                                    Capital Funding, a NY-based private equity firm, which included 425GB of 500,000
                                    legal and financial documents, including tax returns and social security
                                    information.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 12/24/19
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 24, 2019, researchers discovered a data breach from Advantage
                                            and Argus Capital Funding, a NY-based private equity firm, which included
                                            425GB of 500,000 legal and financial documents, including tax returns and
                                            social security information.
                                        </p>
                                        <p>
                                            The breach was discovered by vpnMentor who claim data including credit
                                            reports, bank statements, tax returns and social security information could
                                            be accessed without authentication. The database was linked to MCA Wizard,
                                            an application developed by Advantage and Argus Capital Funding. The
                                            database was stored in an unencrypted S3 bucket on Amazon Web Service. The
                                            vulnerability was patched by AWS on January 9, 2020.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Wawa2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Wawa Inc. Card Data Breach</h2>
                                <span class="frst-date">December 10</span>
                                <p>
                                    On December 10, 2019, Wawa Inc., a U.S.-based convenience store chain, discovered
                                    that its payment card processing systems had been breached for a 9-month long period
                                    in which customers in any of its worldwide locations could have had their card data
                                    stolen.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>12/19/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 10, 2019, Wawa Inc., a U.S.-based convenience store chain,
                                            discovered that its payment card processing systems had been breached for a
                                            9-month long period in which customers in any of its worldwide locations
                                            could have had their card data stolen. On January 27, 30 million card
                                            details believed to be part of the breach posted for sale online, including
                                            card numbers and expiration dates. Pins and CVV records were not exposed.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="IranCard2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Iranian Debit Card Breach</h2>
                                <span class="frst-date">December 10</span>
                                <p>
                                    On December 10, 2019, it was reported that Mellat, Tejarat, and Sarmayeh, Iran’s
                                    three largest banks, had been breached and that the attacker had published 15
                                    million bank debit cards on social media in the aftermath of anti-government
                                    demonstrations.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Iran<br />
                                            <strong>Date Breach First Reported:</strong>12/10/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 10, 2019, it was reported that Mellat, Tejarat, and Sarmayeh,
                                            Iran’s three largest banks, had been breached and that the attacker had
                                            published 15 million bank debit cards on social media in the aftermath of
                                            anti-government demonstrations. Iran’s information and telecommunications
                                            minister denied this was due to attackers but an inside contractor who had
                                            access to the data. Researchers are disputing this and suggest it was likely
                                            a nation state actor.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="UKIsrael2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>UK and Israeli Private Equity Firms Business Email Compromise</h2>
                                <span class="frst-date">December 3</span>
                                <p>
                                    On December 3, 2019, 3 private equity firms in the UK and Israel had £600k stolen by
                                    attackers, known as the “The Florentine Banker,” through a sophisticated business
                                    email compromise scheme.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom, Israel<br />
                                            <strong>Date Breach First Reported:</strong> 12/3/19
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 3, 2019, 3 private equity firms in the UK and Israel had £600k
                                            stolen by attackers, known as the “The Florentine Banker,” through a
                                            sophisticated business email compromise scheme.
                                        </p>
                                        <p>
                                            The attackers gained control over the victim's email accounts and
                                            intercepted specific emails involving the planned transfer of funds. The
                                            group used email rules to divert those they deemed interesting into another
                                            folder. They then registered similar domains to those on the other side of
                                            the conversation, diverted the legitimate communication and instead sent
                                            their own modified emails. In this way the attackers could manipulate all
                                            the parties involved into transferring funds to their own accounts instead
                                            of those intended by impersonating both sides of the conversation. £600k was
                                            taken by the group in 3 different transactions. Researchers noted many other
                                            spoofed domains that appear to have been registered by the attackers
                                            suggesting that the group is targeting other organizations in similar
                                            attacks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="UpbitCrypto2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Upbit Crypto Heist</h2>
                                <span class="frst-date">November 27</span>
                                <p>
                                    On November 27, 2019, $48.5 million in virtual currency was stolen from Upbit a
                                    South Korean cryptocurrency exchange.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong> 11/28/19
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 27, 2019, $48.5 million in virtual currency was stolen from
                                            Upbit a South Korean cryptocurrency exchange. The identity of the attackers
                                            remains unknown.
                                        </p>
                                        <p>
                                            $48.5 million in Ethereum was taken from exchange Upbit's hot wallet in 17
                                            transactions. Upbit have stated they will cover any loss to customers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Edenred2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Edenred Malware</h2>
                                <span class="frst-date">November 21</span>
                                <p>
                                    On November 21, 2019, Edenred, a payment solutions provider, reported that it was
                                    infected by malware that affected a number of the organization’s computers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Europe<br />
                                            <strong>Date Breach First Reported:</strong>11/21/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Unknown
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> N/A<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 21, 2019, Edenred, a payment solutions provider, reported that
                                            it was infected by malware that affected a number of the organization’s
                                            computers. Edenred’s payment platform operates across 46 countries and in
                                            2018 they managed 2.5 billion payment transactions. According to a statement
                                            released by the organization, as soon as the incident was detected they
                                            implemented countermeasures to prevent further infections. The number of
                                            computers effected and the extent of the attack is still currently unknown.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Cayman2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Cayman National Bank and Trust Data Theft</h2>
                                <span class="frst-date">November 18</span>
                                <p>
                                    On November 18, 2019, the Cayman National Bank and Trust Company confirmed it had
                                    been breached and had confidential data stolen.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>11/18/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 18, 2019, the Cayman National Bank and Trust Company confirmed
                                            it had been breached and had confidential data stolen. The Cayman National
                                            Bank did not elaborate on the extent of the breach but confirmed it was
                                            working with law enforcement. This announcement corroborated an earlier
                                            claim by Phineas Fisher, a vigilante hacker persona, who publicized the hack
                                            to encourage similar hacktivism. Phineas Fisher offered $100,000 USD to
                                            hacktivists who breach and leak documents from bank, oil companies,
                                            surveillance spyware vendors, and others.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Cardplanet2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Cardplanet Fraud</h2>
                                <span class="frst-date">November 13</span>
                                <p>
                                    On November 13, 2019, the United States charged a Russian man for running
                                    ‘Cardplanet,’ a card trading platform worth almost $20 million USD that buys and
                                    sells stolen payment card details.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Unknown<br />
                                            <strong>Date Breach First Reported:</strong>11/13/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> N/A
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 13, 2019, the United States charged a Russian man for running
                                            ‘Cardplanet,’ a card trading platform worth almost $20 million USD that buys
                                            and sells stolen payment card details. He is facing a number of charges
                                            including access device fraud, identity theft, and computer intrusion.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RwandaBank2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Rwandan Bank Botched Heist</h2>
                                <span class="frst-date">November 1</span>
                                <p>
                                    On November 1, 2019, authorities apprehended twelve individuals over a cyber-fraud
                                    attempt on Equity Bank Rwanda.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Rwanda<br />
                                            <strong>Date Breach First Reported:</strong>11/1/19
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 1, 2019, authorities apprehended twelve individuals over a
                                            cyber-fraud attempt on Equity Bank Rwanda. The individuals include eight
                                            Kenyans, three Rwandans, and one Ugandan who were attempting to hack the
                                            local bank. Officials noted that the hack was thwarted and that the
                                            fraudsters did not steal any funds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TurkishCards2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>460,000 Turkish Card Details for Sale</h2>
                                <span class="frst-date">October 28</span>
                                <p>
                                    On December 11, 2019, it was reported that 463,378 Turkish payment cards from
                                    Turkish banks had been posted for sale online between late October and late
                                    November, for an estimated total value of USD $500,000.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Turkey<br />
                                            <strong>Date Breach First Reported:</strong> 12/11/19
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 11, 2019, it was reported that 463,378 Turkish payment cards
                                            from Turkish banks had been posted for sale online between late October and
                                            late November, for an estimated total value of USD $500,000. Full card
                                            details were available as well as personal data including emails and phone
                                            numbers. Security researchers from Group-IB speculated the payment card
                                            information was stolen from online card payments using a JavaScript-based
                                            skimmer, such as Magecart.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="JohannesburgCity2019"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Johannesburg City Breach</h2>
                                <span class="frst-date">October 24</span>
                                <p>
                                    On October 24, 2019, the City of Johannesburg reported a breach of its network and
                                    shut down its website and all e-services.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>10/25/19
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 24, 2019, the City of Johannesburg reported a breach of its
                                            network and shut down its website and all e-services. Earlier that day, the
                                            city had received a bitcoin ransom note from a group called the Shadow Kill
                                            Hackers, who demanded payment of 4.0 bitcoins by October 28. The hack
                                            appeared to occur at the same time as several South African banks reported
                                            internet problems believed to also be related to cyber attacks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SabricDdos2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>SABRIC DDoS Attacks</h2>
                                <span class="frst-date">October 23</span>
                                <p>
                                    On October 23, 2019, the South African Banking Risk Information Centre (SABRIC)
                                    reported a series of distributed denial-of-service attacks which targeted several
                                    public facing services across multiple banks in the country.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>10/23/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 23, 2019, the South African Banking Risk Information Centre
                                            (SABRIC) reported a series of distributed denial-of-service attacks which
                                            targeted several public facing services across multiple banks in the
                                            country. The attacks started with a ransom note delivered via email to
                                            several publicly available addresses.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FancyBear2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Fake ”Fancy Bear” Group Targets Financial Sector</h2>
                                <span class="frst-date">October 20</span>
                                <p>
                                    In October 2019, a group of cybercriminals masquerading as ”Fancy Bear,” the
                                    infamous hacking group associated with the DNC hack of 2016 among other major
                                    breaches, launched a series of distributed denial-of-service attacks against
                                    companies in the financial sector.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Singapore, South Africa, Scandinavian
                                            Countries<br />
                                            <strong>Date Breach First Reported:</strong>10/24/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In October 2019, a group of cybercriminals masquerading as ”Fancy Bear,” the
                                            infamous hacking group associated with the DNC hack of 2016 among other
                                            major breaches, launched a series of distributed denial-of-service attacks
                                            against companies in the financial sector. The group demanded ransom
                                            payments of up to 2 bitcoin.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BriansClub2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BriansClub Data Theft</h2>
                                <span class="frst-date">October 16</span>
                                <p>
                                    On October 16, 2019, it was reported that ‘BriansClub’, one of the largest
                                    underground markets for stolen credit card and payment details, was hacked by a
                                    competitor who stole 26 million card details.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Unknown<br />
                                            <strong>Date Breach First Reported:</strong>10/16/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 16, 2019, it was reported that ‘BriansClub’, one of the largest
                                            underground markets for stolen credit card and payment details, was hacked
                                            by a competitor who stole 26 million card details. The credit card data was
                                            added to BriansClub between 2015-2019, representing 30 percent of the total
                                            cards that are currently being sold on the underground market.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Sberbank2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Sberbank Data Leak</h2>
                                <span class="frst-date">October 4</span>
                                <p>
                                    On October 4, 2019, it was reported that Sberbank, one of Russia’s largest banks,
                                    was investigating a suspected data leak that affected at least 200 customers, and
                                    potentially data on 60 million credit cards.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Russia<br />
                                            <strong>Date Breach First Reported:</strong>10/4/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> N/A <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Insider<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 4, 2019, it was reported that Sberbank, one of Russia’s largest
                                            banks, was investigating a suspected data leak that affected at least 200
                                            customers, and potentially data on 60 million credit cards. Sberbank is
                                            investigating an internal employee who may be behind the compromise of the
                                            database. Sberbank is working with law enforcement to investigate the
                                            incident further.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="IndianATM2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Indian ATMs Targeted with ATMDtrack Malware</h2>
                                <span class="frst-date">September 23</span>
                                <p>
                                    On September 23, security researchers reported that North Korean hackers had
                                    developed and inserted malware to steal payment information from Indian ATMs and
                                    banking institutions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong>9/23/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Espionage
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 23, security researchers reported that North Korean hackers had
                                            developed and inserted malware to steal payment information from Indian ATMs
                                            and banking institutions. The malware, known as ATMDtrack, began appearing
                                            on networks during the summer of 2018 and is thought to be attributable to
                                            Lazarus Group, a hacking group that has targeted banks, ATMs, and
                                            cryptocurrency exchanges in order to fund North Korea's weapons of mass
                                            destruction program.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ECB2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>ECB BIRD Site Data Breach</h2>
                                <span class="frst-date">September 16</span>
                                <p>
                                    On September 16, the European Central Bank (ECB) shut down its Banks’ Integrated
                                    Reporting Dictionary (BIRD) site after routine maintenance uncovered a cyberattack
                                    compromising the information of the site’s newsletter subscribers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Germany<br />
                                            <strong>Date Breach First Reported:</strong>9/16/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 16, the European Central Bank (ECB) shut down its Banks’
                                            Integrated Reporting Dictionary (BIRD) site after routine maintenance
                                            uncovered a cyberattack compromising the information of the site’s
                                            newsletter subscribers. The ECB reported that no market-sensitive data was
                                            compromised in the attack, and it planned to contact the 481 individuals
                                            whose names, email addresses, and titles may have been accessed by hackers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="HongKong2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Hong Kong Exchanges and Clearing Limited DDoS Attack</h2>
                                <span class="frst-date">September 6</span>
                                <p>
                                    On September 6, 2019, Hong Kong Exchanges and Clearing Limited (HKEx), a Hong
                                    Kong-based stock exchange, suffered a distributed denial-of-service attack (DDoS)
                                    and discovered a technical bug, forcing them to suspend trading.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> China<br />
                                            <strong>Date Breach First Reported:</strong>9/6/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 6, 2019, Hong Kong Exchanges and Clearing Limited (HKEx), a
                                            Hong Kong-based stock exchange, suffered a distributed denial-of-service
                                            attack (DDoS) and discovered a technical bug, forcing them to suspend
                                            trading. Attackers sent high volumes of traffic to the organization’s
                                            website, causing it to slow down and display limited information on exchange
                                            prices. Although services resumed once the issues were resolved, this is the
                                            second time that HKEx has suffered an attack of this kind. In 2011 a DDoS
                                            attack forced the organizations to suspend their services, and the
                                            individual behind the attack was later sentenced to nine months in prison.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="HimalayanATM2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Himalayan ATM Heist</h2>
                                <span class="frst-date">September 2</span>
                                <p>
                                    On September 2, Nepalese police arrested five Chinese nationals in connection with
                                    cyberattacks that cost Nepalese banks more than 35 million rupees (over $300,000).
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Nepal<br />
                                            <strong>Date Breach First Reported:</strong>9/2/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 2, Nepalese police arrested five Chinese nationals in
                                            connection with cyberattacks that cost Nepalese banks more than 35 million
                                            rupees (over $300,000). The attackers targeted the Nepal Electronic Payment
                                            System, which was established to coordinate cash withdrawals at 17 Nepalese
                                            banks, and inserted malware that directed ATMs to process withdrawal
                                            requests without first verifying with member banks. Staff at one Nepali bank
                                            discovered the theft when ATMs began running out of cash sooner than
                                            expected and informed authorities. Police recovered 12.63 million rupees
                                            (more than $110,000) during the arrests.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SilenceGroup2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Silence Group Targets Banks for 4.2 Million</h2>
                                <span class="frst-date">August 23</span>
                                <p>
                                    On August 23, 2019, it was reported that financial institutions in Bulgaria, Chile,
                                    Costa Rica, and Ghana were compromised by the Silence Group.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Bulgaria, Chile, Costa Rica, Ghana<br />
                                            <strong>Date Breach First Reported:</strong> 08/23/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 23, 2019, it was reported that financial institutions in Bulgaria,
                                            Chile, Costa Rica, and Ghana were compromised by the Silence Group. Since
                                            2016, the Silence Group had stolen a cumulative $4.2 million USD from banks
                                            in Eastern and Western Europe and Asia.
                                        </p>
                                        <p>
                                            Since 2018, Silence has sent over 170,000 phishing attacks to financial
                                            institutions. The group has refined its techniques since it was first
                                            spotted in 2016. Silence now uses fileless techniques, repurposed
                                            open-source projects, and old vulnerabilities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Binance2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Binance Ransomware</h2>
                                <span class="frst-date">August 6</span>
                                <p>
                                    On August 6, Malta-based cryptocurrency exchange Binance became the victim of
                                    ransomware when attackers demanded 300 bitcoin (around $3.5 million at the time) in
                                    exchange for a Know Your Customer (KYC) database containing the personal information
                                    of around 10,000 users.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Malta<br />
                                            <strong>Date Breach First Reported:</strong>8/6/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware <br />
                                            <strong>Type:</strong> Unknown
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On August 6, Malta-based cryptocurrency exchange Binance became the victim
                                            of ransomware when attackers demanded 300 bitcoin (around $3.5 million at
                                            the time) in exchange for a Know Your Customer (KYC) database containing the
                                            personal information of around 10,000 users. The KYC database allegedly
                                            contained personal identification information and photographs of users with
                                            documents like passports. The company contested the authenticity of the
                                            documents, claiming that they lacked digital watermarks, refused to pay the
                                            ransom, and contacted law enforcement for assistance in pursuing the
                                            attacker(s).
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CapitalOne2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Capital One Data Breach</h2>
                                <span class="frst-date">July 29</span>
                                <p>
                                    On July 29, Capital One announced that it had suffered a data breach compromising
                                    the credit card applications of around 100 million individuals after a software
                                    engineer hacked into a cloud-based server.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States and Canada<br />
                                            <strong>Date Breach First Reported:</strong> 7/29/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Data breach/theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 29, Capital One announced that it had suffered a data breach
                                            compromising the credit card applications of around 100 million individuals
                                            after a software engineer hacked into a cloud-based server. The applications
                                            contained names, dates of birth, credit scores, contact information, and
                                            some American and Canadian social security numbers. The hacker exploited a
                                            misconfigured firewall to gain access to a database of personal information
                                            hosted by Amazon Web Services. Upon gaining access, the hacker posted about
                                            it on GitHub, and an unidentified individual notified Capital One about the
                                            presence of the database on GitHub. Authorities arrested one individual in
                                            connection with the data theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BancoPan2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Banco Pan Data Breach</h2>
                                <span class="frst-date">July 25</span>
                                <p>
                                    On July 25, security researchers found a file containing 250GB of personal and
                                    financial information, mainly tied to Brazilian financial institution Banco Pan,
                                    exposed online.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil<br />
                                            <strong>Date Breach First Reported:</strong>7/25/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 25, security researchers found a file containing 250GB of personal
                                            and financial information, mainly tied to Brazilian financial institution
                                            Banco Pan, exposed online. The information, which Banco Pan claims is owned
                                            by a commercial partner, contained scans of identification cards and social
                                            security cards, proof of address documents, and service request forms.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Jana2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Jana Bank Data Breach</h2>
                                <span class="frst-date">July 23</span>
                                <p>
                                    On July 23, a security researcher reported that Jana Bank, an Indian small finance
                                    bank, left exposed a database containing information on millions of financial
                                    transactions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong> 7/23/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 23, a security researcher reported that Jana Bank, an Indian small
                                            finance bank, left exposed a database containing information on millions of
                                            financial transactions. The Know Your Customer verification database was not
                                            password-protected, allowing anyone to access, alter, or download the
                                            information. Jana Bank immediately secured the database upon learning of its
                                            exposure.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Remixipoint2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Remixpoint Inc. Crypto Theft</h2>
                                <span class="frst-date">July 12</span>
                                <p>
                                    On July 12, Remixpoint, a Japanese cryptocurrency exchange, halted services after it
                                    discovered the theft of $32 million in digital currencies.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Japan<br />
                                            <strong>Date Breach First Reported:</strong>7/12/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 12, Remixpoint, a Japanese cryptocurrency exchange, halted services
                                            after it discovered the theft of $32 million in digital currencies. After an
                                            error appeared in the exchange’s outgoing funds transfer system, Remixpoint
                                            discovered that the funds had been taken from a “hot” wallet (one that is
                                            connected to the internet). No funds had been stolen from “cold” wallets
                                            (those not connected to the internet). The company promised to investigate
                                            the incident and provided no further details.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BitpointCrypto2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bitpoint Crypto Heist</h2>
                                <span class="frst-date">July 12</span>
                                <p>
                                    On July 12, 2019, approximately $32 million in virtual currency was stolen from
                                    Bitpoint, a Japanese cryptocurrency exchange.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong>Japan<br />
                                            <strong>Date Breach First Reported:</strong> 07/12/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 12, 2019, approximately $32 million in virtual currency was stolen
                                            from Bitpoint, a Japanese cryptocurrency exchange. The identity of the
                                            attackers remains unknown.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CryptoExchange2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Crypto Exchange Theft</h2>
                                <span class="frst-date">June 25</span>
                                <p>
                                    On June 25, Europol, British law enforcement, and Dutch law enforcement officials
                                    arrested six individuals for cryptocurrency theft amounting to €24 million (over $26
                                    million).
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Netherlands, United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>6/25/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 25, Europol, British law enforcement, and Dutch law enforcement
                                            officials arrested six individuals for cryptocurrency theft amounting to €24
                                            million (over $26 million). The individuals used a technique known as
                                            “typosquatting,” in which they duplicated an online cryptocurrency exchange
                                            to steal information and gain access to victims’ bitcoin wallets. The attack
                                            affected more than 4,000 individuals in at least 12 countries.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SwitchSystem2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bangladesh Switch System Cyberattack</h2>
                                <span class="frst-date">June 22</span>
                                <p>
                                    In June 2019, at least three private Bangladeshi banks were compromised by major
                                    cyberattacks, with one, Dutch Bangla Bank Limited (DBBL), losing as much as TK 25
                                    crore (around $3 million).
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Bangladesh<br />
                                            <strong>Date Breach First Reported:</strong>6/22/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In June 2019, at least three private Bangladeshi banks were compromised by
                                            major cyberattacks, with one, Dutch Bangla Bank Limited (DBBL), losing as
                                            much as TK 25 crore (around $3 million). Attackers deployed malware to
                                            duplicate DBBL's Switch payment management system, allowing fraudulent
                                            financial transactions to be executed undetected. NCC Bank and Prime Bank
                                            were also targeted, but both banks reported no financial losses associated
                                            with the attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="DutchBangla2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Dutch Bangla Bank Heist by Silence Group</h2>
                                <span class="frst-date">May 31</span>
                                <p>
                                    On April 23, 2019, it was reported the Silence Group had targeted financial
                                    institutions in the UK, India, and South Korea since the end of 2018, and had stolen
                                    from at least one institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Bangladesh, India, Sri Lanka, Kyrgyzstan<br />
                                            <strong>Date Breach First Reported:</strong> 05/31/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 31, 2019, the Silence Group stole $3 million from Bangladesh’s Dutch
                                            Bangla Bank via ATM cash outs. Three other undisclosed financial
                                            institutions in India, Sri Lanka, and Kyrgyzstan were also attacked in the
                                            same timeframe. Until recently, Silence had focused on Russia and the
                                            Commonwealth of Independent States.
                                        </p>
                                        <p>
                                            Local media found a video of two Ukrainian men visiting Dutch Bangla Bank
                                            ATMs, making a phone call, and then withdrawing large sums of money.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Upbit2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Upbit Attempted Crypto Heist</h2>
                                <span class="frst-date">May 25</span>
                                <p>
                                    On May 25, 2019, attackers attempted to steal from Upbit, a South Korean
                                    cryptocurrency exchange, but were thwarted by East Security, a security firm.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong> 08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 25, 2019, attackers attempted to steal from Upbit, a South Korean
                                            cryptocurrency exchange, but were thwarted by East Security, a security
                                            firm. In August 2019, the UN Security Council Panel of Experts indicated
                                            DPRK-affiliated actors were behind the attempted theft.
                                        </p>
                                        <p>
                                            Attackers sent phishing emails to Upbit users in an attempt to steal their
                                            funds. It appears as though no losses have resulted from the emails.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FirstAmerican2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>First American Financial Corp.</h2>
                                <span class="frst-date">May 24</span>
                                <p>
                                    On May 24, First American Financial Corp. suffered a data breach compromising around
                                    885 million files related to mortgage deeds.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>5/24/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 24, First American Financial Corp. suffered a data breach
                                            compromising around 885 million files related to mortgage deeds. The
                                            documents, which dated back as far as 2003, contained bank account numbers
                                            and statements, mortgage and tax records, social security numbers, wire
                                            transaction receipts, and images of drivers' licenses. The documents were
                                            accessible to anyone with a web browser because the company used a standard
                                            format for document addresses, meaning that anyone with knowledge of at
                                            least one document link could access others simply by modifying the digits
                                            associated with the record number. Although the company took down the
                                            website, many of the pages remained accessible on archive.org. As of August
                                            2019, the U.S. Securities and Exchange Commission had begun an investigation
                                            into the data breach.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="GozNym2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>GozNym Gang Arrested</h2>
                                <span class="frst-date">May 16</span>
                                <p>
                                    On May 16, 2019, Europol, the U.S. Department of Justice (DoJ), and six other
                                    countries, dismantled a group of international cyber criminals that used the GozNym
                                    malware to steal over $100 million.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong>5/16/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actors<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 16, 2019, Europol, the U.S. Department of Justice (DoJ), and six
                                            other countries, dismantled a group of international cyber criminals that
                                            used the GozNym malware to steal over $100 million. The group stole from
                                            over 40,000 victims, including the bank accounts of small businesses, law
                                            firms, international corporations, and nonprofit organizations. Following a
                                            law enforcement investigation across the U.S., Bulgaria, Germany, Georgia,
                                            Moldova, and Ukraine, ten members were charged for the crime. The leader of
                                            the network was charged in Georgia while another was extradited from
                                            Bulgaria to the U.S. to face trial. Although some members of the gang are
                                            still on the run, the initial charges have been seen as a success for law
                                            enforcement in their efforts to combat international cybercrime.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FirstBank2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>FirstBank Breach</h2>
                                <span class="frst-date">May 13</span>
                                <p>
                                    In May 2019, a Colorado bank suffered an external security incident resulting in the
                                    cancellation and redistribution of customer debit cards.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>5/13/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In May 2019, a Colorado bank suffered an external security incident
                                            resulting in the cancellation and redistribution of customer debit cards.
                                            FirstBank, Colorado’s largest locally-owned bank, issued a security notice
                                            on May 13 informing customers of the breach and instructing them to report
                                            any suspicious behavior. The bank confirmed that the breach did not occur on
                                            its online systems but from other merchants where FirstBank customers made
                                            transactions.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Retefe2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Retefe Malware Resurfaces in Germany and Switzerland</h2>
                                <span class="frst-date">May 2</span>
                                <p>
                                    In May, U.S. security company Proofpoint reported the return of the Retefe banking
                                    Trojan in Germany and Switzerland.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Switzerland, Germany<br />
                                            <strong>Date Breach First Reported:</strong> 5/2/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Unknown
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In May, U.S. security company Proofpoint reported the return of the Retefe
                                            banking Trojan in Germany and Switzerland. Retefe is a malware that installs
                                            the Tor internet browser to redirect infected devices to spoofed banking
                                            sites. The Trojan is typically delivered through email attachments and often
                                            attempts to trick users into downloading spoofed mobile Android applications
                                            to bypass two-factor authentication.
                                        </p>
                                        <p>
                                            In the past, Retefe campaigns have targeted several European countries. In
                                            November 2016, Retefe targeted Tesco Bank and other UK financial
                                            institutions. In September 2017, an updated version of Retefe leveraged the
                                            EternalBlue exploit in a campaign against Swiss targets. Since April, the
                                            Trojan has reemerged in German and Swiss banks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SilenceTargets42019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Silence Targets Banks in UK, India, and South Korea</h2>
                                <span class="frst-date">April 23</span>
                                <p>
                                    On April 23, 2019, it was reported the Silence Group had targeted financial
                                    institutions in the UK, India, and South Korea since the end of 2018, and had stolen
                                    from at least one institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom, India, South Korea<br />
                                            <strong>Date Breach First Reported:</strong> 04/23/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Known
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 23, 2019, it was reported the Silence Group had targeted financial
                                            institutions in the UK, India, and South Korea since the end of 2018, and
                                            had stolen from at least one institution.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MexicoGang2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Romanian ATM Skimmer Gang Arrested in Mexico</h2>
                                <span class="frst-date">April 4</span>
                                <p>
                                    On March 31, Mexican law enforcement arrested two senior members of a Romanian cyber
                                    criminal group allegedly behind an ATM skimming operation in Mexico.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Mexico<br />
                                            <strong>Date Breach First Reported:</strong>4/4/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Skimmer <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 31, Mexican law enforcement arrested two senior members of a
                                            Romanian cyber criminal group allegedly behind an ATM skimming operation in
                                            Mexico. One suspect is believed to be the head of Instacash, a fraudulent
                                            ATM service provider operating out of Mexico. The head of Instacash
                                            allegedly bribed and coerced ATM technicians to install sophisticated
                                            Bluetooth-based skimmers inside competitor’s ATMs, enabling the Romanian
                                            cyber criminal group to steal PINs and card data remotely from ATMs
                                            throughout popular tourist destinations in Mexico.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BitHumb42019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BitHumb Crypto Heist #4</h2>
                                <span class="frst-date">March 29</span>
                                <p>
                                    On March 29, 2019, approximately $20 million in virtual currency was stolen from
                                    BitHumb, a South Korean cryptocurrency exchange, marking the fourth theft in two
                                    years.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 29, 2019, approximately $20 million in virtual currency was stolen
                                            from BitHumb, a South Korean cryptocurrency exchange, marking the fourth
                                            theft in two years. In August 2019, the UN Security Council Panel of Experts
                                            indicated DPRK-affiliated actors were behind the theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Kuwait2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Kuwait Bank Theft</h2>
                                <span class="frst-date">March 27</span>
                                <p>On March 27, 2019, attackers stole $49 million from a bank in Kuwait.</p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Kuwait<br />
                                            <strong>Date Breach First Reported:</strong> 08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 27, 2019, attackers stole $49 million from a bank in Kuwait. In
                                            August 2019, the UN Security Council Panel of Experts indicated
                                            DPRK-affiliated actors were behind the attempted theft.
                                        </p>
                                        <p>
                                            While the UN Security Council Panel of Experts did not reveal the name of
                                            the bank in Kuwait, the Gulf Bank of Kuwait announced a technical failure in
                                            its system of international remittances on Twitter on March 27.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="DragonEx2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>DragonEx Crypto Heist</h2>
                                <span class="frst-date">March 24</span>
                                <p>
                                    On March 24, 2019, $7 million in virtual currency was stolen from DragonEx, a
                                    Singapore based cryptocurrency exchange.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Singapore<br />
                                            <strong>Date Breach First Reported:</strong> 03/24/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 24, 2019, $7 million in virtual currency was stolen from DragonEx,
                                            a Singapore based cryptocurrency exchange. In August 2019, the UN Security
                                            Council Panel of Experts indicated DPRK-affiliated actors were behind the
                                            theft.
                                        </p>
                                        <p>
                                            Stolen coins were across a range of currencies including bitcoin, ether,
                                            xrp, litecoin and EOS. DragonEx released the addresses of 20 wallets where
                                            funds were transferred in the hopes of blocking the movement of these funds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RBSSec2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Royal Bank of Scotland Security Flaw</h2>
                                <span class="frst-date">March 22</span>
                                <p>
                                    In early 2019, the Royal Bank of Scotland’s (RBS) customer accounts were exposed to
                                    a security flaw after introducing a new customer security service.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>3/22/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Software vulnerability <br />
                                            <strong>Type:</strong> N/A
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In early 2019, the Royal Bank of Scotland’s (RBS) customer accounts were
                                            exposed to a security flaw after introducing a new customer security
                                            service. In January, RBS launched a free endpoint security service for
                                            customers in partnership with Danish firm Hedimal Security. While the
                                            security service was intended to detect threats and protect RBS customers
                                            from attacks, researchers discovered a software flaw that enabled access to
                                            customer emails, banking details and internet history. Hedimal Security has
                                            since released an update to fix the security flaw and insisted that only
                                            50,000 computers were effected. They claim that there were no intrusions as
                                            a result of the security flaw.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="UrsnifAttack2019"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Ursnif2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ursnif Malware Attack on Japanese Banks</h2>
                                <span class="frst-date">March 12</span>
                                <p>
                                    The Ursnif banking Trojan, which was discovered in 2007, was repurposed in a
                                    campaign targeting Japanese banks that began in 2016.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Japan<br />
                                            <strong>Date Breach First Reported:</strong>3/12/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Unknown
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            The Ursnif banking Trojan, which was discovered in 2007, was repurposed in a
                                            campaign targeting Japanese banks that began in 2016. Ursnif, also known as
                                            Gozi ISFB, is a popular malware that steals information on infected Windows
                                            devices. Ursnif has been deployed in a new campaign that specifically
                                            targets banks in Japan. The malware terminates itself on devices outside of
                                            the country. The campaign uses a distribution network of spam botnets and
                                            compromised web servers to deliver the Trojan. Between 2016 and 2017,
                                            researchers at Palo Alto Networks observed millions of infected emails sent
                                            to banks in Japan. Researchers have not been able to identify the operation
                                            behind the campaign, but evidence suggests it may be connected to the
                                            Cutwill Botnet, a cyber criminal operation active since 2007.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="GambianFI2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Gambian Financial Institution Attempted Theft</h2>
                                <span class="frst-date">March 1</span>
                                <p>
                                    In March 2019, attackers attempted to steal $9.3 million from a Gambian financial
                                    institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> The Gambia<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In March 2019, attackers attempted to steal $9.3 million from a Gambian
                                            financial institution. In August 2019, the UN Security Council Panel of
                                            Experts indicated DPRK-affiliated actors were behind the attempted theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NigerianFI2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Nigerian Financial Institution Attempted Theft</h2>
                                <span class="frst-date">March 1</span>
                                <p>
                                    In March 2019, attackers attempted to steal $12.2 million from a Nigerian financial
                                    institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Nigeria<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In March 2019, attackers attempted to steal $12.2 million from a Nigerian
                                            financial institution. In August 2019, the UN Security Council Panel of
                                            Experts indicated DPRK-affiliated actors were behind the attempted theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="BankVallettaAttack2019"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BankValletta2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bank of Valletta</h2>
                                <span class="frst-date">February 13</span>
                                <p>
                                    On February 13, the Bank of Valletta (BOV), Malta’s largest and oldest bank, shut
                                    down operations after an attempted theft of €13 million.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Malta<br />
                                            <strong>Date Breach First Reported:</strong> 2/14/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 13, the Bank of Valletta (BOV), Malta’s largest and oldest bank,
                                            shut down operations after an attempted theft of €13 million. In August
                                            2019, the UNSC Panel of Experts indicated DPRK-affiliated actors were behind
                                            the attack.
                                        </p>
                                        <p>
                                            Attackers made multiple transfer requests from the Maltese bank to accounts
                                            in the UK, United States, Czech Republic, and Hong Kong. The bank’s
                                            employees discovered the fraudulent activity during their daily
                                            reconciliation of international orders. Within the hour, BOV notified other
                                            banks in an attempt to freeze the transactions. It also closed all its
                                            branches, shut down its ATMs and point-of-sale system, and stopped all other
                                            electronic services, which were restored the following day. In a statement,
                                            BOV said it was working with local and international police authorities to
                                            track down the attackers. On January 30, 2020, the UK's National Crime
                                            Agency issued arrests in London and Belfast, suspected to be in connection
                                            to the BOV heist.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="USCreditUnionAttack2019"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="USCreditUnion2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>U.S. Credit Union Spear-Phishing</h2>
                                <span class="frst-date">February 8</span>
                                <p>
                                    Multiple credit unions in the United States were hit by spear-phishing emails
                                    impersonating compliance officers from other credit unions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>2/8/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> N/A
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Multiple credit unions in the United States were hit by spear-phishing
                                            emails impersonating compliance officers from other credit unions. Under the
                                            Bank Secrecy Act (BSA), financial institutions are required to have
                                            dedicated compliance personnel responsible for reporting suspicious
                                            transactions and potentially fraudulent activity to the U.S. government.
                                            Emails sent to these compliance officers contained a PDF with a malicious
                                            link. While it is believed that no employee clicked the link, there is
                                            speculation as to how the attackers obtained the email addresses of the
                                            compliance officers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SBI2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>SBI Breach</h2>
                                <span class="frst-date">February 4</span>
                                <p>
                                    The State Bank of India, the country’s largest, has denied claims that its servers
                                    were compromised during a recent intrusion.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong>2/4/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Unknown
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            The State Bank of India, the country’s largest, has denied claims that its
                                            servers were compromised during a recent intrusion. Multiple media outlets
                                            reported an SBI server was unprotected, and as a result attackers were able
                                            to gain access to the system and steal users’ personal information. Despite
                                            the claims, the bank said their investigation revealed that SBI’s servers
                                            remained fully protected and that no breach had occurred.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MetroBank2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Metro Bank 2FA Breach</h2>
                                <span class="frst-date">February 2</span>
                                <p>
                                    UK-based Metro Bank became the first major bank to suffer from a new type of cyber
                                    intrusion that intercepts text messages with two-factor authentication codes used to
                                    verify various customer transactions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>2/2/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            UK-based Metro Bank became the first major bank to suffer from a new type of
                                            cyber intrusion that intercepts text messages with two-factor authentication
                                            codes used to verify various customer transactions. The attackers exploited
                                            flaws in the Signaling System 7 (SS7) protocol, which is used by
                                            telecommunications companies to route text messages around the world. A
                                            spokesperson for the bank stated that only a small number of those defrauded
                                            were Metro Bank customers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SpanishFI2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Spanish Financial Institution Attempted Theft</h2>
                                <span class="frst-date">February 1</span>
                                <p>
                                    In February 2019, attackers attempted to steal $32 million from a a Spanish
                                    financial institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Spain<br />
                                            <strong>Date Breach First Reported:</strong> 08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2019, attackers attempted to steal $32 million from a a Spanish
                                            financial institution. In August 2019, the UN Security Council Panel of
                                            Experts indicated DPRK-affiliated actors were behind the attempted theft.
                                        </p>
                                        <p>
                                            Spain’s National Cryptologic Centre (CCN), under the National Intelligence
                                            Centre stated in its 2019 Cyberthreats and Trends report that hackers
                                            associated with the DPRK government conducted the largest number of reported
                                            cyberattacks against Spain in 2018.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="ChileATMAttack2019"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ChileATM2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Chile ATM Attack</h2>
                                <span class="frst-date">January 10</span>
                                <p>
                                    In December, hackers infiltrated Chile’s ATM interbank network, Redbanc, after
                                    tricking an employee into downloading a malicious program during a fake job
                                    interview over Skype.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Chile<br />
                                            <strong>Date Breach First Reported:</strong> 1/15/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Espionage
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In December, hackers infiltrated Chile’s ATM interbank network, Redbanc,
                                            after tricking an employee into downloading a malicious program during a
                                            fake job interview over Skype. In August 2019, the UNSC Panel of Experts
                                            indicated DPRK-affiliated actors were behind the attack.
                                        </p>
                                        <p>
                                            It is believed that the Redbanc employee saw a LinkedIn job advertisement
                                            and attended a Skype interview where the attackers asked him to download a
                                            software program to submit his application form. The attackers tricked the
                                            victim into downloading malware on his system, giving them access to
                                            Redbanc’s network. Redbanc claims the event had no impact on its business
                                            operations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Fuze2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Fuze Cards</h2>
                                <span class="frst-date">January 10</span>
                                <p>
                                    The U.S. Secret Service has identified a number of criminal rings turning to Fuze
                                    cards in an attempt to avoid detection by U.S. law enforcement.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>1/10/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Cards <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            The U.S. Secret Service has identified a number of criminal rings turning to
                                            Fuze cards in an attempt to avoid detection by U.S. law enforcement. A Fuze
                                            card is a data storage device that looks like a bank card, but can hold
                                            account data for up to thirty cards. Using smartcard technology can help
                                            criminals avoid raising suspicions at payment points or if stopped by
                                            authorities, as it reduces the need for them to carry large numbers of
                                            counterfeit cards on their person.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Janeleiro2019">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Janeleiro Malware Targets Brazilian Organizations</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    On April 6, 2021, a security firm reported a new banking trojan called Janeleiro
                                    that has been targeting corporate users in Brazil since 2019.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil<br />
                                            <strong>Date Breach First Reported:</strong>4/6/2021
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 6, 2021, a security firm reported a new banking trojan called
                                            Janeleiro that has been targeting corporate users in Brazil since 2019. The
                                            affected sectors include engineering, healthcare, retail, manufacturing,
                                            finance, transportation, and government. The malware steals the personal
                                            information and banking credentials of users through fake pop-ups that
                                            imitate Brazilian banks websites.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2018</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Evercore2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Evercore Breach</h2>
                                <span class="frst-date">December 23</span>
                                <p>
                                    In November, hackers breached Evercore gaining access to thousands of sensitive
                                    documents from the global investment bank.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Western Europe<br />
                                            <strong>Date Breach First Reported:</strong>12/23/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In November, hackers breached Evercore gaining access to thousands of
                                            sensitive documents from the global investment bank. The attackers used
                                            phishing tactics to gain access to an employee’s inbox, enabling them to
                                            steal around 160,000 pieces of data including documents, diary invitations,
                                            and emails. A source at the bank believes the motivation for the breach was
                                            to access the administrator's address book to send more phishing emails. The
                                            source also claims no data had been misused in result of the breach.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Click2Gov2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Government Payment Portals</h2>
                                <span class="frst-date">December 18</span>
                                <p>
                                    In August 2017, Click2Gov, an online bill-payment portal used to pay for local
                                    government services in the United States, was the victim of a data breach.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>12/18/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In August 2017, Click2Gov, an online bill-payment portal used to pay for
                                            local government services in the United States, was the victim of a data
                                            breach. The breach exposed customer data including payment card details and
                                            log-in credentials of users in over forty U.S. cities. Threat intelligence
                                            firm Gemini Advisory discovered that several users’ card details were sold
                                            on the dark web for approximately £10. Gemini identified 294,929 compromised
                                            payment records, resulting in at least $1.7 million in earnings for the
                                            criminals.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BrazilMalware2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Brazilian Mobile Malware</h2>
                                <span class="frst-date">December 13</span>
                                <p>
                                    In mid-December, a report revealed that over 2,000 mobile banking users in Brazil
                                    downloaded an Android-based Trojan through Google Play applications.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil<br />
                                            <strong>Date Breach First Reported:</strong>12/13/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In mid-December, a report revealed that over 2,000 mobile banking users in
                                            Brazil downloaded an Android-based Trojan through Google Play applications.
                                            Victims unknowingly downloaded the malware, allowing attackers to gain
                                            access to user devices and data. The “Android.BankBot.495” malware was
                                            designed to read the victim’s information when they logged into their mobile
                                            banking app. Reports suggest that the malware also targeted apps such as
                                            Uber, Netflix, and Twitter using phishing tactics.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Threadkit2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>ThreadKit Exploit</h2>
                                <span class="frst-date">December 11</span>
                                <p>
                                    In late 2018, security researchers uncovered that Cobalt, a state-sponsored threat
                                    group that specializes in attacks on financial institutions, had begun employing a
                                    new variant of the ThreadKit exploit builder kit to execute phishing schemes
                                    utilizing Microsoft Office documents.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Eastern Europe (Ukraine; Poland; Romania; Czech
                                            Republic; Hungary; Belarus; Bulgaria; Slovakia; Moldova)<br />
                                            <strong>Date Breach First Reported:</strong>12/11/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Espionage
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In late 2018, security researchers uncovered that Cobalt, a state-sponsored
                                            threat group that specializes in attacks on financial institutions, had
                                            begun employing a new variant of the ThreadKit exploit builder kit to
                                            execute phishing schemes utilizing Microsoft Office documents. First
                                            observed in October 2017, the new tactics show an evolution of the ThreadKit
                                            macro delivery tool and demonstrate the growing range of techniques employed
                                            by malicious actors.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="EEBanks2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Eastern European Banks Targeted From the Inside</h2>
                                <span class="frst-date">December 6</span>
                                <p>
                                    In 2017 and 2018, eight banks in Eastern Europe were targeted by attackers who
                                    connected electronic devices directly to the banks’ infrastructure.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Eastern Europe<br />
                                            <strong>Date Breach First Reported:</strong>12/6/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In 2017 and 2018, eight banks in Eastern Europe were targeted by attackers
                                            who connected electronic devices directly to the banks’ infrastructure.
                                            Attackers used a range of readily available devices such as netbooks,
                                            inexpensive laptops, USB tools, and other devices. The attackers disguised
                                            themselves as job seekers or couriers and gained access to the local network
                                            from various places inside the victims’ central or regional offices, and
                                            even from company branches in different countries. Once they gained access
                                            to the target bank’s infrastructure, the attackers scanned its networks to
                                            collect valuable information, such as account details for making payments.
                                            The attacks are believed to have caused tens of millions of dollars in
                                            damages.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RapidRaids2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Rapid Raids Jackpotting</h2>
                                <span class="frst-date">November 14</span>
                                <p>
                                    On November 14, two Venezuelan men were found guilty of jackpotting, where they
                                    installed malicious software or hardware on ATMs to force the machines to dispense
                                    huge volumes of cash on demand.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>11/14/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High Confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On November 14, two Venezuelan men were found guilty of jackpotting, where
                                            they installed malicious software or hardware on ATMs to force the machines
                                            to dispense huge volumes of cash on demand. From February to March, the duo
                                            stole $125,000 from four ATMs in Indiana, Kentucky, Wisconsin, and most
                                            recently Michigan, where they were apprehended.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Postbank2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Postbank Internal Data Breach and Fraud</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    In December 2018, Postbank, the banking division of South Africa’s post office,
                                    experienced an internal data breach resulting in the theft of over $3.2 million and
                                    the forced replacement of 12 million cards.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong> 06/18/2020
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Insider<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In December 2018, Postbank, the banking division of South Africa’s post
                                            office, experienced an internal data breach resulting in the theft of over
                                            $3.2 million and the forced replacement of 12 million cards. Employees stole
                                            Postbank’s 36-digit master encryption key and used it to access account
                                            balances in 25.000 fraudulent transactions over the course of a year.
                                        </p>
                                        <p>
                                            According to internal documents acquired by journalists, the stolen 36-digit
                                            encryption key, “allows anyone who has it to gain unfettered access to the
                                            bank’s systems, and allows them to read and rewrite account balances, and
                                            change information and data on any of the bank’s 12-million cards.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="HSBCUS2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>HSBC U.S. Breach</h2>
                                <span class="frst-date">November 6</span>
                                <p>
                                    In November, HSBC reported that hackers had gained access to customer data including
                                    names, addresses, phone numbers, and account details.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>11/6/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In November, HSBC reported that hackers had gained access to customer data
                                            including names, addresses, phone numbers, and account details. When HSBC
                                            discovered the compromised accounts, they suspended online access for
                                            affected customers to prevent further entry to the accounts. At the time of
                                            release, HSBC did not provide details on the number of customers affected.
                                            However, claims estimate that less than 1 percent of the bank’s U.S. online
                                            accounts were potentially compromised.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Magecart2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Magecart Payments Breach</h2>
                                <span class="frst-date">November 2</span>
                                <p>
                                    In early November, Lloyds Banking Group and other UK banks were forced to replace
                                    payment cards after the breach of numerous retail sites.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>11/2/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In early November, Lloyds Banking Group and other UK banks were forced to
                                            replace payment cards after the breach of numerous retail sites. Websites
                                            for retailers, including Ticketmaster and British Airways, were manipulated
                                            to skim card information from hundreds of thousands of customers using the
                                            Magecart toolset.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="BankIslami2018"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Islami2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bank Islami</h2>
                                <span class="frst-date">October 29</span>
                                <p>
                                    On October 29, 2018, Bank Islami in Pakistan detected a cyber attack on its
                                    international payment card network.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Pakistan<br />
                                            <strong>Date Breach First Reported:</strong>10/29/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 29, 2018, Bank Islami in Pakistan detected a cyber attack on its
                                            international payment card network. The bank uncovered suspicious
                                            transactions from payment cards outside of Pakistan and immediately shut
                                            down its international payment scheme. The bank confirmed that around 2.6
                                            million Pakistani rupees (roughly $19,500) were withdrawn from customer
                                            accounts. Following the incident, the State Bank of Pakistan (SBP) issued
                                            directives to all banks, encouraging them to ensure the security of all
                                            payment cards and monitor card activity on a real-time basis.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="DataPakistan2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Pakistan Data Theft</h2>
                                <span class="frst-date">October 27</span>
                                <p>
                                    On October 27, cybersecurity firm Group-IB reported a spike in sales of card details
                                    from Pakistani customers on Joker’s Stash, a popular online marketplace for stolen
                                    information.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Pakistan<br />
                                            <strong>Date Breach First Reported:</strong> 10/27/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 27, cybersecurity firm Group-IB reported a spike in sales of card
                                            details from Pakistani customers on Joker’s Stash, a popular online
                                            marketplace for stolen information. Group-IB identified more than 150,000
                                            card details from at least three Pakistani banks. The Pakistani Federal
                                            Investigation Agency revealed that almost all the nation’s banks had been
                                            affected. However, the State Bank of Pakistan has disputed the scale of the
                                            incident. The compromise of card details came weeks after Karachi-based Bank
                                            Islami suffered a breach of its payment cards system.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="AXA2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>AXA Targeted in Mexico</h2>
                                <span class="frst-date">October 23</span>
                                <p>
                                    On October 22, 2018, unknown hackers attacked insurance firm AXA, causing problems
                                    to the SPEI interbank payment matching system.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Mexico<br />
                                            <strong>Date Breach First Reported:</strong>10/23/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 22, 2018, unknown hackers attacked insurance firm AXA, causing
                                            problems to the SPEI interbank payment matching system. This incident
                                            prompted Mexico’s central bank to raise the security alert level on its
                                            payments system. AXA reported no client information or money was affected by
                                            the incident.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="SAHostingPlatform2018"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South African Hosting Platform Breach</h2>
                                <span class="frst-date">October 5</span>
                                <p>
                                    On October 5, 2018, Hetzner, a popular web hosting platform in South Africa, was
                                    once again targeted in a security breach—the second such breach in a year.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>10/11/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 5, 2018, Hetzner, a popular web hosting platform in South Africa,
                                            was once again targeted in a security breach—the second such breach in a
                                            year. The hackers gained access to private customer information, including
                                            email addresses, phone numbers, and bank account information. Credit card
                                            information and user website passwords were not accessed. The company
                                            noticed the suspicious activity and launched an investigation, warning
                                            customers to beware phishing attacks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Mauritius2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>State Bank of Mauritius</h2>
                                <span class="frst-date">October 2</span>
                                <p>
                                    In October 2018, the Indian subsidiary of the State Bank of Mauritius was targeted
                                    by attackers who attempted to steal $14 million through compromised IT systems.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Mauritius<br />
                                            <strong>Date Breach First Reported:</strong>10/2/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In October 2018, the Indian subsidiary of the State Bank of Mauritius was
                                            targeted by attackers who attempted to steal $14 million through compromised
                                            IT systems. The bank managed to recover $10 million in the days following
                                            the attack and said no customers would lose money as a result. The thieves
                                            reportedly withdrew the funds using fraudulent messages on the SWIFT
                                            interbank messaging network.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Zaif2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Zaif Crypto Heist</h2>
                                <span class="frst-date">September 14</span>
                                <p>
                                    On September 14, 2018, approximately $60 million in virtual currency was stolen from
                                    Zaif, a Japanese cryptocurrency exchange.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Japan<br />
                                            <strong>Date Breach First Reported:</strong> 09/14/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 14, 2018, approximately $60 million in virtual currency was
                                            stolen from Zaif, a Japanese cryptocurrency exchange.
                                        </p>
                                        <p>
                                            The attackers accessed the exchange’s hot wallets to steal roughly $60
                                            million in bitcoin, bitcoin cash, and MonaCoin. The identity of the
                                            attackers remains unknown.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Silence2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Russian Bank Heists by Silence Group</h2>
                                <span class="frst-date">September 5</span>
                                <p>
                                    First reported in 2018, Russian-speaking hackers, dubbed Silence by researchers at
                                    Group IB, targeted Russian banks, stealing $550,000 within a year.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Russia<br />
                                            <strong>Date Breach First Reported:</strong>9/5/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            First reported in 2018, Russian-speaking hackers, dubbed Silence by
                                            researchers at Group IB, targeted Russian banks, stealing $550,000 within a
                                            year. After an unsuccessful attempt to penetrate the Russian Central Bank’s
                                            automated workstation client, the group attacked ATMs directly and through
                                            the supply chain, using phishing emails as its means of entry to the
                                            networks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BancoPeruvian2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Banco de la Nacion</h2>
                                <span class="frst-date">August 17</span>
                                <p>
                                    Over the weekend of August 17–19, 2018, an attack took place on Peruvian banks that
                                    forced at least one bank to take down its internet banking services and some card
                                    transactions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Peru, Thailand, Malaysia, Indonesia, United
                                            States, Latin America<br />
                                            <strong>Date Breach First Reported:</strong>8/17/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Ransomware<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Over the weekend of August 17–19, 2018, an attack took place on Peruvian
                                            banks that forced at least one bank to take down its internet banking
                                            services and some card transactions. There were reports that a new strain of
                                            ransomware was involved. The extent of the damage done remains unclear, but
                                            there were no indications in the weeks afterward that the attack targeted
                                            payment systems, or was a smokescreen for other activity.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="CosmosBankSwift2018"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Cosmos2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Cosmos Bank SWIFT Heist</h2>
                                <span class="frst-date">August 11</span>
                                <p>
                                    In August 2018, it was reported that Cosmos Bank, the second-biggest cooperative
                                    bank in India, lost $13.5 million through ATMs in twenty-eight countries as well as
                                    through unauthorized interbank transactions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong>8/11/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In August 2018, it was reported that Cosmos Bank, the second-biggest
                                            cooperative bank in India, lost $13.5 million through ATMs in twenty-eight
                                            countries as well as through unauthorized interbank transactions. The
                                            attackers seem to have stolen card information and also set up their own
                                            proxy server so transactions with stolen details would not trigger alarms.
                                            In August 2019, the UNSC Panel of Experts indicated DPRK-affiliated actors
                                            were behind the attack.
                                        </p>
                                        <p>
                                            Over the course of just a few hours on August 11, the group coordinated
                                            almost 15,000 transactions to cash out funds through ATMs worldwide using
                                            compromised Visa and Rupay cards. Two days later, the attackers made further
                                            fraudulent transactions through the bank’s interface to the SWIFT messaging
                                            system—a technique used in numerous bank attacks, including against fellow
                                            Indian lender City Union Bank (CUB) in February.
                                        </p>
                                        <p>
                                            The parallels with the CUB heist continued after police arrested several
                                            suspects accused of taking the funds from ATMs. Four of the people involved
                                            also admitted playing a role in the earlier theft, according to
                                            investigators in September.
                                        </p>
                                        <p>
                                            The attack left Cosmos’s online banking service offline for more than a
                                            week, and the funds have not been recovered. There were signs that an attack
                                            on a bank was coming. Two days before the incident, the FBI issued a warning
                                            to banks about an imminent ATM cash-out scheme, without providing further
                                            public details.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Blacksburg2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>National Bank of Blacksburg</h2>
                                <span class="frst-date">July 24</span>
                                <p>
                                    In May 2016 and January 2017, the National Bank of Blacksburg, based in the state of
                                    Virginia, was hit by phishing emails that enabled intruders to install malware and
                                    pivot into the Star Network, a U.S. bank card processing service.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>7/24/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In May 2016 and January 2017, the National Bank of Blacksburg, based in the
                                            state of Virginia, was hit by phishing emails that enabled intruders to
                                            install malware and pivot into the Star Network, a U.S. bank card processing
                                            service. The 2017 attack gave wider access to bank networks and enabled the
                                            thieves to withdraw $1.8 million over the course of a weekend, taking total
                                            losses to $2.4 million. According to a lawsuit filed by the bank against its
                                            insurer to recover more of its losses, an investigation after the second
                                            attack concluded that both incidents were by the same group, using tools and
                                            servers of Russian origin.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PIR2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>PIR Bank Attacked</h2>
                                <span class="frst-date">July 19</span>
                                <p>
                                    On July 3, 2018, attackers targeted Russia’s version of the SWIFT interbank network,
                                    the Automated Workstation Client, to siphon around $1 million from PIR Bank.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Russia<br />
                                            <strong>Date Breach First Reported:</strong>7/19/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 3, 2018, attackers targeted Russia’s version of the SWIFT interbank
                                            network, the Automated Workstation Client, to siphon around $1 million from
                                            PIR Bank. After breaching the network through an outdated router, the group
                                            attempted to install Powershell scripts to remain on the banks’ systems. A
                                            report by Group IB, which responded to the incident, attributed it to an
                                            established criminal group named MoneyTaker that has targeted more than a
                                            dozen banks in the United States, Russia, and the UK since 2016.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BitHumb32018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BitHumb Crypto Heist #3</h2>
                                <span class="frst-date">June 19</span>
                                <p>
                                    On June 19, 2018, approximately $31 million in virtual currency was stolen from
                                    BitHumb, a South Korean cryptocurrency exchange, marking the third theft in the last
                                    16 months.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 19, 2018, approximately $31 million in virtual currency was stolen
                                            from BitHumb, a South Korean cryptocurrency exchange, marking the third
                                            theft in the last 16 months. In August 2019, the UN Security Council Panel
                                            of Experts indicated DPRK-affiliated actors were behind the theft. Proceeds
                                            were laundered through a separate crypto-currency exchange called YoBit. The
                                            company stated they would compensate customers affected.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SAInsurer2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South African Insurer Ransom Attack</h2>
                                <span class="frst-date">June 16</span>
                                <p>
                                    On June 16, 2018, South African insurer Liberty Holdings was targeted by hackers who
                                    claimed to have seized data from the firm.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>06/18/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 16, 2018, South African insurer Liberty Holdings was targeted by
                                            hackers who claimed to have seized data from the firm. The hackers
                                            threatened to publicly disclose the data unless compensated. Liberty
                                            Holdings refused to pay up, suspecting that the stolen data was largely
                                            comprised of recent email exchanges.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Coinrail2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Coinrail Crypto Heist</h2>
                                <span class="frst-date">June 10</span>
                                <p>
                                    On June 10, 2018, approximately $37 million in virtual currency was stolen from
                                    Coinrail, a South Korean cryptocurrency exchange.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>06/10/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 10, 2018, approximately $37 million in virtual currency was stolen
                                            from Coinrail, a South Korean cryptocurrency exchange. The identity of the
                                            attackers remains unknown.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Liberian2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Liberian Financial Institution Attempted Theft</h2>
                                <span class="frst-date">June 1</span>
                                <p>
                                    In June 2018, attackers attempted to steal $32 million from a Liberian financial
                                    institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Liberia<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In June 2018, attackers attempted to steal $32 million from a Liberian
                                            financial institution. In August 2019, the UN Security Council Panel of
                                            Experts indicated DPRK-affiliated actors were behind the attempted theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Canada2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Data Breach Involving Canadian Banks</h2>
                                <span class="frst-date">May 28</span>
                                <p>
                                    In 2018, it was revealed that up to 90,000 clients of the Canadian banks Simplii and
                                    Bank of Montreal (BMO) had been exposed by a data breach that the organization
                                    blamed on unidentified fraudsters.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Canada<br />
                                            <strong>Date Breach First Reported:</strong>5/28/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In 2018, it was revealed that up to 90,000 clients of the Canadian banks
                                            Simplii and Bank of Montreal (BMO) had been exposed by a data breach that
                                            the organization blamed on unidentified fraudsters. Bank of Montreal said
                                            there was a threat to make the data public from the group, which it thinks
                                            is behind the thefts from both banks. Simplii and BMO are now facing a class
                                            action lawsuit, with those involved arguing that the banks failed to
                                            properly protect sensitive information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="BancoDeChile2018"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BancoChile2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Banco de Chile Incident</h2>
                                <span class="frst-date">May 24</span>
                                <p>
                                    In May 2018, Banco de Chile suffered a $10 million theft after the attackers used
                                    destructive software as cover for a fraudulent SWIFT transfer.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Chile<br />
                                            <strong>Date Breach First Reported:</strong>5/24/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Disruption, theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In May 2018, Banco de Chile suffered a $10 million theft after the attackers
                                            used destructive software as cover for a fraudulent SWIFT transfer. The
                                            bank’s 9,000 workstations and 500 servers failed on May 24 as the KillMBR
                                            wiper tool rendered them unable to boot up, adding it to the growing ranks
                                            of Latin American banks suffering cyber attacks. In August 2019, the UNSC
                                            Panel of Experts indicated DPRK-affiliated actors were behind the attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="ViewFines2018"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ViewFines2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>ViewFines Data Breach</h2>
                                <span class="frst-date">May 23</span>
                                <p>
                                    On May 23, ViewFines, an online traffic website, suffered a major data breach
                                    involving the personal records of 934,000 South African drivers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>5/24/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 23, ViewFines, an online traffic website, suffered a major data
                                            breach involving the personal records of 934,000 South African drivers. The
                                            leak was the result of the company's faulty practice of creating a temporary
                                            backup on a publicly viewable directory. A week after the incident, the
                                            company sent warning emails to all of its users about the breach.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="MexicanBankTheft2018"></a>
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Mexican2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Mexican Bank Theft</h2>
                                <span class="frst-date">May 12</span>
                                <p>
                                    Banco de Mexico warned a dozen banks to upgrade their security following $15 million
                                    in fraudulent cash withdrawals from five institutions linked to the central bank’s
                                    electronic payments system, SPEI.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Mexico<br />
                                            <strong>Date Breach First Reported:</strong>5/12/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Software vulnerability<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Banco de Mexico warned a dozen banks to upgrade their security following $15
                                            million in fraudulent cash withdrawals from five institutions linked to the
                                            central bank’s electronic payments system, SPEI. A vulnerability in
                                            third-party software connected to SPEI was used by unknown attackers to get
                                            into the system and make a series of fraudulent transactions before cashing
                                            out.
                                        </p>
                                        <p>
                                            The investigators have not made clear whether each victim bank was
                                            compromised, or whether the attackers moved between them following the
                                            initial breach. It is also unclear whether the gang had insider help to
                                            clear large transactions through the banks’ security checks. The incidents
                                            delayed legitimate transfers but the central bank said client money and the
                                            SPEI infrastructure were unaffected.
                                        </p>
                                        <p>
                                            Following the thefts, Banco de Mexico set up a new cybersecurity unit and
                                            asked its members to move to an in-house, encrypted software with SPEI. The
                                            incident came five months after Bancomext, the state-owned trade bank,
                                            blocked attempts to siphon off $110 million via a compromise in the network
                                            that granted attackers access to the global SWIFT interbank system.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="DDOS2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>DDoS-for-Hire</h2>
                                <span class="frst-date">April 1</span>
                                <p>
                                    In April 2018, it was revealed that authorities in five countries worked together to
                                    take down Webstresser, a DDoS-for-hire site they said was behind up to 6 million
                                    attacks around the world over three years.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Western Europe<br />
                                            <strong>Date Breach First Reported:</strong>4/1/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In April 2018, it was revealed that authorities in five countries worked
                                            together to take down Webstresser, a DDoS-for-hire site they said was behind
                                            up to 6 million attacks around the world over three years. The site was used
                                            to launch a coordinated attack on seven UK banks in November 2017, according
                                            to the UK’s National Crime Agency. Several people have been arrested, and
                                            the U.S. Department of Defense seized the website.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MalaysiaSWIFT2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Malaysian Central Bank Attempted SWIFT Heist</h2>
                                <span class="frst-date">March 29</span>
                                <p>
                                    On March 29, 2018, attackers attempted to use fraudulent SWIFT transactions to steal
                                    $390 million from the Malaysian Central Bank.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Malaysia<br />
                                            <strong>Date Breach First Reported:</strong> 08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 29, 2018, attackers attempted to use fraudulent SWIFT transactions
                                            to steal $390 million from the Malaysian Central Bank.
                                        </p>
                                        <p>
                                            According to the Malaysian Central Bank no funds were stolen during the
                                            incident and the bank's payment systems remained unaffected and operational.
                                            In August 2019, the UN Security Council Panel of Experts indicated
                                            DPRK-affiliated actors were behind the attempted theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RapidRaidsMar2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Rapid Raids Jackpotting</h2>
                                <span class="frst-date">March 19</span>
                                <p>
                                    In March 2018, two Venezuelan men were arrested for jackpotting, where they
                                    installed malicious software or hardware on ATMs to force the machines to dispense
                                    huge volumes of cash on demand.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>3/18/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In March 2018, two Venezuelan men were arrested for jackpotting, where they
                                            installed malicious software or hardware on ATMs to force the machines to
                                            dispense huge volumes of cash on demand. From February to March, the duo
                                            stole $125,000 from four ATMs in Indiana, Kentucky, Wisconsin, and most
                                            recently Michigan, where they were apprehended. The pair were sentenced to
                                            federal prison in November 2018 for conspiracy to commit bank robbery.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Mabna2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Mabna Iranian Hack on the United States</h2>
                                <span class="frst-date">March 23</span>
                                <p>
                                    Two financial firms were among the various U.S. targets of a hacking group operating
                                    under the guise of the Mabna Institute, which used password spraying to access
                                    information.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>3/23/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Password spraying<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Two financial firms were among the various U.S. targets of a hacking group
                                            operating under the guise of the Mabna Institute, which used password
                                            spraying to access information. The actors are accused by the United States
                                            of stealing 31 terabytes of academic and commercial information in a
                                            campaign dating as far back as 2013. Nine Iranians have been charged by the
                                            United States, which claims the group acts on behalf of the Islamic
                                            Revolutionary Guard Corps and has imposed sanctions on numerous individuals
                                            and companies in the country as a result.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Swift2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>City Union Bank SWIFT Attack</h2>
                                <span class="frst-date">February 18</span>
                                <p>
                                    In February 2018, City Union Bank in India suffered a breach that allowed $1 million
                                    to be transferred to a Chinese institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong>2/18/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2018, City Union Bank in India suffered a breach that allowed $1
                                            million to be transferred to a Chinese institution. The attackers tried to
                                            make three transactions totaling $2 million, sending money to Dubai and
                                            Turkey, but were thwarted by City Union Bank and the corresponding bank on
                                            the receiving end of the transfer. Two years earlier, attackers attempted
                                            but failed to make a $170 million SWIFT transfer out of the Union Bank of
                                            India. In August 2019, the UNSC Panel of Experts indicated DPRK-affiliated
                                            actors were behind the attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BitGrail2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BitGrail Crypto Heist</h2>
                                <span class="frst-date">February 9</span>
                                <p>
                                    On February 9, 2018, BitGrail, a small Italian cryptocurrency exchange, announced
                                    that attackers had stolen $170 million in Nano, a cryptocurrency. The identity of
                                    the attackers remains unknown.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Italy<br />
                                            <strong>Date Breach First Reported:</strong>02/10/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 9, 2018, BitGrail, a small Italian cryptocurrency exchange,
                                            announced that attackers had stolen $170 million in Nano, a cryptocurrency.
                                            The identity of the attackers remains unknown.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Infraud2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Infraud Gang</h2>
                                <span class="frst-date">February 7</span>
                                <p>
                                    In February 2018, it was revealed that thirty-six people from seven countries had
                                    been indicted in the United States for their alleged involvement in the Infraud
                                    Organization, which law enforcement officials say sells stolen personal and
                                    financial information.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Netherlands<br />
                                            <strong>Date Breach First Reported:</strong>2/7/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2018, it was revealed that thirty-six people from seven
                                            countries had been indicted in the United States for their alleged
                                            involvement in the Infraud Organization, which law enforcement officials say
                                            sells stolen personal and financial information. More than half a billion
                                            dollars was lost by the victims, the U.S. Department of Justice said, with a
                                            trail going back to October 2010. The organization was said to have more
                                            than 10,000 registered members who bought and sold illicit products
                                            including malware, data from credit card dumps, and information needed for
                                            identity fraud.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Dutch2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Dutch DDoS Attack</h2>
                                <span class="frst-date">January 29</span>
                                <p>
                                    In January, ABN Amro, Rabobank, and ING suffered disruptions to online and mobile
                                    banking services, while the Dutch tax authority website was taken down for several
                                    minutes.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Netherlands<br />
                                            <strong>Date Breach First Reported:</strong>1/29/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In January, ABN Amro, Rabobank, and ING suffered disruptions to online and
                                            mobile banking services, while the Dutch tax authority website was taken
                                            down for several minutes. Initial reports raised concerns of a Russian
                                            connection to the attack, as it came a week after a media report that Dutch
                                            intelligence agents had infiltrated the Russian threat group APT 29.
                                            However, an eighteen-year-old from the Dutch city of Oosterhout was arrested
                                            in February for the attack, having claimed online that he bought a
                                            “stresser” tool for €40 that enabled him to send a deluge of traffic to
                                            victim websites.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Coincheck2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Coincheck Crypto Heist</h2>
                                <span class="frst-date">January 26</span>
                                <p>
                                    On January 26, 2018, $534 million worth of NEM, a cryptocurrency was stolen from
                                    Coincheck, a Japanese cryptocurrency exchange, forcing Coincheck to freeze all
                                    transactions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Japan<br />
                                            <strong>Date Breach First Reported:</strong> 01/26/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 26, 2018, $534 million worth of NEM, a cryptocurrency was stolen
                                            from Coincheck, a Japanese cryptocurrency exchange, forcing Coincheck to
                                            freeze all transactions.
                                        </p>
                                        <p>
                                            In August 2019, the UN Security Council Panel of Experts indicated
                                            DPRK-affiliated actors were behind the theft. NEM Foundation president Lon
                                            Wong called the incident, “the biggest theft in the history of the world.”
                                            Group-IB, a Singapore-based security firm, also attributed the theft to
                                            Lazarus, a group of North Korean hackers, in October 2018.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="KenyaBank2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>National Bank of Kenya Fraud</h2>
                                <span class="frst-date">January 17</span>
                                <p>On January 17, fraudsters stole Sh29 million from the National Bank of Kenya.</p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Kenya<br />
                                            <strong>Date Breach First Reported:</strong>09/21/2018
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 17, fraudsters stole Sh29 million from the National Bank of
                                            Kenya. The bank has noted that the attempted fraud was frustrated by the
                                            system's monitoring and security platforms, and that they were confident
                                            they could recover the siphoned funds.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Bancomext2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bancomext Attempted SWIFT Heist</h2>
                                <span class="frst-date">January 9</span>
                                <p>
                                    On January 9, 2018, attackers attempted to use fraudulent SWIFT transactions to
                                    steal $110 million from Bancomext, Mexico’s state-owned trade bank, but the money
                                    was ultimately recovered.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Mexico<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On January 9, 2018, attackers attempted to use fraudulent SWIFT transactions
                                            to steal $110 million from Bancomext, Mexico’s state-owned trade bank, but
                                            the money was ultimately recovered. In August 2019, the UN Security Council
                                            Panel of Experts indicated DPRK-affiliated actors were behind the attempted
                                            theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CostaRica2018">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Costa Rican Financial Institution Attempted Theft</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    In January 2018, attackers attempted to steal $19 million from a private Costa Rican
                                    financial institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Costa Rica<br />
                                            <strong>Date Breach First Reported:</strong> 08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In January 2018, attackers attempted to steal $19 million from a private
                                            Costa Rican financial institution. In August 2019, the UN Security Council
                                            Panel of Experts indicated DPRK-affiliated actors were behind the attempted
                                            theft.
                                        </p>
                                        <p>
                                            In a submission to the United Nations Security Council Panel of Experts, the
                                            Costa Rican government confirmed that an investigation was launched by the
                                            Office of the Public Prosecutor’s Division on Fraud.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2017</span>
                        </div>
                        <!-- .frst-start-label -->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NiceHash2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>NiceHash Crypto Heist</h2>
                                <span class="frst-date">December 6</span>
                                <p>
                                    On December 6, 2017, approximately $70 million was stolen from NiceHash, a Slovenian
                                    cryptocurrency mining service.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Slovenia<br />
                                            <strong>Date Breach First Reported:</strong>12/06/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 6, 2017, approximately $70 million was stolen from NiceHash, a
                                            Slovenian cryptocurrency mining service. In August 2019, the UN Security
                                            Council Panel of Experts indicated DPRK-affiliated actors were behind the
                                            theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Youbit2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Youbit Hacked</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    On December 19, 2017, YouBit, a South Korean cryptocurrency exchange, was hacked for
                                    the second time that year and had 17 percent of it's digital currency stolen by
                                    attackers, which forced it to stop trading.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>12/19/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 19, 2017, YouBit, a South Korean cryptocurrency exchange, was
                                            hacked for the second time that year and had 17 percent of it's digital
                                            currency stolen by attackers, which forced it to stop trading. It later
                                            declared bankruptcy as a result. In August 2019, the UNSC Panel of Experts
                                            indicated DPRK-affiliated actors were behind the attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Paradise2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Paradise Papers</h2>
                                <span class="frst-date">November 5</span>
                                <p>
                                    In November 2017, an unknown whistle-blower leaked a trove of secret records on
                                    offshore companies to the German newspaper <em>Süddeutsche Zeitung</em>, which
                                    shared the details with 380 journalists around the world.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong>11/5/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In November 2017, an unknown whistle-blower leaked a trove of secret records
                                            on offshore companies to the German newspaper <em>Süddeutsche Zeitung</em>,
                                            which shared the details with 380 journalists around the world. The Paradise
                                            Papers, covering the law firm Appleby’s business as far back as 1950, shone
                                            a light on offshore tax affairs in thirty jurisdictions, including Bermuda
                                            and the Cayman Islands, the heart of the global hedge fund industry. Appleby
                                            has said it was the victim of a cyber attack, alleging the intruder
                                            “deployed the tactics of a professional hacker.” The breach came just over a
                                            year after the Panama Papers, documents from law firm Mossack Fonseca that
                                            were leaked to the same newspaper.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SAHosting2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South African Hosting Platform Breach</h2>
                                <span class="frst-date">November 1</span>
                                <p>
                                    In early November, Hetzner, one of South Africa’s largest hosting companies, was
                                    hacked, exposing hundreds of thousands of domain names, bank account details, and
                                    other personal information.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>11/6/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> SQL injection <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In early November, Hetzner, one of South Africa’s largest hosting companies,
                                            was hacked, exposing hundreds of thousands of domain names, bank account
                                            details, and other personal information. Although hackers did not gain
                                            access to credit card information, the incident did leave many organizations
                                            vulnerable to bad actors who could gain control of their websites. An SQL
                                            injection vulnerability was identified and fixed.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SKCryptoHeist2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South Korean Crypto Heist Thwarted</h2>
                                <span class="frst-date">October 10</span>
                                <p>
                                    In October 2017, the Korean Internet Security Agency thwarted an attack on 10
                                    cryptocurrency exchanges in South Korea.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>12/15/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In October 2017, the Korean Internet Security Agency thwarted an attack on
                                            10 cryptocurrency exchanges in South Korea. The attack used sophisticated
                                            Business Email Compromise. South Korean media reported the attack was
                                            carried out by DPRK-affiliated hackers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="FarEastern2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Far Eastern International Bank</h2>
                                <span class="frst-date">October 1</span>
                                <p>
                                    In October 2017, Far Eastern International Bank in Taiwan became the victim of a $14
                                    million theft when hackers planted malware in the company’s systems to access a
                                    SWIFT terminal, which was then used to make fraudulent transfers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Taiwan<br />
                                            <strong>Date Breach First Reported:</strong>10/1/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In October 2017, Far Eastern International Bank in Taiwan became the victim
                                            of a $14 million theft when hackers planted malware in the company’s systems
                                            to access a SWIFT terminal, which was then used to make fraudulent
                                            transfers. The attackers used an unusual ransomware variant named Hermes,
                                            but this was likely a distraction for their main objective of using
                                            administrative credentials to move funds to Cambodia, the United States, and
                                            Sri Lanka. The attack is suspected of being performed by a group that has
                                            repeatedly intruded on bank networks to carry out thefts. Most of the stolen
                                            money was recovered, and two men were arrested in Sri Lanka after they
                                            attempted to withdraw funds. In August 2019, the UNSC Panel of Experts
                                            indicated DPRK-affiliated actors were behind the attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Tunisia2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Tunisian Financial Institution Attempted Theft</h2>
                                <span class="frst-date">October 10</span>
                                <p>
                                    In October 2017, attackers attempted to steal $60 million from a Tunisian financial
                                    institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Tunisia<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In October 2017, attackers attempted to steal $60 million from a Tunisian
                                            financial institution. In August 2019, the UN Security Council Panel of
                                            Experts indicated DPRK-affiliated actors were behind the attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CoinsiCrypto2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Coinis Crypto Heist</h2>
                                <span class="frst-date">September 23</span>
                                <p>
                                    On September 23, 2017, virtual currency was stolen from Coinis, a South Korean
                                    cryptocurrency exchange, worth an estimate $2.19 million according to reports.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>09/23/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 23, 2017, virtual currency was stolen from Coinis, a South
                                            Korean cryptocurrency exchange, worth an estimate $2.19 million according to
                                            reports. In August 2019, the UN Security Council Panel of Experts indicated
                                            DPRK-affiliated actors were behind the theft. In December 2017, South Korean
                                            newspaper Chosun Ilbo reported that the South Korean government has
                                            attributed the attack to DPRK-affiliated actors.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SEC2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>SEC Edgar Hack</h2>
                                <span class="frst-date">September 21</span>
                                <p>
                                    The Securities and Exchange Commission announced in September 2017 that hackers
                                    might have accessed inside information from the Edgar database, which contains
                                    market-sensitive filings for companies listed on U.S. stock exchanges, and used it
                                    to make illegal profits on share trades.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>9/21/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Software vulnerability <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            The Securities and Exchange Commission announced in September 2017 that
                                            hackers might have accessed inside information from the Edgar database,
                                            which contains market-sensitive filings for companies listed on U.S. stock
                                            exchanges, and used it to make illegal profits on share trades. The
                                            commission did not realize the intrusion, which took place in 2016 through a
                                            software vulnerability in a test filing component, could have leaked company
                                            secrets until August 2017. The identity of the hackers is unknown, although
                                            reports have suggested the perpetrators are based in Eastern Europe.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Equifax2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Equifax Hack</h2>
                                <span class="frst-date">September 7</span>
                                <p>
                                    In one of the biggest data breaches on record, the credit reporting agency Equifax
                                    announced in October 2017 that more than 150 million customer records had been
                                    compromised, including some sensitive data such as birth dates and 12,000 U.S.
                                    social security numbers.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 9/7/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Web app vulnerability<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In one of the biggest data breaches on record, the credit reporting agency
                                            Equifax announced in October 2017 that more than 150 million customer
                                            records had been compromised, including some sensitive data such as birth
                                            dates and 12,000 U.S. social security numbers. According to the U.S.
                                            government indictments, the breach was carried out by the Chinese People’s
                                            Liberation Army (PLA) exploiting a bug in an Apache Struts web application
                                            that the company had failed to patch.
                                        </p>
                                        <p>
                                            The attackers scanned Equifax’s estate for the vulnerability and gained
                                            access to the application, an online dispute portal, days after the bug was
                                            made public in March—but did not take any data for several months. Once
                                            inside the network, the attackers found unencrypted usernames and passwords
                                            for other databases, spent seventy-six days on the network, eventually
                                            accessing forty-eight different datasets.
                                        </p>
                                        <p>
                                            Equifax has spent $439 million on redressing the data loss and, a year after
                                            disclosure, its share price remained below the pre-breach level. However,
                                            the company has avoided fines from the banking regulators in eight U.S.
                                            states after agreeing to a deal in June 2018 to improve its cybersecurity
                                            oversight.
                                        </p>
                                        <p>
                                            On February 10 2020, the U.S. Department of Justice indicted four members of
                                            the Chinese People’s Liberation Army (PLA) for a targeted intrusion into the
                                            networks of Equifax, a credit reporting agency in the United States. The
                                            indictment states that the attackers were targeting the private data of
                                            millions of Americans, along with Equifax trade secrets, such as ‘data
                                            compilations and database plans’. The indictment lists the operators’
                                            affiliation with the 54th Research Institute, formerly part of the PLA and
                                            now part of the PLA Strategic Support Force (SSF).
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PesaLink2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>PesaLink Attempted Hack</h2>
                                <span class="frst-date">August 31</span>
                                <p>
                                    In late August 2017, PesaLink, a jointly-owned payment transfer platform used widely
                                    by Kenya's commercial banks, was the victim of a cyberattack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Kenya<br />
                                            <strong>Date Breach First Reported:</strong>9/1/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In late August 2017, PesaLink, a jointly-owned payment transfer platform
                                            used widely by Kenya's commercial banks, was the victim of a cyberattack. An
                                            official from the company claimed that the attack was halted successfully
                                            and that there was no resulting loss of funds or customer data.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="SouthKoreaMonero2017"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South Korean Monero Cryptojacking</h2>
                                <span class="frst-date">July 15</span>
                                <p>
                                    In the summer of 2017, a South Korean company’s server was hijacked by attackers and
                                    made to mine 70 Monero coins, a cryptocurrency, worth approximately $25,000.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In the summer of 2017, a South Korean company’s server was hijacked by
                                            attackers and made to mine 70 Monero coins, a cryptocurrency, worth
                                            approximately $25,000. The South Korean Financial Stability Institute
                                            attributed the theft to DPRK-affiliated group Andarial in January 2018, and
                                            in August 2019, the UN Security Council Panel of Experts also indicated
                                            DPRK-affiliated actors were behind the theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BitHumbHeist22017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BitHumb Crypto Heist #2</h2>
                                <span class="frst-date">June 29</span>
                                <p>
                                    In February 2017, at least $7 million in virtual currency was stolen from BitHumb, a
                                    South Korean cryptocurrency exchange.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong> 06/29/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On June 29, approximately $7 million in virtual currency was stolen from
                                            BitHumb, a South Korean cryptocurrency exchange for the second time in four
                                            months. The South Korean National Intelligence Services attributed the theft
                                            to the DPRK, and in August 2019, the UN Security Council Panel of Experts
                                            also indicated DPRK-affiliated actors were behind the theft.
                                        </p>
                                        <p>
                                            The attackers gained access to an employee’s personal computer. From there
                                            they managed to exfiltrate the details of 3% of the platforms total users
                                            including names, emails and phone numbers. The company stated they would
                                            compensate customers affected.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="YoubitHacked2017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>YouBit Crypto Heist</h2>
                                <span class="frst-date">April 22</span>
                                <p>
                                    On April 22, 2017, approximately $5.6 million in cryptocurrency was stolen from
                                    YouBit, a South Korean cryptocurrency exchange then named Yapizon.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>12/05/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 22, 2017, approximately $5.6 million in cryptocurrency was stolen
                                            from YouBit, a South Korean cryptocurrency exchange then named Yapizon. In
                                            August 2019, the UN Security Council Panel of Experts indicated
                                            DPRK-affiliated actors were behind the theft. Group-IB, a Singapore-based
                                            security firm, also attributed the theft to Lazarus, a group of North Korean
                                            hackers, in October 2018.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BitHumbHeist12017">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>BitHumb Crypto Heist #1</h2>
                                <span class="frst-date">February 1</span>
                                <p>
                                    In February 2017, at least $7 million in virtual currency was stolen from BitHumb, a
                                    South Korean cryptocurrency exchange.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong> 12/05/2017
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2017, at least $7 million in virtual currency was stolen from
                                            BitHumb, a South Korean cryptocurrency exchange. The hackers also stole PII
                                            from 30,000 customers.
                                        </p>
                                        <p>
                                            In December 2017, the South Korean government attributed the attack to North
                                            Korea. In January 16, 2018, Recorded Future, a security firm known for
                                            analyzing state-sponsored attacks, attributed the attack to the Lazarus
                                            Group in the North Korean government. In August 2019, the UN Security
                                            Council Panel of Experts indicated DPRK-affiliated actors were behind the
                                            theft.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2016</span>
                        </div>
                        <!-- .frst-start-label  -->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RussianBanksDec2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Russian Banks DDoS Attack</h2>
                                <span class="frst-date">December 2</span>
                                <p>
                                    In December 2016, after a number of DDoS attacks on Russian banks throughout the
                                    previous month, the Russian Federal Security Service (FSB) announced that it had
                                    discovered pending cyber attacks intended to impact a range of major Russian banks.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Russia<br />
                                            <strong>Date Breach First Reported:</strong> 12/2/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In December 2016, after a number of DDoS attacks on Russian banks throughout
                                            the previous month, the Russian Federal Security Service (FSB) announced
                                            that it had discovered pending cyber attacks intended to impact a range of
                                            major Russian banks. Servers and command centers purportedly to be used in
                                            these attacks were located in the Netherlands and owned by BlazingFast, a
                                            Ukrainian hosting company. BlazingFast said it had no information about the
                                            asserted attack and that it was unable to find any malicious data. The Dutch
                                            Ministry of Security and Justice said that it was aware its infrastructure
                                            could be used for cyber attacks elsewhere, and that if the Russian
                                            authorities decided to investigate, the Dutch investigating authorities
                                            would provide assistance.
                                        </p>
                                        <p>
                                            On December 9, Rostelecom, Russia’s telecom operator, said in a statement
                                            that it had blocked DDoS attacks against the five biggest banks and
                                            financial institutions in Russia on December 5. They reached a peak volume
                                            of 3.2 million packets per second, which is low compared to the volume of
                                            other recent DDoS attacks. The statement further noted that part of the DDoS
                                            attacks involved a botnet similar to that used in prior weeks against
                                            Germany’s Deutsche Telekom and Ireland’s Eircom, exploiting a vulnerability
                                            in home routers. No perpetrators were identified, though the FSB claimed
                                            that it was organized by foreign intelligence services and speculated it had
                                            been done on behalf of Ukraine, due to the servers’ location and ownership.
                                            The FSB stated that it expected the DDoS attacks to be accompanied by text
                                            messages, agitating social network publications, and blog statements about a
                                            “crisis in the Russian credit and financial system, bankruptcy and
                                            withdrawal of licenses of leading federal and regional banks,” and that “the
                                            campaign [would be] directed against several dozen Russian cities.”
                                            Presumably, this would be an attempt to create a run on Russian banks,
                                            initiating a financial crisis. No evidence exists that such action,
                                            complementary to the DDoS attacks, was attempted.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="HongKong2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Insider Trading Hack</h2>
                                <span class="frst-date">December 1</span>
                                <p>
                                    In late 2016, the Securities and Exchange Commission (SEC) sued three Chinese
                                    traders, arguing that they had installed malware on the networks of two law firms to
                                    steal confidential, market-moving information on mergers and acquisitions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>12/1/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In late 2016, the Securities and Exchange Commission (SEC) sued three
                                            Chinese traders, arguing that they had installed malware on the networks of
                                            two law firms to steal confidential, market-moving information on mergers
                                            and acquisitions. The men were ordered to pay $8.9 million in penalties, and
                                            the trio were also indicted on criminal charges, which are ongoing. Hong
                                            Kong refused a request to extradite one of the men to the United States in
                                            2017.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Tesco2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Tesco Bank Card Theft</h2>
                                <span class="frst-date">November 5</span>
                                <p>
                                    Tesco Bank, a retail bank based in the UK, was the target of thieves who used
                                    vulnerabilities in its card issuing process to guess bank card numbers and steal
                                    £2.26 million in November 2016.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong> 11/5/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Card number guessing<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Tesco Bank, a retail bank based in the UK, was the target of thieves who
                                            used vulnerabilities in its card issuing process to guess bank card numbers
                                            and steal £2.26 million in November 2016. The unknown attackers likely used
                                            an algorithm to generate bank card numbers that used Tesco’s identifying
                                            numbers at the start and conformed to the industry-wide Luhn validation
                                            scheme that helps protect against accidental errors.
                                        </p>
                                        <p>
                                            There are around 1 billion possible card numbers for each bank, but
                                            regulators have said Tesco Bank’s cards had deficiencies, such as sequential
                                            card numbers, that made guessing the full numbers easier. The bank only used
                                            basic checks to assess whether cards were genuine, for example merely
                                            inspecting whether the debit card would expire in the future instead of
                                            making sure the exact expiration date matched its records.
                                        </p>
                                        <p>
                                            Visa and Mastercard had both previously warned of an increase in the type of
                                            fraud seen in this case, which used the magnetic strip to verify the
                                            transaction. On November 5, 2016, as the weekend began, the gang started
                                            making fraudulent transactions with the card details it had calculated.
                                            Almost 9,000 accounts were affected, or 6.6 percent of the bank’s entire
                                            customer base. One customer had twenty-two fraudulent transactions totaling
                                            £65,000 on his account.
                                        </p>
                                        <p>
                                            Tesco Bank halted all online and contactless transactions after a day of
                                            struggling to block all the fake purchases reported in the United States,
                                            Spain, and Brazil. In October 2018, Tesco was fined £16.4 million by the
                                            UK’s Financial Conduct Authority for deficiencies in its bank card policies
                                            and its response to the incident.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MiraiBotnetM2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Liberia Mirai Botnet Attack</h2>
                                <span class="frst-date">October 31</span>
                                <p>
                                    On October 31, a distributed denial-of-service attack was launched against Lonestar
                                    MTN, a Liberian network provider.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Liberia<br />
                                            <strong>Date Breach First Reported:</strong> 11/4/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 31, a distributed denial-of-service attack was launched against
                                            Lonestar MTN, a Liberian network provider. The DDos attack employed the now
                                            infamous internet-of-things Mirai botnet to crash large segments of the
                                            country's internet. A British hacker named Daniel Kaye was eventually
                                            sentenced for the crime after claiming to have been funded by a senior
                                            official at Cellcom, another Liberian network provider, to disrupt its
                                            competitor Lonestar.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="IndianATM2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Indian ATM Breach</h2>
                                <span class="frst-date">October 20</span>
                                <p>
                                    In mid-2016, a number of Indian banks replaced or changed security codes on 3.25
                                    million debit cards after uncovering a breach in Hitachi’s payment switch systems,
                                    which link into the ATM network.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong>10/20/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In mid-2016, a number of Indian banks replaced or changed security codes on
                                            3.25 million debit cards after uncovering a breach in Hitachi’s payment
                                            switch systems, which link into the ATM network. Visa, Mastercard, and
                                            India’s Rupay cards were all affected by the compromise.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="UnionBankIndia2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Union Bank of India Attempted SWIFT Heist</h2>
                                <span class="frst-date">July 21</span>
                                <p>
                                    On July 21, 2016, attackers attempted to use fraudulent SWIFT transactions to steal
                                    $170 million from the Union Bank of India (UBI), but the money was ultimately
                                    recovered within three days after the transactions were flagged.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> India<br />
                                            <strong>Date Breach First Reported:</strong> 08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On July 21, 2016, attackers attempted to use fraudulent SWIFT transactions
                                            to steal $170 million from the Union Bank of India (UBI), but the money was
                                            ultimately recovered within three days after the transactions were flagged.
                                        </p>
                                        <p>
                                            Multiple security firms noted the attackers used tactics and techniques
                                            similar to the Bangladesh heist four months previously. The attackers sent
                                            the money to accounts in Thailand, Cambodia, Australia, Hong Kong and
                                            Taiwan, and those accounts belonged to shell companies associated with
                                            Chinese-organized crime syndicates. In August 2019, the UN Security Council
                                            Panel of Experts indicated DPRK-affiliated actors were behind the attempted
                                            theft of UBI.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NigerianBank2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Nigerian Bank Attempted SWIFT Heist</h2>
                                <span class="frst-date">July 1</span>
                                <p>
                                    In July 2016, attackers attempted to use fraudulent SWIFT transactions to steal $100
                                    million from a Nigerian bank, but the money was ultimately recovered.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Nigeria<br />
                                            <strong>Date Breach First Reported:</strong> 08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In July 2016, attackers attempted to use fraudulent SWIFT transactions to
                                            steal $100 million from a Nigerian bank, but the money was ultimately
                                            recovered.
                                        </p>
                                        <p>
                                            The attackers initiated fraudulent SWIFT transactions of $100 million from
                                            the unnamed Nigerian Bank to bank accounts in Asia, similar to the
                                            techniques seen in the 2016 Bangladesh heist. The funds were later returned
                                            at the request of the Nigerian bank. In August 2019, the UN Security Council
                                            Panel of Experts indicated DPRK-affiliated actors were behind the attack on
                                            the Nigerian bank, referencing the “African Bank” named in the U.S.
                                            Department of Justice 2018 indictment of Park Jin Hyok.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="StandardBank2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Standard Bank Theft</h2>
                                <span class="frst-date">May 5</span>
                                <p>
                                    On May 15, 2016, attackers stole $19 million from South Africa’s Standard Bank by
                                    making 14,000 withdrawals over 3 hours from 1,700 ATMs across Japan.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa, Japan<br />
                                            <strong>Date Breach First Reported:</strong> 08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On May 15, 2016, attackers stole $19 million from South Africa’s Standard
                                            Bank by making 14,000 withdrawals over 3 hours from 1,700 ATMs across Japan.
                                        </p>
                                        <p>
                                            UN Security Council Panel of Experts indicated in August 2019 that
                                            DPRK-affiliated actors were behind the attack. According to the Japanese
                                            government, the attackers used forged cards with data of roughly 3,000
                                            pieces of customer information stolen from Standard Bank to withdraw cash
                                            from ATMs located in Tokyo and 16 prefectures across Japan. 260 suspects,
                                            including organized crime group members, have been arrested as of July 2019.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CentralBank2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Central Banks DDoS Attack</h2>
                                <span class="frst-date">May 4</span>
                                <p>
                                    In May 2016, hacktivists briefly took down the Bank of Greece’s website, and later
                                    did the same to the central banks of Mexico, Panama, Kenya, and Bosnia and
                                    Herzegovina.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Panama, Greece, Mexico, Kenya, Bosnia and
                                            Herzegovina<br />
                                            <strong>Date Breach First Reported:</strong>5/4/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In May 2016, hacktivists briefly took down the Bank of Greece’s website, and
                                            later did the same to the central banks of Mexico, Panama, Kenya, and Bosnia
                                            and Herzegovina. Anonymous claimed responsibility as part of Operation
                                            Icarus, a campaign against central banks.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PanamaPapers2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Panama Papers</h2>
                                <span class="frst-date">April 3</span>
                                <p>
                                    In April 2016, an anonymous source leaked 2.6 terabytes of information from the
                                    Panamanian law firm Mossack Fonseca to the German newspaper
                                    <em>Süddeutsche Zeitung</em>.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Panama<br />
                                            <strong>Date Breach First Reported:</strong>4/3/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In April 2016, an anonymous source leaked 2.6 terabytes of information from
                                            the Panamanian law firm Mossack Fonseca to the German newspaper
                                            <em>Süddeutsche Zeitung</em>. The journalists shared the 11.5 million leaked
                                            documents with a dozen global news organizations to simultaneously print
                                            stories about the money-laundering, tax affairs, and financial secrecy
                                            within. The revelations had far-reaching effects, including the resignation
                                            of the Icelandic prime minister, a number of tax evasion investigations, and
                                            the closure of Mossack Fonseca.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BelgianBankFeb2016">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Belgian National Bank Incident</h2>
                                <span class="frst-date">February 22</span>
                                <p>
                                    On February 22, 2016, a hacking group called DownSec Belgium shut down the website
                                    for Belgium’s National Bank for most of the morning using DDoS attacks.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Belgium<br />
                                            <strong>Date Breach First Reported:</strong>2/22/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On February 22, 2016, a hacking group called DownSec Belgium shut down the
                                            website for Belgium’s National Bank for most of the morning using DDoS
                                            attacks. Little information has been reported about the attack, but it
                                            followed similar DDoS attacks by the same group against the websites for the
                                            Belgian Federal Agency for Nuclear Control, the country’s Crisis Center, and
                                            its federal cyber emergency team. DownSec Belgium claims to fight against
                                            corrupt government abuses.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <a class="anchor-point" name="BangladeshBankSwift2016"></a>
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="BangladeshBankFeb2016"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bangladesh Bank SWIFT Hack</h2>
                                <span class="frst-date">February 1</span>
                                <p>
                                    In February 2016, media outlets reported that hackers had breached the network of
                                    the Bangladesh central bank and sent thirty-five fraudulent transfer requests to the
                                    Federal Reserve Bank of New York, totaling nearly $1 billion.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Bangladesh<br />
                                            <strong>Date Breach First Reported:</strong> 2/1/2016
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2016, media outlets reported that hackers had breached the
                                            network of the Bangladesh central bank and sent thirty-five fraudulent
                                            transfer requests to the Federal Reserve Bank of New York, totaling nearly
                                            $1 billion. Four of these fraudulent requests succeeded, and the hackers
                                            were able to transfer $81 million to accounts in the Philippines,
                                            representing one of the largest bank thefts in history. A fifth request for
                                            $20 million to be sent to an account in Sri Lanka was stopped due to the
                                            recipient’s name, Shalika Foundation, being misspelled “fandation.” The
                                            remaining transfers, which totaled somewhere between $850 and $870 million,
                                            were also stopped before they could be completed due to a stroke of good
                                            fortune: the name of the destination bank branch included the word
                                            “Jupiter,” which was the name of an unrelated company on a sanctions
                                            blacklist. In August 2019, the UNSC Panel of Experts indicated
                                            DPRK-affiliated actors were behind the attack.
                                        </p>
                                        <p>
                                            The hackers had introduced malware onto the Bangladesh central bank’s server
                                            and deployed keylogger software that allowed them to steal the bank’s
                                            credentials for the SWIFT system. The hackers also custom-designed a malware
                                            toolkit that compromised SWIFT’s Alliance Access system and was designed to
                                            cover their tracks. This toolkit allowed them to delete records of transfer
                                            requests, bypass validity checks, delete records of logins, manipulate
                                            reporting of balances, and stop attached printers from printing transaction
                                            logs. Although the malware was custom-designed to steal from the Bangladesh
                                            central bank, the toolkit could potentially be used against other banks in
                                            the SWIFT system running Alliance Access software.
                                        </p>
                                        <p>
                                            The intruders had monitored the bank’s routine activity in order to create
                                            money transfer requests that appeared genuine. Furthermore, they timed the
                                            thefts so that it would be the weekend in Bangladesh when the Federal
                                            Reserve reached out to confirm the transactions, and then it would be the
                                            weekend in New York when the Bangladesh central bank employees instructed
                                            the Federal Reserve to cancel the transactions. "
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content -->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2015</span>
                        </div>
                        <!-- .frst-start-label -->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Guatemala2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Guatemalan Financial Institution Theft</h2>
                                <span class="frst-date">December 01</span>
                                <p>
                                    In December 2015, attackers stole $16 million from a Guatemalan financial
                                    institution.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Guatemala<br />
                                            <strong>Date Breach First Reported:</strong>08/30/2019
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In December 2015, attackers stole $16 million from a Guatemalan financial
                                            institution. In August 2019, the UN Security Council Panel of Experts
                                            indicated DPRK-affiliated actors were behind the attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Greek2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Greek Banks DDoS Attack</h2>
                                <span class="frst-date">November 30</span>
                                <p>
                                    In late 2015, hackers threatened to disable systems at three Greek banks unless they
                                    paid a bitcoin ransom.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Greece<br />
                                            <strong>Date Breach First Reported:</strong>11/30/2015
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In late 2015, hackers threatened to disable systems at three Greek banks
                                            unless they paid a bitcoin ransom. When the banks refused, they had their
                                            sites repeatedly knocked out for several hours. The group claiming
                                            responsibility for the extortion said it was part of the Armada Collective,
                                            which had previously targeted numerous businesses including Cloudflare and
                                            Proton Mail, although some investigators believed it might have been a
                                            copycat attack using the same name. Some suspected original members of the
                                            collective were arrested in Europol’s Operation Pleiades in January 2016,
                                            which targeted the group DDoS4Bitcoin that has been active since mid-2014.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Swedbank2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Swedbank and Nordea DDoS Attack</h2>
                                <span class="frst-date">November 6</span>
                                <p>
                                    In November 2015, a teenager was sentenced to community service after carrying out
                                    four DDoS attacks against Nordea and Swedbank.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Denmark, Sweden<br />
                                            <strong>Date Breach First Reported:</strong>11/6/2015
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In November 2015, a teenager was sentenced to community service after
                                            carrying out four DDoS attacks against Nordea and Swedbank. The attacks
                                            blocked customers from the banks’ websites for hours at a time. The
                                            perpetrator’s lawyers said he was “drawn into a circus” where online groups
                                            would test the power of botnets.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="ShanghaiJun2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Shanghai Composite Index Suspected Manipulation</h2>
                                <span class="frst-date">June 12</span>
                                <p>
                                    Beginning on June 12, 2015, the Shanghai Composite Index began to plummet, and by
                                    June 19 it had fallen by 13 percent.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> China<br />
                                            <strong>Date Breach First Reported:</strong>6/12/2015
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach, disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Beginning on June 12, 2015, the Shanghai Composite Index began to plummet,
                                            and by June 19 it had fallen by 13 percent. Chinese stock markets continued
                                            to fall throughout July and August, and again in January and February 2016.
                                            Although there is no public evidence, some have speculated that the initial
                                            sudden crash may have been caused by a cyber attack.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="TienPhong2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Tien Phong Commercial Joint Stock Bank</h2>
                                <span class="frst-date">May 15</span>
                                <p>
                                    In May 2015, the Vietnamese bank Tien Phong announced it had blocked a fraudulent
                                    SWIFT transaction worth €1m several months before attackers successfully stole from
                                    the Bank of Bangladesh using the same method.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Vietnam<br />
                                            <strong>Date Breach First Reported:</strong>5/15/2015
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In May 2015, the Vietnamese bank Tien Phong announced it had blocked a
                                            fraudulent SWIFT transaction worth €1m several months before attackers
                                            successfully stole from the Bank of Bangladesh using the same method. Tien
                                            Phong did not name the bank that had been the source of the fraudulent
                                            transfer request.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Wolf2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Dyre Wolf Campaign</h2>
                                <span class="frst-date">April 2</span>
                                <p>
                                    In April 2015, a threat group twinned malware with a sophisticated social
                                    engineering tactic to steal more than $1 million from businesses.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong>4/2/2015
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In April 2015, a threat group twinned malware with a sophisticated social
                                            engineering tactic to steal more than $1 million from businesses. A variant
                                            of Dyre malware named Upatre, which spread through victims’ email contacts,
                                            was used to block hundreds of bank websites on the victim’s device. The
                                            victim was then prompted to call a helpline number—actually staffed by a
                                            member of the gang who would then harvest the victim’s banking credentials
                                            and subsequently make fraudulent wire transfers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Health2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Health Insurer Hacks</h2>
                                <span class="frst-date">February 4</span>
                                <p>
                                    In February 2015, reports indicated that records for almost 80 million customers
                                    were stolen from Anthem, a U.S. healthcare insurer, after attackers deployed a
                                    spearphishing email that gave access to ninety of the company’s systems, including
                                    its back-end database.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>2/4/2015
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2015, reports indicated that records for almost 80 million
                                            customers were stolen from Anthem, a U.S. healthcare insurer, after
                                            attackers deployed a spearphishing email that gave access to ninety of the
                                            company’s systems, including its back-end database. The stolen data was
                                            taken over the course of several weeks and included personal information,
                                            such as social security numbers. A subsequent report by the California
                                            Department of Insurance pointed to a national government as the likely
                                            culprit for the attack, and suggested the initial breach occurred in
                                            February 2014, meaning Anthem was exposed for a year before the compromise
                                            was discovered. Anthem ended up settling a lawsuit relating to the data loss
                                            for $115 million. Several weeks after the incident was disclosed, fellow
                                            insurer Premera Blue Cross announced that around 11 million customer
                                            accounts had been compromised by attackers, and rival CareFirst admitted 1.1
                                            million current and former members may have had their information stolen.
                                            Some researchers believe the thefts were carried out by the same group. In
                                            September 2015, Excellus announced a data loss, with 10 million customers’
                                            data exposed by a breach that initially occurred in December 2013.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Ecuador2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ecuadorian Banco del Austro</h2>
                                <span class="frst-date">January 12</span>
                                <p>
                                    In early 2015, a bank in Ecuador was the first known victim in a series of
                                    multimillion dollar heists that used compromised payments systems to then transfer
                                    funds over the SWIFT interbank messaging network.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Ecuador<br />
                                            <strong>Date Breach First Reported:</strong> 1/12/2015
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In early 2015, a bank in Ecuador was the first known victim in a series of
                                            multimillion dollar heists that used compromised payments systems to then
                                            transfer funds over the SWIFT interbank messaging network. In January 2015,
                                            thieves transferred $12 million out of Banco del Austro and routed most of
                                            the proceeds to twenty-three companies registered in Hong Kong.
                                        </p>
                                        <p>
                                            The same method has been used in several thefts in the preceding years
                                            including the $81 million Bank of Bangladesh heist in 2016. If an attacker
                                            manages to gain access to a bank’s SWIFT terminal, the system can be used to
                                            ask other banks to transfer funds. Banco del Austro said it recovered around
                                            $2.8 million of the stolen money. The heist came to light in a lawsuit Banco
                                            brought against Wells Fargo, which it alleged failed to spot red flags when
                                            it approved the fraudulent transaction. The litigation was settled in
                                            February 2018 but no details were disclosed.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Metel2015">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Metel Malware Attack on Russian Banks</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    The Metel banking Trojan, which was discovered in 2011, was repurposed by a criminal
                                    gang in 2015 to steal directly from bank ATMs and even manipulate the Russian
                                    exchange rate.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Russia<br />
                                            <strong>Date Breach First Reported:</strong>1/1/2015
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple: malware, phishing and browser
                                            vulnerabilities
                                            <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            The Metel banking Trojan, which was discovered in 2011, was repurposed by a
                                            criminal gang in 2015 to steal directly from bank ATMs and even manipulate
                                            the Russian exchange rate. The group used spearphishing emails or browser
                                            vulnerabilities to deliver Metel, also known as Corcow, and access the
                                            bank’s systems before pivoting into areas that allowed them to roll back ATM
                                            transactions. This meant they could withdraw unlimited amounts of money,
                                            automatically resetting the account balance after each transaction.
                                            Researchers at Kaspersky, who first reported on the operation, said the gang
                                            comprised fewer than ten members and had made no infections outside Russia.
                                            In February 2015, Energobank fell victim to a Metel infection that allowed
                                            attackers to place some $500 million in currency orders, sending the ruble
                                            swinging with extreme volatility between 55 and 66 rubles per dollar for a
                                            period of fourteen minutes. However, there is no evidence the attackers
                                            profited from the movement. Metel had infected 250,000 devices and more than
                                            100 financial institutions in 2015, according to researchers at Group IB.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2014</span>
                        </div>
                        <!-- .frst-start-label -->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Gautrain2014">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Gautrain Management Agency Insider Threat Thwarted</h2>
                                <span class="frst-date">November 1</span>
                                <p>
                                    In November 2014, the Hawks (South Africa’s Directorate for Priority Crime
                                    Investigation) thwarted an insider attempt to defraud the Gautrain Management Agency
                                    (GMA), a roads and transportation agency of Gauteng Province.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>11/12/2014
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Insider threat <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In November 2014, the Hawks (South Africa’s Directorate for Priority Crime
                                            Investigation) thwarted an insider attempt to defraud the Gautrain
                                            Management Agency (GMA), a roads and transportation agency of Gauteng
                                            Province. The attempted theft could have cost the agency up to R800 million.
                                            One of the criminals was identified as a rogue employee who had installed
                                            key-loggers and programs to override the security measures in an effort to
                                            steal financial information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Tyupkin2014">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Tyupkin ATM Malware</h2>
                                <span class="frst-date">October 7</span>
                                <p>
                                    In October 2014, reports revealed that criminals had written malware to infect
                                    Windows-based ATMs and steal millions from machines primarily in Eastern Europe.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Eastern Europe<br />
                                            <strong>Date Breach First Reported:</strong>10/7/2014
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In October 2014, reports revealed that criminals had written malware to
                                            infect Windows-based ATMs and steal millions from machines primarily in
                                            Eastern Europe. The malware, dubbed Tyupkin, was spread by a CD and once
                                            installed it laid low, only accepting commands on Sunday and Monday nights.
                                            Mules could type in a randomly generated key allowing them to withdraw 40
                                            banknotes. Similar to the Ploutus campaign in Latin America, the Tyupkin
                                            group had an organized gang of mules to access the ATMs and collect the
                                            money. Eight Romanian and Moldovan nationals were arrested in connection
                                            with the scheme in January 2016.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="WarsawOct2014">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Warsaw Stock Exchange Breach</h2>
                                <span class="frst-date">October 1</span>
                                <p>
                                    In October 2014, a group claiming to be affiliated with the so-called Islamic State
                                    hacked the internal networks of the Warsaw Stock Exchange and posted dozens of login
                                    credentials for brokers online.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Poland<br />
                                            <strong>Date Breach First Reported:</strong>10/1/2014
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In October 2014, a group claiming to be affiliated with the so-called
                                            Islamic State hacked the internal networks of the Warsaw Stock Exchange and
                                            posted dozens of login credentials for brokers online. The means by which
                                            the group gained access to the exchange’s networks are unknown, but they
                                            were reportedly able to infiltrate an investment simulator and a web portal
                                            for managing the stock exchange’s upgrade to a new trading system, as well
                                            as render the exchange’s website unavailable for two hours. The exchange’s
                                            employees say that the trading system itself was not breached. NATO
                                            officials later indicated privately that they believed that the hacking
                                            group’s claim of being affiliated with Islamic militants was a false flag
                                            operation, and that in fact the breach was conducted by APT 28, a group
                                            widely believed by security researchers to be affiliated with the Russian
                                            government.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="JPMorgan2014">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>JPMorgan Chase Data Breach</h2>
                                <span class="frst-date">August 1</span>
                                <p>
                                    In August 2014, the first reports emerged that account information and home
                                    addresses for 83 million customers were exposed after attackers stole login
                                    credentials from a JPMorgan Chase employee.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 8/1/2014
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Stolen password<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In August 2014, the first reports emerged that account information and home
                                            addresses for 83 million customers were exposed after attackers stole login
                                            credentials from a JPMorgan Chase employee. The group entered the network
                                            through a single-factor authentication server that had not been upgraded
                                            with the rest of the firm’s estate, before gaining access to more than
                                            ninety bank servers for several months. However, the bank said the attackers
                                            had not accessed more sensitive information, such as social security
                                            numbers.
                                        </p>
                                        <p>
                                            JPMorgan discovered the breach after reportedly finding the same group on a
                                            website for a charity race that it sponsors. The size of the incident
                                            prompted the National Security Agency and the FBI to join the investigation.
                                            Other companies targeted in the attacks included Dow Jones, Fidelity,
                                            E*Trade, and Scottrade. The U.S. authorities believe the harvested
                                            information was used in securities fraud, money laundering, credit-card
                                            fraud, and fake pharmaceuticals.
                                        </p>
                                        <p>
                                            Nine people so far have been charged in the ongoing probe. A Russian
                                            national was extradited from Georgia to the United States in September 2018,
                                            although he denied that he was the central hacker in the attacks. The
                                            federal authorities in New York said the man worked with an international
                                            syndicate from 2012 to 2015 to steal customer information, which was used in
                                            numerous crimes including a spam email campaign to falsely tout stocks and
                                            shares to ramp up the price. In September 2019, he pleaded guilty to six
                                            felony charges in connection with the data breach and other cybercrimes, and
                                            he faces up to a lifetime in prison.
                                        </p>
                                        <p>
                                            In January 2017, a Florida man pleaded guilty to charges linked to funds
                                            processed through Coin.mx, an unlicensed bitcoin exchange owned by an
                                            Israeli who the United States has alleged masterminded the information
                                            stealing campaign. The supposed ringleader was extradited to the United
                                            States in 2016 and, according to media reports, entered a plea deal with
                                            prosecutors."
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div
                        class="frst-timeline-block frst-even-item"
                        data-animation="slideInUp"
                        id="EuropeanCentralBank2014"
                    >
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>European Central Bank</h2>
                                <span class="frst-date">July 24</span>
                                <p>
                                    In July 2014, the European Central Bank (ECB) announced that hackers had breached
                                    the security of a database holding email addresses and other contact data submitted
                                    by people registering for events at the bank.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Eastern Europe, Western Europe<br />
                                            <strong>Date Breach First Reported:</strong> 7/24/2014
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In July 2014, the European Central Bank (ECB) announced that hackers had
                                            breached the security of a database holding email addresses and other
                                            contact data submitted by people registering for events at the bank. The ECB
                                            said most of the stolen data was encrypted, and no internal systems or
                                            sensitive market data had been compromised as the database was separate to
                                            those systems. Approximately 20,000 people had their information exposed in
                                            non-encrypted form.
                                        </p>
                                        <p>
                                            The attack came to light after the supposed perpetrators emailed the ECB
                                            demanding a ransom payment on July 21. The bank informed the German police,
                                            although no further information is available about the investigation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="UkraineJuly2014">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ukrainian Bank Data Breach</h2>
                                <span class="frst-date">July 8</span>
                                <p>
                                    In July 2014, the pro-Russian group called CyberBerkut hacked into PrivatBank, one
                                    of Ukraine’s largest commercial banks, and published stolen customer data on
                                    VKontakte, a Russian social media website.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Ukraine<br />
                                            <strong>Date Breach First Reported:</strong>7/8/2014
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In July 2014, the pro-Russian group called CyberBerkut hacked into
                                            PrivatBank, one of Ukraine’s largest commercial banks, and published stolen
                                            customer data on VKontakte, a Russian social media website. The means by
                                            which it gained access to the data is unknown. It is believed that
                                            CyberBerkut targeted PrivatBank because the bank’s co-owner, Igor
                                            Kolomoisky, had offered a $10,000 bounty for the capture of Russian-backed
                                            militants in Ukraine. The group warned PrivatBank customers to transfer
                                            their money to state-owned banks. CyberBerkut may have connections to the
                                            Russian government, but the relative lack of sophistication of their attacks
                                            has led some experts to conclude that official links are unlikely.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SARoadsAgency2014">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South African Roads Agency Heist</h2>
                                <span class="frst-date">June 1</span>
                                <p>
                                    In 2014, a group of hackers targeted the Road Traffic Management Corporation,
                                    stealing R8.5 million through a series of fraudulent transfers before getting
                                    caught.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>6/14/2014
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In 2014, a group of hackers targeted the Road Traffic Management
                                            Corporation, stealing R8.5 million through a series of fraudulent transfers
                                            before getting caught. Eventually, over R4 million was recovered, and
                                            several of the hackers were apprehended.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2013</span>
                        </div>
                        <!-- .frst-start-label -->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="China2013">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>People’s Bank of China DDoS Attack</h2>
                                <span class="frst-date">December 19</span>
                                <p>
                                    In December 2013, the People’s Bank of China (PBOC) was bombarded with DDoS traffic
                                    that reportedly came from disgruntled bitcoin users who were protesting the
                                    country’s ban on the decentralized currency.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> China<br />
                                            <strong>Date Breach First Reported:</strong>12/19/2013
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In December 2013, the People’s Bank of China (PBOC) was bombarded with DDoS
                                            traffic that reportedly came from disgruntled bitcoin users who were
                                            protesting the country’s ban on the decentralized currency. The week before
                                            the attack, PBOC had warned that bitcoin was “not a real currency” and that
                                            Chinese institutions would not accept bitcoin deposits. With China the
                                            largest source of bitcoin trading at the time, the announcement sent the
                                            value of the currency down by around 40 percent. The perpetrators of the
                                            DDoS attack have not been publicly identified.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="DexterSA2013">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Dexter Malware hits South Africa's Banks</h2>
                                <span class="frst-date">September 1</span>
                                <p>
                                    In 2013, hackers infected electronic point-of-sale terminals with a malware called
                                    Dexter, allowing them to breach most major South African banks and make off with
                                    millions of rand.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>10/13/2013
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Non-state actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In 2013, hackers infected electronic point-of-sale terminals with a malware
                                            called Dexter, allowing them to breach most major South African banks and
                                            make off with millions of rand. The fast food industry was a major target
                                            for the hackers, who are believed to be part of an organized criminal group.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Ploutus2013">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Ploutus Malware</h2>
                                <span class="frst-date">September 1</span>
                                <p>
                                    In September 2013, the malware Ploutus was built to be installed directly on ATMs in
                                    order to give an attacker privileged rights, including the ability to dispense cash
                                    on demand via SMS or using a keyboard attached to the machine.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong>9/1/2013
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In September 2013, the malware Ploutus was built to be installed directly on
                                            ATMs in order to give an attacker privileged rights, including the ability
                                            to dispense cash on demand via SMS or using a keyboard attached to the
                                            machine. The malware has been altered several times to enable its use in new
                                            ATM models. Ploutus has resulted in numerous attacks in Mexico and later
                                            other countries, including the United States, where in 2018 two men were
                                            convicted of installing the malware on cash machines in Connecticut and
                                            Rhode Island.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="CME2013">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>CME Group</h2>
                                <span class="frst-date">July 1</span>
                                <p>
                                    In July 2013, CME Group, which operates the world’s largest futures exchange,
                                    announced in November 2013 that its ClearPort clearing service had been compromised
                                    the previous July.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>7/1/2013
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In July 2013, CME Group, which operates the world’s largest futures
                                            exchange, announced in November 2013 that its ClearPort clearing service had
                                            been compromised the previous July. The firm said some customer information
                                            was compromised but that trading was not affected. While large financial
                                            firms are generally under no obligation to make data breaches public, the
                                            company informed affected customers and announced that it was working with
                                            the authorities. The FBI investigated the incident but has released no
                                            further information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Carbanak2013">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Carbanak Malware</h2>
                                <span class="frst-date">June 1</span>
                                <p>
                                    In 2013, the source code for the Carbanak banking Trojan was leaked online. Since
                                    then, the malware has been used by several gangs to steal from dozens of financial
                                    institutions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States, Russia, Taiwan, Australia<br />
                                            <strong>Date Breach First Reported:</strong> 6/1/2013
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In 2013, the source code for the Carbanak banking Trojan was leaked online.
                                            Since then, the malware has been used by several gangs to steal from dozens
                                            of financial institutions. The attack strategies have changed many times in
                                            order to avoid detection.
                                        </p>
                                        <p>
                                            The malware is often pushed into financial companies by luring employees to
                                            click malicious documents, which provide the attackers a foothold to move
                                            across the network to remotely manipulate ATMs, known as “jackpotting,” or
                                            to compromise point-of-sale data. The gangs planned each theft carefully,
                                            taking between two and four months to complete each intrusion, ultimately
                                            using mules to withdraw the funds from ATMs and transfer them to the
                                            criminals’ accounts.
                                        </p>
                                        <p>
                                            Fin7, the most prolific group using Carbanak, has stolen more than €1
                                            billion from banks in more than thirty countries over the past three years,
                                            according to Europol. As well as using Carbanak, the gang is understood to
                                            use widely available tools such as the Cobalt Strike framework. The group
                                            recruited developers to work for an Israeli-Russian front company named
                                            Combi Security, and it is not clear whether the employees knew the nature of
                                            the work.
                                        </p>
                                        <p>
                                            The authorities arrested a man thought to be the gang’s ringleader in Spain
                                            in March 2018, while in August the U.S. Department of Justice arrested three
                                            Ukrainian suspects. The United States claims the group stole the details of
                                            15 million payment cards by attacking more than 120 U.S. companies,
                                            including the Chipotle and Arby’s restaurant chains.
                                        </p>
                                        <p>
                                            Another Trojan, which is named Odinaff and bears a resemblance to Carbanak,
                                            was spotted attacking banking, trading, and payroll companies in 2016. It is
                                            unclear whether this is the work of Fin7 or another gang. While Fin7 appears
                                            to have gone quiet, it is unclear whether this is because activity stopped
                                            following the arrests or its techniques have changed again.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SouthKoreaMar2013">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South Korea Attacked III</h2>
                                <span class="frst-date">March 20</span>
                                <p>
                                    In March 2013, almost exactly two years since the last DDoS attack on South Korea,
                                    the Shinhan, Nonghyup, and Jeju banks were targeted by a Trojan that deleted data
                                    and disrupted ATMs, online banking, and mobile payments.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>3/20/2013
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Diskwiping <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In March 2013, almost exactly two years since the last DDoS attack on South
                                            Korea, the Shinhan, Nonghyup, and Jeju banks were targeted by a Trojan that
                                            deleted data and disrupted ATMs, online banking, and mobile payments.
                                            Trojan.Jokra was used to wipe disks, but the attack varied from its
                                            predecessors in that it did not include a DDoS attack. After six months of
                                            attacks, South Korean politicians said this wave cost the country almost
                                            $650 million in economic damage, making it far larger than the two previous
                                            campaigns. The incident was attributed by some to the DarkSeoul gang, a
                                            threat actor linked to the North Korean regime that would later be tied to
                                            the Sony breach in 2014.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BankWest2013">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bank of the West DDoS Attack</h2>
                                <span class="frst-date">February 19</span>
                                <p>
                                    On Christmas Eve 2013, Bank of the West was the victim of a DDoS attack used to
                                    disguise $900,000 in fraudulent transfers out of accounts belonging to Ascent
                                    Builders, a Californian construction firm.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>2/19/2013
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On Christmas Eve 2013, Bank of the West was the victim of a DDoS attack used
                                            to disguise $900,000 in fraudulent transfers out of accounts belonging to
                                            Ascent Builders, a Californian construction firm. The perpetrators made
                                            fraudulent, automated clearinghouse and wire transfers before they knocked
                                            the bank’s website offline. A network of more than sixty mules was
                                            reportedly used to transfer the money into criminal accounts, making the
                                            funds more difficult to trace.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2012</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Ababil2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Operation Ababil</h2>
                                <span class="frst-date">September 18</span>
                                <p>
                                    In September 2012, a group called the Cyber Fighters of Izz ad-Din al-Qassam
                                    launched several waves of DDoS attacks against U.S. financial institutions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>9/18/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In September 2012, a group called the Cyber Fighters of Izz ad-Din al-Qassam
                                            launched several waves of DDoS attacks against U.S. financial institutions.
                                            Naming the campaign Operation Ababil, the group justified their attacks as
                                            retribution for an anti-Islam video released by the U.S. pastor Terry Jones.
                                            The attacks were powerful, sending 100 gigabits per second of data to the
                                            victim sites, prompting claims that this was beyond the capabilities of a
                                            hacktivist group. Some reports said the group had ties to Anonymous, while
                                            others made links to the Iranian government—however, the group claimed it
                                            acted independently. The campaign launched two additional waves of attacks
                                            on December 10, 2012, and March 5, 2013.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Paygate2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>PayGate Breach</h2>
                                <span class="frst-date">August 1</span>
                                <p>
                                    In August 2012, online payment service provider PayGate suffered a system breach
                                    where credit card and banking details were leaked.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>11/12/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In August 2012, online payment service provider PayGate suffered a system
                                            breach where credit card and banking details were leaked. The company
                                            confirmed the hack in November but claimed that the breach was confined to
                                            August.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="HighRoller2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Operation High Roller</h2>
                                <span class="frst-date">June 25</span>
                                <p>
                                    In June 2012, U.S. security researchers uncovered a fraud ring attempting to execute
                                    high-value transactions worth between €60 million and €2 billion by using a
                                    customized Trojan spyware tool.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States, Colombia<br />
                                            <strong>Date Breach First Reported:</strong>6/25/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In June 2012, U.S. security researchers uncovered a fraud ring attempting to
                                            execute high-value transactions worth between €60 million and €2 billion by
                                            using a customized Trojan spyware tool. Operation High Roller, as it was
                                            named by the researchers who uncovered it, was the first gang to automate
                                            many of the steps in fraudulent transactions. The malware automatically
                                            checked balances, found active mule accounts that could receive stolen
                                            funds, and deleted emails confirming transfers. It also managed to bypass
                                            two-factor authentication and run its command servers on the cloud. Its
                                            targets were chiefly high-balance bank accounts in Europe. U.S. authorities
                                            indicted two men, a Russian and an Albanian, who authored the original
                                            SpyEye Trojan in 2011 subsequently used during the operation.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Shanghai2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Shanghai Composite Index Suspected Manipulation</h2>
                                <span class="frst-date">June 4</span>
                                <p>
                                    In June 2012, the Shanghai Composite Index saw a severe drop on the anniversary of
                                    the Tiananmen Square massacre of 1989.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> China<br />
                                            <strong>Date Breach First Reported:</strong>6/4/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Multiple
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In June 2012, the Shanghai Composite Index saw a severe drop on the
                                            anniversary of the Tiananmen Square massacre of 1989. While there is no
                                            confirmation of any wrongdoing in this case, the Shanghai Composite Index
                                            opened at 2,346.98 and fell exactly 64.89 points, matching the date of the
                                            incident (June 4, 1989). This led to widespread but unproven speculation
                                            about a protest hack that had manipulated trading that day. The Chinese
                                            censors blocked online references to the Shanghai Composite Index and
                                            several other terms on the anniversary.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Iran2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Iranian Banking Data Breaches</h2>
                                <span class="frst-date">April 16</span>
                                <p>
                                    In April 2012, a security researcher, Khosrow Zarefarid, dumped online the names,
                                    card numbers, and PINs of 3 million people across twenty-two Iranian banks after his
                                    reports on vulnerabilities were ignored by the companies involved.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Iran<br />
                                            <strong>Date Breach First Reported:</strong>4/16/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In April 2012, a security researcher, Khosrow Zarefarid, dumped online the
                                            names, card numbers, and PINs of 3 million people across twenty-two Iranian
                                            banks after his reports on vulnerabilities were ignored by the companies
                                            involved. However, no funds were stolen in the breach. Google took down the
                                            blog containing the information, and the banks urged customers to change
                                            their PINs. Zarefarid maintained that he was a whistleblower rather than a
                                            hacker.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="USFinancial2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>U.S. Financial Exchange DDoS Attacks</h2>
                                <span class="frst-date">February 1</span>
                                <p>
                                    In February 2012, financial exchange operators Nasdaq, CBOE, and BATS were hit by
                                    DDoS attacks for several days, resulting in patchy access to company websites but
                                    with no disruptions to trading.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>2/1/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2012, financial exchange operators Nasdaq, CBOE, and BATS were
                                            hit by DDoS attacks for several days, resulting in patchy access to company
                                            websites but with no disruptions to trading. The activist group Anonymous
                                            claimed responsibility for the incident, saying it acted out of sympathy for
                                            the Occupy Wall Street protests in New York.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BrazilDDOS2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Brazil Banks DDoS Attacks</h2>
                                <span class="frst-date">January 30</span>
                                <p>
                                    In January 2012, the hacktivist collective Anonymous used DDoS attacks to bring down
                                    numerous Brazilian banking websites to protest corruption and inequality in the
                                    country.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil<br />
                                            <strong>Date Breach First Reported:</strong>1/30/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In January 2012, the hacktivist collective Anonymous used DDoS attacks to
                                            bring down numerous Brazilian banking websites to protest corruption and
                                            inequality in the country. Banco do Brasil, Itaú Unibanco, Citibank, and
                                            Bradesco were among those affected by the #OpWeeksPayment campaign. The
                                            attackers reprised their campaign around the World Cup in 2014, which Brazil
                                            hosted.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Brazil2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Brazilian Payments System Attack</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    From 2012 to 2014, Boleto Bancario, a payments system used for almost half of
                                    non-cash transactions in Brazil, was targeted by malware that manipulated the
                                    victim’s browser to reroute payments to attacker-controlled accounts.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Brazil<br />
                                            <strong>Date Breach First Reported:</strong>1/1/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            From 2012 to 2014, Boleto Bancario, a payments system used for almost half
                                            of non-cash transactions in Brazil, was targeted by malware that manipulated
                                            the victim’s browser to reroute payments to attacker-controlled accounts.
                                            The technique compromised $3.75 billion in payments within a two-year
                                            period, using several different versions of malware including Eupuds,
                                            Boleteiro, and Domingo, according to researchers at RSA. The unidentified
                                            gang responsible later changed its “bolware” strategy to introduce DNS
                                            poisoning as a means to install the malware, lessening the need for spam
                                            emails to spread the malware.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PostBank2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Postbank Heist</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    From January 1-3, hackers targeted Postbank, a division of the South African Post
                                    Office, breaching the organization's IT system and siphoning off cash into dummy
                                    accounts.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>1/15/2012
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            From January 1-3, hackers targeted Postbank, a division of the South African
                                            Post Office, breaching the organization's IT system and siphoning off cash
                                            into dummy accounts. The hackers stole R42 million from accounts through
                                            automated teller machines (ATMs) in Gauteng, Free State, and KwaZulu-Natal.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="InvestorBroker2012">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Investor broker deal fraud</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    From 2012 to October 2020, an Internet-based fraud scheme generated approximately
                                    $50 million in fraudulent investments.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 01/07/2022
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            From 2012 to October 2020, an Internet-based fraud scheme generated
                                            approximately $50 million in fraudulent investments. At least 150 fraudulent
                                            sites advertising investment opportunities to solicit funds were created as
                                            part of the scheme. Victims who reached out following the advertisements
                                            spoke with threat actors posing as broker dealers claiming to be employed by
                                            finanical institutions that they had spoofed on the scam websites.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2011</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Citigroup2011">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Citigroup Data Theft</h2>
                                <span class="frst-date">June 8</span>
                                <p>
                                    In June, Citigroup announced that 360,000 card details in the United States were
                                    exposed after attackers exploited a URL vulnerability that allowed them to hop
                                    between accounts by slightly changing the website address.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 6/8/2011
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In June, Citigroup announced that 360,000 card details in the United States
                                            were exposed after attackers exploited a URL vulnerability that allowed them
                                            to hop between accounts by slightly changing the website address. The
                                            attackers reportedly created a script that would repeat this action tens of
                                            thousands of times in order to harvest the information before they were
                                            detected by a routine check in early May. The attackers stole names, account
                                            numbers, and contact information but were not able to access the card
                                            security codes needed to clone the cards, Citigroup said. The bank later
                                            settled lawsuits with the states of California and Connecticut over the
                                            breach. The website vulnerability was present as early as 2008, according to
                                            Connecticut authorities.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="GlobalPayments2011">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Global Payments Breach</h2>
                                <span class="frst-date">June 1</span>
                                <p>
                                    In June 2011, bank and retail payment processor Global Payments was hit by a major
                                    data breach.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>6/1/2011
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In June 2011, bank and retail payment processor Global Payments was hit by a
                                            major data breach. The company said unknown attackers had stolen the details
                                            of around 1.5 million cards from a handful of servers, with enough
                                            information to counterfeit the cards although not customer names or
                                            addresses. Details of the intrusion remain scarce, although Vons
                                            supermarkets said it detected compromised prepaid credit cards around the
                                            same time that appeared related to the Global Payments breach. The incident
                                            prompted Mastercard and Visa to warn card-issuing banks about the potential
                                            fraud.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SouthKorea2011">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South Korea Attacked II</h2>
                                <span class="frst-date">March 1</span>
                                <p>
                                    In March 2011, South Korea was hit by a widespread DDoS attack, almost two years
                                    after a similar campaign in 2009.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Korea<br />
                                            <strong>Date Breach First Reported:</strong>3/1/2011
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In March 2011, South Korea was hit by a widespread DDoS attack, almost two
                                            years after a similar campaign in 2009. Targets included Hanabank, Jeilbank,
                                            and Wooribank as well as government websites and the network of U.S. Forces
                                            Korea. The Koredos Trojan was used to wipe disks on the computers used as
                                            command-and-control servers. North Korea is speculated to be behind the
                                            ten-day incident.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Multinational2011">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Multinational Prepaid Card Heist</h2>
                                <span class="frst-date">February 27</span>
                                <p>
                                    In February 2011, a criminal gang breached at least three payment processors to take
                                    card information during a $55 million stealing spree.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong> 2/27/2011
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In February 2011, a criminal gang breached at least three payment processors
                                            to take card information during a $55 million stealing spree. Once inside
                                            the processors’ networks, the gang used administrator privileges to steal
                                            card and PIN details and lift withdrawal limits. The U.S. authorities said
                                            the gang then sent the data to “cashing crews” worldwide, who used it to
                                            clone cards. The mules withdrew $10 million through 15,000 fraudulent ATM
                                            withdrawals in eighteen countries over the course of a weekend. The American
                                            Red Cross had distributed the original prepaid cards to disaster victims.
                                        </p>
                                        <p>
                                            The gang’s second operation resulted in $5 million in withdrawals in twenty
                                            countries. In February 2013, the gang carried out its third and largest
                                            operation, taking just hours to withdraw $40 million from twenty-four
                                            countries.
                                        </p>
                                        <p>
                                            A Turkish man named as the gang’s leader, Ercan Findikoglu, was jailed for
                                            eight years in the United States in 2017 after extradition from Germany. He
                                            has also been convicted in Turkey for conspiring to produce fake cards—with
                                            a nineteen-and-a-half-year sentence he is expected to serve upon release in
                                            the United States. Three other men were jailed in 2014.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Iran2011">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Iranian DDoS Attacks on U.S. Banks</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    On March 24, 2016, the United States unsealed an indictment of seven Iranians
                                    allegedly responsible for the DDoS attacks targeting U.S. financial institutions
                                    across a two-year period on behalf of the Iranian government and Islamic
                                    Revolutionary Guard Corps.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 1/1/2011
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On March 24, 2016, the United States unsealed an indictment of seven
                                            Iranians allegedly responsible for the DDoS attacks targeting U.S. financial
                                            institutions across a two-year period on behalf of the Iranian government
                                            and Islamic Revolutionary Guard Corps. The indictment followed the landmark
                                            international deal to limit Iran’s nuclear capabilities in July 2015. Over
                                            forty-six financial organizations were targeted over the course of 176 days
                                            between December 2011 and mid-2013, the indictment said. The victims, which
                                            included Bank of America, the New York Stock Exchange, and Capital One,
                                            spent tens of millions of dollars to counteract the attacks, which at their
                                            height were occurring on a near-weekly basis.
                                        </p>
                                        <p>
                                            The seven men were accused of managing several “botnets” consisting of
                                            thousands of compromised computers to send malicious traffic to victim
                                            website, blocking access for legitimate users. They built the botnet by
                                            exploiting a known vulnerability in a popular content management software to
                                            install malware. The men worked for two private computer security companies
                                            in Iran that allegedly performed tasks for the government. Several were also
                                            accused of belonging to hacking groups that have claimed responsibility for
                                            attacks on NASA in February 2012.
                                        </p>
                                        <p>
                                            The political fallout from the attack was far-reaching. The U.S. Treasury
                                            Department imposed sanctions against eleven individuals and organizations in
                                            September 2017 over their links to Iran, some of whom were accused of
                                            participating in the DDoS attack. Meanwhile, U.S. President Donald Trump
                                            announced the United States’ withdrawal from the Iran nuclear deal in May
                                            2018.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Lebanon2011">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Lebanese Banks Espionage Operation</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    In early 2011, a virus named Gauss was used to steal inside information from
                                    multiple Lebanese banks.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Lebanon<br />
                                            <strong>Date Breach First Reported:</strong>1/1/2011
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Espionage
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In early 2011, a virus named Gauss was used to steal inside information from
                                            multiple Lebanese banks. Gauss, which bore resemblances to the Flame and
                                            Stuxnet malware, stole passwords, banking credentials, and browser cookies
                                            from infected devices. Most of the 2,500 infections detected by researchers
                                            at Kaspersky were on personal computers in Lebanon. News outlets have
                                            speculated that this cyber surveillance tool was designed by the U.S. and
                                            Israeli governments to circumvent Lebanon’s strict banking secrecy laws,
                                            which have made it difficult for global authorities to access information of
                                            suspected wrongdoing. These speculations were fueled by a statement made by
                                            the United States in March 2011, accusing a Lebanese bank of laundering
                                            money for a Mexican drug ring with links to Hezbollah.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2010</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Absa2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Absa Land Bank Fraud</h2>
                                <span class="frst-date">December 24</span>
                                <p>
                                    On December 24, 2010, South African financial services firm Absa noticed a series of
                                    transfers from the Land Bank and froze the accounts.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>12/24/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Insider<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 24, 2010, South African financial services firm Absa noticed a
                                            series of transfers from the Land Bank and froze the accounts. Hackers had
                                            set up over 30 dummy companies and many more fake accounts, attempting to
                                            make off with R150 million. Only R8 million was transferred, with all but
                                            R380,000 recovered.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Cleveland2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>U.S. Federal Reserve Bank of Cleveland Breach</h2>
                                <span class="frst-date">November 19</span>
                                <p>
                                    On October 21, 2010, a Malaysian national was arrested by the Secret Service for
                                    hacking into Federal Reserve Bank in Cleveland and a range of other U.S. firms.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>11/19/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On October 21, 2010, a Malaysian national was arrested by the Secret Service
                                            for hacking into Federal Reserve Bank in Cleveland and a range of other U.S.
                                            firms. He successfully stole over 400,000 credit and debit card numbers.
                                            However, the Federal Reserve said none of its production data was accessed,
                                            and that the hacker had only accessed test computers, but the intrusion
                                            nevertheless caused thousands of dollars in damage. Several organizations
                                            including Fed Comp, a data processor for federal credit unions, were
                                            breached. The Malaysian national was jailed for ten years for running the
                                            scheme. The U.S. central banking system is a prominent target for attackers.
                                            Records obtained by Reuters showed that the Federal Reserve’s
                                            Washington-based Board of Governors detected more than fifty breaches
                                            between 2011 and 2015.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Nasdaq2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Nasdaq Intrusion</h2>
                                <span class="frst-date">October 1</span>
                                <p>
                                    In October 2010, the FBI detected an intrusion on servers used by financial markets
                                    operator Nasdaq.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong> 10/1/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Data breach, disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Multiple<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In October 2010, the FBI detected an intrusion on servers used by financial
                                            markets operator Nasdaq. Further investigation by several U.S. agencies
                                            found that hackers had been in the network for around a year. They had used
                                            two zero-day exploits to build their presence in the stock exchange’s
                                            network, and planted malware on the Director’s Desk system, where directors
                                            of publicly held companies share confidential information. Nasdaq said no
                                            data was taken, and there was reportedly no evidence of suspicious trades
                                            that could be based on information in the system. The malware also included
                                            a destructive capability, but it is unclear whether disruption was a goal or
                                            simply a tool the attackers might use to cover their tracks. At the same
                                            time, a group of criminals penetrated Nasdaq in an incident that some
                                            investigators believed was linked. In 2013, following a sprawling
                                            investigation, the United States charged four Russians and a Ukrainian man
                                            with a string of online break-ins at Nasdaq and other companies dating back
                                            to 2005. Carrefour, 7-Eleven, Heartland Payment Systems, and JC Penney were
                                            among their other targets, together losing $300 million as a result of the
                                            scheme. Breaching Heartland exposed more than 100 million payment cards,
                                            ultimately costing the firm $12 million in fines and fees.
                                        </p>
                                        <p>
                                            The gang was said to have found a vulnerability in the password-reminder
                                            page of the Nasdaq site that enabled it to steal information, including
                                            hashed passwords, from the firm’s SQL servers.
                                        </p>
                                        <p>
                                            Two men were jailed in 2018 for twelve years and four years, respectively,
                                            for their roles in the gang. The pair helped steal more than 160 million
                                            credit card numbers from the companies they breached, according to U.S.
                                            prosecutors, using techniques such as “war-driving,” or traveling with a
                                            laptop to pick up the signal from unsecured networks. These details were
                                            sold via middlemen to “cashers,” who used the information to create cloned
                                            cards. Albert Gonzalez, an American known online as Soupnazi, was jailed in
                                            2009 for twenty years. The other indicted men are still at large.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="PNC2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>PNC Bank ATM Skimming</h2>
                                <span class="frst-date">April 15</span>
                                <p>
                                    In mid-2010, it was reported that over $200,000 in fraudulent transactions took
                                    place in New York and Washington, DC.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>4/15/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In mid-2010, it was reported that over $200,000 in fraudulent transactions
                                            took place in New York and Washington, DC. The transactions were traced back
                                            to compromised accounts and withdrawals in Pittsburg. Two Romanians were
                                            jailed for bank fraud, access device fraud, and aggravated identity theft.
                                            While this was one of the first instances of ATM skimming for card details
                                            in the United States, the technique was already widespread in Eastern
                                            Europe.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Schwab2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Charles Schwab Hack</h2>
                                <span class="frst-date">April 7</span>
                                <p>
                                    In mid-2010, a Russian national based in New York was jailed for three years for
                                    stealing and laundering more than $246,000 through Charles Schwab brokerage accounts
                                    in 2006.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>4/7/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Keylogging <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In mid-2010, a Russian national based in New York was jailed for three years
                                            for stealing and laundering more than $246,000 through Charles Schwab
                                            brokerage accounts in 2006. The hacker accessed the accounts through a
                                            keylogging Trojan, which captured the information of 180 credit cards. The
                                            hacker and his accomplices sent a portion of the proceeds back to
                                            co-conspirators in Russia, according to the FBI.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="BankAmerica2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Bank of America ATM Fraud</h2>
                                <span class="frst-date">April 1</span>
                                <p>
                                    In 2010, a Bank of America employee was charged with computer fraud after installing
                                    malware on 100 ATMs to steal $304,000 over seven months, in an early example of ATM
                                    “jackpotting.”
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>4/1/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In 2010, a Bank of America employee was charged with computer fraud after
                                            installing malware on 100 ATMs to steal $304,000 over seven months, in an
                                            early example of ATM “jackpotting.” The man was jailed for twenty-seven
                                            months after admitting to writing code that ordered the ATMs to issue cash
                                            without a record of the transaction. He withdrew his funds over the seven
                                            months, stopping in October 2009 when Bank of America’s internal control
                                            systems spotted the suspicious transactions.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="NationalCity2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>National City Bank Breach</h2>
                                <span class="frst-date">March 18</span>
                                <p>
                                    In early 2010, National City Bank identified a number of former debit accounts that
                                    had been compromised.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>3/18/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In early 2010, National City Bank identified a number of former debit
                                            accounts that had been compromised. The breach was only discovered after PNC
                                            Financial Services acquired the bank in 2008, highlighting the importance of
                                            assessing cybersecurity during large mergers and acquisitions. While the new
                                            owners announced the breach, they did not reveal the number of customers
                                            affected or the amount of money stolen.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="MorganStanley2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Morgan Stanley Break-In</h2>
                                <span class="frst-date">February 28</span>
                                <p>
                                    Morgan Stanley detected a very sensitive network break-in that lasted six months in
                                    2009, according to leaked emails.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>2/28/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach, theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Morgan Stanley detected a very sensitive network break-in that lasted six
                                            months in 2009, according to leaked emails. The bank believed the incident
                                            was part of Operation Aurora, carried out by the same state-sponsored
                                            attackers that targeted Google, Rackspace, Northrop Grumman, and Yahoo
                                            earlier that year.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Latvia2010">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Latvian Bank Leak</h2>
                                <span class="frst-date">February 24</span>
                                <p>
                                    In early 2010, a hacker leaked financial details of banks, tax records, and
                                    state-owned firms to a TV station, to raise public awareness of lucrative public
                                    sector salaries during a period of austerity in Latvia.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Latvia<br />
                                            <strong>Date Breach First Reported:</strong> 2/24/2010
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown<br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In early 2010, a hacker leaked financial details of banks, tax records, and
                                            state-owned firms to a TV station, to raise public awareness of lucrative
                                            public sector salaries during a period of austerity in Latvia. Ilmars
                                            Poikans, an IT researcher who used the alias Neo, was arrested shortly
                                            afterward and sentenced in 2015 to community service for accessing 7.5
                                            million tax records. He was pardoned in December 2017.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2009</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SouthKorea2009">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>South Korea and United States Attacked</h2>
                                <span class="frst-date">July 4</span>
                                <p>
                                    In July 2009, financial institutions in the United States and South Korea were among
                                    several targets of a widespread DDoS attack.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States and South Korea<br />
                                            <strong>Date Breach First Reported:</strong>7/4/2009
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDOS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In July 2009, financial institutions in the United States and South Korea
                                            were among several targets of a widespread DDoS attack. The incident, which
                                            began over a U.S. holiday weekend, comprised three waves of attacks spanning
                                            six days. The botnet of up to 65,000 compromised computers blocked and
                                            slowed government and commercial websites for several hours at a time. The
                                            New York Stock Exchange website was reportedly affected, as well as those
                                            for the Nasdaq, the White House, and the Washington Post. Several days
                                            later, the sites of Shinhan Bank, the newspaper Chosun Ilbo, and the
                                            National Assembly were hit in South Korea. In total, there were around
                                            thirty-five sites targeted by the attacks. Researchers estimated that the
                                            botnet generated 23 megabits of data per second, not enough to cause
                                            long-lasting disruption to the targeted sites. The malware spread through
                                            email with a time bomb in its code to trigger on July 10, when it would
                                            overwrite the victim’s hard drive with the string “Memory of the
                                            Independence Day.” This destroyed the master boot record and made the device
                                            unusable. While no one was publically attributed to the attack, South Korean
                                            intelligence suspects it was the work of a specific criminal or
                                            state-sponsored organization.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="VodacomFraud2009">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Vodacom Fraud Campaign</h2>
                                <span class="frst-date">June 1</span>
                                <p>
                                    Between June and July, hackers targeted customers of Vodacom with phishing attacks
                                    and carried out fradulent bank transactions.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> South Africa<br />
                                            <strong>Date Breach First Reported:</strong>7/9/2009
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Between June and July, hackers targeted customers of Vodacom with phishing
                                            attacks and carried out fradulent bank transactions. The hackers stole bank
                                            account details by imitating bank officials; one employee of Vodacom who was
                                            also involved in the scam then intercepted the one-time passwords on fake
                                            SIM cards to siphon off cash. Several hackers were arrested in South Africa
                                            in July and August.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Zeus2009">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Zeus Malware Attacks</h2>
                                <span class="frst-date">March 1</span>
                                <p>
                                    Between 2007 and 2011, a Trojan malware known as Zeus was used in numerous criminal
                                    operations to steal data on Windows devices.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> N/A<br />
                                            <strong>Date Breach First Reported:</strong> 3/1/2009
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware<br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Between 2007 and 2011, a Trojan malware known as Zeus was used in numerous
                                            criminal operations to steal data on Windows devices. Zeus was widely traded
                                            on criminal forums as a way to harvest online credentials. Its source code
                                            was made public in 2011 after its purported creator announced his
                                            retirement, which allowed multiple versions to spread. The Trojan included a
                                            keylogger that recorded bank login credentials and a botnet that executed
                                            attacks using infected devices.
                                        </p>
                                        <p>
                                            In March 2009, a security firm discovered an online data trove of stolen
                                            information from 160,000 computers infected by Zeus malware, including
                                            devices at Metro City Bank. A criminal gang also used Zeus in a global
                                            scheme to wire millions of dollars from five banks to overseas accounts,
                                            according to U.S. and UK officials who made more than 100 arrests in October
                                            2010. The gang recruited mules to launder the stolen funds and withdraw
                                            money from ATMs around the world.
                                        </p>
                                        <p>
                                            The variant Gameover Zeus was controlled by a group of hackers in Russia and
                                            Ukraine from October 2011 onward, according to the FBI. Among its many uses
                                            was as a platform to infect systems with Cryptolocker ransomware. Operation
                                            Tovar, an international law enforcement effort in June 2014, resulted in the
                                            seizure of key Gameover Zeus infrastructure and the release of up to 1
                                            million victim machines from the botnet. The authorities believe the gang
                                            stole more than $100 million. The Russian man accused of authoring both Zeus
                                            and Gameover Zeus remains at large.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Skimer2009">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Skimer ATM Malware Attack</h2>
                                <span class="frst-date">March 1</span>
                                <p>
                                    In 2009, security researchers discovered Skimer, an advanced multifunctional malware
                                    employed in several ATM heists across the world.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Multiple<br />
                                            <strong>Date Breach First Reported:</strong>3/1/2009
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In 2009, security researchers discovered Skimer, an advanced multifunctional
                                            malware employed in several ATM heists across the world. Skimer is capable
                                            of executing over twenty malicious commands, including withdrawing ATM funds
                                            and collecting customer information such as bank account numbers and payment
                                            card PINs. To install Skimer, attackers had to access ATMs and install
                                            backdoors in the device’s Windows operating system. Then, the attackers
                                            could silently siphon card numbers and customer information for later use in
                                            fraudulent transactions. Once correct details were entered into the ATM pin
                                            pad, Skimer gave attackers a control panel to execute multiple commands from
                                            cashing out an ATM to deleting traces of the infection from the system. The
                                            malware has continued to evolve with later variants still in use around the
                                            world.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2008</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="RBS2008">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>RBS WorldPay Hack</h2>
                                <span class="frst-date">November 1</span>
                                <p>
                                    Toward the end of 2008, Atlanta-based credit card processing company RBS WorldPay
                                    was breached by an international crime ring.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>11/1/2008
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Toward the end of 2008, Atlanta-based credit card processing company RBS
                                            WorldPay was breached by an international crime ring. The group used
                                            sophisticated hacking techniques to break the encryption used by RBS
                                            WorldPay to protect customer data on payroll debit cards. Once bypassed, the
                                            group created counterfeit payroll debit cards and raised their account
                                            limits. The group employed a network of individuals to use the cards to
                                            withdraw over $9 million from more than 2,100 ATMs in at least 280 cities
                                            worldwide. The investigation of the incident identified over 1.5 million
                                            customers whose confidential information was compromised. Individuals in
                                            Russia, Moldova, Nigeria, and Estonia were indicted from the hack in 2009.
                                            To date, U.S. authorities have charged fourteen men.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="UAE2008">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>United Arab Emirates ATM Fraud</h2>
                                <span class="frst-date">September 9</span>
                                <p>
                                    In September 2008, six banks in the UAE alerted customers to change their PINs after
                                    concerns over a spike in ATM fraud in the region.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Middle East<br />
                                            <strong>Date Breach First Reported:</strong>9/9/2008
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Unknown <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In September 2008, six banks in the UAE alerted customers to change their
                                            PINs after concerns over a spike in ATM fraud in the region. HSBC, one of
                                            the affected banks, said the move was in response to counterfeit ATM card
                                            usage from abroad, highlighting an early case of financial attacks operating
                                            on an international scale.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Georgia2008">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Russian Cyber Attacks on Georgia</h2>
                                <span class="frst-date">July 20</span>
                                <p>
                                    Between July and August, Georgia became the victim of a coordinated defacement and
                                    DDoS campaign that disrupted government and bank websites during the lead up to a
                                    war with Russia.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Georgia<br />
                                            <strong>Date Breach First Reported:</strong> 7/20/2008
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Multiple<br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Between July and August, Georgia became the victim of a coordinated
                                            defacement and DDoS campaign that disrupted government and bank websites
                                            during the lead up to a war with Russia. The first incident occurred on July
                                            20, when the website of then Georgian president Mikheil Saakashvili was
                                            disrupted by a DDoS attack, just weeks before Russia invaded the country.
                                            The DDoS attack was directed using a strain of Pinch malware frequently used
                                            in Russia, which flooded websites with traffic that included the phrase “win
                                            love in Russia.”
                                        </p>
                                        <p>
                                            As part of the conflict and war that took place from August 7 to 12, 2008,
                                            numerous Georgian government and media sites were defaced and disrupted,
                                            including depictions of Saakashvili next to Hitler on the president’s
                                            website. The only impact on the financial sector throughout this campaign
                                            was the defacement of the National Bank of Georgia’s website. A group by the
                                            name of South Ossetia Hack Crew claimed responsibility for the attacks.
                                            However, Georgia would later attribute the attack to the Russia government,
                                            which denied the allegations.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="HSBC2008">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>HSBC Insider Fraud</h2>
                                <span class="frst-date">July 7</span>
                                <p>
                                    On April 18, a clerk at HSBC’s headquarters in London fraudulently wired €90 million
                                    to accounts in Manchester and Morocco.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United Kingdom<br />
                                            <strong>Date Breach First Reported:</strong>7/7/2008
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Other <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On April 18, a clerk at HSBC’s headquarters in London fraudulently wired €90
                                            million to accounts in Manchester and Morocco. The employee used passwords
                                            stolen from colleagues to execute two transactions on a Friday afternoon. He
                                            was caught when he forgot to leave the original accounts with zero balances,
                                            which HSBC staff in Malaysia spotted over the weekend. He was jailed for
                                            nine years, and the money was returned to its owners. Investigators in the
                                            UK would later uncover the gang that masterminded the fraud.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Citibank2008">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Citibank ATM Theft</h2>
                                <span class="frst-date">July 1</span>
                                <p>
                                    In early 2008, a Russian hacking ring stole $2 million after penetrating a network
                                    of Citibank-affiliated ATMs across New York City.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>7/1/2008
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Malware <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In early 2008, a Russian hacking ring stole $2 million after penetrating a
                                            network of Citibank-affiliated ATMs across New York City. The group gained
                                            access to a server that processed ATM withdrawals within 7-Eleven stores.
                                            This enabled them to steal debit card numbers and PINs from 2,200 machines,
                                            which they used to withdraw the $2 million. Three members of the group were
                                            arrested and pleaded guilty to numerous counts of fraud and conspiracy later
                                            that year. Investigators later linked this theft to a global network of
                                            hackers that had stolen card information as early as 2005. A hacker
                                            identified as the ringleader by authorities was jailed in 2010. He would
                                            also be linked to the Nasdaq intrusion two years later.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="SocieteGenerale2008">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Société Générale Rogue Trader</h2>
                                <span class="frst-date">January 1</span>
                                <p>
                                    In January 2008, a junior trader at the French bank Société Générale executed
                                    fraudulent transactions to cover up $7.2 billion in losses from risky futures
                                    trades.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> France<br />
                                            <strong>Date Breach First Reported:</strong>1/1/2008
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Insider threat <br />
                                            <strong>Type:</strong> Theft
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            In January 2008, a junior trader at the French bank Société Générale
                                            executed fraudulent transactions to cover up $7.2 billion in losses from
                                            risky futures trades. The rogue trader hid his losses by booking fake
                                            offsetting trades on colleagues’ accounts and using knowledge from his
                                            previous role in the back office to alter internal risk controls so he would
                                            not trigger internal alerts. At one point, the portfolio of unauthorized
                                            trades was worth over €50 billion, approximately the same value as the
                                            entire firm. The employee was arrested and sentenced to three years in
                                            prison in 2010. The bank suffered one of the biggest trading losses on
                                            record due to the incident, and the French banking regulator imposed a $6
                                            million penalty for its lax controls.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                    <div class="frst-timeline-block frst-timeline-label-block" data-animation="slideInUp">
                        <div class="frst-labels frst-start-label">
                            <span>2007</span>
                        </div>
                        <!-- .frst-start-label-->
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Davidson2007">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>DA Davidson Data Breach</h2>
                                <span class="frst-date">December 25</span>
                                <p>
                                    On December 25–26, 2017, confidential information from 192,000 customers was stolen
                                    from financial services holding company DA Davidson.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>12/25/2007
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> SQL injection <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Nonstate actor<br />
                                            <strong>Attribution:</strong> High confidence
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On December 25–26, 2017, confidential information from 192,000 customers was
                                            stolen from financial services holding company DA Davidson. Attackers
                                            deployed a SQL injection into the brokerage’s website over the Christmas
                                            holiday to access customer records. The breach was discovered after the
                                            perpetrators attempted to blackmail the firm several weeks later. The U.S.
                                            Secret Service launched an investigation that identified four suspects,
                                            three of whom were Latvian nationals, who were extradited from the
                                            Netherlands to face charges in the United States. Following the breach, the
                                            Financial Industry Regulatory Authority issued a $375,000 fine to DA
                                            Davidson for its failure to protect confidential customer information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Ameritrade2007">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>TD Ameritrade Data Breach</h2>
                                <span class="frst-date">September 14</span>
                                <p>
                                    On September 14, 2007, online brokerage firm TD Ameritrade revealed that its
                                    database was the target of a data breach that led to the theft of 6.3 million
                                    customer account records.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> United States<br />
                                            <strong>Date Breach First Reported:</strong>9/14/2007
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> Phishing <br />
                                            <strong>Type:</strong> Data breach
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> Unknown<br />
                                            <strong>Attribution:</strong> Unknown
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            On September 14, 2007, online brokerage firm TD Ameritrade revealed that its
                                            database was the target of a data breach that led to the theft of 6.3
                                            million customer account records. The attackers gained access to
                                            Ameritrade’s database via investment-themed phishing emails. According to
                                            Ameritrade, sensitive data on the database, such as social security numbers,
                                            were not accessed during the breach. No identify theft was detected in the
                                            aftermath of the breach. However, customers did claim to have received spam
                                            emails. The FBI and U.S. financial regulators investigated the incident, but
                                            no arrests were reported. On September 13, 2011, TD Ameritrade agreed to pay
                                            customers $6.5 million to settle a class action suit in relation to the
                                            breach.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--frst-timeline-block-->
                    <div class="frst-timeline-block frst-even-item" data-animation="slideInUp" id="Estonia2007">
                        <div class="frst-timeline-img"><span></span></div>
                        <!-- frst-timeline-img -->
                        <div class="frst-timeline-content swing" style="position: relative">
                            <div class="frst-timeline-content-inner">
                                <h2>Estonian DDoS Attacks</h2>
                                <span class="frst-date">April 26</span>
                                <p>
                                    Following the contentious relocation of a Soviet-era statue in Tallinn, Estonia fell
                                    victim to a series of coordinated DDoS attacks against government, bank, university,
                                    and newspaper websites that lasted three weeks.
                                </p>
                                <div
                                    class="accordion-trigger more-less-timeline"
                                    data-more-label="Learn More"
                                    data-less-label="Close"
                                >
                                    Learn More
                                </div>
                                <div class="accordion-content">
                                    <div class="inside">
                                        <h4>Target</h4>
                                        <p>
                                            <strong>Location:</strong> Estonia<br />
                                            <strong>Date Breach First Reported:</strong>4/26/2007
                                        </p>
                                        <h4>Incident</h4>
                                        <p>
                                            <strong>Method:</strong> DDoS <br />
                                            <strong>Type:</strong> Disruption
                                        </p>
                                        <h4>Actor</h4>
                                        <p>
                                            <strong>Type:</strong> State-sponsored actor<br />
                                            <strong>Attribution:</strong> Speculated
                                        </p>
                                        <h4>Description</h4>
                                        <p>
                                            Following the contentious relocation of a Soviet-era statue in Tallinn,
                                            Estonia fell victim to a series of coordinated DDoS attacks against
                                            government, bank, university, and newspaper websites that lasted three
                                            weeks. The attacks began on April 26, when government and political party
                                            email servers and websites were disrupted. The following week, a second wave
                                            began that disrupted access to Estonian news websites. The final wave, which
                                            began on May 9, was the heaviest and targeted the Estonian banking sector.
                                            The attack forced two major Estonian banks to suspend online banking,
                                            disabling bank card transactions and ATM withdrawals. The disruption did not
                                            end until the attackers’ botnet contracts expired on May 19. The attacks
                                            were carried out by Russian hacktivists communicating openly on
                                            Russian-language chatrooms, where users shared precise instructions on how
                                            to conduct the attacks. Estonia accused the Russian government of ordering
                                            the attacks but was unable to produce definitive proof.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!--frst-timeline-content-inner-->
                            <!-- frst-timeline-content-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
useHead({
    script: [
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/index.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/map.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/geodata/worldLow.js' },
        { innerHTML: '', src: 'https://cdn.amcharts.com/lib/5/themes/Animated.js' },
    ],
});
import { onMounted, ref } from 'vue';
import FeatureFragment from '@fragments/pages/FeatureFragment.ts';

const pageData = await usePageData(FeatureFragment, 'features');

let activeCountry = '#41928c';
let inactiveCountry = '#e6e7ed';

onMounted(() => {
    callMap();
    aboutTab();

    // I need to catch any time a sortable is clicked, so it looks for all clicks on anything and acts if the className includes sortable ....
    document.onclick = function (e) {
        if (e.target.className && e.target.className.indexOf('more-less-timeline') != -1) {
            openTimelineEntries(e);
        } else if (e.target.className && e.target.className.indexOf('menu-trigger') != -1) {
            openFilterSections(e);
        }
    };
});

// colors
// all possible filter items -- it should only include ones being used, or the js will balk on an ID that doesn't mach to actual content
let my_data_location = [
    'Africa',
    'Bangladesh',
    'Brazil',
    'Canada',
    'CentralAmerica',
    'Chile',
    'China',
    'EastAsia',
    'EasternEurope',
    'Estonia',
    'France',
    'Georgia',
    'Germany',
    'India',
    'Iran',
    'Japan',
    'Kenya',
    'Mexico',
    'MiddleEast',
    'Nigeria',
    'NorthAmerica',
    'Poland',
    'Russia',
    'SouthAmerica',
    'SouthAsia',
    'SoutheastAsia',
    'SouthAfrica',
    'SouthKorea',
    'Thailand',
    'Uganda',
    'Ukraine',
    'UK',
    'UnitedStates',
    'UnitedArabEmirates',
    'WesternEurope',
];
let my_data_incidentType = ['dataBreach', 'disruption', 'espionage', 'theft'];
let my_data_actor = ['nonstate', 'stateSponsored'];
let my_data_attribution = ['confirmed', 'speculated', 'unknown'];
let my_data_year = [
    'y2022',
    'y2021',
    'y2020',
    'y2019',
    'y2018',
    'y2017',
    'y2016',
    'y2015',
    'y2014',
    'y2013',
    'y2012',
    'y2011',
    'y2010',
    'y2009',
    'y2008',
    'y2007',
];
let my_data_map = [
    'AE',
    'AR',
    'AO',
    'AU',
    'BA',
    'BD',
    'BE',
    'BR',
    'BG',
    'CA',
    'CL',
    'CN',
    'CR',
    'CZ',
    'CY',
    'HR',
    'EE',
    'EC',
    'FI',
    'FR',
    'GE',
    'GT',
    'GH',
    'DE',
    'DK',
    'HK',
    'HU',
    'IS',
    'IN',
    'ID',
    'IE',
    'IR',
    'IL',
    'IT',
    'GM',
    'GH',
    'JO',
    'JP',
    'KE',
    'KW',
    'KG',
    'LB',
    'LR',
    'LK',
    'LS',
    'MY',
    'MA',
    'ME',
    'MT',
    'MX',
    'MW',
    'MZ',
    'NA',
    'NI',
    'NP',
    'NG',
    'NO',
    'NZ',
    'PA',
    'PE',
    'PK',
    'PH',
    'PL',
    'RO',
    'RS',
    'RU',
    'RW',
    'SI',
    'SG',
    'KR',
    'ES',
    'SZ',
    'CH',
    'TW',
    'TG',
    'TH',
    'TN',
    'TR',
    'TZ',
    'UA',
    'UG',
    'UY',
    'GB',
    'US',
    'VN',
    'ZA',
    'ZM',
    'ZW',
];
//confirmed = known

// each unique ID relevant to a filter item goes here, to enable redactive filtering
let my_filter_data_original = [
    {
        filter: 'Africa',
        trueFilter:
            'VodacomFraud2009, Absa2010, PostBank2012, Paygate2012, DexterSA2013, SARoadsAgency2014, Gautrain2014, MiraiBotnetM2016, StandardBank2016, NigerianBank2016, CentralBank2016, PesaLink2017, Tunisia2017, SAHosting2017, KenyaBank2018, ViewFines2018, SAInsurer2018, SAHostingPlatform2018, Mauritius2018, Liberian2018, Postbank2018, NigerianFI2019, GambianFI2019, FancyBear2019, SabricDdos2019, JohannesburgCity2019, RwandaBank2019, SilenceGroup2019, AfricaBanks2020, Nedbank2020, SAExperian2020, BeagleBoyz2020, CIH2020, BetterSure202, AttemptedSASSA0200, RwandaBankHeist20, UgandaMObile2020, SouthAfricanBankBreach2020, FIN8BadHatch2021, SADebt2021, NigerianFraudster2021, Flubot2021, TransUnionSA2022',
    },
    {
        filter: 'Bangladesh',
        trueFilter: 'BangladeshBankFeb2016, SwitchSystem2019, DutchBangla2019, BeagleBoyz2020',
    },
    {
        filter: 'Brazil',
        trueFilter:
            'Brazil2012, BrazilDDOS2012, BrazilMalware2018, Janeleiro2019, BancoPan2019, BeagleBoyz2020, Vizom2020, Ghimob2020, BrazilianNT2021, PixStealer2021, BrazilianInsurance2021',
    },
    {
        filter: 'Canada',
        trueFilter:
            'GlobalPayments2011, Canada2018, CapitalOne2019, BankTrojan2020, Scotiabank2020, CACodvid2020, FIN8BadHatch2021, RoninCrypto2022',
    },
    {
        filter: 'CentralAmerica',
        trueFilter:
            'Guatemala2015, PanamaPapers2016, CentralBank2016, CostaRica2018, SilenceGroup2019, BancoBCR2020, BeagleBoyz2020, FIN8BadHatch2021',
    },
    {
        filter: 'Chile',
        trueFilter: 'BancoChile2018, ChileATM2019, SilenceGroup2019, BeagleBoyz2020, ChileanBanco2020',
    },
    {
        filter: 'China',
        trueFilter:
            'Shanghai2012, China2013, Tyupkin2014, ShanghaiJun2015, HongKong2019, dForce2020, Goldenspy2020, DeathStalker2020, PolyNetwork2021',
    },
    {
        filter: 'EastAsia',
        trueFilter:
            'SouthKorea2009, SouthKorea2011, Multinational2011, Shanghai2012, Carbanak2013, SouthKoreaMar2013, China2013, Tyupkin2014, ShanghaiJun2015, StandardBank2016, BitHumbHeist12017, FarEastern2017, Youbit2017, YoubitHacked2017, BitHumbHeist22017, SouthKoreaMonero2017, CoinsiCrypto2017, SKCryptoHeist2017, Coincheck2018, Coinrail2018, BitHumb32018, Zaif2018, Ursnif2019, Remixipoint2019, HongKong2019, BitHumb42019, SilenceTargets42019, Upbit2019, BitpointCrypto2019, UpbitCrypto2019, SouthKoreaUSCard2020, dForce2020, Coincheck2020, Goldenspy2020, DeathStalker2020, BeagleBoyz2020, JapaneseGlitch2020, SouthKoreaSupply2020, LazarusGroup2021, Oscorp2021, PolyNetwork2021, JapanCrypto2021, TaiwaneseDeFi2021, TaiwaneseData2020, TaiwaneseFinancialNov2021, FakecallsTrojan2022',
    },
    {
        filter: 'EasternEurope',
        trueFilter:
            'Estonia2007, Georgia2008, Latvia2010, Multinational2011, Carbanak2013, EuropeanCentralBank2014, UkraineJuly2014, WarsawOct2014, Tyupkin2014, Metel2015, Greek2015, CentralBank2016, RussianBanksDec2016, NiceHash2017, PIR2018, EEBanks2018, Silence2018, GozNym2019, Sberbank2019, SilenceGroup2019, NKoreaWebSkimming2020, DeathStalker2020, BeagleBoyz2020, RussianBanks2020, HungarianBanks2020, Oscorp2021, TA5052021, CreamFinance2021, UkraineGovFebDDOS2022, MoscowStockExchange2022',
    },
    {
        filter: 'Estonia',
        trueFilter: 'Estonia2007, EuropeanCentralBank2014',
    },
    {
        filter: 'France',
        trueFilter: 'SocieteGenerale2008, EuropeanCentralBank2014, Tyupkin2014, Oscorp2021',
    },
    {
        filter: 'Georgia',
        trueFilter: 'Georgia2008, GozNym2019',
    },
    {
        filter: 'Germany',
        trueFilter:
            'EuropeanCentralBank2014, Retefe2019, GozNym2019, ECB2019, Paypal2020, ECBGlitch2020, GermanGootkit2020, GermanBanksDDOS2021, Oscorp2021',
    },
    {
        filter: 'India',
        trueFilter:
            'Tyupkin2014, IndianATM2016, UnionBankIndia2016, Swift2018, Cosmos2018, SBI2019, Jana2019, IndianATM2019, SilenceTargets42019, DutchBangla2019, IndianMobileApp2020, DeathStalker2020, BeagleBoyz2020, IndianChqbook2020, Upstox2021, Oscorp2021, BankingTrojanIndia2021, CashMama2022',
    },
    {
        filter: 'Iran',
        trueFilter: 'Iran2012, IranCard2019, MrbMiner2020',
    },
    {
        filter: 'Japan',
        trueFilter:
            'StandardBank2016, Zaif2018, Coincheck2018, Ursnif2019, Remixipoint2019, BitpointCrypto2019, Coincheck2020, BeagleBoyz2020, JapaneseGlitch2020, LazarusGroup2021, Oscorp2021, JapanCrypto2021',
    },
    {
        filter: 'Kenya',
        trueFilter: 'CentralBank2016, KenyaBank2018, Nedbank2020, BeagleBoyz2020',
    },
    {
        filter: 'Mexico',
        trueFilter:
            'GlobalPayments2011, Ploutus2013, CentralBank2016, Mexican2018, Bancomext2018, AXA2018, MexicoGang2019, BeagleBoyz2020, AmericanExpress2021',
    },
    {
        filter: 'MiddleEast',
        trueFilter:
            'UAE2008, Multinational2011, Lebanon2011, Multinational2011, Iran2012, Tyupkin2014, TurkishCards2019, IranCard2019, Kuwait2019, UKIsrael2019, DeathStalker2020, BeagleBoyz2020, MrbMiner2020, Shirbit2020, TurkeyDogContinues2020, DeepVoice2020, LazarusGroup2021, Bit2check2021',
    },
    {
        filter: 'Nigeria',
        trueFilter: 'NigerianBank2016, NigerianFI2019, BeagleBoyz2020, NigerianFraudster2021, Flubot2021',
    },
    {
        filter: 'NorthAmerica',
        trueFilter:
            'Ameritrade2007, Davidson2007, Citibank2008, RBS2008, SouthKorea2009, MorganStanley2010, NationalCity2010, BankAmerica2010, Schwab2010, PNC2010, Nasdaq2010, Cleveland2010, Iran2011, GlobalPayments2011, Citigroup2011, Multinational2011, HighRoller2012, USFinancial2012, Ababil2012, BankWest2013, CME2013, Carbanak2013, Ploutus2013, JPMorgan2014, Tyupkin2014, Wolf2015, Health2015, CentralBank2016, HongKong2016, Equifax2017, SEC2017, Mabna2018, Mexican2018, BancoPeruvian2018, AXA2018, Canada2018, HSBCUS2018, RapidRaids2018, Bancomext2018, Evercore2018, Blacksburg2018, RapidRaidsMar2018, HSBCUS2018, Click2Gov2018, Fuze2019, USCreditUnion2019, MexicoGang2019, FirstBank2019, CapitalOne2019, FirstAmerican2019, GozNym2019, Wawa2019, Advantage2019, Paypal2020, NigerianHackingGroup2020, SquareMilner2020, ChubbRansomware2020, SouthKoreaUSCard2020, Diebold2020, SECRansomeware2020, Twitter2020, Scotiabank2020, Dave2020, CACodvid2020, FinanceRDoS2020, SolarWindsUS2020, MobileSpoofing2020, FBIThirdParty2020, Accellion2020, AmericanExpress2021, CubaRansomware2021, IRSPhishing2021, NYCovid2021, SequoiaCapital2021, WallStreetCapitalCall2021, FinraScam2021, FIN8BadHatch2021, FBI4BilCybercrime2021, FTCPhishingMar2021, USCNA021, TruistBankSpear2021, CNAFinancial2021, LazarusGroup2021, ChasePhishing2021, SmallBanksRansomware2021, IntuitTurbotax2021, MorganStanleyAccellion2021, FBIWarning72021, BackNine2021, Oscorp2021, FIN8US2021, Nixdorf2021, FBIRansomware2021, FBIATM2021, Robinhood2021, USRegs2021, InvestorBroker2012, IRAFinancialTrust2022, AonRansomware022, RoninCrypto2022, BeanstalkFarms2022',
    },
    {
        filter: 'Poland',
        trueFilter: 'WarsawOct2014, Oscorp2021, CreamFinance2021',
    },
    {
        filter: 'Russia',
        trueFilter:
            'Carbanak2013, Tyupkin2014, Metel2015, RussianBanksDec2016, PIR2018, Silence2018, Sberbank2019, RussianBanks2020, TA5052021, MoscowStockExchange2022',
    },
    {
        filter: 'SouthAfrica',
        trueFilter:
            'VodacomFraud2009, Absa2010, PostBank2012, Paygate2012, DexterSA2013, SARoadsAgency2014, Gautrain2014, StandardBank2016, SAHosting2017, Postbank2018, SAInsurer2018, ViewFines2018, SAHostingPlatform2018, FancyBear2019, SabricDdos2019, JohannesburgCity2019, Nedbank2020, SAExperian2020, BeagleBoyz2020, BetterSure2020, AttemptedSASSA020, SouthAfricanBankBreach2020, FIN8BadHatch2021, SADebt2021, TransUnionSA2022',
    },
    {
        filter: 'SouthAmerica',
        trueFilter:
            'Brazil2012, BrazilDDOS2012, HighRoller2012, Ecuador2015, BancoChile2018, BancoPeruvian2018, BrazilMalware2018, Janeleiro2019, ChileATM2019, BancoPan2019, SilenceGroup2019, DeathStalker2020, BeagleBoyz2020, ChileanBanco2020, Vizom2020, Ghimob2020, PloutusVariant2021, BrazilianNT2021, PixStealer2021, BrazilianInsurance2021, Pichincha2021',
    },
    {
        filter: 'SouthAsia',
        trueFilter:
            'Tyupkin2014, BangladeshBankFeb2016, IndianATM2016, UnionBankIndia2016, Swift2018, Cosmos2018, DataPakistan2018, Islami2018, SBI2019, SwitchSystem2019, Jana2019, HimalayanATM2019, IndianATM2019, SilenceTargets42019, FancyBear2019, DutchBangla2019, IndianMobileApp2020, DeathStalker2020, BeagleBoyz2020, IndianChqbook2020, Upstox2021, Oscorp2021, BankingTrojanIndia2021, PakistanBank2021, CashMama2022',
    },
    {
        filter: 'SoutheastAsia',
        trueFilter:
            'Multinational2011, Tyupkin2014, TienPhong2015, BancoPeruvian2018, MalaysiaSWIFT2018, BancoPeruvian2018, DragonEx2019, DutchBangla2019, SEAsiaBanks2020, FinanceRDoS2020, BeagleBoyz2020, IndonesianFintech2020, Rakyat2020, AXA2021, Monox2021',
    },
    {
        filter: 'SouthKorea',
        trueFilter:
            'SouthKorea2009, SouthKorea2011, SouthKoreaMar2013, BitHumbHeist12017, Youbit2017, BitHumbHeist22017, YoubitHacked2017, SouthKoreaMonero2017, CoinsiCrypto2017, SKCryptoHeist2017, Coinrail2018, BitHumb32018, BitHumb42019, SilenceTargets42019, Upbit2019, UpbitCrypto2019, SouthKoreaUSCard2020, BeagleBoyz2020, SouthKoreaSupply2020, FakecallsTrojan2022',
    },
    {
        filter: 'Thailand',
        trueFilter: 'SEAsiaBanks2020, BancoPeruvian2018, Multinational2011',
    },
    {
        filter: 'Uganda',
        trueFilter: 'UgandaMObile2020',
    },
    {
        filter: 'Ukraine',
        trueFilter: 'UkraineJuly2014, GozNym2019, EEBanks2018, UkraineGovFebDDOS2022',
    },
    {
        filter: 'UnitedArabEmirates',
        trueFilter: 'UAE2008, Multinational2011, DeathStalker2020, DeepVoice2020',
    },
    {
        filter: 'UK',
        trueFilter:
            'HSBC2008, Tesco2016, Magecart2018, Evercore2018, MetroBank2019, RBSSec2019, Cayman2019, Travelex2019, CryptoExchange2019, SilenceTargets42019, UKIsrael2019, Loqbox2020, Finastra2020, DeathStalker2020, ScottishEPA2020, UKInsurer2021, SharkBot2021, Qubit2022',
    },
    {
        filter: 'UnitedStates',
        trueFilter:
            'Ameritrade2007, Davidson2007, Citibank2008, RBS2008, SouthKorea2009, MorganStanley2010, NationalCity2010, BankAmerica2010, Schwab2010, PNC2010, Nasdaq2010, Cleveland2010, Iran2011, GlobalPayments2011, Citigroup2011, USFinancial2012, Ababil2012, HighRoller2012, BankWest2013, CME2013, Carbanak2013, Ploutus2013, JPMorgan2014, Tyupkin2014, Wolf2015, Health2015, HongKong2016, Equifax2017, SEC2017, Evercore2018, Mabna2018, Blacksburg2018, RapidRaids2018, HSBCUS2018, Click2Gov2018, BancoPeruvian2018, RapidRaidsMar2018, Fuze2019, USCreditUnion2019, FirstBank2019, CapitalOne2019, FirstAmerican2019, Advantage2019, GozNym2019, Wawa2019, Paypal2020, SquareMilner2020, NigerianHackingGroup2020, ChubbRansomware2020, BankTrojan2020, SouthKoreaUSCard2020, Diebold2020, SECRansomeware2020, Twitter2020, Dave2020, SolarWindsUS2020, FBIThirdParty2020, Accellion2020, CubaRansomware2021, IRSPhishing2021, NYCovid2021, SequoiaCapital2021, WallStreetCapitalCall2021, FinraScam2021, FIN8BadHatch2021, FBI4BilCybercrime2021, FTCPhishingMar2021, USCNA021, TruistBankSpear2021, CNAFinancial2021, LazarusGroup2021, ChasePhishing2021, SmallBanksRansomware2021, IntuitTurbotax2021, MorganStanleyAccellion2021, FBIWarning72021, BackNine2021, Oscorp2021, FIN8US2021, Nixdorf2021, FBIRansomware2021, FBIATM2021, Robinhood2021, USRegs2021, InvestorBroker2012, IRAFinancialTrust2022, AonRansomware022, BeanstalkFarms2022',
    },
    {
        filter: 'WesternEurope',
        trueFilter:
            'SocieteGenerale2008, HSBC2008, Multinational2011, HighRoller2012, EuropeanCentralBank2014, Tyupkin2014, Swedbank2015, BelgianBankFeb2016, Tesco2016, Dutch2018, Evercore2018, Magecart2018, Infraud2018, BitGrail2018, MetroBank2019, Retefe2019, BankValletta2019, RBSSec2019, ECB2019, GozNym2019, Cayman2019, Binance2019, CryptoExchange2019, Edenred2019, Travelex2019, SpanishFI2019, SilenceTargets42019, UKIsrael2019, Loqbox2020, Paypal2020, Finastra2020, MontePaschi2020, SpanishBanks2020, Norfund2020, EuropeanDDOS2020, Argenta2020, FinanceRDoS2020, DeathStalker2020, ItalianBanks2020, BeagleBoyz2020, ECBGlitch2020, GermanGootkit2020, MobileSpoofing2020, DenmarkBank2020, ScottishEPA2020, TeaBot2021, FIN8BadHatch2021, LazarusGroup2021, UKInsurer2021, GermanBanksDDOS2021, Oscorp2021, SharkBot2021, OPFinancialGroup2022, Qubit2022, WormholeCryptocurrency2022',
    },
    {
        filter: 'dataBreach',
        trueFilter:
            'Ameritrade2007, Davidson2007, UAE2008, MorganStanley2010, Nasdaq2010, Latvia2010, NationalCity2010, Citigroup2011, Iran2012, Paygate2012, CME2013, UkraineJuly2014, EuropeanCentralBank2014, JPMorgan2014, WarsawOct2014, Health2015, ShanghaiJun2015, PanamaPapers2016, IndianATM2016, HongKong2016, Equifax2017, SEC2017, Paradise2017, SAHosting2017, Mabna2018, ViewFines2018, Canada2018, HSBCUS2018, DataPakistan2018, SAInsurer2018, SAHostingPlatform2018, AXA2018, Evercore2018, Click2Gov2018, FirstBank2019, Jana2019, BancoPan2019, CapitalOne2019, FirstAmerican2019, ECB2019, JohannesburgCity2019, Sberbank2019, Cayman2019, TurkishCards2019, IranCard2019, Wawa2019, Advantage2019, Nedbank2020, PerSwaysion2020, Loqbox2020, SEAsiaBanks2020, Finastra2020, SquareMilner2020, ChubbRansomware2020, MontePaschi2020, Coincheck2020, Scotiabank2020, Dave2020, DenmarkBank2020, Pepperstone2020, SAExperian2020, BetterSure2020, LedgerWallet2020, IndonesianFintech2020, IndianChqbook2020, AmericanExpress2021, NZBankData2021, MicrosoftExchangeServers2021, CNAFinancial2021, SADebt2021, IntuitTurbotax2021, BackNine2021, Robinhood2021, TransUnionSA2022, CashMama2022',
    },
    {
        filter: 'disruption',
        trueFilter:
            'Estonia2007, Georgia2008, SouthKorea2009, Nasdaq2010, Iran2011, SouthKorea2011, BrazilDDOS2012, USFinancial2012, Ababil2012, SouthKoreaMar2013, China2013, ShanghaiJun2015, Swedbank2015, Greek2015, BelgianBankFeb2016, CentralBank2016, MiraiBotnetM2016, RussianBanksDec2016, Dutch2018, DDOS2018, BancoPeruvian2018, BancoChile2018, MetroBank2019, HongKong2019, FancyBear2019, SabricDdos2019, AustraliaBanks2020, EuropeanDDOS2020, FinanceRDoS2020, NZStock2020, HungarianBanks2020, JapaneseGlitch2020, ECBGlitch2020, AustralianStockExchange2020, GermanBanksDDOS2021, NZOutages2021, BrazilianInsurance2021, Pichincha2021, PakistanBank2021, OPFinancialGroup2022, UkraineGovFebDDOS2022, MoscowStockExchange2022, AonRansomware022',
    },
    {
        filter: 'espionage',
        trueFilter:
            'Lebanon2011, ChileATM2019, Threadkit2018, IndianATM2019, SolarWindsUS2020, TaiwaneseData2020, TaiwaneseFinancialNov2021',
    },
    {
        filter: 'theft',
        trueFilter:
            'RBS2008, Skimer2009, Zeus2009, VodacomFraud2009, MorganStanley2010, BankAmerica2010, Schwab2010, PNC2010, Cleveland2010, Absa2010, Multinational2011, GlobalPayments2011, Brazil2012, HighRoller2012, PostBank2012, DexterSA2013, BankWest2013, Carbanak2013, Ploutus2013, SARoadsAgency2014, Tyupkin2014, Gautrain2014, Metel2015, Ecuador2015, Wolf2015, TienPhong2015, Guatemala2015, BangladeshBankFeb2016, Tesco2016, StandardBank2016, NigerianBank2016, UnionBankIndia2016, BitHumbHeist12017, FarEastern2017, Youbit2017, YoubitHacked2017, SouthKoreaMonero2017, BitHumbHeist22017, CoinsiCrypto2017, Tunisia2017, SKCryptoHeist2017, NiceHash2017, PesaLink2017, CostaRica2018, BitGrail2018, Infraud2018, Coincheck2018, Swift2018, Mexican2018, PIR2018, Blacksburg2018, Bancomext2018, KenyaBank2018, MalaysiaSWIFT2018, Cosmos2018, Silence2018, Mauritius2018, RapidRaids2018, Zaif2018, Magecart2018, RapidRaidsMar2018, Islami2018, BancoChile2018, EEBanks2018, Postbank2018, Coinrail2018, BitHumb32018, BrazilMalware2018, Janeleiro2019, Fuze2019, MexicoGang2019, GozNym2019, NigerianFI2019, GambianFI2019, SpanishFI2019, SwitchSystem2019, CryptoExchange2019, Remixipoint2019, DragonEx2019, Kuwait2019, CapitalOne2019, HimalayanATM2019, BankValletta2019, DutchBangla2019, BriansClub2019, Upbit2019, UpbitCrypto2019, Travelex2019, SilenceTargets42019, RwandaBank2019, BitHumb42019, BitpointCrypto2019, UKIsrael2019, SilenceGroup2019, WebShellUse2020, AfricaBanks2020, Paypal2020, BankTrojan2020, TurkeyDogContinues2020, SouthKoreaUSCard2020, SpanishBanks2020, dForce2020, NKoreaWebSkimming2020, Diebold2020, Norfund2020, IndianMobileApp2020, BancoBCR2020, IcedID2020, SECRansomeware2020, SpanishCrypto2020, Argenta2020, Twitter2020, Kattana2020, DeepVoice2020, Emotet2020, NetWalker2020, CACodvid2020, BeagleBoyz2020, MrbMiner2020, NigerianHackingGroup2020, CIH2020, RussianBanks2020, FIN112020, Vizom2020, AttemptedSASSA020, RwandaBankHeist20, JuspayData2020, UgandaMObile2020, GermanGootkit2020, Ghimob2020, GoDaddyScam2020, SouthKoreaSupply2020, ElectroRAT2020, Classiscam2020, SouthAfricanBankBreach2020, Shirbit2020, MobileSpoofing2020, FBIThirdParty2020, Accellion2020, ScottishEPA2020, ItalianBanks2020, RockeGroup2021, CubaRansomware2021, IRSPhishing2021, NYCovid2021, IndictNKCybercriminals2021, SequoiaCapital2021, PloutusVariant2021, WallStreetCapitalCall2021, FinraScam2021, FIN8BadHatch2021, FBI4BilCybercrime2021, FTCPhishingMar2021, USCNA021, TeaBot2021, FIN72021, TruistBankSpear2021, GooglePlayFraud2021, Swarmshop2021, Upstox2021, BizarroEU2021, LazarusGroup2021, CounterfeitApps2021, AXA2021, ChasePhishing2021, SmallBanksRansomware2021, UKInsurer2021, Bit2check2021, MorganStanleyAccellion2021, FBIWarning72021, PolyNetwork2021, NigerianFraudster2021, JapanCrypto2021, FIN8US2021, TaiwaneseDeFi2021, Kaspersky09021, PixStealer2021, Nixdorf2021, CreamFinance2021, FBIATM2021, bZx2021, BadgerDAO2021, Bitmart2021, AscendEX2021, Monox2021, Zloader2021, InvestorBroker2012, OCBCPhishing2021, CryptoCom2022, Multichain2022, TeaBotFluBot2022, Qubit2022, OnlineRetailersTrojan2021, WormholeCryptocurrency2022, IRAFinancialTrust2022, RoninCrypto2022, BeanstalkFarms2022',
    },
    {
        filter: 'nonstate',
        trueFilter:
            'Davidson2007, SocieteGenerale2008, Citibank2008, HSBC2008, RBS2008, Zeus2009, VodacomFraud2009, Latvia2010, BankAmerica2010, Schwab2010, PNC2010, Cleveland2010, Multinational2011, BrazilDDOS2012, USFinancial2012, Iran2012, Carbanak2013, DexterSA2013, SARoadsAgency2014, JPMorgan2014, Tyupkin2014, Gautrain2014, Swedbank2015, Greek2015, BelgianBankFeb2016, MiraiBotnetM2016, CentralBank2016, HongKong2016, Dutch2018, Infraud2018, DDOS2018, PIR2018, Silence2018, RapidRaids2018, RapidRaidsMar2018, BrazilMalware2018, Click2Gov2018, Evercore2018, Fuze2019, MexicoGang2019, BankValletta2019, GozNym2019, CapitalOne2019, BriansClub2019, FancyBear2019, JohannesburgCity2019, RwandaBank2019, Cardplanet2019, Cayman2019, Travelex2019, DutchBangla2019, SilenceGroup2019, AfricaBanks2020, PerSwaysion2020, SpanishBanks2020, BancoBCR2020, Emotet2020, Dave2020, NetWalker2020, ChileanBanco2020, RussianBanks2020,  MrbMiner2020, NigerianHackingGroup2020, FIN112020, AttemptedSASSA020, RwandaBankHeist20, GermanGootkit2020, ItalianBanks2020, Ghimob2020, SouthKoreaSupply2020, SouthAfricanBankBreach2020, Shirbit2020, Accellion2020, MicrosoftExchangeServers2021, FIN8BadHatch2021, FIN72021, CNAFinancial2021, USCNA021, Swarmshop2021, SADebt2021, AXA2021, Bit2check2021, MorganStanleyAccellion2021, NigerianFraudster2021, FIN8US2021, TA5052021, FBIATM2021, MoscowStockExchange2022',
    },
    {
        filter: 'stateSponsored',
        trueFilter:
            'Georgia2008, SouthKorea2009, Ababil2012, RussianBanksDec2016,Estonia2007,MorganStanley2010, Lebanon2011, Iran2011, SouthKorea2011, SouthKoreaMar2013, UkraineJuly2014, WarsawOct2014, Health2015, TienPhong2015, Guatemala2015, BangladeshBankFeb2016, StandardBank2016, NigerianBank2016, UnionBankIndia2016, BitHumbHeist12017, FarEastern2017, Youbit2017, SouthKoreaMonero2017, YoubitHacked2017, BitHumbHeist22017, CoinsiCrypto2017, Tunisia2017, SKCryptoHeist2017, NiceHash2017, Equifax2017, CostaRica2018, Bancomext2018, Coincheck2018, MalaysiaSWIFT2018, NigerianFI2019, GambianFI2019, Swift2018, Liberian2018, Mabna2018, BancoChile2018, Cosmos2018, BancoPeruvian2018, Threadkit2018, SpanishFI2019, ChileATM2019, DragonEx2019, HimalayanATM2019, IndianATM2019, Kuwait2019, BitHumb42019, SilenceTargets42019, Upbit2019, NKoreaWebSkimming2020, Rakyat2020, DenmarkBank2020, BeagleBoyz2020, SolarWindsUS2020, RockeGroup2021, IndictNKCybercriminals2021, LazarusGroup2021, TaiwaneseData2020, UkraineGovFebDDOS2022, TaiwaneseFinancialNov2021, RoninCrypto2022, LazarusTrojan2022',
    },
    // {
    //     "filter": "actorUnknown",
    //     "trueFilter": "Ameritrade2007, UAE2008, Skimer2009, NationalCity2010, GlobalPayments2011, Citigroup2011, Brazil2012, Shanghai2012, PostBank2012, HighRoller2012, Paygate2012, BankWest2013, CME2013, Ploutus2013, China2013, EuropeanCentralBank2014, Metel2015, Ecuador2015, Wolf2015, ShanghaiJun2015, PanamaPapers2016, IndianATM2016, Tesco2016, SEC2017, SAHosting2017, PesaLink2017, Paradise2017, Mexican2018, Canada2018, Blacksburg2018, Mauritius2018, Zaif2018, KenyaBank2018, ViewFines2018, HSBCUS2018, Magecart2018, DataPakistan2018, Islami2018, AXA2018, Islami2018, SAHostingPlatform2018, Coinrail2018, SAInsurer2018, Janeleiro2019, SBI2019, MetroBank2019, EEBanks2018, BitGrail2018, USCreditUnion2019, Ursnif2019, RBSSec2019, Retefe2019, FirstBank2019, SwitchSystem2019, CryptoExchange2019, Remixipoint2019, Jana2019, BancoPan2019, Binance2019, FirstAmerican2019, ECB2019, HongKong2019, UpbitCrypto2019, SabricDdos2019, UKIsrael2019, BitpointCrypto2019, TurkishCards2019, IranCard2019, Wawa2019, Advantage2019, WebShellUse2020, Loqbox2020, Nedbank2020, Paypal2020, AustraliaBanks2020, SEAsiaBanks2020, Finastra2020, SquareMilner2020, ChubbRansomware2020, MontePaschi2020, BankTrojan2020, TurkeyDogContinues2020, SouthKoreaUSCard2020, dForce2020, Diebold2020, DeepVoice2020, Norfund2020, IndianMobileApp2020, Coincheck2020, EuropeanDDOS2020, IcedID2020, SpanishCrypto2020, Argenta2020, Twitter2020, Kattana2020, Scotiabank2020, Pepperstone2020, CACodvid2020, SAExperian2020, NZStock2020, DeathStalker2020, CIH2020, HungarianBanks2020, BetterSure2020, Vizom2020, LedgerWallet2020, JuspayData2020, UgandaMObile2020, IndonesianFintech2020, GoDaddyScam2020, ElectroRAT2020, Classiscam2020, MobileSpoofing2020, ScottishEPA2020, IndianChqbook2020, PayPalSMS2021, AmericanExpress2021, NZBankData2021, CubaRansomware2021, IRSPhishing2021, NYCovid2021, SequoiaCapital2021, PloutusVariant2021, WallStreetCapitalCall2021, FinraScam2021, TeaBot2021, TruistBankSpear2021, GooglePlayFraud2021, Upstox2021, BizarroEU2021, CounterfeitApps2021, ChasePhishing2021, SmallBanksRansomware2021, UKInsurer2021, GermanBanksDDOS2021, IntuitTurbotax2021, Oscorp2021, PolyNetwork2021, BrazilianNT2021, JapanCrypto2021, TaiwaneseDeFi2021, NZOutages2021, BankingTrojanIndia2021, PixStealer2021, BrazilianInsurance2021, Pichincha2021, Flubot2021, Nixdorf2021, CreamFinance2021, PakistanBank2021, FBIRansomware2021, SharkBot2021, bZx2021, Robinhood2021, BadgerDAO2021, Bitmart2021, AscendEX2021, Monox2021, Zloader2021, InvestorBroker2012, OPFinancialGroup2022, OCBCPhishing2021, CryptoCom2022, Multichain2022, TeaBotFluBot2022, Qubit2022, OnlineRetailersTrojan2021, WormholeCryptocurrency2022, MedusaPhishing2022, IRAFinancialTrust2022, AonRansomware022, TransUnionSA2022, CashMama2022, FakecallsTrojan2022, BeanstalkFarms2022"
    // },
    // 'confirmed' is also 'known' and also 'high confidence'
    {
        filter: 'confirmed',
        trueFilter:
            'Davidson2007, SocieteGenerale2008, Citibank2008, HSBC2008, Georgia2008, RBS2008, Zeus2009, VodacomFraud2009, Latvia2010, BankAmerica2010, Schwab2010, PNC2010, Cleveland2010, Absa2010, Iran2011, Multinational2011, BrazilDDOS2012, USFinancial2012, Iran2012, SARoadsAgency2014, JPMorgan2014, Tyupkin2014, Gautrain2014, Guatemala2015, Swedbank2015, BelgianBankFeb2016, CentralBank2016, MiraiBotnetM2016, StandardBank2016, NigerianBank2016, UnionBankIndia2016, HongKong2016, BitHumbHeist12017, YoubitHacked2017, BitHumbHeist22017, Tunisia2017, SouthKoreaMonero2017, Equifax2017, NiceHash2017, CoinsiCrypto2017, CostaRica2018, Coincheck2018, RapidRaids2018, Liberian2018, RapidRaidsMar2018, MalaysiaSWIFT2018, Dutch2018, RapidRaids2018, BitHumb32018, Bancomext2018, GambianFI2019, DragonEx2019, SpanishFI2019, NigerianFI2019, Fuze2019, MexicoGang2019, GozNym2019, SilenceGroup2019, RwandaBank2019, CapitalOne2019, Cardplanet2019, Kuwait2019, SilenceTargets42019, Upbit2019, DutchBangla2019, NKoreaWebSkimming2020, Rakyat2020, BeagleBoyz2020, ChileanBanco2020, FIN112020, AttemptedSASSA020, RwandaBankHeist20, SouthKoreaSupply2020, SolarWindsUS2020, SouthAfricanBankBreach2020, ItalianBanks2020, Shirbit2020, Accellion2020, RockeGroup2021, IndictNKCybercriminals2021, FIN8BadHatch2021, FIN72021, CNAFinancial2021, USCNA021, LazarusGroup2021, AXA2021, Bit2check2021, MorganStanleyAccellion2021, NigerianFraudster2021, FIN8US2021, TA5052021, TaiwaneseData2020, UkraineGovFebDDOS2022, RoninCrypto2022, LazarusTrojan2022',
    },
    {
        filter: 'speculated',
        trueFilter:
            'Estonia2007, SouthKorea2009, MorganStanley2010, Nasdaq2010, Lebanon2011, SouthKorea2011, Ababil2012, SouthKoreaMar2013, Carbanak2013, DexterSA2013, UkraineJuly2014, WarsawOct2014, Health2015, TienPhong2015, Greek2015, BangladeshBankFeb2016, RussianBanksDec2016, FarEastern2017, Youbit2017, SKCryptoHeist2017, Infraud2018, Swift2018, Mabna2018, DDOS2018, BancoChile2018, PIR2018, Cosmos2018, BancoPeruvian2018, Silence2018, Postbank2018, Threadkit2018, BrazilMalware2018, Click2Gov2018, Evercore2018, ChileATM2019, CryptoExchange2019, HimalayanATM2019, IndianATM2019, Sberbank2019, BriansClub2019, FancyBear2019, JohannesburgCity2019, Cayman2019, AfricaBanks2020, PerSwaysion2020, NigerianHackingGroup2020, Goldenspy2020, MrbMiner2020, DenmarkBank2020, GermanGootkit2020, MicrosoftExchangeServers2021, SADebt2021, PixStealer2021, OPFinancialGroup2022, TaiwaneseFinancialNov2021, MoscowStockExchange2022',
    },
    {
        filter: 'unknown',
        trueFilter:
            'Ameritrade2007, UAE2008, Skimer2009, NationalCity2010, GlobalPayments2011, Citigroup2011, Brazil2012, Shanghai2012, HighRoller2012, PostBank2012, Paygate2012, BankWest2013, CME2013, Ploutus2013, China2013, EuropeanCentralBank2014, Metel2015, Ecuador2015, Wolf2015, ShanghaiJun2015, PanamaPapers2016, IndianATM2016, Tesco2016, SEC2017, SAHosting2017, PesaLink2017, Paradise2017, Mexican2018, Canada2018, Blacksburg2018, Mauritius2018, HSBCUS2018, BitGrail2018, Magecart2018, DataPakistan2018, Islami2018, AXA2018, EEBanks2018, Zaif2018, Coinrail2018, SAInsurer2018, SAHostingPlatform2018, KenyaBank2018, ViewFines2018, Janeleiro2019, MetroBank2019, SBI2019, USCreditUnion2019, BankValletta2019, Ursnif2019, RBSSec2019, Retefe2019, FirstBank2019, SwitchSystem2019, Remixipoint2019, Jana2019, BancoPan2019, Binance2019, FirstAmerican2019, ECB2019, HongKong2019, Edenred2019, BitpointCrypto2019, TurkishCards2019, SabricDdos2019, IranCard2019, Wawa2019, Travelex2019, WebShellUse2020, UpbitCrypto2019, UKIsrael2019, Advantage2019, Loqbox2020, Paypal2020, AustraliaBanks2020, SEAsiaBanks2020, Finastra2020, SquareMilner2020, ChubbRansomware2020, MontePaschi2020, BankTrojan2020, TurkeyDogContinues2020, SouthKoreaUSCard2020, SpanishBanks2020, dForce2020, Diebold2020, Norfund2020, IndianMobileApp2020, BancoBCR2020, Coincheck2020, EuropeanDDOS2020, IcedID2020, DeepVoice2020, SpanishCrypto2020, Argenta2020, Nedbank2020, Twitter2020, Kattana2020, Emotet2020, Scotiabank2020, Dave2020, NetWalker2020, Pepperstone2020, CACodvid2020, SAExperian2020, NZStock2020, DeathStalker2020, CIH2020, RussianBanks2020, HungarianBanks2020, BetterSure2020, Vizom2020, LedgerWallet2020, JuspayData2020, UgandaMObile2020, IndonesianFintech2020, Ghimob2020, GoDaddyScam2020, ElectroRAT2020, Classiscam2020, MobileSpoofing2020, ScottishEPA2020, IndianChqbook2020, PayPalSMS2021, AmericanExpress2021, NZBankData2021, CubaRansomware2021, IRSPhishing2021, NYCovid2021, SequoiaCapital2021, PloutusVariant2021, WallStreetCapitalCall2021, FinraScam2021, TeaBot2021, TruistBankSpear2021, GooglePlayFraud2021, Swarmshop2021, Upstox2021, BizarroEU2021, CounterfeitApps2021, ChasePhishing2021, SmallBanksRansomware2021, UKInsurer2021, GermanBanksDDOS2021, IntuitTurbotax2021, Oscorp2021, PolyNetwork2021, BrazilianNT2021, JapanCrypto2021, TaiwaneseDeFi2021, NZOutages2021, BankingTrojanIndia2021, BrazilianInsurance2021, Pichincha2021, Flubot2021, Nixdorf2021, CreamFinance2021, PakistanBank2021, FBIRansomware2021, SharkBot2021, FBIATM2021, bZx2021, Robinhood2021, BadgerDAO2021, Bitmart2021, AscendEX2021, Monox2021, Zloader2021, InvestorBroker2012, OCBCPhishing2021, CryptoCom2022, Multichain2022, TeaBotFluBot2022, Qubit2022, OnlineRetailersTrojan2021, WormholeCryptocurrency2022, MedusaPhishing2022, IRAFinancialTrust2022, AonRansomware022, TransUnionSA2022, CashMama2022, FakecallsTrojan2022, BeanstalkFarms2022',
    },
    {
        filter: 'y2022',
        trueFilter:
            'OPFinancialGroup2022, CryptoCom2022, Multichain2022, TeaBotFluBot2022, Qubit2022, WormholeCryptocurrency2022, MedusaPhishing2022, IRAFinancialTrust2022, UkraineGovFebDDOS2022, MoscowStockExchange2022, AonRansomware022, RoninCrypto2022, TransUnionSA2022, LazarusTrojan2022, CashMama2022, FakecallsTrojan2022, BeanstalkFarms2022',
    },
    {
        filter: 'y2021',
        trueFilter:
            'RockeGroup2021, PayPalSMS2021, AmericanExpress2021, NZBankData2021, MicrosoftExchangeServers2021, CubaRansomware2021, IRSPhishing2021, NYCovid2021, IndictNKCybercriminals2021, SequoiaCapital2021, PloutusVariant2021, WallStreetCapitalCall2021, FinraScam2021, FIN8BadHatch2021, FBI4BilCybercrime2021, FTCPhishingMar2021, USCNA021, TeaBot2021, FIN72021, TruistBankSpear2021, CNAFinancial2021, GooglePlayFraud2021, Swarmshop2021, SADebt2021, Upstox2021, BizarroEU2021, LazarusGroup2021, CounterfeitApps2021, AXA2021, ChasePhishing2021, SmallBanksRansomware2021, UKInsurer2021, GermanBanksDDOS2021, IntuitTurbotax2021, Bit2check2021, MorganStanleyAccellion2021, FBIWarning72021, BackNine2021, Oscorp2021, PolyNetwork2021, BrazilianNT2021, NigerianFraudster2021, JapanCrypto2021, FIN8US2021, Kaspersky09021, NZOutages2021, BankingTrojanIndia2021, PixStealer2021, BrazilianInsurance2021, Pichincha2021, TA5052021, Flubot2021, Nixdorf2021, CreamFinance2021, PakistanBank2021, FBIRansomware2021, SharkBot2021, FBIATM2021, bZx2021, Robinhood2021, USRegs2021, BadgerDAO2021, BitmartBreach2021, AscendEX2021, Monox2021, Zloader2021, OCBCPhishing2021, OnlineRetailersTrojan2021, TaiwaneseFinancialNov2021',
    },
    {
        filter: 'y2020',
        trueFilter:
            'Scotiabank2020, Nedbank2020, Emotet2020, Kattana2020, Twitter2020, Argenta2020, SECRansomeware2020, SpanishCrypto2020, IcedID2020, Goldenspy2020, Coincheck2020, EuropeanDDOS2020, IndianMobileApp2020, BancoBCR2020, PerSwaysion2020, Diebold2020, Norfund2020, NKoreaWebSkimming2020, dForce2020, SouthKoreaUSCard2020, SpanishBanks2020, MontePaschi2020, BankTrojan2020, TurkeyDogContinues2020, SquareMilner2020, ChubbRansomware2020, Finastra2020, AfricaBanks2020, Loqbox2020, Paypal2020, AustraliaBanks2020, SEAsiaBanks2020, Dave2020, NetWalker2020, Pepperstone2020, CACodvid2020, FinanceRDoS2020, SAExperian2020, NZStock2020, DeathStalker2020, BeagleBoyz2020, CIH2020, ChileanBanco2020, RussianBanks2020, NigerianHackingGroup2020, HungarianBanks2020, JapaneseGlitch2020, BetterSure2020, FIN112020, Vizom2020, ECBGlitch2020, LedgerWallet2020, MrbMiner2020, AttemptedSASSA020, RwandaBankHeist20, JuspayData2020, UgandaMObile2020, IndonesianFintech2020, GermanGootkit2020, Ghimob2020, GoDaddyScam2020, AustralianStockExchange2020, SouthKoreaSupply2020, SolarWindsUS2020, ElectroRAT2020, Classiscam2020, SouthAfricanBankBreach2020, Shirbit2020, MobileSpoofing2020, FBIThirdParty2020, Accellion2020, ScottishEPA2020, IndianChqbook2020, DeepVoice2020, WebShellUse2020, Rakyat2020, ItalianBanks2020, TaiwaneseData2020',
    },
    {
        filter: 'y2019',
        trueFilter:
            'Advantage2019, UKIsrael2019, SilenceGroup2019, UpbitCrypto2019, DutchBangla2019, BitpointCrypto2019, SilenceTargets42019, Upbit2019, Kuwait2019, BitHumb42019, DragonEx2019, GambianFI2019, NigerianFI2019, SpanishFI2019, Fuze2019, ChileATM2019, MetroBank2019, SBI2019, USCreditUnion2019, BankValletta2019, Ursnif2019, RBSSec2019, MexicoGang2019, Retefe2019, FirstBank2019, GozNym2019, SwitchSystem2019, CryptoExchange2019, Remixipoint2019, Jana2019, BancoPan2019, CapitalOne2019, Binance2019, FirstAmerican2019, HimalayanATM2019, ECB2019, IndianATM2019, HongKong2019, Sberbank2019, BriansClub2019, FancyBear2019, RwandaBank2019, JohannesburgCity2019, Cardplanet2019, Cayman2019, Edenred2019, SabricDdos2019, TurkishCards2019, IranCard2019, Wawa2019, Travelex2019, Janeleiro2019',
    },
    {
        filter: 'y2018',
        trueFilter:
            'Postbank2018, BitHumb32018, Zaif2018, Liberian2018, Coinrail2018, SAInsurer2018, MalaysiaSWIFT2018, BitGrail2018, RapidRaidsMar2018, Coincheck2018, CostaRica2018, Bancomext2018, KenyaBank2018, ViewFines2018, Mauritius2018, Silence2018, BancoPeruvian2018, Cosmos2018, Blacksburg2018, PIR2018, Canada2018, BancoChile2018, Mexican2018, DDOS2018, Mabna2018, Swift2018, Infraud2018, Dutch2018, RapidRaids2018, HSBCUS2018, Magecart2018, DataPakistan2018, Islami2018, AXA2018, EEBanks2018, Threadkit2018, BrazilMalware2018, Click2Gov2018, Evercore2018, SAHostingPlatform2018',
    },
    {
        filter: 'y2017',
        trueFilter:
            'Youbit2017, BitHumbHeist22017, SouthKoreaMonero2017, YoubitHacked2017, Paradise2017, FarEastern2017, SEC2017, PesaLink2017, BitHumbHeist12017, CoinsiCrypto2017, Equifax2017, Tunisia2017, SKCryptoHeist2017, SAHosting2017, NiceHash2017',
    },
    {
        filter: 'y2016',
        trueFilter:
            'CostaRica2018, RussianBanksDec2016, HongKong2016, Tesco2016, IndianATM2016, MiraiBotnetM2016, CentralBank2016, StandardBank2016, NigerianBank2016, UnionBankIndia2016, PanamaPapers2016, BelgianBankFeb2016, BangladeshBankFeb2016',
    },
    {
        filter: 'y2015',
        trueFilter:
            'Greek2015, Guatemala2015, ShanghaiJun2015, TienPhong2015, Wolf2015, Health2015, Ecuador2015, Metel2015',
    },
    {
        filter: 'y2014',
        trueFilter:
            'SARoadsAgency2014, Tyupkin2014, Gautrain2014, WarsawOct2014, JPMorgan2014, EuropeanCentralBank2014, UkraineJuly2014',
    },
    {
        filter: 'y2013',
        trueFilter: 'China2013, DexterSA2013, Ploutus2013, CME2013, Carbanak2013, SouthKoreaMar2013, BankWest2013',
    },
    {
        filter: 'y2012',
        trueFilter:
            'Paygate2012, Ababil2012, HighRoller2012, Shanghai2012, Iran2012, USFinancial2012, BrazilDDOS2012, Brazil2012, PostBank2012',
    },
    {
        filter: 'y2011',
        trueFilter:
            'Citigroup2011, GlobalPayments2011, SouthKorea2011, Multinational2011, Iran2011, Lebanon2011, InvestorBroker2012',
    },
    {
        filter: 'y2010',
        trueFilter:
            'Absa2010, Cleveland2010, Nasdaq2010, PNC2010, Schwab2010, BankAmerica2010, NationalCity2010, MorganStanley2010, Latvia2010',
    },
    {
        filter: 'y2009',
        trueFilter: 'SouthKorea2009, VodacomFraud2009, Zeus2009, Skimer2009',
    },
    {
        filter: 'y2008',
        trueFilter: 'RBS2008, UAE2008, Georgia2008, HSBC2008, Citibank2008, SocieteGenerale2008',
    },
    {
        filter: 'y2007',
        trueFilter: 'Davidson2007, Ameritrade2007, Estonia2007',
    },
];

// actual array of data for each timeline entry
let my_data_original = [
    {
        name: 'BeanstalkFarms2022',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'yy2022',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FakecallsTrojan2022',
        location: 'SouthKorea, EastAsia',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'yy2022',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CashMama2022',
        location: 'India, SouthAsia',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'yy2022',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'LazarusTrojan2022',
        location: 'Multiple',
        incidentType: 'multiple',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'yy2022',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'TransUnionSA2022',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'yy2022',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'RoninCrypto2022',
        location: 'Canada, NorthAmerica',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'yy2022',
        mapID: [
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AonRansomware022',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'yy2022',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MoscowStockExchange2022',
        location: 'Russia, EasternEurope',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'yy2022',
        mapID: [
            {
                id: 'Ru',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'UkraineGovFebDDOS2022',
        location: 'Ukraine, EasternEurope',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'yy2022',
        mapID: [
            {
                id: 'UA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'UA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IRAFinancialTrust2022',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'yy2022',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MedusaPhishing2022',
        location: 'Multiple',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'yy2022',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'WormholeCryptocurrency2022',
        location: 'Switzerland, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'yy2022',
        mapID: [
            {
                id: 'CH',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CH',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Qubit2022',
        location: 'UK, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2022',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'TeaBotFluBot2022',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2022',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Multichain2022',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2022',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'CryptoCom2022',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2022',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'OPFinancialGroup2022',
        location: 'Finland, WesternEurope',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'speculated',
        year: 'y2022',
        mapID: [
            {
                id: 'FI',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'FI',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'OCBCPhishing2021',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Zloader2021',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Monox2021',
        location: 'Singapore, SoutheastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'SG',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'SG',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AscendEX2021',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Bitmart2021',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'BadgerDAO2021',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'TaiwaneseFinancialNov2021',
        location: 'Taiwan, EastAsia',
        incidentType: 'espionage',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2021',
        mapID: [
            {
                id: 'TW',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'TW',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'USRegs2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: '',
        actor: '',
        attribution: '',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Robinhood2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'bZx2021',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'FBIATM2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SharkBot2021',
        location: 'Italy, UK, WesternEurope',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'IT',
                settings: { fill: activeCountry },
            },
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FBIRansomware2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PakistanBank2021',
        location: 'Pakistan, SouthAsia',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'PK',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'PK',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CreamFinance2021',
        location: 'Poland, EasternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'PL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'PL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Nixdorf2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Flubot2021',
        location: 'Nigeria, Africa',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'NG',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NG',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'TA5052021',
        location: 'Russia, EasternEurope',
        incidentType: 'multiple',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Pichincha2021',
        location: 'Ecuador, SouthAmerica',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'EC',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'EC',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BrazilianInsurance2021',
        location: 'Brazil, SouthAmerica',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'OnlineRetailersTrojan2021',
        location: 'Multiple',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'PixStealer2021',
        location: 'Brazil, SouthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'speculated',
        year: 'y2021',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BankingTrojanIndia2021',
        location: 'India, SouthAsia',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NZOutages2021',
        location: 'NewZealand, Australia, Oceania',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'NZ',
                settings: { fill: activeCountry },
            },
            {
                id: 'AU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NZ',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'AU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Kaspersky09021',
        location: 'Multiple',
        incidentType: 'theft',
        actor: '',
        attribution: '',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'TaiwaneseDeFi2021',
        location: 'Taiwan, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'TW',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'TW',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FIN8US2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'JapanCrypto2021',
        location: 'Japan, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NigerianFraudster2021',
        location: 'Nigeria, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [
            {
                id: 'NG',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NG',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BrazilianNT2021',
        location: 'Brazil, SouthAmerica',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PolyNetwork2021',
        location: 'China, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Oscorp2021',
        location:
            'Spain, Poland, Germany, Turkey, UnitedStates, Japan, Italy, Australia, France, India, EasternEurope, SouthernEurope, WesternEurope, NorthAmerica, EastAsia, SouthAsia, Oceania',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'ES',
                settings: { fill: activeCountry },
            },
            {
                id: 'PL',
                settings: { fill: activeCountry },
            },
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
            {
                id: 'TR',
                settings: { fill: activeCountry },
            },
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
            {
                id: 'IT',
                settings: { fill: activeCountry },
            },
            {
                id: 'AU',
                settings: { fill: activeCountry },
            },
            {
                id: 'FR',
                settings: { fill: activeCountry },
            },
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ES',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'PL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'AU',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'FR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BackNine2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: '',
        attribution: '',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FBIWarning72021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: '',
        attribution: '',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MorganStanleyAccellion2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Bit2check2021',
        location: 'MiddleEast',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'IntuitTurbotax2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'GermanBanksDDOS2021',
        location: 'Germany, WesternEurope',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'UKInsurer2021',
        location: 'UK, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SmallBanksRansomware2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ChasePhishing2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AXA2021',
        location: 'SoutheastAsia',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'CounterfeitApps2021',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'LazarusGroup2021',
        location: 'UnitedStates, Israel, Japan, WasternEurope, NorthAmerica, MiddleEast, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'IL',
                settings: { fill: activeCountry },
            },
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BizarroEU2021',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Upstox2021',
        location: 'India, SouthAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SADebt2021',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2021',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'USCNA021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Swarmshop2021',
        location: '',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'FTCPhishingMar2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: '',
        attribution: '',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FBI4BilCybercrime2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: '',
        attribution: '',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'GooglePlayFraud2021',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'FIN8BadHatch2021',
        location:
            'UnitedStates, Canada, SouthAfrica, Panama, Italy, Africa, CentralAmerica, WesternEurope, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confident',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'IT',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IT',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FinraScam2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'WallStreetCapitalCall2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PloutusVariant2021',
        location: 'SouthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'CNAFinancial2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SequoiaCapital2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IndictNKCybercriminals2021',
        location: '',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'NYCovid2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IRSPhishing2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CubaRansomware2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MicrosoftExchangeServers2021',
        location: '',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'TruistBankSpear2021',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FIN72021',
        location: '',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'NZBankData2021',
        location: 'NewZealand, Oceania',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'NZ',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NZ',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AmericanExpress2021',
        location: 'Mexico, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'RockeGroup2021',
        location: '',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'PayPalSMS2021',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'TeaBot2021',
        location: 'WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2021',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'IndianChqbook2020',
        location: 'India, SouthAsia',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ScottishEPA2020',
        location: 'UnitedKingdom, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Accellion2020',
        location: 'Australia, NewZealand, UnitedStates, Oceania, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'AU',
                settings: { fill: activeCountry },
            },
            {
                id: 'NZ',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'AU',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'NZ',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FBIThirdParty2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: '',
        attribution: '',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MobileSpoofing2020',
        location: 'NorthAmerica, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Shirbit2020',
        location: 'Israel, MiddleEast',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'IL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SouthAfricanBankBreach2020',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Classiscam2020',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'ElectroRAT2020',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'DenmarkBank2020',
        location: 'Denmark, WesternEurope',
        incidentType: 'dataBreach',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2020',
        mapID: [
            {
                id: 'DK',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'DK',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SolarWindsUS2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'espionage',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SouthKoreaSupply2020',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AustralianStockExchange2020',
        location: 'Australia, Oceania',
        incidentType: 'disruption',
        actor: '',
        attribution: '',
        year: 'y2020',
        mapID: [
            {
                id: 'AU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'GoDaddyScam2020',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Ghimob2020',
        location: 'Brazil, SouthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'GermanGootkit2020',
        location: 'Germany, WesternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2020',
        mapID: [
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IndonesianFintech2020',
        location: 'Indonesia, SoutheastAsia',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'ID',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ID',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ECBGlitch2020',
        location: 'Germany, WesternEurope',
        incidentType: 'disruption',
        actor: '',
        attribution: '',
        year: 'y2020',
        mapID: [
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Vizom2020',
        location: 'Brazil, SouthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FIN112020',
        location: '',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'BetterSure2020',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'UgandaMObile2020',
        location: 'Uganda, Africa',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'UG',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'UG',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'JapaneseGlitch2020',
        location: 'Japan, EastAsia',
        incidentType: 'disruption',
        actor: '',
        attribution: '',
        year: 'y2020',
        mapID: [
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'HungarianBanks2020',
        location: 'Hungary, EasternEurope',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'HU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'HU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'RussianBanks2020',
        location: 'Russia, EasternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ChileanBanco2020',
        location: 'Chile, SouthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'CL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CIH2020',
        location: 'Morocco, Africa',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'MA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BeagleBoyz2020',
        location:
            'Argentina, Brazil, Bangladesh, Bosnia and Herzegovina, Bulgaria, Chile, Costa Rica, Ecuador, Ghana, India, Indonesia, Japan, Jordan, Kenya, Kuwait, Malaysia, Malta, Mexico, Mozambique, Nepal, Nicaragua, Nigeria, Pakistan, Panama, Peru, Philippines, Singapore, South Africa, South Korea, Spain, Taiwan, Tanzania, Togo, Turkey, Uganda, Uruguay, Vietnam, Zambia, CentralAmerica, SouthAmerica, Africa, EastAsia, SoutheastAsia, SouthAsia, MiddleEast, WesternEurope, EasternEurope',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'AR',
                settings: { fill: activeCountry },
            },
            {
                id: 'BD',
                settings: { fill: activeCountry },
            },
            {
                id: 'BA',
                settings: { fill: activeCountry },
            },
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
            {
                id: 'BG',
                settings: { fill: activeCountry },
            },
            {
                id: 'CL',
                settings: { fill: activeCountry },
            },
            {
                id: 'CR',
                settings: { fill: activeCountry },
            },
            {
                id: 'EC',
                settings: { fill: activeCountry },
            },
            {
                id: 'GH',
                settings: { fill: activeCountry },
            },
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
            {
                id: 'ID',
                settings: { fill: activeCountry },
            },
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
            {
                id: 'JO',
                settings: { fill: activeCountry },
            },
            {
                id: 'KE',
                settings: { fill: activeCountry },
            },
            {
                id: 'KW',
                settings: { fill: activeCountry },
            },
            {
                id: 'MY',
                settings: { fill: activeCountry },
            },
            {
                id: 'MT',
                settings: { fill: activeCountry },
            },
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
            {
                id: 'MZ',
                settings: { fill: activeCountry },
            },
            {
                id: 'NP',
                settings: { fill: activeCountry },
            },
            {
                id: 'NI',
                settings: { fill: activeCountry },
            },
            {
                id: 'PK',
                settings: { fill: activeCountry },
            },
            {
                id: 'PA',
                settings: { fill: activeCountry },
            },
            {
                id: 'PE',
                settings: { fill: activeCountry },
            },
            {
                id: 'PH',
                settings: { fill: activeCountry },
            },
            {
                id: 'SG',
                settings: { fill: activeCountry },
            },
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
            {
                id: 'ES',
                settings: { fill: activeCountry },
            },
            {
                id: 'TW',
                settings: { fill: activeCountry },
            },
            {
                id: 'TZ',
                settings: { fill: activeCountry },
            },
            {
                id: 'TG',
                settings: { fill: activeCountry },
            },
            {
                id: 'TR',
                settings: { fill: activeCountry },
            },
            {
                id: 'UG',
                settings: { fill: activeCountry },
            },
            {
                id: 'UY',
                settings: { fill: activeCountry },
            },
            {
                id: 'VN',
                settings: { fill: activeCountry },
            },
            {
                id: 'ZM',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BD',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BG',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'EC',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GH',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ID',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'JO',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'KE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'KW',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MY',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MZ',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'NP',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'NI',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'PK',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'PA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'PE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'PH',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'SG',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ES',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TW',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TZ',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TG',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'UG',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'UY',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'VN',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ZM',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'DeathStalker2020',
        location:
            'Argentina, China, Cyprus, India, Israel, Lebanon, Switzerland, Russia, Taiwan, Turkey, UK, UAE, SouthAmerica, EastAsia, SouthAsia, MiddleEast, WesternEurope, EasternEurope',
        incidentType: 'multiple',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'AR',
                settings: { fill: activeCountry },
            },
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
            {
                id: 'CY',
                settings: { fill: activeCountry },
            },
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
            {
                id: 'IL',
                settings: { fill: activeCountry },
            },
            {
                id: 'LB',
                settings: { fill: activeCountry },
            },
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
            {
                id: 'CH',
                settings: { fill: activeCountry },
            },
            {
                id: 'TW',
                settings: { fill: activeCountry },
            },
            {
                id: 'TR',
                settings: { fill: activeCountry },
            },
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
            {
                id: 'AE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CY',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'LB',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CH',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TW',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'AE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NZStock2020',
        location: 'NewZealand, Oceania',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'NZ',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NZ',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SAExperian2020',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'JuspayData2020',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'FinanceRDoS2020',
        location: 'NorthAmerica, WesternEurope, SoutheastAsia, Oceania',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'CACodvid2020',
        location: 'Canada, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Pepperstone2020',
        location: 'Australia, Oceania',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'AU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NetWalker2020',
        location: '',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'TaiwaneseData2020',
        location: 'Taiwan, EastAsia',
        incidentType: 'espionage',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'TW',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'TW',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Dave2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'RwandaBankHeist20',
        location: 'Rwanda, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'RW',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RW',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AttemptedSASSA020',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Scotiabank2020',
        location: 'Canada, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Emotet2020',
        location: 'a',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Kattana2020',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Twitter2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Argenta2020',
        location: 'Belgium, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'BE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SpanishCrypto2020',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'SECRansomeware2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: '',
        attribution: '',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MrbMiner2020',
        location: 'Iran, MiddleEast',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2020',
        mapID: [
            {
                id: 'IR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'LedgerWallet2020',
        location: '',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'uknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Goldenspy2020',
        location: 'China, EastAsia',
        incidentType: '',
        actor: 'speculated',
        attribution: 'speculated',
        year: 'y2020',
        mapID: [
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IcedID2020',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'EuropeanDDOS2020',
        location: 'WesternEurope',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Coincheck2020',
        location: 'Japan, EastAsia',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BancoBCR2020',
        location: 'CostaRica, CentralAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'CR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NigerianHackingGroup2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'specualted',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IndianMobileApp2020',
        location: 'India, SouthAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Norfund2020',
        location: 'Norway, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'NO',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NO',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PerSwaysion2020',
        location: '',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Diebold2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NKoreaWebSkimming2020',
        location: 'Serbia, Montenegro, Croatia, Slovenia, BosniaHerzegovina, EasternEurope',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'RS',
                settings: { fill: activeCountry },
            },
            {
                id: 'ME',
                settings: { fill: activeCountry },
            },
            {
                id: 'HR',
                settings: { fill: activeCountry },
            },
            {
                id: 'SL',
                settings: { fill: activeCountry },
            },
            {
                id: 'BA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RS',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ME',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'HR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'SL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'dForce2020',
        location: 'China, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SpanishBanks2020',
        location: 'Spain, WesternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'ES',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ES',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SouthKoreaUSCard2020',
        location: 'UnitedStates, NorthAmerica, SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'TurkeyDogContinues2020',
        location: 'Turkey, MiddleEast',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'TR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'TR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BankTrojan2020',
        location: 'UnitedStates, NorthAmerica, Canada, Australia, Oceania',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
            {
                id: 'AU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'AU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MontePaschi2020',
        location: 'Italy, WesternEurope',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'IT',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IT',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ChubbRansomware2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SquareMilner2020',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Finastra2020',
        location: 'UK, WesternEurope',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'UK',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'UK',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SEAsiaBanks2020',
        location: 'SoutheastAsia, Malaysia, Singapore, Philippines, Vietnam, Indonesia, Thailand',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'VN',
                settings: { fill: activeCountry },
            },
            {
                id: 'MY',
                settings: { fill: activeCountry },
            },
            {
                id: 'SG',
                settings: { fill: activeCountry },
            },
            {
                id: 'PH',
                settings: { fill: activeCountry },
            },
            {
                id: 'ID',
                settings: { fill: activeCountry },
            },
            {
                id: 'TH',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'VN',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MY',
                settings: { fill: activeCountry },
            },
            {
                id: 'SG',
                settings: { fill: activeCountry },
            },
            {
                id: 'PH',
                settings: { fill: activeCountry },
            },
            {
                id: 'ID',
                settings: { fill: activeCountry },
            },
            {
                id: 'TH',
                settings: { fill: activeCountry },
            },
        ],
    },
    {
        name: 'ItalianBanks2020',
        location: 'Italy, WesternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'IT',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IT',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AustraliaBanks2020',
        location: 'Australia, Oceania',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'AU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Paypal2020',
        location: 'UnitedStates, NorthAmerica, Germany, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Loqbox2020',
        location: 'UnitedKingdom, WesternEurope',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Rakyat2020',
        location: 'Indonesia, SoutheastAsia',
        incidentType: 'Multiple',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2020',
        mapID: [
            {
                id: 'ID',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ID',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Nedbank2020',
        location: 'Africa, SouthAfrica, Angola, Kenya, Lesotho, Malawi, Mozambique, Namibia, Swaziland, Zimbabwe',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'AO',
                settings: { fill: activeCountry },
            },
            {
                id: 'KE',
                settings: { fill: activeCountry },
            },
            {
                id: 'LS',
                settings: { fill: activeCountry },
            },
            {
                id: 'MW',
                settings: { fill: activeCountry },
            },
            {
                id: 'MZ',
                settings: { fill: activeCountry },
            },
            {
                id: 'NA',
                settings: { fill: activeCountry },
            },
            {
                id: 'SZ',
                settings: { fill: activeCountry },
            },
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
            {
                id: 'ZW',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AO',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'KE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'LS',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MW',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MZ',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'NA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'SZ',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ZW',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'DeepVoice2020',
        location: 'UnitedArabEmirates, MiddleEast',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [
            {
                id: 'AE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AfricaBanks2020',
        location: 'Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'WebShellUse2020',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2020',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Travelex2019',
        location: 'UnitedKingdom, WesternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Advantage2019',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IUSR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Wawa2019',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IranCard2019',
        location: 'Iran, MiddleEast',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'IR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'UKIsrael2019',
        location: 'UK, WesternEurope, Israel, MiddleEast',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'UK',
                settings: { fill: activeCountry },
            },
            {
                id: 'IL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'UK',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'UpbitCrypto2019',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Edenred2019',
        location: 'WesternEurope',
        incidentType: '',
        actor: '',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Cayman2019',
        location: 'UK, WesternEurope',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2019',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'TurkishCards2019',
        location: 'Turkey, MiddleEast',
        incidentType: '',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'TR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'TR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Cardplanet2019',
        location: '',
        incidentType: '',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'RwandaBank2019',
        location: 'SouthAfrica, Rwanda',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'RW',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RW',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'JohannesburgCity2019',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2019',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SabricDdos2019',
        location: 'SouthAfrica, Africa',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FancyBear2019',
        location: 'Singapore, SouthAfrica, SouthAsia, Africa, WesternEurope, Norway',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2019',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
            {
                id: 'SG',
                settings: { fill: activeCountry },
            },
            {
                id: 'NO',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'SG',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'NO',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BriansClub2019',
        location: '',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2019',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Sberbank2019',
        location: 'Russia, EasternEurope',
        incidentType: 'dataBreach',
        actor: '',
        attribution: 'speculated',
        year: 'y2019',
        mapID: [
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IndianATM2019',
        location: 'India, SouthAsia',
        incidentType: 'espionage',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2019',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ECB2019',
        location: 'WesternEurope, Germany',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'HongKong2019',
        location: 'EastAsia, China',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'HimalayanATM2019',
        location: 'Nepal, SouthAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2019',
        mapID: [
            {
                id: 'NP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FirstAmerican2019',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SilenceGroup2019',
        location: 'Bulgaria, Chile, CostaRica, Ghana, EasternEurope, SouthAmerica, CentralAmerica, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'BG',
                settings: { fill: activeCountry },
            },
            {
                id: 'CL',
                settings: { fill: activeCountry },
            },
            {
                id: 'CR',
                settings: { fill: activeCountry },
            },
            {
                id: 'GH',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BG',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GH',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Binance2019',
        location: 'Malta, WesternEurope',
        incidentType: '',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'CapitalOne2019',
        location: 'UnitedStates, Canada, NorthAmerica',
        incidentType: 'dataBreach, theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BancoPan2019',
        location: 'Brazil, SouthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Jana2019',
        location: 'India, SouthAsia',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Remixipoint2019',
        location: 'Japan, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BitpointCrypto2019',
        location: 'Japan, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CryptoExchange2019',
        location: 'Netherlands, UK, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'SwitchSystem2019',
        location: 'Bangladesh, SouthAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'BD',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BD',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'DutchBangla2019',
        location: 'Bangladesh, India, SriLanka, Kyrgyzstan, SoutheastAsia, SouthAsia',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'BD',
                settings: { fill: activeCountry },
            },
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
            {
                id: 'LK',
                settings: { fill: activeCountry },
            },
            {
                id: 'KG',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BD',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'LK',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'KG',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Upbit2019',
        location: 'South Korea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'GozNym2019',
        location:
            'Multiple, UnitedStates, NorthAmerica, Bulgaria, Germany, Georgia, Ukraine, Moldova, WesternEurope, EasternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'BG',
                settings: { fill: activeCountry },
            },
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
            {
                id: 'GE',
                settings: { fill: activeCountry },
            },
            {
                id: 'UA',
                settings: { fill: activeCountry },
            },
            {
                id: 'MD',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BG',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'UA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MD',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FirstBank2019',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Retefe2019',
        location: 'Germany, Switzerland, WesternEurope',
        incidentType: '',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
            {
                id: 'CH',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CH',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SilenceTargets42019',
        location: 'UK, India, SouthKorea, EastAsia, SouthAsia, WesternEurope',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
            {
                id: 'UK',
                settings: { fill: activeCountry },
            },
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'UK',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MexicoGang2019',
        location: 'Mexico, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BitHumb42019',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Kuwait2019',
        location: 'Kuwait, MiddleEast',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'KW',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KW',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'DragonEx2019',
        location: 'Singapore, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'SG',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'SG',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'RBSSec2019',
        location: 'UK, WesternEurope',
        incidentType: 'unknown',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Ursnif2019',
        location: 'Japan, EastAsia',
        incidentType: 'unknown',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'GambianFI2019',
        location: 'Gambia, Africa',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'GM',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GM',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NigerianFI2019',
        location: 'Nigeria, Africa',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'NG',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NG',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BankValletta2019',
        location: 'WesternEurope, Malta',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'MT',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MT',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'USCreditUnion2019',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'unknown',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SBI2019',
        location: 'India, SouthAsia',
        incidentType: 'unknown',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MetroBank2019',
        location: 'UK, WesternEurope',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SpanishFI2019',
        location: 'Spain, WesternEurope',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'ES',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ES',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ChileATM2019',
        location: 'Chile, SouthAmerica',
        incidentType: 'espionage',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2019',
        mapID: [
            {
                id: 'CL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Fuze2019',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2019',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Janeleiro2019',
        location: 'Brazil, SouthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2019',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Evercore2018',
        location: 'WesternEurope, UnitedStates, UnitedKingdom, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Click2Gov2018',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BrazilMalware2018',
        location: 'Brazil, SouthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Threadkit2018',
        location: '',
        incidentType: 'espionage',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'EEBanks2018',
        location:
            'EasternEurope, Ukraine, Poland, Romania, CzechRepublic, Hungary, Belarus, Bulgaria, Slovakia, Moldova',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'UA',
                settings: { fill: activeCountry },
            },
            {
                id: 'PL',
                settings: { fill: activeCountry },
            },
            {
                id: 'RO',
                settings: { fill: activeCountry },
            },
            {
                id: 'CZ',
                settings: { fill: activeCountry },
            },
            {
                id: 'HU',
                settings: { fill: activeCountry },
            },
            {
                id: 'BY',
                settings: { fill: activeCountry },
            },
            {
                id: 'BG',
                settings: { fill: activeCountry },
            },
            {
                id: 'SK',
                settings: { fill: activeCountry },
            },
            {
                id: 'MD',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'UA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'PL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'RO',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CZ',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'HU',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BY',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BG',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'SK',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MD',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'RapidRaids2018',
        location: 'UnitedStates',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Postbank2018',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'insider',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'HSBCUS2018',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Magecart2018',
        location: 'UnitedKingdom, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'DataPakistan2018',
        location: 'Pakistan, SouthAsia',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'PK',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'PK',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Islami2018',
        location: 'Other, Pakistan, SouthAsia',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'PK',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'PK',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'AXA2018',
        location: 'Mexico, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SAHostingPlatform2018',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Mauritius2018',
        location: 'Mauritius, Africa',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'MU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Zaif2018',
        location: 'Japan, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Silence2018',
        location: 'Russia, EasternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BancoPeruvian2018',
        location: 'Peru, Thailand, Malaysia, Indonesia, UnitedStates, NorthAmerica, SouthAmerica, SoutheastAsia',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'PE',
                settings: { fill: activeCountry },
            },
            {
                id: 'TH',
                settings: { fill: activeCountry },
            },
            {
                id: 'MY',
                settings: { fill: activeCountry },
            },
            {
                id: 'ID',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'PE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TH',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MY',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ID',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Cosmos2018',
        location: 'India, SouthAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Blacksburg2018',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PIR2018',
        location: 'Russia, EasternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BitHumb32018',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SAInsurer2018',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Coinrail2018',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Liberian2018',
        location: 'Liberia, Africa',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'LR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'LR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Canada2018',
        location: 'Canada, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BancoChile2018',
        location: 'Chile, SouthAmerica',
        incidentType: 'disruption, theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'CL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ViewFines2018',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Mexican2018',
        location: 'Mexico, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'DDOS2018',
        location: '',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'MalaysiaSWIFT2018',
        location: 'Malaysia, SoutheastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'MY',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MY',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'RapidRaidsMar2018',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Mabna2018',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Swift2018',
        location: 'India, SouthAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BitGrail2018',
        location: 'Italy, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'IT',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IT',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Infraud2018',
        location: 'Multiple, Netherlands, WesternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2018',
        mapID: [
            {
                id: 'NL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Dutch2018',
        location: 'Netherlands, WesternEurope',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'NL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Coincheck2018',
        location: 'Japan, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'KenyaBank2018',
        location: 'Kenya, Africa',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2018',
        mapID: [
            {
                id: 'KE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Bancomext2018',
        location: 'Mexico, NorthAmerica',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CostaRica2018',
        location: 'CostaRica, CentralAmerica',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2018',
        mapID: [
            {
                id: 'CR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NiceHash2017',
        location: 'Slovenia, EasternEurope',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2017',
        mapID: [
            {
                id: 'SI',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'SI',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Youbit2017',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2017',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Paradise2017',
        location: 'Multiple',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2017',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'SAHosting2017',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2017',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SKCryptoHeist2017',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2017',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'FarEastern2017',
        location: 'Taiwan, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2017',
        mapID: [
            {
                id: 'TW',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'TW',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Tunisia2017',
        location: 'Tunisia, Africa',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2017',
        mapID: [
            {
                id: 'TN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'TN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CoinsiCrypto2017',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2017',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SEC2017',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2017',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Equifax2017',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2017',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PesaLink2017',
        location: 'Kenya, Africa',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2017',
        mapID: [
            {
                id: 'KE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SouthKoreaMonero2017',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2017',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BitHumbHeist22017',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2017',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'YoubitHacked2017',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2017',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BitHumbHeist12017',
        location: 'SouthKorea, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2017',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'RussianBanksDec2016',
        location: 'Russia,EasternEurope',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2016',
        mapID: [
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'HongKong2016',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2016',
        mapID: 'US',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Tesco2016',
        location: 'UK, WesternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2016',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MiraiBotnetM2016',
        location: 'Liberia, Africa',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2016',
        mapID: [
            {
                id: 'LR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'LR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'IndianATM2016',
        location: 'India, SouthAsia',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2016',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'UnionBankIndia2016',
        location: 'India, SouthAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2016',
        mapID: [
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NigerianBank2016',
        location: 'Nigeria, Africa',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2016',
        mapID: [
            {
                id: 'NG',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'NG',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'StandardBank2016',
        location: 'SouthAfrica, Japan, Africa, EastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2016',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CentralBank2016',
        location:
            'Multiple, Panama, Greece, Mexico, Kenya, BosniaHerzegovina, CentralAmerica, Africa, EasternEurope, NorthAmerica',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2016',
        mapID: [
            {
                id: 'PA',
                settings: { fill: activeCountry },
            },
            {
                id: 'GR',
                settings: { fill: activeCountry },
            },
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
            {
                id: 'KE',
                settings: { fill: activeCountry },
            },
            {
                id: 'BA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'PA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'KE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PanamaPapers2016',
        location: 'Panama, CentralAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2016',
        mapID: [
            {
                id: 'PA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'PA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BelgianBankFeb2016',
        location: 'Belgium, WesternEurope',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2016',
        mapID: [
            {
                id: 'BE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BangladeshBankFeb2016',
        location: 'Bangladesh, SouthAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2016',
        mapID: [
            {
                id: 'BD',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BD',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Guatemala2015',
        location: 'Guatemala, CentralAmerica',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2015',
        mapID: [
            {
                id: 'GT',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GT',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Greek2015',
        location: 'Greece, EasternEurope',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2015',
        mapID: [
            {
                id: 'GR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Swedbank2015',
        location: 'Denmark, Sweden, WesternEurope',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2015',
        mapID: [
            {
                id: 'DK',
                settings: { fill: activeCountry },
            },
            {
                id: 'SE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'DK',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'SE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'ShanghaiJun2015',
        location: 'China, EastAsia',
        incidentType: 'disruption, dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2015',
        mapID: [
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'TienPhong2015',
        location: 'Vietnam, SoutheastAsia',
        incidentType: 'theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2015',
        mapID: [
            {
                id: 'VN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'VN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Wolf2015',
        location: 'Multiple, UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2015',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Health2015',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2015',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Ecuador2015',
        location: 'Ecuador, SouthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2015',
        mapID: [
            {
                id: 'EC',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'EC',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Metel2015',
        location: 'Russia, EasternEurope',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2015',
        mapID: [
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Gautrain2014',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2014',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Tyupkin2014',
        location:
            'EasternEurope, WesternEurope, MiddleEast, NorthAmerica, SouthAsia, SoutheastAsia, Russia, UnitedStates, Israel, India, China, France, Malaysia',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2014',
        mapID: [
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'IL',
                settings: { fill: activeCountry },
            },
            {
                id: 'IN',
                settings: { fill: activeCountry },
            },
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
            {
                id: 'FR',
                settings: { fill: activeCountry },
            },
            {
                id: 'MY',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IN',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'FR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MY',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'WarsawOct2014',
        location: 'Poland, EasternEurope',
        incidentType: 'dataBreach',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2014',
        mapID: [
            {
                id: 'PL',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'PL',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'JPMorgan2014',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2014',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'EuropeanCentralBank2014',
        location:
            'WesternEurope, EasternEurope, Austria, Belgium, Cyprus, Estonia, Finland, France, Germany, Greece, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Portugal, Slovakia, Slovenia, Spain',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2014',
        mapID: [
            {
                id: 'AT',
                settings: { fill: activeCountry },
            },
            {
                id: 'BE',
                settings: { fill: activeCountry },
            },
            {
                id: 'CY',
                settings: { fill: activeCountry },
            },
            {
                id: 'EE',
                settings: { fill: activeCountry },
            },
            {
                id: 'FI',
                settings: { fill: activeCountry },
            },
            {
                id: 'FR',
                settings: { fill: activeCountry },
            },
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
            {
                id: 'GR',
                settings: { fill: activeCountry },
            },
            {
                id: 'IE',
                settings: { fill: activeCountry },
            },
            {
                id: 'IT',
                settings: { fill: activeCountry },
            },
            {
                id: 'LV',
                settings: { fill: activeCountry },
            },
            {
                id: 'LT',
                settings: { fill: activeCountry },
            },
            {
                id: 'LU',
                settings: { fill: activeCountry },
            },
            {
                id: 'MT',
                settings: { fill: activeCountry },
            },
            {
                id: 'NL',
                settings: { fill: activeCountry },
            },
            {
                id: 'PT',
                settings: { fill: activeCountry },
            },
            {
                id: 'SK',
                settings: { fill: activeCountry },
            },
            {
                id: 'SI',
                settings: { fill: activeCountry },
            },
            {
                id: 'ES',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CY',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'EE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'FI',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'FR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'LV',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'LT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'LU',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'NL',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'PT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'SK',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'SI',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ES',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'UkraineJuly2014',
        location: 'Ukraine, EasternEurope',
        incidentType: 'dataBreach',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2014',
        mapID: [
            {
                id: 'UA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'UA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SARoadsAgency2014',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2013',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'China2013',
        location: 'China, EastAsia',
        incidentType: 'disruption',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2013',
        mapID: [
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'DexterSA2013',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2013',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Ploutus2013',
        location: 'Multiple, Mexico, UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2013',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'CME2013',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2013',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Carbanak2013',
        location: 'Oceania, NorthAmerica, UnitedStates, Russia, Taiwan, Australia, EastAsia, EasternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'speculated',
        year: 'y2013',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'RU',
                settings: { fill: activeCountry },
            },
            {
                id: 'TW',
                settings: { fill: activeCountry },
            },
            {
                id: 'AU',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'RU',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TW',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'AU',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SouthKoreaMar2013',
        location: 'SouthKorea, EastAsia',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2013',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BankWest2013',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2013',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Ababil2012',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2012',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Paygate2012',
        location: 'SouthAfrica, Africa',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2012',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'HighRoller2012',
        location: 'UnitedStates, Columbia, WesternEurope, NorthAmerica, SouthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2012',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'CO',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CO',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Shanghai2012',
        location: 'China, EastAsia',
        incidentType: '',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2012',
        mapID: [
            {
                id: 'CN',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'CN',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Iran2012',
        location: 'Iran, MiddleEast',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2012',
        mapID: [
            {
                id: 'IR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'IR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'USFinancial2012',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2012',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BrazilDDOS2012',
        location: 'Brazil, SouthAmerica',
        incidentType: 'disruption',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2012',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Brazil2012',
        location: 'Brazil, SouthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2012',
        mapID: [
            {
                id: 'BR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'BR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PostBank2012',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2012',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'InvestorBroker2012',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2011',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Citigroup2011',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2011',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'GlobalPayments2011',
        location: 'UnitedStates, Mexico, Canada, NorthAmerica',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2011',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SouthKorea2011',
        location: 'SouthKorea, EastAsia',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2011',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Multinational2011',
        location:
            'Multiple, UnitedStates, UnitedArabEmirates, Japan, Canada, Germany, Romania, Oman, Romania, DominicanRepublic, Mexico, Italy, Spain, Belgium, France, UnitedKingdom, Latvia, Estonia, Thailand, Malaysia, NorthAmerica, MiddleEast, EastAsia, WesternEurope, EasternEurope, SoutheastAsia',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2011',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
            {
                id: 'AE',
                settings: { fill: activeCountry },
            },
            {
                id: 'OM',
                settings: { fill: activeCountry },
            },
            {
                id: 'JP',
                settings: { fill: activeCountry },
            },
            {
                id: 'CA',
                settings: { fill: activeCountry },
            },
            {
                id: 'DE',
                settings: { fill: activeCountry },
            },
            {
                id: 'RO',
                settings: { fill: activeCountry },
            },
            {
                id: 'DO',
                settings: { fill: activeCountry },
            },
            {
                id: 'MX',
                settings: { fill: activeCountry },
            },
            {
                id: 'IT',
                settings: { fill: activeCountry },
            },
            {
                id: 'ES',
                settings: { fill: activeCountry },
            },
            {
                id: 'BE',
                settings: { fill: activeCountry },
            },
            {
                id: 'FR',
                settings: { fill: activeCountry },
            },
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
            {
                id: 'LV',
                settings: { fill: activeCountry },
            },
            {
                id: 'EE',
                settings: { fill: activeCountry },
            },
            {
                id: 'TH',
                settings: { fill: activeCountry },
            },
            {
                id: 'MY',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'AE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'OM',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'JP',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'CA',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'DE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'RO',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'DO',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MX',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'IT',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'ES',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'BE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'FR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'LV',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'EE',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'TH',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'MY',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Iran2011',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2011',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Lebanon2011',
        location: 'Lebanon, MiddleEast',
        incidentType: 'espionage',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2011',
        mapID: [
            {
                id: 'LB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'LB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Absa2010',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'insider',
        attribution: 'confirmed',
        year: 'y2010',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Cleveland2010',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2010',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Nasdaq2010',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach, disruption',
        actor: 'multiple',
        attribution: 'speculated',
        year: 'y2010',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'PNC2010',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2010',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Schwab2010',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2010',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'BankAmerica2010',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2010',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'NationalCity2010',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2010',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'MorganStanley2010',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach, theft',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2010',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Latvia2010',
        location: 'Latvia, EasternEurope',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2010',
        mapID: [
            {
                id: 'LV',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'LV',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SouthKorea2009',
        location: 'UnitedStates, SouthKorea, NorthAmerica, EastAsia',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2009',
        mapID: [
            {
                id: 'KR',
                settings: { fill: activeCountry },
            },
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'KR',
                settings: { fill: inactiveCountry },
            },
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'VodacomFraud2009',
        location: 'SouthAfrica, Africa',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2009',
        mapID: [
            {
                id: 'ZA',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'ZA',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Zeus2009',
        location: '',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2009',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'Skimer2009',
        location: '',
        incidentType: 'theft',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2009',
        mapID: [],
        inactiveMapID: [],
    },
    {
        name: 'RBS2008',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2008',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'UAE2008',
        location: 'UnitedArabEmirates, MiddleEast',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2008',
        mapID: [
            {
                id: 'AE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'AE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Georgia2008',
        location: 'Georgia, EasternEurope',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'confirmed',
        year: 'y2008',
        mapID: [
            {
                id: 'GE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'HSBC2008',
        location: 'UK, WesternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2008',
        mapID: [
            {
                id: 'GB',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'GB',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Citibank2008',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2008',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'SocieteGenerale2008',
        location: 'France, WesternEurope',
        incidentType: 'theft',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2008',
        mapID: [
            {
                id: 'FR',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'FR',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Davidson2007',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'nonstate',
        attribution: 'confirmed',
        year: 'y2007',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Ameritrade2007',
        location: 'UnitedStates, NorthAmerica',
        incidentType: 'dataBreach',
        actor: 'actorUnknown',
        attribution: 'unknown',
        year: 'y2007',
        mapID: [
            {
                id: 'US',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'US',
                settings: { fill: inactiveCountry },
            },
        ],
    },
    {
        name: 'Estonia2007',
        location: 'Estonia, EasternEurope',
        incidentType: 'disruption',
        actor: 'stateSponsored',
        attribution: 'speculated',
        year: 'y2007',
        mapID: [
            {
                id: 'EE',
                settings: { fill: activeCountry },
            },
        ],
        inactiveMapID: [
            {
                id: 'EE',
                settings: { fill: inactiveCountry },
            },
        ],
    },
];

// making proper names from IDs
function renameIDs(contentPanelId) {
    let html = document.querySelector('#filters-display').innerHTML;
    switch (contentPanelId) {
        case 'SouthKorea':
            html += '<li>South Korea</li>';
            break;
        case 'UnitedStates':
            html += '<li>United States</li>';
            break;
        case 'UnitedArabEmirates':
            html += '<li>United Arab Emirates</li>';
            break;
        case 'CentralAmerica':
            html += '<li>Central America</li>';
            break;
        case 'EastAsia':
            html += '<li>East Asia</li>';
            break;
        case 'EasternEurope':
            html += '<li>Eastern Europe</li>';
            break;
        case 'SouthAmerica':
            html += '<li>South America</li>';
            break;
        case 'MiddleEast':
            html += '<li>Middle East</li>';
            break;
        case 'NorthAmerica':
            html += '<li>North America</li>';
            break;
        case 'SoutheastAsia':
            html += '<li>Southeast Asia</li>';
            break;
        case 'SouthAsia':
            html += '<li>South Asia</li>';
            break;
        case 'WesternEurope':
            html += '<li>Western Europe</li>';
            break;
        case 'dataBreach':
            html += '<li>Data breach</li>';
            break;
        case 'nationalGovernment':
            html += '<li>National government</li>';
            break;
        case 'nonstate':
            html += '<li>Nonstate actor</li>';
            break;
        case 'stateSponsored':
            html += '<li>State-sponsored actor</li>';
            break;
        case 'confirmed':
            html += '<li>High Confidence</li>';
            break;
        case 'y2022':
            html += '<li>2022</li>';
        case 'y2021':
            html += '<li>2021</li>';
            break;
        case 'y2020':
            html += '<li>2020</li>';
            break;
        case 'y2019':
            html += '<li>2019</li>';
            break;
        case 'y2018':
            html += '<li>2018</li>';
            break;
        case 'y2017':
            html += '<li>2017</li>';
            break;
        case 'y2016':
            html += '<li>2016</li>';
            break;
        case 'y2015':
            html += '<li>2015</li>';
            break;
        case 'y2014':
            html += '<li>2014</li>';
            break;
        case 'y2013':
            html += '<li>2013</li>';
            break;
        case 'y2012':
            html += '<li>2012</li>';
            break;
        case 'y2011':
            html += '<li>2011</li>';
            break;
        case 'y2010':
            html += '<li>2010</li>';
            break;
        case 'y2009':
            html += '<li>2009</li>';
            break;
        case 'y2008':
            html += '<li>2008</li>';
            break;
        case 'y2007':
            html += '<li>2007</li>';
            break;

        default:
            html += '<li>' + contentPanelId + '</li>';
    }
    document.querySelector('#filters-display').innerHTML = html;
}

function openTimelineEntries(e) {
    e.preventDefault();
    let triggerLabel = e.target.innerHTML,
        moreLabel = e.target.getAttribute('data-more-label'),
        lessLabel = e.target.getAttribute('data-less-label'),
        nextRow = e.target.nextSibling;

    if (triggerLabel == moreLabel) {
        e.target.innerHTML = lessLabel;
    } else {
        e.target.innerHTML = moreLabel;
    }
    nextRow.classList.toggle('active');
}

function openFilterSections(e) {
    e.preventDefault();

    let myItem = e.target.nextSibling;

    if (myItem.classList.contains('active')) {
        myItem.classList.remove('active');
    } else {
        let elList = document.querySelectorAll('.mega-menu');
        elList.forEach((el) => el.classList.remove('active'));
        myItem.classList.add('active');
    }
}

// run through the filters to gray out non-available options
function InactiveFilters(resultsFilter, contentPanelId) {
    // start with array of all filters with relevant hacks
    let locationFilter = my_filters;
    let filteredResultsJoin = [];
    for (let i = 0; i < resultsFilter.length; i++) {
        //use that item as the filter string to identify all array items that do have that string
        let filterResults = locationFilter.filter(function (data) {
            return data.trueFilter.indexOf(resultsFilter[i].name) !== -1;
        });
        // concatenate results so it isn't replacing content with last loop results
        let filteredResultsJoin = filteredResultsJoin.concat(filterResults);
    }
    // compare the list of filters with one or more active hacks to the list of all filters
    let locationFilterInactive = my_data_location;
    let incidentTypeFilterInactive = my_data_incidentType;
    let actorFilterInactive = my_data_actor;
    let attributionFilterInactive = my_data_attribution;
    let yearFilterInactive = my_data_year;
    for (let i = 0; i < filteredResultsJoin.length; i++) {
        //use that item as the filter string to identify all location array items that do NOT have that string
        let filterInactiveResultsLocation = locationFilterInactive.filter(function (data) {
            return data.indexOf(filteredResultsJoin[i].filter) == -1;
        });
        locationFilterInactive = filterInactiveResultsLocation;
        //use that item as the filter string to identify all incident type array items that do NOT have that string
        let filterInactiveResultsIncidentType = incidentTypeFilterInactive.filter(function (data) {
            return data.indexOf(filteredResultsJoin[i].filter) == -1;
        });
        incidentTypeFilterInactive = filterInactiveResultsIncidentType;
        //use that item as the filter string to identify all actor type array items that do NOT have that string
        let filterInactiveResultsActor = actorFilterInactive.filter(function (data) {
            return data.indexOf(filteredResultsJoin[i].filter) == -1;
        });
        actorFilterInactive = filterInactiveResultsActor;
        //use that item as the filter string to identify all attribution array items that do NOT have that string
        let filterInactiveResultsAttribution = attributionFilterInactive.filter(function (data) {
            return data.indexOf(filteredResultsJoin[i].filter) == -1;
        });
        attributionFilterInactive = filterInactiveResultsAttribution;
        //use that item as the filter string to identify all year array items that do NOT have that string
        let filterInactiveResultsYear = yearFilterInactive.filter(function (data) {
            return data.indexOf(filteredResultsJoin[i].filter) == -1;
        });
        yearFilterInactive = filterInactiveResultsYear;
    }
    // merge location and incident type filters to make them all inactive gray
    let filterInactiveResults1 = filterInactiveResultsLocation.concat(filterInactiveResultsIncidentType);
    let filterInactiveResults2 = filterInactiveResults1.concat(filterInactiveResultsActor);
    let filterInactiveResults3 = filterInactiveResults2.concat(filterInactiveResultsAttribution);
    let filterInactiveResults = filterInactiveResults3.concat(filterInactiveResultsYear);
    for (let i = 0; i < filterInactiveResults.length; i++) {
        let idName = '#' + filterInactiveResults[i];
        document.querySelector(idName).classList.remove('active');
    }
    let elList = document.querySelectorAll('.mega-menu');
    elList.forEach((el) => el.classList.remove('active'));
    renameIDs(contentPanelId);
}

// making a copy of the array to be 'edited' by the filters so the starter area can stay clean for reset
let my_data = my_data_original;
let my_filters = my_filter_data_original;
let my_filtered_results = my_data_original;

//reset
function resetTimeline() {
    for (let i = 0; i < my_data_original.length; i++) {
        let idName = '#' + my_data_original[i].name;
        document.querySelector(idName).classList.add('active');
    }

    for (let i = 0; i < my_filter_data_original.length; i++) {
        let idName = '#' + my_filter_data_original[i].filter;
        document.querySelector(idName).classList.add('active');
    }
    let elList = document.querySelectorAll('.mega-menu');
    elList.forEach((el) => el.classList.remove('active'));
    document.querySelector('#filters-display').innerHTML = '';
    document.querySelector('#activeFilters').classList.add('hidden');
    my_filtered_results = my_data_original;
}

function countryFilterInput(event) {
    //get ID of item clicked
    let contentPanelId = event.target.getAttribute('id');
    //use that item as the filter string to identify all array items that do NOT have that string
    let results = my_data.filter(function (data) {
        return data.location.indexOf(contentPanelId) == -1;
    });
    //now run the filter for all items that do have that string
    let resultsFilterLocation = my_filtered_results.filter(function (data) {
        return data.location.indexOf(contentPanelId) !== -1;
    });
    my_filtered_results = resultsFilterLocation;
    //run through the new filter of items without that string and hide everything
    for (let i = 0; i < results.length; i++) {
        let idName = '#' + results[i].name;
        document.querySelector(idName).classList.add('hidden');
    }
    // run through the filters to gray out non-available options
    InactiveFilters(my_filtered_results, contentPanelId);
    document.querySelector('#activeFilters').classList.remove('hidden');
}

function incidentFilterInput(event) {
    //get ID of item clicked
    let contentPanelId = event.target.getAttribute('id');
    //use that item as the filter string to identify all array items that do NOT have that string
    let results = my_data.filter(function (data) {
        return data.incidentType.indexOf(contentPanelId) == -1;
    });
    //now run the filter for all items that do have that string
    let resultsFilterIncidentType = my_filtered_results.filter(function (data) {
        return data.incidentType.indexOf(contentPanelId) !== -1;
    });
    my_filtered_results = resultsFilterIncidentType;
    //run through the new filter of items without that string and hide everything
    for (let i = 0; i < results.length; i++) {
        let idName = '#' + results[i].name;
        document.querySelector(idName).classList.add('hidden');
    }
    // run through the filters to gray out non-available options
    InactiveFilters(my_filtered_results, contentPanelId);
    document.querySelector('#activeFilters').classList.remove('hidden');
}

function actorFilterInput(event) {
    //get ID of item clicked
    let contentPanelId = event.target.getAttribute('id');
    //use that item as the filter string to identify all array items that do NOT have that string
    let results = my_data.filter(function (data) {
        return data.actor.indexOf(contentPanelId) == -1;
    });
    //now run the filter for all items that do have that string
    let resultsFilterActor = my_filtered_results.filter(function (data) {
        return data.actor.indexOf(contentPanelId) !== -1;
    });
    my_filtered_results = resultsFilterActor;
    //run through the new filter of items without that string and hide everything
    for (let i = 0; i < results.length; i++) {
        let idName = '#' + results[i].name;
        document.querySelector(idName).classList.add('hidden');
    }
    // run through the filters to gray out non-available options
    InactiveFilters(my_filtered_results, contentPanelId);
    document.querySelector('#activeFilters').classList.remove('hidden');
}

function attributionFilterInput(event) {
    //get ID of item clicked
    let contentPanelId = event.target.getAttribute('id');
    //use that item as the filter string to identify all array items that do NOT have that string
    let results = my_data.filter(function (data) {
        return data.attribution.indexOf(contentPanelId) == -1;
    });
    //now run the filter for all items that do have that string
    let resultsFilterAttribution = my_filtered_results.filter(function (data) {
        return data.attribution.indexOf(contentPanelId) !== -1;
    });
    my_filtered_results = resultsFilterAttribution;
    //run through the new filter of items without that string and hide everything
    for (let i = 0; i < results.length; i++) {
        let idName = '#' + results[i].name;
        document.querySelector(idName).classList.add('hidden');
    }
    // run through the filters to gray out non-available options
    InactiveFilters(my_filtered_results, contentPanelId);
    document.querySelector('#activeFilters').classList.remove('hidden');
}

function yearFilterInput(event) {
    //get ID of item clicked
    let contentPanelId = event.target.getAttribute('id');
    //use that item as the filter string to identify all array items that do NOT have that string
    let results = my_data.filter(function (data) {
        return data.year.indexOf(contentPanelId) == -1;
    });
    //now run the filter for all items that do have that string
    let resultsFilterYear = my_filtered_results.filter(function (data) {
        return data.year.indexOf(contentPanelId) !== -1;
    });
    my_filtered_results = resultsFilterYear;
    //run through the new filter of items without that string and hide everything
    for (let i = 0; i < results.length; i++) {
        let idName = '#' + results[i].name;
        document.querySelector(idName).classList.add('hidden');
    }
    // run through the filters to gray out non-available options
    InactiveFilters(my_filtered_results, contentPanelId);
    document.querySelector('#activeFilters').classList.remove('hidden');
}

function callMap() {
    // Create root element
    // https://www.amcharts.com/docs/v5/getting-started/#Root_element
    let root = am5.Root.new('chartdiv');

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);

    // Create the map chart
    // https://www.amcharts.com/docs/v5/charts/map-chart/
    let chart = root.container.children.push(
        am5map.MapChart.new(root, {
            panX: 'none',
            panY: 'none',
            wheelX: 'none',
            wheelY: 'none',
            projection: am5map.geoMercator(),
            homeZoomLevel: 2,
            homeGeoPoint: { longitude: 0, latitude: 20 },
        }),
    );
    // adding the zoom controls and making them teal
    const zoomControl = chart.set('zoomControl', am5map.ZoomControl.new(root, {}));
    const zoomButtons = ['minusButton', 'plusButton'];

    zoomButtons.forEach((button) => {
        zoomControl[button].get('background').setAll({
            fill: am5.color(0x00a79d),
        });
        zoomControl[button]
            .get('background')
            .states.create('hover', {})
            .setAll({
                fill: am5.color(0x99dcd8),
            });
    });

    // Create series for background fill
    // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
    let backgroundSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {}));
    backgroundSeries.mapPolygons.template.setAll({
        fill: am5.color('#cdd4d9'),
        fillOpacity: 1,
        strokeOpacity: 0,
    });

    // Add background polygon
    // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
    backgroundSeries.data.push({
        geometry: am5map.getGeoRectangle(90, 180, -90, -180),
    });

    // Create main polygon series for countries
    // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/
    let polygonSeries = chart.series.push(
        am5map.MapPolygonSeries.new(root, {
            geoJSON: am5geodata_worldLow,
            exclude: ['AQ'],
        }),
    );

    // Configure series
    polygonSeries.mapPolygons.template.setAll({
        tooltipText: '{name}',
        interactive: true,
        fill: am5.color('#e6e7ed'),
        templateField: 'settings',
    });

    polygonSeries.events.on('datavalidated', function () {
        chart.goHome();
    });

    //reconfigure based on filters

    function buildMapFromButton(inactiveResults, results) {
        // create array that is only the negative results inactiveMapData
        let inactiveMapDataArray = [];
        let index = 0;
        for (let e in inactiveResults) {
            inactiveMapDataArray[index] = inactiveResults[e];
            index++;
        }
        // push to new polygonSeries the array with positive results as normal
        let activeMapColors = [];
        for (let e in results) {
            activeMapColors.push(results[e]);
        }
        // combine the inactive array for light color inactive countries and active array for bright active countries
        const fullMap = inactiveMapDataArray.concat(activeMapColors);
        polygonSeries.data.setAll(fullMap);
    }

    //All protests
    document.querySelector('#Reset').onclick = function (e) {
        // push to new polygonSeries the array with positive results as normal
        let activeMapColors = [];
        for (let e in my_data_original) {
            for (let f in my_data_original[e].mapID) {
                activeMapColors.push(my_data_original[e].mapID[f]);
            }
        }
        polygonSeries.data.setAll(activeMapColors);
    };

    //Country
    const countries = document.getElementsByClassName('countryFilter');

    for (const country of countries) {
        country.addEventListener('click', (event) => {
            //get ID of item clicked
            let contentPanelId = event.target.getAttribute('id');
            //use that item as the filter string to identify all array items that do NOT have that string
            let inactiveResults = my_data.filter(function (data) {
                return data.location.indexOf(contentPanelId) == -1;
            });
            //now run the filter for all items that do have that string
            let resultsFilterAttribution = my_filtered_results.filter(function (data) {
                return data.location.indexOf(contentPanelId) !== -1;
            });
            my_filtered_results = resultsFilterAttribution;
            // create array that is only the negative results inactiveMapData
            let inactiveMapDataArray = [];
            for (let e in inactiveResults) {
                let inactiveMapAdd = inactiveResults[e].inactiveMapID;
                inactiveMapDataArray[e] = inactiveMapAdd;
            }
            // push new polygonSeries the array with active results to override
            let mapColors = [];
            for (let e in my_filtered_results) {
                for (let f in my_filtered_results[e].mapID) {
                    mapColors.push(my_filtered_results[e].mapID[f]);
                }
            }
            buildMapFromButton(inactiveMapDataArray, mapColors);
        });
    }

    //Incident type
    const incidentTypeValue = document.getElementsByClassName('incidentTypeFilter');

    for (const type of incidentTypeValue) {
        type.addEventListener('click', (event) => {
            //get ID of item clicked
            let contentPanelId = event.target.getAttribute('id');
            //use that item as the filter string to identify all array items that do NOT have that string
            let inactiveResults = my_data.filter(function (data) {
                return data.incidentType.indexOf(contentPanelId) == -1;
            });
            //now run the filter for all items that do have that string
            let resultsFilterAttribution = my_filtered_results.filter(function (data) {
                return data.incidentType.indexOf(contentPanelId) !== -1;
            });
            my_filtered_results = resultsFilterAttribution;
            // create array that is only the negative results inactiveMapData
            let inactiveMapDataArray = [];
            for (let e in inactiveResults) {
                let inactiveMapAdd = inactiveResults[e].inactiveMapID;
                inactiveMapDataArray[e] = inactiveMapAdd;
            }
            // push new polygonSeries the array with active results to override
            let mapColors = [];
            for (let e in my_filtered_results) {
                for (let f in my_filtered_results[e].mapID) {
                    mapColors.push(my_filtered_results[e].mapID[f]);
                }
            }
            buildMapFromButton(inactiveMapDataArray, mapColors);
        });
    }

    //Actor type
    const actorTypeValue = document.getElementsByClassName('actorFilter');

    for (const actor of actorTypeValue) {
        actor.addEventListener('click', (event) => {
            //get ID of item clicked
            let contentPanelId = event.target.getAttribute('id');
            //use that item as the filter string to identify all array items that do NOT have that string
            let inactiveResults = my_data.filter(function (data) {
                return data.actor.indexOf(contentPanelId) == -1;
            });
            //now run the filter for all items that do have that string
            let resultsFilterAttribution = my_filtered_results.filter(function (data) {
                return data.actor.indexOf(contentPanelId) !== -1;
            });
            my_filtered_results = resultsFilterAttribution;
            // create array that is only the negative results inactiveMapData
            let inactiveMapDataArray = [];
            for (let e in inactiveResults) {
                let inactiveMapAdd = inactiveResults[e].inactiveMapID;
                inactiveMapDataArray[e] = inactiveMapAdd;
            }
            // push new polygonSeries the array with active results to override
            let mapColors = [];
            for (let e in my_filtered_results) {
                for (let f in my_filtered_results[e].mapID) {
                    mapColors.push(my_filtered_results[e].mapID[f]);
                }
            }
            buildMapFromButton(inactiveMapDataArray, mapColors);
        });
    }

    //Attribution type
    const attributionValue = document.getElementsByClassName('attributionFilter');

    for (const attribution of attributionValue) {
        attribution.addEventListener('click', (event) => {
            //get ID of item clicked
            let contentPanelId = event.target.getAttribute('id');
            //use that item as the filter string to identify all array items that do NOT have that string
            let inactiveResults = my_data.filter(function (data) {
                return data.attribution.indexOf(contentPanelId) == -1;
            });
            //now run the filter for all items that do have that string
            let resultsFilterAttribution = my_filtered_results.filter(function (data) {
                return data.attribution.indexOf(contentPanelId) !== -1;
            });
            my_filtered_results = resultsFilterAttribution;
            // create array that is only the negative results inactiveMapData
            let inactiveMapDataArray = [];
            for (let e in inactiveResults) {
                let inactiveMapAdd = inactiveResults[e].inactiveMapID;
                inactiveMapDataArray[e] = inactiveMapAdd;
            }
            // push new polygonSeries the array with active results to override
            let mapColors = [];
            for (let e in my_filtered_results) {
                for (let f in my_filtered_results[e].mapID) {
                    mapColors.push(my_filtered_results[e].mapID[f]);
                }
            }
            buildMapFromButton(inactiveMapDataArray, mapColors);
        });
    }

    //Year type
    const yearValue = document.getElementsByClassName('yearFilter');

    for (const year of yearValue) {
        year.addEventListener('click', (event) => {
            //get ID of item clicked
            let contentPanelId = event.target.getAttribute('id');
            //use that item as the filter string to identify all array items that do NOT have that string
            let inactiveResults = my_data.filter(function (data) {
                return data.year.indexOf(contentPanelId) == -1;
            });
            //now run the filter for all items that do have that string
            let resultsFilterAttribution = my_filtered_results.filter(function (data) {
                return data.year.indexOf(contentPanelId) !== -1;
            });
            my_filtered_results = resultsFilterAttribution;
            // create array that is only the negative results inactiveMapData
            let inactiveMapDataArray = [];
            for (let e in inactiveResults) {
                let inactiveMapAdd = inactiveResults[e].inactiveMapID;
                inactiveMapDataArray[e] = inactiveMapAdd;
            }
            // push new polygonSeries the array with active results to override
            let mapColors = [];
            for (let e in my_filtered_results) {
                for (let f in my_filtered_results[e].mapID) {
                    mapColors.push(my_filtered_results[e].mapID[f]);
                }
            }
            buildMapFromButton(inactiveMapDataArray, mapColors);
        });
    }

    let mapColors = [];
    for (let e in my_data_original) {
        for (let f in my_data_original[e].mapID) {
            mapColors.push(my_data_original[e].mapID[f]);
        }
    }
    polygonSeries.data.setAll(mapColors);

    // Make stuff animate on load
    chart.appear(1000, 100);
}

function aboutTab() {
    document.querySelector('#aboutTabClick').onclick = function (e) {
        document.getElementById('aboutTabContent').classList.add('active');
    };
    document.querySelector('#close-about').onclick = function (e) {
        document.getElementById('aboutTabContent').classList.remove('active');
    };
}
function openTab(tabName, event) {
    let i, tabcontent, tablinks, activeTab;
    tabcontent = document.getElementsByClassName('tab-pane');
    for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].classList.remove('active');
    }
    document.getElementById(tabName).classList.add('active');

    tablinks = document.getElementsByClassName('tab-clicks');
    for (i = 0; i < tablinks.length; i++) {
        tablinks[i].parentElement.classList.remove('active');
    }
    activeTab = event.target.parentElement;
    activeTab.classList.add('active');
}
</script>

<style lang="scss" scoped>
//layout
$gutter: 30px;
$site-width: 1000px;

$gray-light: #e4e3dd;
$gold: #a28556;
$black: #000;
$white: #fff;
$teal: #00a79d;
$dark-gray-new: #6e6e71;
$light-gray: #f5f5f5;
$dark-gray: #929497;
$yellow: #fbb040;
$primary-light-blue: #3183b1;
$primary-dark-blue: #072a42;
$teal-light: #99dcd8; // 40% $teal
$primary-dark-blue-light: #9caab3; // 40% $primary-dark-blue
$yellow-light: #fee7c5; //40% $yellow
$light-gray-new: #e6e7e8;

$secondary: $light-gray-new; //$gray-light;
$tertiary: $dark-gray-new; //$gray-dark;

$roman-normal-book: 'Frutiger Neue LT W06 Book', Arial, sans-serif;
$roman-italic-book: 'Frutiger Neue LT W06 Book It', Arial, sans-serif;
$roman-normal-bold: 'Frutiger Neue LT W06 Bold', 'Arial Black', Gadget, sans-serif;

@mixin all-transition($time) {
    transition: all $time;
    -webkit-transition: all $time;
}

//layout basics
.foreground {
    position: relative;
    margin: 0 auto;
    box-sizing: content-box;
    max-width: $site-width;
    padding-left: calc($gutter / 2);
    padding-right: calc($gutter / 2);
}

.section {
    display: block;
    clear: both;
    margin-top: $gutter;
    margin-bottom: $gutter;
}

.cols {
    clear: both;
    //use a .no-gutters class to undo these default styles
    margin-left: calc($gutter / 2) * -1;
    margin-right: calc($gutter / 2) * -1;

    &:before,
    &:after {
        content: ' ';
        display: table;
        height: 0;
        clear: both;
        font-size: 1px;
        line-height: 0px;
        visibility: hidden;
    }

    &--gutters-tablet {
        // @include bp(tablet) {
        //     margin-left: calc($gutter / 2) * -1 !important;
        //     margin-right: calc($gutter / 2) * -1 !important;
        // }
    }

    // @include bp(mobile) {
    //     margin-left: 0 !important;
    //     margin-right: 0 !important;
    // }
}

.cols--equal-heights {
    flex-wrap: wrap;

    &,
    > .col {
        display: flex;

        // @include bp(mobile) {
        //     display: block;
        // }
    }

    > .col {
        flex-direction: column;
    }

    .banded {
        flex: 1 0 auto;
    }
}

.cols {
    clear: both;
}

.col {
    float: left;

    .gutters {
        margin-left: 15px;
        margin-right: 15px;
    }

    // @include bp(mobile) {
    //     float: none;
    //     width: 100% !important;

    //     > .gutters {
    //         margin-left: 0;
    //         margin-right: 0;
    //     }
    // }
}

.col-80 {
    width: 80%;
}

.col-70 {
    width: 70%;
}

//two across
.col-50 {
    width: 50%;
}

.col-30 {
    width: 30%;
}

//four across
.col-25 {
    width: 25%;
}

//five across
.col-20 {
    width: 20%;
}

.padded {
    padding: $gutter;
}

.gutter-top {
    margin-top: 30px;
}

.nav-tabs {
    div {
        border: 0 !important;
        text-transform: uppercase;
    }

    > li {
        margin-bottom: 0;
        float: left;
        position: relative;
        display: block;

        > div {
            line-height: 1;
            border-radius: 0;
        }
    }
}

.gutter-right {
    margin-right: 30px;
}

.gutter-left {
    margin-left: 30px;
}

:deep(.accordion-content),
:deep(.hidden),
:deep(.mega-menu) {
    display: none;

    &.active {
        display: block;
    }
}

:deep(.mega-menu) {
    font-family: $roman-normal-book;
    color: #000;
    position: absolute;
    z-index: 9;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
    overflow: hidden;
    font-size: 20px;
    -webkit-box-shadow: 0 4px 5px 0px rgba(0, 0, 0, 0.2), inset 0 -3px 0 0 #a7a9ac;
    box-shadow: 0 4px 5px 0px rgba(0, 0, 0, 0.2), inset 0 -3px 0 0 #a7a9ac;
}

:deep(.clean-list) {
    list-style: none;
    margin-bottom: 15px;
    padding: 0;

    li {
        margin-right: 30px;
        float: none;
        display: inline-block;
    }
}

.frst-container {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* this class is used to give a max-width to the element it is applied to, and center it horizontally when it reaches that max-width */
    max-width: 1200px;
    margin: 0 auto;
    padding: 100px 15px;
}

.frst-container::after {
    /* clearfix */
    content: '';
    display: table;
    clear: both;
}

/* --------------------------------

Main components

-------------------------------- */
.frst-timeline {
    position: relative;
}

.frst-right-align {
    text-align: right;
}

/*.frst-date-opposite{
padding: 0;
}*/

.frst-timeline-block {
    position: relative;
    min-height: 16px;
    padding-left: 35px;
    padding-right: 35px;
}

.frst-timeline-block::before {
    content: '';
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
}

.frst-timeline-block:last-child::before {
    display: none;
}

.frst-left-align .frst-timeline-block::before {
}

.frst-right-align .frst-timeline-block::before {
    right: 0;
    left: auto !important;
    margin-left: 0 !important;
}

.frst-timeline-block::after {
    content: '';
    display: table;
    clear: both;
}

.frst-timeline-img {
    position: absolute;
    min-width: 1px;
    min-height: 1px;
    left: 0;
    top: 0;
}

.frst-timeline-img i {
    display: block;
}

.frst-right-align .frst-timeline-img {
    margin-left: 0 !important;
    left: auto !important;
    right: 0;
}

.frst-last-empty-item .frst-timeline-img span {
    vertical-align: top;
}

.frst-timeline-content-inner {
    position: relative;
}

.frst-date {
    display: block;
}

.cssanimations .frst-timeline-content.is-hidden {
    visibility: hidden;
}

.cssanimations .frst-timeline-content.animated {
    visibility: visible;
}

.frst-labels span {
    display: inline-block;
}

.frst-labels {
    padding: 20px 0;
}

.frst-labels.frst-start-label {
    padding-top: 0 !important;
}

.frst-labels.frst-end-label {
    margin-bottom: 0 !important;
}

.frst-container .turqoise {
    background: #00a79d !important;
}

.frst-container .light-blue {
    background: #27aae2 !important;
}

.frst-container .blue {
    background: #1d75bd !important;
}

.frst-container .violette {
    background: #2b3991 !important;
}

.frst-container .dark-violette {
    background: #272264 !important;
}

/*.aqua-blue{
  background: #36ACB6 !important;
}
.red{
  background: #C84028 !important;
}
.orange{
  background: #EB8D23 !important;
}
.light-green{
  background: #C2C84A !important;
}*/

@media only screen and (min-width: 679px) {
    .frst-date-opposite {
        margin-left: 190px;
    }

    .frst-left-align.frst-date-opposite {
        margin-left: 190px;
    }

    .frst-right-align.frst-date-opposite {
        margin-right: 190px;
        margin-left: 0;
        text-align: right;
    }

    .frst-date-opposite.frst-alternate {
        margin: 0;
    }

    .frst-timeline.frst-alternate.frst-left-align .frst-timeline-content,
    .frst-timeline.frst-date-opposite.frst-left-align .frst-timeline-content,
    .frst-timeline.frst-alternate.frst-right-align .frst-timeline-content,
    .frst-timeline.frst-date-opposite.frst-right-align .frst-timeline-content {
        width: 100%;
    }

    .frst-alternate .frst-timeline-block::before {
        left: 50%;
    }

    .frst-alternate .frst-timeline-img {
        left: 50% !important;
    }

    .frst-alternate .frst-timeline-block.frst-even-item .frst-timeline-content {
        float: right;
    }

    .frst-alternate .frst-timeline-block.frst-odd-item .frst-timeline-content {
        float: left;
    }

    .frst-date-opposite .frst-date {
        position: absolute;
        top: 0;
        text-align: right;
    }

    .frst-alternate .frst-timeline-block.frst-odd-item .frst-timeline-content,
    .frst-alternate.frst-date-opposite .frst-timeline-block.frst-even-item .frst-date,
    .frst-date-opposite.frst-left-align .frst-date,
    .frst-right-align {
        text-align: right;
    }

    .frst-alternate.frst-date-opposite .frst-timeline-block.frst-odd-item .frst-timeline-content .frst-date,
    .frst-date-opposite.frst-right-align .frst-date {
        text-align: left;
    }

    .frst-alternate .frst-timeline-label-block {
        text-align: center;
    }

    .frst-alternate .frst-timeline-label-block .frst-labels span {
        left: 0;
        right: 0;
    }
}

@media only screen and (max-width: 678px) {
    .frst-timeline {
        margin-left: 20px;
    }

    .frst-timeline.frst-right-align,
    .frst-timeline.frst-responsive-right {
        margin-right: 20px;
        margin-left: 0;
    }

    .frst-responsive-right .frst-timeline-block::before {
        right: 0;
        left: auto !important;
        margin-left: 0 !important;
    }

    .frst-responsive-right {
        text-align: right;
    }

    .frst-responsive-right .frst-timeline-img {
        margin-left: 0 !important;
        left: auto !important;
        right: 0;
    }

    .frst-date {
        margin-bottom: 10px;
    }
}

/*-------- Type- 01 ------*/

.frst-timeline-style-8 {
    color: #000;
}

.frst-timeline-style-8 .frst-timeline-block::before {
    width: 3px;
    background: rgba(0, 0, 0, 0);
    margin-left: -2px;
    background: rgba(12, 12, 12, 0.8);
    top: 12px;
}

.frst-timeline-style-8.frst-right-align .frst-timeline-block::before {
    margin-right: -2px;
}

.frst-timeline-block {
    padding-bottom: 30px;
    padding-left: 45px;
    padding-right: 45px;
}

.frst-timeline-style-8 .frst-timeline-img {
    padding: 0;
    margin-left: -21px;
    top: 6px;
    /*--- Box shadow value --*/
    width: 42px;
    height: 42px;
    color: #fff;
    text-align: center;
    font-size: 24px;
}

.frst-timeline-style-8 .frst-timeline-img span {
    display: inline-block;
    margin: auto;
    padding: 6px;
    height: 50%;
    width: 50%;
    background: #202020;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    vertical-align: top;
    border: 3px solid #202020;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
    vertical-align: middle;
}

.frst-timeline-style-8 .frst-timeline-img i {
    display: block;
}

.frst-timeline-style-8.frst-right-align .frst-timeline-img {
    margin-right: -21px;
}

.frst-timeline-style-8 .frst-timeline-content {
    color: #777;
    background: white;
}

.frst-timeline-style-8 .frst-date {
    color: #9c9c9c;
}

.frst-timeline-style-8 h2 {
    margin: 0 0 5px;
    font-weight: 800;
    color: #444;
    font-size: 18px;
}

.frst-date-opposite.frst-timeline-style-8 h2 {
    font-family: 'Frutiger Neue LT W06 Book', Arial, sans-serif;
    margin-top: 1em;
}

.frst-timeline-style-8 p {
    margin: 0;
    font-family: 'Frutiger Neue LT W06 Thin', Arial, sans-serif;
    font-size: 0.75em;
    line-height: normal;
}

.frst-timeline-style-8 .frst-timeline-label-block {
    padding-top: 0;
}

.frst-timeline-style-8 .frst-labels span {
    font-family: 'Frutiger Neue LT W06 Book', Arial, sans-serif;
    position: relative;
    background: #202020;
    color: #fff;
    font-weight: 800;
    padding: 8px 30px;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    text-transform: uppercase;
    text-align: center;
    font-size: 14px;
}

.frst-timeline-style-8.frst-right-align .frst-labels span {
    left: auto;
    right: -47px;
}

.frst-timeline-style-8.frst-left-align .frst-labels span {
    right: auto;
    left: -47px;
}

/*--------- news-------*/

.frst-timeline-style-8 .frst-timeline-content-inner {
    border: 2px solid #d8d8d8;
    padding: 30px;
    position: relative;
    -webkit-border-radius: 4px;
    border-radius: 4px;
}

.frst-timeline-style-8 .frst-timeline-content-inner .media-section {
    width: 100%;
    max-height: 350px;
    overflow: hidden;
    margin-bottom: 20px;
}

.frst-timeline-style-8 .frst-timeline-content-inner .media-section iframe {
    max-width: 100%;
}

.frst-timeline-style-8 .frst-timeline-content-inner::before,
.frst-timeline-style-8 .frst-timeline-content-inner::after {
    content: '';
    border-style: solid;
    border-color: transparent;
    position: absolute;
}

.frst-timeline-style-8 .frst-timeline-content-inner::before {
    border-width: 10px 11px 10px 0;
    border-right-color: #d8d8d8;
    left: -11px;
    top: 10px;
}

.frst-timeline-style-8 .frst-timeline-content-inner::after {
    border-width: 8px 9px 8px 0;
    border-right-color: #fff;
    left: -9px;
    top: 12px;
}

.frst-timeline-style-8.frst-right-align .frst-timeline-content-inner::before {
    border-width: 10px 0 10px 11px;
    border-left-color: #d8d8d8;
    left: auto;
    right: -11px;
}

.frst-timeline-style-8.frst-right-align .frst-timeline-content-inner::after {
    border-width: 8px 0 8px 9px;
    border-left-color: #fff;
    right: -8px;
    left: auto;
}

/*---------- Responsive part ------------*/

@media only screen and (min-width: 679px) {
    .frst-date-opposite {
        margin-left: 203px;
    }

    .frst-left-align.frst-date-opposite {
        margin-left: 203px;
    }

    .frst-right-align.frst-date-opposite {
        margin-right: 203px;
        margin-left: 0;
    }

    .frst-timeline-style-8.frst-alternate .frst-timeline-content,
    .frst-timeline-style-8.frst-date-opposite .frst-timeline-content {
        width: calc(50% - 44px);
    }

    .frst-timeline-style-8.frst-date-opposite .frst-date {
        font-family: 'Frutiger Neue LT W06 Book', Arial, sans-serif;
        left: -248px;
        line-height: 32px;
        width: 160px;
    }

    .frst-timeline-style-8.frst-date-opposite.frst-right-align .frst-date,
    .frst-timeline-style-8.frst-date-opposite.frst-alternate .frst-timeline-block.frst-odd-item .frst-date {
        right: -248px;
        left: auto;
        text-align: left;
    }

    .frst-timeline-style-8.frst-right-align .frst-date {
        left: auto;
        right: 0;
    }

    /*--------- news-------*/
    .frst-timeline-style-8.frst-alternate .frst-odd-item .frst-timeline-content-inner::before {
        border-width: 10px 0 10px 11px;
        border-left-color: #d8d8d8;
        left: auto;
        right: -11px;
    }

    .frst-timeline-style-8.frst-alternate .frst-odd-item .frst-timeline-content-inner::after {
        border-width: 8px 0 8px 9px;
        border-left-color: #fff;
        right: -8px;
        left: auto;
    }
}

@media only screen and (max-width: 678px) {
    .frst-timeline-style-8.frst-responsive-right .frst-labels span {
        left: auto;
        right: -47px;
    }

    .frst-timeline-style-8.frst-responsive-right .frst-timeline-block::before {
        margin-right: -2px;
    }

    .frst-timeline-style-8.frst-responsive-right .frst-timeline-img {
        margin-right: -21px;
    }

    /*--------- news-------*/
    .frst-timeline-style-8.frst-responsive-right .frst-timeline-content-inner::before {
        border-width: 10px 0 10px 11px;
        border-left-color: #d8d8d8;
        left: auto;
        right: -11px;
    }

    .frst-timeline-style-8.frst-responsive-right .frst-timeline-content-inner::after {
        border-width: 8px 0 8px 9px;
        border-left-color: #fff;
        right: -8px;
        left: auto;
    }
}

.section.top {
    margin-top: 0;
}

.landing--hero-image .zone-title {
    background-size: cover;
}

body.cybertimeline .landing--hero-image .zone-title {
    background-size: cover;
}

.landing--hero-image.protectingFinancialStability .zone-title {
    background-image: url(https://ceipimg.s3.amazonaws.com/static/banner-fincyber.jpg);
}

.landing--hero-image .zone-title {
    background-position: center center;
}

.zone-title--bg {
    background-color: #f5f5f5;
    background-image: url('https://ceipimg.s3.amazonaws.com/static/bg_zoneTitle2.png');
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
}

.zone-title {
    position: relative;
    z-index: 10;
    margin-top: 80px;
    @include type-h2;
}

.landing--hero-image .zone-title__foreground {
    height: 265px;
}

//  .landing--hero-image .container-title {
//      background: black;
//      background: rgba(0, 0, 0, 0.7);
//      position: absolute;
//      bottom: 30px;
//      padding: 15px;
//  }

.container-title {
    padding: 40px 0;
    display: flex;
    text-align: center;
    width: 50%;
    margin: 0 auto;
}

.landing--hero-image .headline {
    position: relative;
    padding: 0;
    bottom: 0;
    background: none;
    width: auto;
    text-transform: none;
    //  font-size: 43px;
    //  font-size: 2.5rem;
}

.float-left {
    float: left;
}

.landing--hero-image .container-title .headline {
    color: white;
}

#sticky-filter {
    background: #ffffff;
    box-shadow: 0 4px 5px 0px rgba(0, 0, 0, 0.2), inset 0 -3px 0 0 #ccc7c2;
    display: block;
    padding: 1em 1em 0 1em;
    position: relative;
    text-align: center;
    width: auto;
    max-width: 1000px;
    z-index: 99;

    // @include bp(tablet) {
    //     font-size: 0.8em;
    //     width: 94vw;
    // }

    // @include bp(mobile) {
    //     font-size: 0.7em;

    //     li {
    //         padding-bottom: 0.4em;
    //     }
    // }

    strong {
        text-align: left;
        display: inline-block;
        @include type-body;
        & {
            @include font-weight(bold);
        }
    }

    ul.sticky {
        padding-bottom: calc($gutter / 2);
    }

    &.show {
        position: fixed;
        top: 60px;
        width: 75vw;

        // @include bp(tablet) {
        //     width: 94vw;
        // }
    }

    a.button-alt {
        background: $light-gray-new;
        border: 1px solid $light-gray-new;
        border-radius: 3px;
        color: $primary-light-blue;
        margin-bottom: $gutter;
        margin-top: calc($gutter / 2);
        margin-right: $gutter;
        padding: 0.4rem 1rem 0.5rem;
        text-transform: uppercase;
        @include font-weight(bold);
        @include type-body;
    }

    .menu-trigger {
        font-size: 2rem;
        @include font-weight(bold);
    }

    .mega-menu {
        background: $white;
        border-top: 2px solid $secondary;
        margin-top: -5px;
        padding: $gutter;
        z-index: 9;

        ul:nth-child(2) {
            padding-top: 1em;
        }

        // @include bp(tablet) {
        //     font-size: 0.9em;
        // }

        // @include bp(mobile) {
        //     font-size: 0.8em;
        // }

        .list-across-divided > li {
            border-right: 1px solid #cbced0;
            margin-right: 10px;
            padding-right: 10px;
            @include type-body;
            & {
                font-size: 16px;
                line-height: 2;
                @include font-weight(bold);
            }

            &:last-of-type {
                border-right: none;
            }
        }
    }

    .mega-menu ul li a {
        color: #cccccc;
        cursor: default;
        text-decoration: none;

        &.active {
            color: #3d71b7;
            cursor: pointer;
        }
    }

    .active-filters {
        padding-bottom: 1em;
        text-align: left;
        @include type-body;
        & {
            @include font-weight(bold);
        }

        //  strong {
        //      font-family: $roman-normal-book;
        //  }

        ul {
            display: inline-block;
            padding-left: calc($gutter / 2);
        }
    }
}

#aboutTab {
    h3 {
        background-color: $teal;
        border-radius: 5px 0 0 5px;
        color: $white;
        cursor: pointer;
        display: none;
        padding: 20px 0;
        position: fixed;
        right: 0;
        top: 50vh;
        writing-mode: vertical-lr;
        text-orientation: mixed;
        text-transform: uppercase;
        z-index: 11;
        @include type-body;
        & {
            font-size: 1.5rem;
            line-height: 2.3em;
        }

        &.active {
            display: block;
        }

        span {
            display: inline;
        }
    }

    #aboutTabContent {
        box-shadow: -5px 0px 8px -3px rgba(0, 0, 0, 0.69);
        display: none;
        background-color: $light-gray;
        width: 90vw;
        height: 65vh;
        cursor: auto;
        overflow-y: scroll !important;
        position: fixed;
        right: 0;
        top: 20vh;
        -webkit-border-radius: 5px 0 0 5px;
        -moz-border-radius: 5px 0 0 5px;
        border-radius: 5px 0 0 5px;
        z-index: 101;

        &.active {
            display: block;
        }

        h3 {
            border-radius: 0;
            display: block;
            height: 100%;
            top: 0;
            display: none;
        }

        .section {
            padding: 0 15px 15px 0;

            &.about-overlay {
                &.section {
                    margin-top: 0;
                    margin-bottom: 0;
                }

                .foreground {
                    padding-left: 0;
                }
            }
        }

        .top-section {
            background-color: $light-gray;
            display: block;
            padding: 0 0 $gutter * 2 0;
            position: sticky;
            position: webkit-sticky;
            top: 0;
            width: 100%;
            z-index: 9;

            .foreground {
                float: left;
                position: relative;
                left: $gutter * 2;
            }
        }

        .nav {
            margin-left: $gutter * 2;
        }

        .tab-content {
            font-size: 1.2rem;
            line-height: normal;

            .component {
                margin: 0 !important;

                .cols {
                    margin-left: 0;
                    margin-right: 0;
                }
            }

            .tab-pane {
                margin: $gutter 0 0 0;

                h4 {
                    color: $teal;
                    margin-bottom: 1em;
                    text-transform: uppercase;
                    @include type-h4;
                }

                p,
                li,
                .col {
                    @include type-body;
                }

                p {
                    margin-bottom: $gutter;
                }

                em {
                    @include type-body;
                }

                strong {
                    display: block;
                    padding-bottom: calc($gutter / 3);
                    @include type-body;
                    & {
                        @include font-weight(bold);
                    }
                }

                li.gutter-bottom {
                    margin-bottom: calc($gutter / 2);
                }

                .button {
                    background-color: #0050a9;
                }
            }
        }

        .close-button {
            button.close-panel {
                background-color: transparent;
                color: $teal;
                margin-bottom: $gutter;
                font-family: $roman-normal-bold;
                font-size: 2rem;
                font-weight: normal;
                padding: 0;
                position: absolute;
                left: 20px;
                top: 20px;
                text-transform: uppercase;

                &:after {
                    border: none;
                }
            }
        }
    }
}

.gray-background {
    background-color: $light-gray-new;
    margin-bottom: 0;
    margin-top: 0;
    padding-bottom: $gutter;
    padding-top: $gutter;
}

.intro {
    p {
        margin-bottom: 1em;
        @include type-body;
        & {
            font-size: 1.5rem;
            line-height: 1.5em;
        }
    }

    a:hover {
        text-decoration: none;
    }

    .banded {
        background-color: transparent;
        //  border: 2px dotted $teal;
        display: flex;
        padding: 10px;

        .inside {
            background-color: rgba(0, 167, 157, 0.7);
            padding: 15px;
            width: 100%;

            &:hover {
                background-color: rgba(0, 167, 157, 0.9);
                text-decoration: none;
            }

            // @include bp(tablet) {
            //     padding: 10px;
            // }

            // @include bp(mobile) {
            //     padding: 15px;
            // }
        }

        .text {
            background-position: top center;
            background-repeat: no-repeat;
            color: $white;
            padding: 0;
            text-align: center;
            width: 100%;
            @include type-body;
            & {
                line-height: 1.1em;
                @include font-weight(bold);
            }
        }
    }
}

#chartdiv {
    height: 600px;
}

h2.headline span {
    //  font-size: 0.6em;
}

.frst-container {
    padding-bottom: 0;
    padding-top: 50px;
}

.frst-alternate .frst-timeline-block.frst-odd-item .frst-timeline-content,
.frst-date-opposite.frst-left-align .frst-date,
.frst-right-align {
    text-align: left;
}

.frst-alternate.frst-date-opposite {
    .frst-timeline-block.frst-odd-item .frst-date {
        line-height: 2em;
        text-align: left;
    }

    .frst-timeline-block.frst-even-item .frst-date {
        line-height: 2em;
        text-align: right;
    }
}

.frst-timeline-style-8 .frst-timeline-content-inner {
    padding: 1em 1em 0 1em;

    h2 {
        margin-top: 0;
        @include type-h3;
    }

    p {
        margin-bottom: 15px;
        @include type-body;
    }
}

.frst-timeline-label-block {
    padding-left: 0;

    .frst-labels {
        margin-left: -50px;
        @include type-body;
        & {
            @include font-weight(bold);
        }

        span {
            background-color: #0050a9;
            font-size: 2rem;
        }
    }
}

.frst-timeline-style-8 .frst-timeline-img span {
    background-color: #0050a9;
    border: #0050a9 solid 3px;
}

.frst-timeline-style-8 .frst-timeline-block::before {
    background: rgba(0, 80, 169, 0.8) none repeat scroll 0 0;
}

.frst-date {
    color: #005089;
    text-transform: uppercase;
    @include type-body;
    & {
        font-size: 1.1em;
        line-height: 2em;
    }
}

.frst-timeline-style-8 li {
    margin: 0;
    @include type-body;
    & {
        font-size: 1rem;
        line-height: normal;
    }
}

.frst-timeline-style-8 p {
    color: $tertiary;
    font-size: 1rem;
    @include type-body;
}

.frst-timeline-style-8 h4 {
    color: $black;
    margin-top: 2em;
    text-transform: uppercase;
    @include type-h4;
    & {
        font-size: 1.5rem;
    }
}

.css-timeline li {
    margin-top: 1em;
}

.accordion-trigger {
    background: none;
    color: #0981b5; //$gold;
    margin: 1em 0;
    padding: 0;

    &:after {
        // @extend %ceip-icon;
        // @extend %icon-arrow-down:before;
        background: none;
        display: inline;
        line-height: 1;
        margin-top: 0;
        position: relative;
        right: 0;
        text-transform: none;
    }
}

@include media-query(tablet) {
    .frst-timeline-label-block .frst-labels {
        margin-left: -15px;
    }
}

@include media-query(phone) {
    .zone-title {
        margin-top: 50px;
    }

    .container-title {
        width: auto;
    }

    .section.gray-background {
        .col-70,
        .col-30 {
            display: block;
            float: none;
            width: auto;
        }
    }

    .frst-timeline-label-block .frst-labels {
        margin-left: -30px;
    }

    .frst-timeline-block {
        padding-left: 25px;
        padding-right: 0;
    }
}

// @include bp(tablet) {
//     .zone-title.zone-title--bg {
//         background-size: cover;
//     }

//     #aboutTab #aboutTabContent {
//         .about-overlay {
//             .foreground {
//                 margin: 0 $gutter;
//             }
//         }

//         .top-section {
//             height: 70px;
//             padding: calc($gutter / 2) 0;

//             .foreground {
//                 display: inline-block;
//                 float: none;
//                 left: 10px;
//                 top: 60px;
//                 width: 22vw;
//             }
//         }

//         // .nav {margin-left: calc($gutter * 2);}

//         .nav-tabs {
//             margin-left: 0;
//             width: auto;

//             li {
//                 a {
//                     background-color: transparent;
//                     color: $medium-blue !important;
//                     font-size: 1.1rem;
//                     line-height: 1.1em;
//                     padding-right: $gutter;
//                 }

//                 &:last-child {
//                     a {
//                         padding-right: 0;
//                     }
//                 }

//                 &.active a {
//                     color: $teal !important;
//                     background-color: transparent;
//                 }
//             }
//         }

//         .section.about-overlay.section {
//             margin-left: 22vw;
//             width: 68vw;
//         }

//         .tab-content {
//             font-size: 1.1rem;

//             .tab-pane {
//                 margin: 10px 0 0;
//             }
//         }

//         .close-button {
//             display: block;
//             float: left;
//         }
//     }
// }

// @include bp(mobile) {
//     #aboutTab {
//         width: 100vw;
//         h3 span.hide-mobile {
//             display: none;
//         }

//         #aboutTabContent {
//             .top-section .foreground {
//                 background-color: $light-gray;
//                 top: 40px;
//                 width: 85%;

//                 .nav-tabs li a {
//                     font-size: 0.8rem;
//                 }
//             }
//             .section.about-overlay.section {
//                 margin-left: 0;
//                 margin-top: $gutter * 4;
//                 width: 95%;
//             }
//         }
//     }

//     #chartdiv {
//         height: 350px;
//     }
// } //         height: 350px;
//     }
// }
</style>
